// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "Alumni Sans";
  src: url("../assets/fonts/AlumniSans-SemiBold.woff2") format("woff2"), url("../assets/fonts/AlumniSans-SemiBold.woff") format("woff"), url("../assets/fonts/AlumniSans-SemiBold.ttf") format("truetype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Alumni Sans";
  src: url("../assets/fonts/AlumniSans-SemiBoldItalic.woff2") format("woff2"), url("../assets/fonts/AlumniSans-SemiBoldItalic.woff") format("woff"), url("../assets/fonts/AlumniSans-SemiBoldItalic.ttf") format("truetype");
  font-weight: 600;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "Euclid Circular A";
  src: url("../assets/fonts/EuclidCircularA-Medium.woff2") format("woff2"), url("../assets/fonts/EuclidCircularA-Medium.woff") format("woff"), url("../assets/fonts/EuclidCircularA-Medium.ttf") format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Euclid Circular A";
  src: url("../assets/fonts/EuclidCircularA-Regular.woff2") format("woff2"), url("../assets/fonts/EuclidCircularA-Regular.woff") format("woff"), url("../assets/fonts/EuclidCircularA-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Literata";
  src: url("../assets/fonts/Literata-Medium.woff2") format("woff2"), url("../assets/fonts/Literata-Medium.woff") format("woff"), url("../assets/fonts/Literata-Medium.ttf") format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Literata";
  src: url("../assets/fonts/Literata-Regular.woff2") format("woff2"), url("../assets/fonts/Literata-Regular.woff") format("woff"), url("../assets/fonts/Literata-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: "Alumni Sans";
  font-size: 0.5208335vw;
  font-style: normal;
  font-weight: normal;
  -webkit-animation: bugfix infinite 1s;
  line-height: normal;
  margin: 0;
  padding: 0;
}

body {
  font-optical-sizing: none;
  font-style: normal;
  font-weight: normal;
  -webkit-animation: bugfix infinite 1s;
  line-height: normal;
  margin: 0;
  padding: 0;
  color: #330d03;
  background-color: #fff4da;
}

input,
textarea {
  -webkit-animation: bugfix infinite 1s;
  line-height: inherit;
  margin: 0;
  padding: 0;
  background-color: transparent;
  border: none;
  color: inherit;
}

a {
  color: unset;
}

a,
a:hover {
  text-decoration: none;
}

button,
input,
a,
textarea {
  outline: none;
  cursor: pointer;
  font: inherit;
}
button:focus,
input:focus,
a:focus,
textarea:focus {
  outline: none;
}
button:active,
input:active,
a:active,
textarea:active {
  outline: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font: inherit;
  margin: 0;
  padding: 0;
}

p {
  margin-top: 0;
  margin-bottom: 0;
}

img,
svg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

button {
  border: none;
  color: inherit;
  font: inherit;
  text-align: inherit;
  padding: 0;
  background-color: transparent;
}

ul {
  padding: 0;
  margin: 0;
}

ul li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.container {
  width: 180rem;
  margin: 0 auto;
}

section {
  margin-bottom: 20rem;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

@media (min-width: 1920px) {
  html {
    font-size: 10px;
  }
}
@media (max-width: 48em) {
  html {
    font-size: 5px;
    font-size: 1.5625vw;
    font-size: 1.3333333333vw;
    -webkit-text-size-adjust: none;
  }
  body {
    -webkit-text-size-adjust: none;
  }
  section {
    margin-bottom: 20rem;
  }
  .container {
    padding: 0 3.2rem;
    width: 100%;
  }
}
.index-list {
  padding: 5rem;
}

body.lock {
  overflow: hidden;
  touch-action: none;
}

html {
  scroll-behavior: smooth;
}

main {
  padding-top: 9rem;
}

.h1 {
  font-size: 25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%; /* 225px */
  letter-spacing: -1.5rem;
}

.h2 {
  font-family: "Literata";
  font-size: 19rem;
  font-style: normal;
  font-weight: 400;
  line-height: 90%; /* 171px */
  letter-spacing: -0.76rem;
}

.h3 {
  font-size: 9rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%; /* 81px */
  letter-spacing: -0.27rem;
}

.h4 {
  font-family: "Literata";
  font-size: 8rem;
  font-style: normal;
  font-weight: 500;
  line-height: 110%; /* 88px */
  letter-spacing: -0.16rem;
}

.text-45 {
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
}

.text-30 {
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 93.333% */
  letter-spacing: -0.06rem;
}

.text-24 {
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
}

.text-22 {
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
}

.text-18 {
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}

.btn {
  color: #330d03;
  text-align: center;
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 93.333% */
  letter-spacing: -0.06rem;
  text-transform: uppercase;
  display: inline-flex;
  height: 7rem;
  padding: 2.6rem 4rem;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
  background: #ff6d2f;
  position: relative;
  overflow: hidden;
}
.btn::after {
  content: "";
  width: 110%;
  height: 300%;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  z-index: 1;
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out 0.2s;
}
.btn span {
  color: #ff6d2f;
  display: block;
  position: absolute;
  z-index: 2;
  transform: translateY(250%);
  transition: transform 0.3s ease-in-out;
}
.btn:hover::after {
  transition: transform 0.3s ease-in-out;
  transform: translateY(0);
}
.btn:hover span {
  transition: transform 0.3s ease-in-out 0.2s;
  transform: translateY(0);
}
.btn-circle {
  display: block;
  width: 7rem;
  height: 7rem;
  padding: 2.3rem;
  border-radius: 50%;
  border: 0.1rem solid #330d03;
  transition: background 0.2s linear;
}
.btn-circle svg path {
  transition: fill 0.2s linear;
}
.btn-circle:hover {
  transition: background 0.2s linear;
  background: #330d03;
}
.btn-circle:hover svg path {
  transition: fill 0.2s linear;
  fill: #ff6d2f;
}

.navigation {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.navigation-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  background-color: #330d03;
  transition: background 0.1s linear;
}
.navigation-btn::after {
  content: "";
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  background-color: #b5bf3d;
  position: absolute;
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;
}
.navigation-btn svg {
  position: relative;
  z-index: 2;
  width: 2.4rem;
  height: 2.4rem;
}
.navigation-btn.swiper-button-disabled {
  background-color: #ff6d2f;
  cursor: default;
}
.navigation-btn.swiper-button-disabled:hover {
  background-color: #ff6d2f;
}
.navigation-btn.swiper-button-disabled:hover::after {
  transform: translateY(100%);
}
.navigation-btn:hover {
  transition: background 0.3s linear 0.15s;
  background-color: #b5bf3d;
}
.navigation-btn:hover::after {
  transition: transform 0.3s ease-in-out;
  transform: translateY(0);
}

.small-btn {
  position: relative;
  color: #330d03;
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 93.333% */
  letter-spacing: -0.06rem;
  text-transform: uppercase;
}
.small-btn::after {
  transition: width 0.3s linear;
  content: "";
  width: 100%;
  height: 0.2rem;
  background: #330d03;
  position: absolute;
  bottom: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
}
.small-btn:hover::after {
  transition: width 0.3s linear;
  width: 20%;
}

@media (max-width: 48em) {
  main {
    padding-top: 13.6rem;
  }
  .navigation {
    display: flex;
    flex-direction: row;
    gap: 0.8rem;
  }
  .navigation-btn {
    width: 8.8rem;
    height: 8.8rem;
  }
  .navigation-btn:nth-child(1) {
    order: 2;
  }
  .navigation-btn::after {
    width: 8.8rem;
    height: 8.8rem;
  }
  .navigation-btn svg {
    width: 3.2rem;
    height: 3.2rem;
  }
  .h4 {
    font-size: 5.6rem;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    letter-spacing: -0.112rem;
  }
  .text-30 {
    font-size: 4rem;
    font-style: normal;
    font-weight: 600;
    line-height: 5.6rem; /* 140% */
    letter-spacing: -0.08rem;
  }
  .text-24 {
    font-size: 3.6rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.216rem;
    text-transform: uppercase;
  }
  .text-18 {
    font-size: 2.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: 4rem; /* 142.857% */
    letter-spacing: -0.056rem;
  }
  .small-btn {
    position: relative;
    font-size: 3.6rem;
    line-height: normal;
    letter-spacing: -0.072rem;
    text-transform: uppercase;
  }
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  background-color: #4c0d00;
}
.header__inner {
  display: flex;
  position: relative;
  padding: 1rem 0;
  align-items: center;
  justify-content: space-between;
}
.header__logo {
  width: 21.9rem;
  height: 7rem;
}
.header__logo a {
  display: block;
  width: 100%;
  height: 100%;
}
.header__logo a img {
  height: auto;
}
.header__navigation {
  display: flex;
  align-items: center;
  gap: 5.6rem;
}
.header__nav {
  gap: 3rem;
}
.nav {
  display: flex;
}
.nav__link {
  display: block;
  color: #fff4da;
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
}

.burger-btn {
  display: none;
}
.burger-menu {
  display: none;
}

@media (max-width: 48em) {
  .header__inner {
    padding: 2.4rem 0;
  }
  .header__logo {
    position: relative;
    z-index: 1002;
    width: 24rem;
    height: 8rem;
  }
  .header__navigation {
    display: none;
  }
  .header__nav {
    gap: 3rem;
  }
  .nav {
    display: flex;
  }
  .nav__link {
    display: block;
    color: #fff4da;
    font-family: "Euclid Circular A";
    font-size: 2.2rem;
    font-style: normal;
    font-weight: 500;
    line-height: 2.8rem; /* 127.273% */
  }
  .burger-btn {
    position: relative;
    z-index: 1002;
    display: flex;
    align-items: flex-start;
    padding: 0 2.4rem;
    justify-content: center;
    flex-direction: column;
    width: 8.8rem;
    height: 8.8rem;
    border-radius: 50%;
    background-color: #fff4da;
    gap: 1rem;
  }
  .burger-btn.active span:nth-child(1) {
    width: 4.1rem;
    transition: transform 0.3s linear;
    transform-origin: center;
    transform: translateY(0.7rem) rotate(45deg);
  }
  .burger-btn.active span:nth-child(2) {
    display: none;
  }
  .burger-btn.active span:nth-child(3) {
    transition: transform 0.3s linear;
    transform-origin: center;
    transform: translateY(-0.6rem) rotate(-45deg);
  }
  .burger-btn span {
    display: block;
    width: 4.1rem;
    height: 0.4rem;
    background-color: #330d03;
    border-radius: 10rem;
    transition: transform 0.2s linear;
  }
  .burger-btn span:nth-child(1) {
    width: 2.5rem;
  }
  .burger-menu {
    display: flex;
    width: 100vw;
    height: 100vh;
    margin-left: -3.2rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    padding-top: 13.6rem;
    transform: translateY(100%);
    transition: transform 0.5s ease-in-out;
  }
  .burger-menu.show {
    transform: translateY(0);
    transition: transform 0.5s ease-in-out;
  }
  .burger-menu__inner {
    display: flex;
    position: relative;
    width: 100%;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background-color: #fff4da;
    padding: 10.4rem 0 8rem;
  }
  .burger-menu__nav {
    flex-direction: column;
    gap: 6.4rem;
    margin-bottom: 13.2rem;
  }
  .burger-menu__nav .nav__link {
    color: #330d03;
    font-family: "Alumni Sans";
    font-size: 4.8rem;
    font-style: normal;
    font-weight: 600;
    line-height: 100%; /* 24px */
    letter-spacing: -0.192rem;
    text-transform: uppercase;
  }
  .burger-menu__btn {
    max-width: 50.4rem;
    width: 100%;
  }
  .burger-menu__social {
    display: flex;
    align-items: center;
    gap: 6.4rem;
    margin-top: 10.4rem;
  }
  .burger-menu__social a {
    display: block;
    color: #330d03;
    text-align: center;
    font-family: "Alumni Sans";
    font-size: 4rem;
    font-style: normal;
    font-weight: 600;
    line-height: 100%; /* 20px */
    letter-spacing: -0.16rem;
    text-transform: uppercase;
  }
  .burger-menu__icon {
    position: absolute;
  }
  .burger-menu__icon-cucumber {
    width: 27rem;
    height: 23rem;
    top: 1.3rem;
    right: -7.4rem;
  }
  .burger-menu__icon-tacos {
    width: 32rem;
    height: 22rem;
    transform: rotate(25deg) scale(-1, 1);
    left: -13rem;
    top: 50rem;
  }
}
.footer__container {
  margin: 0 auto;
  width: 100%;
  max-width: 180rem;
}
.footer__top {
  display: flex;
  flex-direction: row;
}
.footer__top-left {
  width: fit-content;
}
.footer__top-right {
  margin-left: 19.8rem;
  width: 100%;
}
.footer__logo-container {
  margin-top: 3.5rem;
}
.footer__logo-container img {
  width: 22rem;
  height: 7rem;
}
.footer__socials {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 6.7rem;
}
.footer__social {
  color: #330d03;
  text-transform: uppercase;
}
.footer__form {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-bottom: 2.4rem;
  border-bottom: 1px #330d03 solid;
}
.footer__input-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.footer__form-title {
  width: 100%;
}
.footer__form-input {
  text-transform: uppercase;
  margin-top: 2rem;
}
.footer__form-input::placeholder {
  color: rgba(51, 13, 3, 0.3);
}
.footer__form-submit {
  cursor: pointer;
  position: absolute;
  right: 0;
  bottom: 2.4rem;
}
.footer__form-submit svg {
  width: 2.4rem;
  height: 2.4rem;
}
.footer__bottom {
  margin-top: 6.4rem;
}
.footer__menu {
  width: 100%;
  max-width: 128rem;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.footer__menu-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 20.4rem;
  gap: 3.2rem;
}
.footer__link {
  width: 100%;
  text-transform: uppercase;
}
.footer__link--light {
  color: rgba(51, 13, 3, 0.6);
}
.footer__copyright {
  margin-top: 2.4rem;
  width: 100%;
  position: relative;
  padding: 3.2rem 0 2.45rem;
  border-top: 1px solid rgba(51, 13, 3, 0.3);
}
.footer__copyright-text {
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-weight: 400;
  letter-spacing: -0.036rem;
  line-height: 2.8rem; /* 155.556% */
  font-style: normal;
  color: rgba(51, 13, 3, 0.6);
}
.footer__copyright-inner {
  margin: 0 auto;
  color: rgba(51, 13, 3, 0.6);
  width: 100%;
  max-width: 180rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

@media (max-width: 48em) {
  .footer__container {
    max-width: 68.2rem;
  }
  .footer__top {
    order: 2;
    flex-direction: column;
  }
  .footer__top-left {
    width: fit-content;
  }
  .footer__top-right {
    display: flex;
    flex-direction: column;
    margin-left: 0;
    width: 100%;
  }
  .footer__logo-container {
    margin-top: 3.5rem;
  }
  .footer__logo-container svg {
    width: 24rem;
    height: 8rem;
  }
  .footer__socials {
    display: none;
  }
  .footer__form {
    margin-top: 10.4rem;
    order: 2;
    position: relative;
    display: flex;
    flex-direction: column;
    padding-bottom: 2.4rem;
    border-bottom: 1px #330d03 solid;
  }
  .footer__input-container {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
  .footer__form-title {
    width: 100%;
  }
  .footer__form-input {
    margin-top: 2rem;
  }
  .footer__form-input::placeholder {
    color: rgba(51, 13, 3, 0.3);
  }
  .footer__form-submit {
    position: absolute;
    right: 0;
    bottom: 2.4rem;
  }
  .footer__form-submit svg {
    width: 3.2rem;
    height: 3.2rem;
  }
  .footer__bottom {
    order: 1;
    margin-top: 6.4rem;
  }
  .footer__menu {
    gap: 3.4rem;
    width: 100%;
    max-width: 100%;
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .footer__menu-item {
    max-width: 28.8rem;
    gap: 3rem;
  }
  .footer__copyright {
    margin-top: 6.4rem;
    padding: 4rem 3.2rem 3.2rem;
  }
  .footer__copyright-inner {
    width: 100%;
    max-width: 100%;
    gap: 1.6rem;
    display: flex;
    flex-direction: column;
  }
}
.review-modal__title {
  color: #fff4da;
  text-transform: uppercase;
}
.review-modal__form {
  width: 96.6rem;
  margin-top: 5.1rem;
}
.review-modal__icon {
  width: 18.7rem;
  height: 12.6rem;
  margin-bottom: 6.4rem;
}
.review-modal__content {
  padding: 6rem;
  overflow: hidden;
}
.review-modal__description {
  margin-top: 4.8rem;
  overflow: hidden;
  color: #fff4da;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  /* Desktop/text 22 */
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
}
.review-modal__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 96.6rem;
}

.review-modal-detail__slider {
  overflow: hidden;
  width: 92.6rem;
  height: 62.5rem;
}
.review-modal-detail__slide.swiper-slide {
  width: 100%;
  display: flex;
  padding: 6rem 6rem 4.2rem;
  flex-direction: column;
  gap: 4.8rem;
}
.review-modal-detail__header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.review-modal-detail__header::after {
  content: "";
  position: absolute;
  top: -13.2rem;
  right: -13rem;
  z-index: -1;
  width: 25.2rem;
  height: 25.2rem;
  background-color: #ff6d2f;
  border-radius: 50%;
}
.review-modal-detail__icon {
  width: 9.6rem;
  height: 9.6rem;
  padding: 2.8rem;
  border-radius: 50%;
  background: #fff4da;
}
.review-modal-detail__rating {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #330d03;
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 93.333% */
  letter-spacing: -0.06rem;
  text-transform: uppercase;
}
.review-modal-detail__rating span {
  display: block;
  width: 2.4rem;
  height: 2.4rem;
}
.review-modal-detail__info {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.review-modal-detail__name {
  color: #fff4da;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
}
.review-modal-detail__date {
  color: #fff4da;
  text-align: right;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}
.review-modal-detail__main {
  position: relative;
  overflow: auto;
  max-height: 17rem;
  color: #fff4da;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
  /* W3C standard
  сейчас только для Firefox */
  scrollbar-width: thin;
  scrollbar-color: #330d03 #ff6d2f;
  /* для Chrome/Edge/Safari */
}
.review-modal-detail__main::-webkit-scrollbar {
  width: 0.3rem;
}
.review-modal-detail__main::-webkit-scrollbar-thumb {
  background-color: #330d03;
  border-radius: 10rem;
}
.review-modal-detail__footer {
  height: 7rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.review-modal-detail__address {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #fff4da;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}
.review-modal-detail__address span {
  display: block;
  width: 2.4rem;
  height: 2.4rem;
}
.review-modal-detail__navigation.navigation {
  position: absolute;
  right: 6rem;
  bottom: 4.2rem;
  z-index: 100;
  flex-direction: row;
}
.review-modal-detail__navigation-btn {
  background-color: #fff4da;
}
.review-modal-detail__navigation-btn svg path {
  fill: #4c0d00;
}

.subscribe__content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8rem;
  width: 108.6rem;
}
.subscribe__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.subscribe__icon {
  width: 18.5rem;
  margin-bottom: 6.4rem;
}
.subscribe__title {
  color: #fff4da;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 4.8rem;
  width: 79.6rem;
}
.subscribe__description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: #fff4da;
  text-overflow: ellipsis;
}

.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2010;
  width: 100%;
  height: 100vh;
}
.modal.active {
  display: block;
}
.modal-back {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: rgba(51, 13, 3, 0.3);
  backdrop-filter: blur(0.5rem);
  opacity: 0;
  transition: opacity 0.4s ease-in-out;
}
.modal-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #4c0d00;
  opacity: 0;
  transition: opacity 0.4s ease-in-out;
}
.modal-exit {
  cursor: pointer;
  position: absolute;
  top: 2.2rem;
  right: 2.2rem;
  z-index: 1000;
  width: 2rem;
  height: 2rem;
}
.modal-exit svg {
  width: 100%;
  height: 100%;
}
.modal-content {
  display: none;
  visibility: hidden;
}
.modal-content.active {
  display: block;
  visibility: visible;
}

.footer__input-container.error .error-text {
  position: absolute;
  margin: 0;
  bottom: -2.8rem;
  left: 0;
}

.error-text {
  margin: 0.6rem 0 0 3.2rem;
  color: #ff2f2f;
  font-family: "Euclid Circular A";
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
  letter-spacing: -0.028rem;
}

.form-input {
  background: #a5806d;
  width: 100%;
  padding: 3.2rem;
  color: #330d03;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}
.form-input::placeholder {
  color: rgba(51, 13, 3, 0.6);
}
.form-textarea {
  width: 100%;
  height: 15.5rem;
  resize: none;
  background: #a5806d;
  padding: 3.2rem;
  color: #330d03;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
  /* W3C standard
  сейчас только для Firefox */
  scrollbar-width: thin;
  scrollbar-color: #330d03 #ff6d2f;
  /* для Chrome/Edge/Safari */
}
.form-textarea::placeholder {
  color: rgba(51, 13, 3, 0.6);
}
.form-textarea::-webkit-scrollbar {
  width: 0.3rem;
}
.form-textarea::-webkit-scrollbar-thumb {
  background-color: #330d03;
  border-radius: 10rem;
}
.form__main {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 4.1rem;
}
.form__main-top {
  display: flex;
  gap: 1rem;
}
.form__main-bottom {
  width: 100%;
}
.form__label {
  flex: 1;
}
.form__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rating {
  display: flex;
  align-items: center;
  gap: 3.2rem;
}
.rating__title {
  color: #fff4da;
  text-transform: uppercase;
}
.rating__main {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  position: relative;
}
.rating__main label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  cursor: pointer;
  margin-right: 0.8rem;
}
.rating__main label:nth-child(2) {
  margin-right: 0;
}
.rating__main label svg path {
  fill: none;
  stroke: #fff4da;
}
.rating__main label:hover svg path {
  fill: #fff4da;
}
.rating__main input {
  display: none;
}
.rating__main input:checked ~ label svg path {
  fill: #fff4da;
}
.rating__main label:hover svg,
.rating__main label:hover ~ label svg path {
  fill: #fff4da;
}
.rating__main input:checked + label:hover svg path {
  fill: #fff4da;
}
.rating__main input:checked ~ label:hover svg,
.rating__main input:checked ~ label:hover ~ label svg path {
  fill: #fff4da;
}
.rating__main label:hover ~ input:checked ~ label svg path {
  fill: #fff4da;
}

.vacancy-modal__content {
  padding: 6rem;
  overflow: hidden;
}
.vacancy-modal__title {
  color: #fff4da;
  text-transform: uppercase;
}
.vacancy-modal__form {
  width: 108.6rem;
  margin-top: 5.1rem;
}
.vacancy-modal__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 96.6rem;
}
.vacancy-modal__icon {
  width: 18.7rem;
  height: 12.6rem;
  margin-bottom: 6.4rem;
}
.vacancy-modal__description {
  margin-top: 4.8rem;
  overflow: hidden;
  color: #fff4da;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  /* Desktop/text 22 */
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
}

.input-file {
  display: none;
  appearance: none;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  z-index: -1;
}

.custom-file {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1.6rem;
}
.custom-file span {
  color: #fff4da;
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
}
.custom-file svg {
  width: 3.2rem;
  height: 3.2rem;
}
.custom-file svg path {
  stroke: #fff4da;
}

.custom-preview {
  display: none;
  align-items: center;
}
.custom-preview__close {
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  margin-left: 1.6rem;
}
.custom-preview__name {
  max-width: 15rem;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  color: #fff4da;
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
}
.custom-preview__size {
  color: #ff6d2f;
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
  margin-left: 1.2rem;
}

.map-modal__slider {
  overflow: hidden;
  width: 50.1rem;
  height: 61.4rem;
}
.map-modal .modal-exit svg path {
  fill: #330d03;
}
.map-modal .modal-exit:hover svg path {
  fill: #ff6d2f;
}
.map-modal__content {
  padding: 6.5rem 6rem;
  background-color: #fff4da;
  gap: 1rem;
}
.map-modal__content.active {
  display: flex;
}
.map-modal__left {
  width: 79rem;
  height: 61.4rem;
  overflow: hidden;
}
.map-modal__left-wrapper {
  width: 100%;
  height: 100%;
}
.map-modal__map {
  width: 100%;
  height: 100%;
}
.map-modal__card {
  height: 100%;
  width: 50.1rem;
  border: 0.1rem solid #330d03;
}

@media (max-width: 48em) {
  .footer__input-container.error .error-text {
    bottom: -4.2rem;
  }
  .error-text {
    margin: 0.6rem 0 0 3.2rem;
    font-size: 2.4rem;
    line-height: normal; /* 16.8px */
    letter-spacing: -0.056rem;
  }
  .review-modal__title {
    text-align: center;
    font-size: 8rem;
    letter-spacing: -0.24rem;
    margin-bottom: 0;
  }
  .review-modal__form {
    width: 100%;
    margin-top: 4.8rem;
  }
  .review-modal__icon {
    width: 21.4rem;
    height: 14.4rem;
    margin-bottom: 0;
  }
  .review-modal__content {
    padding: 13rem 6rem;
  }
  .review-modal__description {
    margin-top: 0;
    display: block;
    text-align: center;
    max-width: 38.8rem;
    font-size: 3.6rem;
    line-height: 5.6rem; /* 127.273% */
  }
  .review-modal__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4.8rem;
    width: auto;
  }
  .review-modal-detail__slider {
    overflow: hidden;
    width: 100%;
    height: auto;
    padding: 13rem 6rem;
  }
  .review-modal-detail__slide.swiper-slide {
    width: 100%;
    display: flex;
    padding: 0;
    flex-direction: column;
    gap: 4.8rem;
  }
  .review-modal-detail__header::after {
    top: -17.6rem;
    right: -14.2rem;
    width: 32.8rem;
    height: 32.8rem;
  }
  .review-modal-detail__icon {
    width: 12.4rem;
    height: 12.4rem;
    padding: 3.6rem;
  }
  .review-modal-detail__rating {
    gap: 1.2rem;
    font-size: 4.8rem;
    line-height: 100%; /* 93.333% */
    letter-spacing: -0.192rem;
  }
  .review-modal-detail__rating span {
    width: 4.8rem;
    height: 4.8rem;
  }
  .review-modal-detail__name {
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
  .review-modal-detail__date {
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .review-modal-detail__main {
    max-height: 45rem;
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .review-modal-detail__main::-webkit-scrollbar {
    width: 0.6rem;
  }
  .review-modal-detail__main::-webkit-scrollbar-thumb {
    border-radius: 20rem;
  }
  .review-modal-detail__footer {
    height: auto;
  }
  .review-modal-detail__address {
    gap: 1.2rem;
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .review-modal-detail__address span {
    width: 4.8rem;
    height: 4.8rem;
  }
  .review-modal-detail__navigation.navigation {
    position: static;
    flex-direction: row-reverse;
    justify-content: space-between;
    margin-top: 4.8rem;
  }
  .subscribe__content {
    padding: 13rem 6rem;
    width: auto;
  }
  .subscribe__wrapper {
    gap: 4.8rem;
  }
  .subscribe__icon {
    width: 18.5rem;
    margin-bottom: 0;
  }
  .subscribe__title {
    margin-bottom: 0;
    width: 100%;
  }
  .subscribe__description {
    display: block;
    text-align: center;
    font-size: 3.6rem;
    line-height: 5.6rem; /* 155.556% */
  }
  .modal-wrapper {
    width: 68.6rem;
  }
  .modal-exit {
    top: 2.6rem;
    right: 2.6rem;
    width: 3.4rem;
    height: 3.4rem;
  }
  .form-input {
    padding: 3.2rem 4.8rem;
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .form-textarea {
    height: 37.2rem;
    padding: 3.2rem 4.8rem;
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .form__main {
    gap: 2rem;
    margin-bottom: 4.8rem;
  }
  .form__main-top {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
  .form__main-bottom {
    width: 100%;
  }
  .form__label {
    flex: 1;
  }
  .form__footer {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 3.2rem;
  }
  .form__btn {
    width: 100%;
  }
  .form__btn .btn {
    width: 100%;
  }
  .rating {
    gap: 4.8rem;
  }
  .rating__title {
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
  .rating__main label {
    width: 4.8rem;
    height: 4.8rem;
    margin-right: 1.2rem;
  }
  .vacancy-modal__content {
    padding: 13rem 6rem;
  }
  .vacancy-modal__title {
    text-align: center;
    font-size: 8rem;
    letter-spacing: -0.24rem;
    margin-bottom: 0;
  }
  .vacancy-modal__form {
    width: 100%;
    margin-top: 4.8rem;
  }
  .vacancy-modal__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4.8rem;
    width: auto;
  }
  .vacancy-modal__icon {
    width: 21.4rem;
    height: 14.4rem;
    margin-bottom: 0;
  }
  .vacancy-modal__description {
    margin-top: 0;
    display: block;
    text-align: center;
    max-width: 38.8rem;
    font-size: 3.6rem;
    line-height: 5.6rem; /* 127.273% */
  }
  .custom-file {
    gap: 3.2rem;
  }
  .custom-file span {
    font-size: 3.6rem;
    line-height: 5.6rem; /* 127.273% */
  }
  .custom-file svg {
    width: 4.8rem;
    height: 4.8rem;
  }
  .custom-preview {
    display: none;
    align-items: center;
  }
  .custom-preview__close {
    width: 3rem;
    height: 3rem;
    margin-left: 4rem;
  }
  .custom-preview__name {
    max-width: 20rem;
    font-size: 3.6rem;
    line-height: 5.6rem; /* 127.273% */
  }
  .custom-preview__size {
    margin-left: 2.4rem;
    font-size: 3.6rem;
    line-height: 5.6rem; /* 127.273% */
  }
  .map-modal .modal-wrapper {
    width: 100vw;
    background-color: #fff4da;
  }
  .map-modal .modal-exit {
    width: 8.8rem;
    height: 8.8rem;
    right: unset;
    top: 4rem;
    left: 3.2rem;
  }
  .map-modal .modal-exit.mobile {
    position: static;
    margin-bottom: 1.6rem;
  }
  .map-modal .modal-exit .btn-circle {
    width: 100%;
    height: 100%;
    padding: 2.8rem;
  }
  .map-modal .modal-exit svg {
    width: 3.2rem;
    height: 3.2rem;
  }
  .map-modal__content {
    height: 100vh;
    padding: 4rem 3.2rem;
  }
  .map-modal__content.active {
    overflow: auto;
    flex-direction: column;
    gap: 4.8rem;
  }
  .map-modal__slider.swiper {
    overflow: hidden;
    width: 100%;
    height: 85rem;
  }
  .map-modal__slider.swiper .main-map__slider-slide.swiper-slide {
    height: 85rem;
  }
  .map-modal__left {
    flex: none;
    width: 100%;
    height: 80rem;
  }
  .map-modal__right {
    flex: none;
    padding-bottom: 4rem;
  }
  .map-modal__card {
    height: 100%;
    width: 100%;
    border: 0.2rem solid #330d03;
  }
}
.ticker {
  max-width: 192rem;
  margin: 0 auto;
  height: 6rem;
  display: flex;
  align-items: center;
  background-color: #b5bf3d;
  overflow: hidden;
}
.ticker-content {
  display: flex;
  gap: 3rem;
  width: 200%;
  animation: ticker 20s linear infinite;
}
.ticker-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 3rem;
}
.ticker-element {
  display: flex;
  align-items: center;
  gap: 3rem;
}
.ticker-element strong {
  display: block;
  width: max-content;
  text-wrap: nowrap;
  color: #330d03;
  font-size: 3rem;
  font-weight: 600;
  line-height: 2.8rem; /* 93.333% */
  letter-spacing: -0.06rem;
  text-transform: uppercase;
}
.ticker-element span {
  display: block;
  width: 0.4rem;
  height: 0.4rem;
}

@keyframes ticker {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(calc(-50% - 23.3rem));
  }
}
@media (max-width: 48em) {
  .ticker {
    height: 7.2rem;
  }
  .ticker-content {
    gap: 4rem;
    width: 350%;
  }
  .ticker-wrapper {
    gap: 4rem;
  }
  .ticker-element {
    gap: 4rem;
  }
  .ticker-element strong {
    font-size: 3.6rem;
    line-height: normal; /* 93.333% */
    letter-spacing: -0.072rem;
  }
  .ticker-element span {
    width: 0.8rem;
    height: 0.8rem;
  }
  @keyframes ticker {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(calc(-50% - 135rem));
    }
  }
}
.main-banner__inner.desktop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 2.3rem;
  margin: 0 auto;
  max-width: 192rem;
  height: 90.7rem;
}
.main-banner__inner.mobile {
  display: none;
}
.main-banner__social {
  position: relative;
  width: 2.8rem;
  height: 2.8rem;
  transform: rotate(-90deg);
}
.main-banner__social-wrapper {
  display: flex;
  gap: 4.8rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.main-banner__social-wrapper a {
  display: block;
  color: #330d03;
  text-align: center;
  font-size: 2.4rem;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
}
.main-banner__left {
  display: flex;
  flex-direction: column;
  width: 80.1rem;
  height: 81.7rem;
  margin-left: 0.9rem;
}
.main-banner__left-header {
  width: 100%;
  position: relative;
}
.main-banner__left-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 6.8rem;
  margin-top: -1.5rem;
}
.main-banner__left-footer {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
}
.main-banner__right {
  position: relative;
  overflow: hidden;
  width: 95.5rem;
  height: 90.7rem;
  margin-left: auto;
}
.main-banner__right-back.swiper {
  height: 90.7rem;
  overflow: hidden;
  position: relative;
}
.main-banner__right-back.swiper::after {
  content: "";
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 54.32%, rgba(0, 0, 0, 0.2) 81.02%);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.main-banner__right-back--slide.swiper-slide {
  width: 95.5rem;
  height: 90.7rem;
}
.main-banner__right-back--slide.swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-banner__right-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
}
.main-banner__right-wrapper {
  height: 18.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6rem;
  width: 100%;
  margin-top: 4rem;
}
.main-banner__right-wrapper--btn {
  display: flex;
  width: 7rem;
  height: 7rem;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 0.1rem solid #fff4da;
}
.main-banner__right-wrapper--btn svg {
  width: 2.4rem;
  height: 2.4rem;
}
.main-banner__right-controls {
  position: relative;
  margin-left: auto;
  margin-right: 19rem;
  width: 31.5rem;
  height: 18.7rem;
}
.main-banner__right-controls--progressbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 31.5rem;
  height: 31.5rem;
  border-radius: 50%;
  flex-shrink: 0;
}
.main-banner__right-controls--progressbar svg {
  overflow: visible;
}
.main-banner__right-controls--fraction.swiper-pagination-fraction {
  width: auto;
  position: absolute;
  left: 50%;
  bottom: 5.6rem;
  top: unset;
  transform: translateX(-50%);
  color: #fff4da;
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
}

.main-banner__right-controls--progressbar.swiper-pagination-progressbar.swiper-pagination-vertical {
  width: 31.5rem;
  height: 31.5rem;
  background: none;
}

.pagination-swiper-up__bg {
  stroke: rgba(255, 244, 218, 0.2);
}

.pagination-swiper-up__progress {
  stroke: #fff4da;
  transition: stroke-dashoffset 0.8s ease-in-out;
  stroke-dasharray: var(--stroke-dasharray);
  stroke-dashoffset: var(--stroke-dashoffset);
  stroke-linecap: round;
  transform: rotate(-190deg);
  transform-origin: center;
}

.top-title.swiper {
  overflow: hidden;
  height: 22.5rem;
}
.top-title__slide.swiper-slide {
  color: #ff6d2f;
  font-size: 25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%; /* 225px */
  letter-spacing: -1.5rem;
  text-transform: uppercase;
}

.bottom-title.swiper {
  width: 100%;
  height: 17.1rem;
  overflow: hidden;
  position: absolute;
  top: 7rem;
}
.bottom-title__slide.swiper-slide {
  color: #330d03;
  font-feature-settings: "dnom" on;
  font-family: "Literata";
  font-size: 19rem;
  font-style: normal;
  font-weight: 400;
  line-height: 90%; /* 171px */
  letter-spacing: -0.76rem;
}

.banner-illustration.swiper {
  margin: 0;
  width: 60.2rem;
  height: 39.7rem;
  overflow: hidden;
}
.banner-illustration__wrapper.swiper-wrapper {
  width: 100%;
  height: 100%;
}
.banner-illustration__slide.swiper-slide {
  overflow: hidden;
  width: 60.2rem;
  height: 39.7rem;
}
.banner-illustration__slide.swiper-slide img {
  object-fit: contain;
}

.banner-footer-left.swiper {
  overflow: hidden;
  height: 10rem;
  width: 27.3rem;
  margin: 0;
}
.banner-footer-left__slide.swiper-slide {
  width: 27.3rem;
  color: #330d03;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
}
.banner-footer-left__slide.swiper-slide span {
  font-style: italic;
  font-weight: 700;
  letter-spacing: -0.09rem;
}

.banner-footer-right.swiper {
  overflow: hidden;
  margin: 0;
  width: 31.1rem;
  height: 12rem;
}
.banner-footer-right__slide.swiper-slide {
  width: 31.1rem;
  color: #330d03;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}

@keyframes ticker {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(calc(-50% - 23.3rem));
  }
}
@media (max-width: 48em) {
  .main-banner__inner.desktop {
    display: none;
  }
  .main-banner__inner.mobile {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 4.8rem;
    padding-top: 6.6rem;
  }
  .main-banner__inner-main {
    overflow: hidden;
    display: flex;
    padding-left: 3.2rem;
    gap: 9.2rem;
  }
  .main-banner__inner-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .main-banner__left-header {
    margin-bottom: 5.4rem;
  }
  .main-banner__left-footer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 4rem;
    margin: 0;
  }
  .main-banner__right-back-mobile.swiper {
    width: 68.6rem;
    height: 35.2rem;
  }
  .main-banner__right-back-mobile--slide.swiper-slide {
    width: 68.6rem;
    height: 35.2rem;
  }
  .top-title-mobile.swiper {
    overflow: hidden;
    max-height: 21.6rem;
  }
  .top-title-mobile__slide.swiper-slide {
    color: #ff6d2f;
    font-size: 24rem;
    font-style: normal;
    font-weight: 600;
    line-height: 90%; /* 225px */
    letter-spacing: -1.44rem;
    text-transform: uppercase;
  }
  .bottom-title-mobile.swiper {
    width: 100%;
    max-height: 16.2rem;
    overflow: hidden;
    position: absolute;
    top: 6.4rem;
  }
  .bottom-title-mobile__slide.swiper-slide {
    color: #330d03;
    font-feature-settings: "dnom" on;
    font-family: "Literata";
    font-size: 18rem;
    font-style: normal;
    font-weight: 400;
    line-height: 90%; /* 171px */
    letter-spacing: -0.72rem;
  }
  .banner-illustration-mobile.swiper {
    margin: 0;
    margin-top: 2.2rem;
    width: 35.2rem;
    max-height: 24.6rem;
    overflow: hidden;
  }
  .banner-illustration-mobile__wrapper.swiper-wrapper {
    width: 100%;
    height: 100%;
  }
  .banner-illustration-mobile__slide.swiper-slide {
    overflow: hidden;
    width: 35.2rem;
  }
  .banner-illustration-mobile__slide.swiper-slide img {
    object-fit: contain;
  }
  .banner-footer-left-mobile.swiper {
    overflow: hidden;
    max-height: 9.6rem;
    width: 39.2rem;
    margin: 0;
  }
  .banner-footer-left-mobile__slide.swiper-slide {
    width: 39.2rem;
    color: #330d03;
    font-size: 4.8rem;
    font-style: normal;
    font-weight: 600;
    line-height: 100%; /* 45px */
    letter-spacing: -0.192rem;
    text-transform: uppercase;
  }
  .banner-footer-left-mobile__slide.swiper-slide span {
    font-style: italic;
    font-weight: 700;
    letter-spacing: -0.096rem;
  }
  .banner-footer-right-mobile.swiper {
    overflow: hidden;
    margin: 0;
    width: 39.2rem;
    max-height: 16rem;
  }
  .banner-footer-right-mobile__slide.swiper-slide {
    width: 39.2rem;
    color: #330d03;
    font-family: "Euclid Circular A";
    font-size: 2.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .btn {
    font-size: 3.6rem;
    font-weight: 600;
    line-height: normal; /* 93.333% */
    letter-spacing: -0.072rem;
    height: 8.8rem;
    padding: 4rem 4.8rem;
    gap: 2rem;
  }
  @keyframes ticker {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(calc(-50% - 135rem));
    }
  }
}
.main-news__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.main-news__title {
  display: flex;
  gap: 2.5rem;
  align-items: center;
  margin-bottom: 7rem;
}
.main-news__title strong {
  display: block;
  margin-top: 1rem;
  width: 11rem;
  height: 8.9rem;
}
.main-news__slider {
  margin: 0 auto 5.6rem;
  max-width: 192rem;
  width: 100%;
  padding: 0 1rem;
}
.main-news__slider-wrapper {
  gap: 1rem;
  display: flex;
  flex-wrap: wrap;
}
.main-news__slider-slide {
  width: 24.6%;
  height: 63.2rem;
  display: flex;
  flex-direction: column;
  transition: background 0.3s linear;
}

.news-slide {
  position: relative;
  overflow: hidden;
  border: 0.1rem solid #330d03;
}
.news-slide:hover {
  transition: color 0.3s linear;
  color: #fff4da;
}
.news-slide:hover .news-slide__bg-circle {
  transition: opacity 0.6s linear, transform 0.8s linear;
  opacity: 1;
  transform: scale(20);
}
.news-slide:hover .news-slide__date {
  transition: color 0.3s linear;
  color: #fff4da;
}
.news-slide:hover .news-slide__btn {
  transition: color 0.3s linear;
  color: #fff4da;
}
.news-slide:hover .news-slide__btn::after {
  transition: width 0.3s linear, background 0.3s linear;
  background: #fff4da;
}
.news-slide:nth-child(2n) .news-slide__img {
  width: 100%;
  height: 34rem;
}
.news-slide__date {
  transition: color 0.3s linear;
  color: #330d03;
  text-align: right;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
  padding: 1.7rem 2.4rem 1.3rem;
}
.news-slide__content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.news-slide__img {
  width: 100%;
  height: 21.3rem;
}
.news-slide__title {
  text-transform: uppercase;
  padding: 0 2.4rem;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.news-slide__footer {
  padding: 0 2.4rem 3.9rem;
  margin-top: auto;
}
.news-slide__btn.small-btn {
  transition: color 0.3s linear;
}
.news-slide__btn.small-btn::after {
  transition: width 0.3s linear, background 0.3s linear;
}
.news-slide__bg {
  z-index: -1;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.news-slide__bg-circle {
  transition: opacity 0.6s linear, transform 0.8s linear;
  position: absolute;
  border-radius: 50%;
  background-color: #ff6d2f;
  width: 5rem;
  height: 5rem;
  transform: scale(0);
  opacity: 0;
  z-index: 1;
}
.news-slide__bg-circle--first {
  bottom: 5rem;
  left: 12rem;
}
.news-slide__bg-circle--second {
  top: 10rem;
  left: 20rem;
}
.news-slide__bg-circle--third {
  top: 40rem;
  right: 10rem;
}

@media (max-width: 48em) {
  .main-news__title {
    display: flex;
    gap: 1.6rem;
    align-items: center;
    margin-bottom: 8.6rem;
  }
  .main-news__title strong {
    margin-top: 0;
    width: 9.4rem;
    height: 7.4rem;
  }
  .main-news__slider {
    padding: 0 3.2rem;
    margin-bottom: 6.4rem;
  }
  .main-news__slider-wrapper {
    gap: 2rem;
  }
  .main-news__slider-slide {
    width: 100%;
    height: 67.4rem;
  }
  .news-slide {
    background: #fff4da;
    border: 0.2rem solid #330d03;
  }
  .news-slide:nth-child(2n) .news-slide__img {
    height: 33.5rem;
  }
  .news-slide:hover {
    transition: color 0.3s linear;
    color: #330d03;
  }
  .news-slide:hover .news-slide__bg-circle {
    transition: opacity 0.6s linear, transform 0.8s linear;
    opacity: 1;
    transform: scale(20);
  }
  .news-slide:hover .news-slide__date {
    color: #330d03;
  }
  .news-slide:hover .news-slide__btn {
    transition: color 0.3s linear;
    color: #330d03;
  }
  .news-slide__date {
    text-align: right;
    font-size: 3.2rem;
    line-height: normal; /* 116.667% */
    letter-spacing: 0.288rem;
    padding: 2.2rem 3.2rem 1.4rem;
  }
  .news-slide__content {
    gap: 1.2rem;
  }
  .news-slide__img {
    width: 100%;
    height: 22rem;
  }
  .news-slide__title {
    padding: 0 3.2rem;
    font-size: 4.8rem;
  }
  .news-slide__footer {
    padding: 0 4rem 5rem;
  }
}
.main-menu__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.main-menu__header {
  margin-bottom: 6.4rem;
}
.main-menu__title {
  display: flex;
  align-items: center;
  gap: 1.8rem;
}
.main-menu__title strong {
  display: block;
  width: 10rem;
  height: 13.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-menu__title strong img {
  width: 5rem;
  height: 12.5rem;
  transform: rotate(30deg);
}
.main-menu__categories {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 140rem;
  flex-wrap: wrap;
  gap: 5rem 8.8rem;
  margin-bottom: 2rem;
}
.main-menu__categories-btn {
  transition: color 0.2s linear;
  color: #330d03;
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 93.333% */
  letter-spacing: -0.06rem;
  text-transform: uppercase;
}
.main-menu__categories-btn::after {
  content: "";
  width: 0;
}
.main-menu__categories-btn.active {
  position: relative;
  color: #ff6d2f;
}
.main-menu__categories-btn.active::after {
  content: "";
  transition: width 0.2s linear;
  width: 100%;
  height: 0.2rem;
  background: #ff6d2f;
  position: absolute;
  bottom: -0.8rem;
  left: 50%;
  transform: translateX(-50%);
}
.main-menu__footer {
  margin-top: 6.6rem;
}
.main-menu__cards.swiper {
  max-width: 192rem;
  margin: 0 auto;
  width: 100%;
  padding: 0 1rem;
}
.main-menu__cards-wrapper.swiper-wrapper {
  gap: 1rem;
}
.main-menu__cards-slide.swiper-slide {
  width: 46.3rem;
  height: 55rem;
  display: flex;
}
.main-menu__btn {
  margin-top: 6.6rem;
}

.menu-card {
  height: 55rem;
  display: flex;
}
.menu-card:hover .menu-card__img {
  transition: transform 0.3s ease-in-out;
  transform: translateX(-50%) scale(1.05) translateY(-5rem);
}
.menu-card:hover .menu-card__bg-circle {
  transition: opacity 0.6s linear, transform 0.8s linear;
  opacity: 1;
  transform: scale(20);
}
.menu-card:hover .menu-card__description {
  transition: height 0.5s linear;
  -webkit-line-clamp: 4;
  height: 11rem;
}
.menu-card__img {
  transition: transform 0.2s ease-in-out;
  position: absolute;
  width: 34.5rem;
  height: 28.7rem;
  left: 50%;
  top: 6rem;
  z-index: 2;
  transform: translateX(-50%);
  transform-origin: center bottom;
}
.menu-card__wrapper {
  position: relative;
  transition: background 0.3s ease-in-out;
  align-self: flex-end;
  background: #b5bf3d;
  width: 100%;
  height: 38.4rem;
  padding: 3rem;
  display: flex;
}
.menu-card__info {
  position: relative;
  z-index: 2;
  width: 100%;
  align-self: flex-end;
  display: flex;
  flex-direction: column;
  gap: 1.7rem;
}
.menu-card__info-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 2rem;
}
.menu-card__info-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menu-card__name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #330d03;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
}
.menu-card__price {
  padding-right: 1.5rem;
  position: relative;
  color: #330d03;
  text-align: right;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
}
.menu-card__price sup {
  position: absolute;
  top: -0.5rem;
  right: 0;
  font-size: 3.5rem;
}
.menu-card__description {
  transition: height 0.3s linear;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-width: 20rem;
  height: 5.5rem;
  color: #330d03;
  text-overflow: ellipsis;
  overflow: hidden;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}
.menu-card__btn {
  background: #330d03;
  color: #fff;
}
.menu-card__bg {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.menu-card__bg-circle {
  transition: opacity 0.6s linear, transform 0.8s linear;
  position: absolute;
  border-radius: 50%;
  background-color: #fff4da;
  width: 5rem;
  height: 5rem;
  transform: scale(0);
  opacity: 0;
  z-index: 1;
}
.menu-card__bg-circle--first {
  bottom: 5rem;
  left: 12rem;
}
.menu-card__bg-circle--second {
  top: 10rem;
  left: 20rem;
}
.menu-card__bg-circle--third {
  top: 20rem;
  left: 30rem;
}
.menu-card__btn-right {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 48em) {
  .main-menu__header {
    margin-bottom: 8rem;
  }
  .main-menu__title {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    font-size: 5.6rem;
  }
  .main-menu__title strong {
    display: flex;
    width: 7rem;
    height: 9rem;
  }
  .main-menu__title strong img {
    width: 3.4rem;
    height: 8.4rem;
    transform: rotate(30deg);
  }
  .main-menu__navigation {
    display: none;
  }
  .main-menu__navigation.mobile {
    display: flex;
  }
  .main-menu__categories {
    justify-content: flex-start;
    max-width: 100%;
    overflow: auto;
    padding: 0 3.2rem;
    flex-wrap: nowrap;
    height: 6rem;
    margin-bottom: 4.8rem;
  }
  .main-menu__categories-btn {
    width: max-content;
    color: #330d03;
    font-size: 4rem;
    font-style: normal;
    line-height: 100%; /* 93.333% */
    letter-spacing: -0.16rem;
  }
  .main-menu__categories-btn span {
    display: block;
    width: max-content;
    text-wrap: nowrap;
  }
  .main-menu__cards.swiper {
    max-width: 100%;
    padding: 0 3.2rem;
  }
  .main-menu__cards-wrapper.swiper-wrapper {
    gap: 0;
  }
  .main-menu__cards-slide.swiper-slide {
    width: auto;
    height: 68.6rem;
    display: flex;
  }
  .main-menu__btn {
    margin-top: 0;
    font-size: 3.6rem;
    line-height: normal; /* 93.333% */
    letter-spacing: -0.072rem;
  }
  .main-menu__btn::after {
    content: "";
    width: 100%;
    height: 0.2rem;
    background: #330d03;
    position: absolute;
    bottom: -0.8rem;
  }
  .main-menu__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 3.2rem;
    margin-top: 6.4rem;
  }
  .menu-card:hover .menu-card__img {
    transform: translateX(-50%);
  }
  .menu-card:hover .menu-card__bg-circle {
    opacity: 0;
    transform: scale(0);
  }
  .menu-card:hover .menu-card__description {
    transition: height 0.5s linear;
    -webkit-line-clamp: 3;
    height: 12rem;
  }
  .menu-card__img {
    top: 4rem;
    width: 49.4rem;
    height: 41rem;
    left: 50%;
  }
  .menu-card__wrapper {
    align-self: flex-end;
    background: #b5bf3d;
    width: 100%;
    height: 52.2rem;
    padding: 4rem;
    display: flex;
  }
  .menu-card__info {
    width: 100%;
    align-self: flex-end;
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
  }
  .menu-card__info-footer {
    align-items: flex-end;
  }
  .menu-card__name {
    max-width: 30rem;
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
  .menu-card__price {
    padding-right: 1.4rem;
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
  .menu-card__description {
    max-width: 30rem;
    -webkit-line-clamp: 3;
    height: 12rem;
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .menu-card__btn {
    background: #330d03;
    color: #fff;
  }
}
.main-sale {
  width: 100%;
  max-width: 192rem;
  position: relative;
  margin: 0 auto 20rem;
  padding: 0 1rem;
}
.main-sale__inner.desktop {
  position: relative;
  display: flex;
  gap: 1rem;
}
.main-sale__inner.mobile {
  display: none;
}
.main-sale__header {
  position: absolute;
  top: -2rem;
  left: 5.1rem;
}
.main-sale__title {
  display: flex;
  align-items: center;
}
.main-sale__title strong {
  display: block;
  margin: 2rem 3rem 0 1.5rem;
  width: 8.7rem;
  height: 6.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-sale__title strong img {
  width: 100%;
  height: 100%;
}
.main-sale__footer {
  position: absolute;
  bottom: 0;
  left: 50%;
  z-index: 10;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  max-width: 192rem;
  width: 100%;
  padding: 0 16.5rem 0 6rem;
}
.main-sale__navigation.navigation {
  flex-direction: row;
}

.sale-slider-first.swiper {
  overflow: hidden;
  width: 70.7rem;
  margin-top: 12.7rem;
}
.sale-slider-first__slide.swiper-slide {
  position: relative;
  display: flex;
  gap: 6.4rem;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.sale-slide-first__wrapper {
  overflow: hidden;
  width: 100%;
  height: 53.9rem;
  position: relative;
  padding: 5rem 6rem;
}
.sale-slide-first__subtitle {
  max-width: 42.7rem;
  max-height: 16.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4rem;
  color: #ff6d2f;
  font-size: 9rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%; /* 81px */
  letter-spacing: -0.27rem;
  text-transform: uppercase;
}
.sale-slide-first__subtitle span {
  font-style: italic;
}
.sale-slide-first__coast {
  margin-bottom: 6.2rem;
  display: flex;
  align-items: center;
  color: #fff;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}
.sale-slide-first__coast span {
  padding-left: 0.5rem;
  position: relative;
  color: #fff4da;
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
}
.sale-slide-first__coast span sup {
  position: absolute;
  top: -0.5rem;
  right: -2rem;
  font-size: 3rem;
}
.sale-slide-first__coast strong {
  position: relative;
  display: block;
  margin-left: 3rem;
  color: #b79783;
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.09rem;
  text-transform: uppercase;
}
.sale-slide-first__coast strong::after {
  content: "";
  width: 100%;
  height: 0.2rem;
  background-color: #b79783;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.sale-slide-first__coast strong sup {
  position: absolute;
  top: -0.5rem;
  right: -1.5rem;
  font-size: 3rem;
}
.sale-slide-first__img {
  position: absolute;
  width: 100%;
  z-index: -1;
  height: 100%;
  top: 0;
  left: 0;
}

.sale-slider-second.swiper {
  overflow: hidden;
  width: 70.7rem;
}
.sale-slider-second__slide.swiper-slide {
  width: 100%;
  height: 80rem;
}

.sale-slide-second {
  overflow: hidden;
  position: relative;
  padding: 6rem;
}
.sale-slide-second__wrapper {
  margin-top: 7.4rem;
}
.sale-slide-second__date {
  color: #fff4da;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
  margin-bottom: 4.8rem;
}
.sale-slide-second__title {
  position: relative;
  margin-bottom: 6.7rem;
  max-width: 100%;
  max-height: 30rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  color: #fff4da;
  font-size: 9rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%; /* 81px */
  letter-spacing: -0.27rem;
  text-transform: uppercase;
}
.sale-slide-second__title strong {
  position: absolute;
  right: 2rem;
  bottom: 1rem;
  display: block;
  font-size: 4.5rem;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
}
.sale-slide-second__title strong span {
  font-style: italic;
  font-weight: 700;
}
.sale-slide-second__img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
}

.sale-slider-third.swiper {
  overflow: hidden;
  width: 44.9rem;
}
.sale-slider-third__slide.swiper-slide {
  width: 100%;
  height: 66.6rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4.5rem;
}

.sale-slide-third {
  position: relative;
}
.sale-slide-third__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sale-slide-third__title {
  margin-bottom: 2.7rem;
  max-width: 100%;
  color: #fff4da;
  text-align: center;
  font-size: 7rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%; /* 8.1rem */
  letter-spacing: -0.27rem;
  text-transform: uppercase;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sale-slide-third__btn {
  margin-bottom: 6.1rem;
  background-color: #330d03;
  color: #fff;
}
.sale-slide-third__img {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
}

@media (max-width: 48em) {
  .main-sale {
    position: relative;
  }
  .main-sale__inner.desktop {
    display: none;
  }
  .main-sale__inner.mobile {
    display: block;
  }
  .main-sale__header {
    position: static;
    margin-bottom: 8rem;
  }
  .main-sale__title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 5.6rem;
  }
  .main-sale__title strong {
    width: 6.6rem;
    height: 4.8rem;
    display: block;
    margin: 2rem 2rem 0 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .main-sale__title strong img {
    width: 100%;
    height: 100%;
  }
  .main-sale__footer {
    position: static;
    transform: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 3.2rem;
  }
  .main-sale__btn {
    position: relative;
    font-size: 3.6rem;
    line-height: normal; /* 93.333% */
    letter-spacing: -0.072rem;
    text-transform: uppercase;
  }
  .sale-slide-first__wrapper {
    width: 100%;
    height: 100%;
    padding: 9.2rem 4.8rem;
  }
  .sale-slide-first__subtitle {
    max-width: 75%;
    max-height: auto;
    font-size: 8rem;
    letter-spacing: -0.24rem;
  }
  .sale-slide-first__subtitle span {
    font-style: italic;
    font-weight: 700;
  }
  .sale-slide-first__coast {
    margin-bottom: 9.2rem;
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .sale-slide-first__coast span {
    padding-left: 1rem;
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
  .sale-slide-first__coast span sup {
    font-size: 3.5rem;
  }
  .sale-slide-first__coast strong {
    margin-left: 3.2rem;
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
  .sale-slide-first__coast strong sup {
    font-size: 3.5rem;
  }
  .sale-slider-second__slide.swiper-slide {
    height: 78rem;
  }
  .sale-slide-second {
    padding: 4.8rem;
  }
  .sale-slide-second__top-img {
    position: absolute;
    top: 4.3rem;
    right: 0;
    z-index: 2;
    width: 24rem;
    height: 16.6rem;
  }
  .sale-slide-second__wrapper {
    margin-top: 4.6rem;
  }
  .sale-slide-second__date {
    color: #fff4da;
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
    margin-bottom: 2.6rem;
  }
  .sale-slide-second__title {
    margin-bottom: 9.2rem;
    max-width: 100%;
    font-size: 8rem;
    letter-spacing: -0.24rem;
  }
  .sale-slide-second__title strong {
    max-width: 27.6rem;
    display: block;
    right: 8rem;
    bottom: -2rem;
    font-size: 4.8rem;
    line-height: 100%; /* 45px */
    letter-spacing: -0.18rem;
  }
  .sale-slide-second__title strong span {
    font-style: italic;
  }
  .sale-slide-third {
    position: relative;
    padding: 9.4rem 9.4rem 4rem;
  }
  .sale-slide-third__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .sale-slide-third__title {
    margin-bottom: 4.8rem;
    font-size: 8rem;
    letter-spacing: -0.24rem;
  }
  .sale-slide-third__btn {
    margin-bottom: 6rem;
  }
  .sale-slider-third__slide.swiper-slide {
    height: 78rem;
    padding: 10rem;
  }
  .sale-slider-mobile.swiper {
    width: 100%;
    height: 78rem;
    padding: 0 3.2rem;
    margin-bottom: 8rem;
  }
  .sale-slider-mobile__slide.swiper-slide {
    width: 63.6rem;
    height: 100%;
  }
}
.main-advantages__inner {
  max-width: 192rem;
  width: 100%;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.main-advantages__title {
  margin-bottom: 12.6rem;
}
.main-advantages__cards {
  position: relative;
  z-index: 200;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 20rem;
}
.main-advantages__card {
  flex: 1 1 auto;
  position: relative;
  height: 25.4rem;
}
.main-advantages__video {
  will-change: transform;
  cursor: pointer;
  width: 100%;
  height: 72rem;
  position: relative;
}
.main-advantages__video.play {
  cursor: default;
}
.main-advantages__video video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  z-index: 1;
  background-color: #330d03;
}
.main-advantages__video img {
  transition: opacity 0.3s linear;
  position: absolute;
  z-index: 2;
}
.main-advantages__video-play {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 3;
  transform: translate(-50%, -50%);
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  background-color: #fff4da;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-advantages__video-play svg {
  width: 2.4rem;
  height: 2.4rem;
}

.advantages-card {
  border: 0.1rem solid #4c0d00;
  background: #fff4da;
}
.advantages-card:hover .advantages-card__text {
  color: #ff6d2f;
  transition: color 0.3s linear;
}
.advantages-card:hover .advantages-card__icon {
  transition: transform 0.3s linear;
  transform: scale(0.9);
}
.advantages-card__icon {
  transition: transform 0.3s linear;
  position: absolute;
  left: 4rem;
  top: -6.2rem;
}
.advantages-card__icon--zoom {
  width: 21.6rem;
  height: 26.9rem;
}
.advantages-card__icon--star {
  width: 24rem;
  height: 24rem;
}
.advantages-card__icon--shield {
  width: 20.6rem;
  height: 24rem;
}
.advantages-card__bg {
  position: absolute;
  top: 0;
  right: 0.8rem;
  z-index: 1;
  overflow: hidden;
  width: 32.9rem;
  height: 9.4rem;
}
.advantages-card__bg img {
  width: 32.9rem;
  height: 26.9rem;
  position: absolute;
  bottom: 0;
  left: 0;
}
.advantages-card__text {
  cursor: default;
  transform-origin: center top;
  transition: color 0.3s linear;
  width: 22.9rem;
  max-height: 9rem;
  overflow: hidden;
  position: absolute;
  right: 5.8rem;
  bottom: 4rem;
  color: #330d03;
  text-align: center;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

@media (max-width: 48em) {
  .main-advantages__inner {
    padding: 0 3.2rem;
  }
  .main-advantages__title {
    margin-bottom: 11.4rem;
  }
  .main-advantages__cards {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 9.8rem;
  }
  .main-advantages__card {
    width: 100%;
    flex: 1 1 auto;
    height: 36.4rem;
  }
  .main-advantages__video {
    height: 44.8rem;
  }
  .main-advantages__video video {
    object-fit: cover;
  }
  .main-advantages__video-play {
    width: 8.8rem;
    height: 8.8rem;
  }
  .main-advantages__video-play svg {
    width: 3rem;
    height: 3rem;
  }
  .advantages-card {
    border: 0.2rem solid #4c0d00;
  }
  .advantages-card__icon {
    position: absolute;
    left: 4rem;
    top: -4rem;
  }
  .advantages-card__icon--zoom {
    width: 26rem;
    height: 32rem;
  }
  .advantages-card__icon--star {
    width: 28rem;
    height: 28rem;
  }
  .advantages-card__icon--shield {
    width: 24rem;
    height: 28rem;
  }
  .advantages-card__bg {
    right: -0.5rem;
    width: 35.2rem;
    height: 10rem;
  }
  .advantages-card__bg img {
    width: 100%;
    height: 27.9rem;
  }
  .advantages-card__text {
    width: 23.4rem;
    max-height: 9.6rem;
    right: 6.6rem;
    bottom: 4rem;
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
}
.main-reviews__inner {
  max-width: 192rem;
  width: 100%;
  margin: 0 auto;
}
.main-reviews__header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6.3rem;
  margin-bottom: 6.4rem;
}
.main-reviews__navigation.navigation.desktop {
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
}
.main-reviews__title {
  display: flex;
  flex: 1 1 auto;
  margin-left: 41.1rem;
}
.main-reviews__title strong {
  display: block;
  width: 12rem;
  min-height: 8rem;
  margin: 1.8rem 4rem 0;
}
.main-reviews__wrapper {
  padding-top: 8.7rem;
  position: relative;
}
.main-reviews__wrapper::after {
  content: "";
  width: 64rem;
  height: 64rem;
  background-color: #b5bf3d;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
}
.main-reviews__wrapper::before {
  content: "";
  width: 100%;
  height: 36rem;
  position: absolute;
  bottom: 6.5rem;
  z-index: -1;
  background: url(../assets/images/icons/review-line-bg.svg) center/cover no-repeat;
}
.main-reviews__slider {
  overflow: hidden;
  height: 63.5rem;
}
.main-reviews__slider-wrapper.swiper-wrapper {
  width: 100%;
}
.main-reviews__slider-slide.swiper-slide {
  width: 59.1rem;
  height: 43rem;
  cursor: pointer;
}
.main-reviews__footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4.8rem;
  margin: 0 auto;
}
.main-reviews__subtitle {
  color: #330d03;
  text-align: center;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
}
.main-reviews__links-wrapper {
  display: flex;
  gap: 4rem;
}
.main-reviews__link {
  height: 8rem;
}

.review-slide__icon {
  position: absolute;
  top: 0;
  left: 4rem;
  z-index: 2;
  width: 9.6rem;
  height: 9.6rem;
  border-radius: 50%;
  background: #330d03;
  display: flex;
  align-items: center;
  justify-content: center;
}
.review-slide__icon img {
  width: 4rem;
  height: 4rem;
}
.review-slide__date {
  position: absolute;
  right: 4rem;
  top: 1.2rem;
  color: #330d03;
  text-align: center;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}
.review-slide__wrapper {
  width: 100%;
  position: relative;
  align-self: flex-end;
  padding: 4.5rem 4rem 3rem;
  border: 0.1rem solid #330d03;
  background: #fff4da;
  height: 39.2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.review-slide__main {
  display: flex;
  flex-direction: column;
  gap: 4.8rem;
}
.review-slide__name {
  color: #330d03;
  text-align: center;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
}
.review-slide__transform {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  transition: all 0.6s linear;
  top: 0;
}
.review-slide__content {
  width: 100%;
  overflow: hidden;
  color: #330d03;
  text-align: center;
  text-overflow: ellipsis;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.review-slide__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.review-slide__footer::after {
  content: "";
  width: 18.8rem;
  height: 18.8rem;
  border-radius: 50%;
  background-color: #ff6d2f;
  position: absolute;
  right: -7.6rem;
  top: -6.1rem;
}
.review-slide__address {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.review-slide__address span {
  display: block;
  width: 2.4rem;
  height: 2.4rem;
}
.review-slide__address strong {
  display: block;
  color: #330d03;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}
.review-slide__rate {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.review-slide__rate span {
  display: block;
  width: 2.4rem;
  height: 2.4rem;
}
.review-slide__rate strong {
  color: #fff4da;
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
}

.review-link {
  display: flex;
}
.review-link__text {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding: 2.4rem;
  border: 0.1rem solid #330d03;
  border-right: 0;
}
.review-link__text span {
  display: block;
  width: 3.2rem;
  height: 3.2rem;
}
.review-link__text strong {
  color: #330d03;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
}
.review-link__rate {
  background: #ff6d2f;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 1.35rem;
}
.review-link__rate span {
  display: block;
  width: 2.4rem;
  height: 2.4rem;
}
.review-link__rate strong {
  color: #fff4da;
  text-align: center;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}

@media (max-width: 48em) {
  .main-reviews {
    overflow: hidden;
  }
  .main-reviews__inner {
    max-width: 192rem;
    width: 100%;
    margin: 0 auto;
  }
  .main-reviews__header {
    padding: 0 3.2rem;
    margin-bottom: 8rem;
  }
  .main-reviews__navigation.navigation.desktop {
    display: none;
  }
  .main-reviews__title {
    justify-content: center;
    margin-left: 0;
  }
  .main-reviews__title strong {
    width: 9rem;
    min-height: 6.2rem;
    margin: 1.3rem 2.2rem 0;
  }
  .main-reviews__wrapper {
    padding: 4.8rem 0 9.2rem;
    margin-bottom: 6.4rem;
    position: relative;
  }
  .main-reviews__wrapper::after {
    width: 75rem;
    height: 75rem;
  }
  .main-reviews__wrapper::before {
    display: none;
  }
  .main-reviews__slider {
    height: 61rem;
    padding: 0 3.2rem;
  }
  .main-reviews__slider-slide.swiper-slide {
    width: 68.4rem;
    height: 100%;
  }
  .main-reviews__footer {
    overflow: auto;
    align-items: flex-start;
    gap: 0;
    padding: 0 3.2rem;
  }
  .main-reviews__footer-mobile.mobile {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8rem;
  }
  .main-reviews__subtitle {
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
    margin-bottom: 4.8rem;
  }
  .main-reviews__links {
    overflow: auto;
    padding: 0 3.2rem;
  }
  .main-reviews__links-wrapper {
    width: max-content;
    gap: 1.6rem;
  }
  .main-reviews__link {
    height: 9.2rem;
  }
  .review-slide__icon {
    left: 6.4rem;
    width: 14rem;
    height: 14rem;
  }
  .review-slide__icon img {
    width: 6rem;
    height: 6rem;
  }
  .review-slide__date {
    right: 6.4rem;
    top: 3.8rem;
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .review-slide__wrapper {
    padding: 10.4rem 6.4rem 6.4rem;
    height: 56.6rem;
  }
  .review-slide__name {
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
  .review-slide__content {
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .review-slide__footer::after {
    content: "";
    width: 23.4rem;
    height: 23.4rem;
    right: -10.4rem;
    top: -7rem;
  }
  .review-slide__address {
    gap: 1.2rem;
  }
  .review-slide__address span {
    width: 3.2rem;
    height: 3.2rem;
  }
  .review-slide__address strong {
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .review-slide__rate {
    gap: 0.8rem;
  }
  .review-slide__rate span {
    width: 3.2rem;
    height: 3.2rem;
  }
  .review-slide__rate strong {
    font-size: 3.2rem;
    line-height: 5.6rem; /* 127.273% */
  }
  .review-link__text {
    gap: 1.6rem;
    padding: 2.4rem;
    border: 0.2rem solid #330d03;
    border-right: 0;
  }
  .review-link__text span {
    width: 4.8rem;
    height: 4.8rem;
  }
  .review-link__text strong {
    font-size: 3.2rem;
    line-height: normal; /* 116.667% */
    letter-spacing: 0.288rem;
  }
  .review-link__rate {
    gap: 0.8rem;
    padding: 3rem 2rem;
  }
  .review-link__rate span {
    width: 3.2rem;
    height: 3.2rem;
  }
  .review-link__rate strong {
    font-size: 3.2rem;
    line-height: 5.6rem; /* 155.556% */
    letter-spacing: 0;
  }
}
.main-map__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 192rem;
  width: 100%;
  margin: 0 auto;
  padding: 0 1rem;
  gap: 8rem;
}
.main-map__title {
  display: flex;
  align-items: center;
}
.main-map__title strong {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  margin-right: 0.6rem;
  width: 11.5rem;
  height: 12.3rem;
}
.main-map__title strong img {
  width: 7.6rem;
  height: 9.8rem;
  transform: rotate(30deg);
}
.main-map__wrapper {
  position: relative;
  display: flex;
  width: 100%;
  gap: 1rem;
}
.main-map__wrapper::after {
  content: "";
  width: 166.1rem;
  height: 67.8rem;
  border: 0.1rem solid #330d03;
  position: absolute;
  right: 0;
  top: -3.3rem;
  z-index: -1;
}
.main-map__map {
  position: relative;
  width: 125.4rem;
  height: 61.4rem;
  background-color: #919191;
}
.main-map__map-header {
  width: 100%;
  height: 9.6rem;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(51, 13, 3, 0.1);
  backdrop-filter: blur(0.4rem);
}
.main-map__map-nav {
  display: flex;
  align-items: center;
  gap: 8.8rem;
}
.main-map__map-btn {
  font-size: 3rem;
  color: rgba(255, 255, 255, 0.7);
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 93.333% */
  letter-spacing: -0.06rem;
  text-transform: uppercase;
}
.main-map__map-content {
  width: 100%;
  height: 100%;
}
.main-map__slider {
  overflow: hidden;
  width: 50.2rem;
  height: 61.4rem;
}
.main-map__slider-slide.swiper-slide {
  width: 100%;
  height: 100%;
  border: 0.1rem solid #330d03;
  background: #fff4da;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}
.main-map__slider-navigation {
  position: absolute;
  bottom: 0;
  right: 2.4rem;
}
.main-map__slider-fraction.swiper-pagination-fraction {
  width: max-content;
  height: auto;
  position: absolute;
  top: 13.4rem;
  left: unset;
  right: 3.8rem;
  z-index: -1;
  color: #330d03;
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
}

.map-btn {
  position: relative;
  transition: color 0.3s linear;
}
.map-btn:not(:first-child) {
  padding-left: 1.6rem;
}
.map-btn::after {
  content: "";
  transition: width 0.2s linear;
  width: 0;
  height: 0.2rem;
  background-color: #fff;
  position: absolute;
  bottom: -0.4rem;
  left: 50%;
  transform: translateX(-50%);
}
.map-btn span {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
}
.map-btn.active {
  color: #fff;
}
.map-btn.active::after {
  width: 100%;
  transition: width 0.2s linear;
}
.map-btn:hover {
  transition: color 0.3s linear;
  color: #fff;
}
.map-btn span {
  position: absolute;
}
.map-btn--shawerma span {
  background-color: #ff6d2f;
}
.map-btn--fastfood span {
  background-color: #b5bf3d;
}
.map-btn--culinary span {
  background-color: #fff4da;
}

.map-slide__img {
  width: 100%;
  height: 29.5rem;
}
.map-slide__content {
  overflow: hidden;
  flex: 1 1 auto;
  padding: 2.4rem;
  display: flex;
  flex-direction: column;
}
.map-slide__type {
  color: #330d03;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
  margin-bottom: 1.2rem;
}
.map-slide__type span {
  display: inline-block;
  margin-right: 0.8rem;
  vertical-align: middle;
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
}
.map-slide__address {
  color: #330d03;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 2rem;
}
.map-slide__time {
  color: #330d03;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
  margin-bottom: 2rem;
}
.map-slide__underground {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem 2.4rem;
  margin-bottom: 3.9rem;
}
.map-slide__underground p {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: #330d03;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}
.map-slide__underground p span {
  width: 2.3rem;
  height: 1.9rem;
}

.map-slide--fastfood .map-slide__type span {
  background: #b5bf3d;
}

.map-slide--shawerma .map-slide__type span {
  background: #ff6d2f;
}

.map-slide--culinary .map-slide__type span {
  background: rgba(51, 13, 3, 0.3);
}

.map-slide--red .map-slide__type span {
  background: #ff0000;
}

.map-slide--dark-red .map-slide__type span {
  background: #cd5c5c;
}

.map-slide--brick .map-slide__type span {
  background: #8b0000;
}

.map-slide--orange .map-slide__type span {
  background: #ffa500;
}

.map-slide--dark-orange .map-slide__type span {
  background: #ff8c00;
}

.map-slide--golden .map-slide__type span {
  background: #ff4500;
}

.map-slide--yellow .map-slide__type span {
  background: #ffff00;
}

.map-slide--sunny .map-slide__type span {
  background: #ffd700;
}

.map-slide--amber .map-slide__type span {
  background: #ffb900;
}

.map-slide--green .map-slide__type span {
  background: #008000;
}

.map-slide--dark-green .map-slide__type span {
  background: #006400;
}

.map-slide--forest .map-slide__type span {
  background: #004d00;
}

.map-slide--blue .map-slide__type span {
  background: #00bfff;
}

.map-slide--bluish-gray .map-slide__type span {
  background: #87ceeb;
}

.map-slide--royal .map-slide__type span {
  background: #1e90ff;
}

.map-slide--azure .map-slide__type span {
  background: #4169e1;
}

.map-slide--dark-blue .map-slide__type span {
  background: #00008b;
}

.map-slide--purple .map-slide__type span {
  background: #8a2be2;
}

.map-slide--lilac-purple .map-slide__type span {
  background: #9400d3;
}

.map-slide--indigo .map-slide__type span {
  background: #4b0082;
}

.map-slide--pink .map-slide__type span {
  background: #ffc0cb;
}

.map-slide--pink-purple .map-slide__type span {
  background: #ff69b4;
}

.map-slide--dustypink .map-slide__type span {
  background: #db7093;
}

.map-slide--black .map-slide__type span {
  background: #000000;
}

.map-slide--dark-gray .map-slide__type span {
  background: #111111;
}

.map-slide--charcoal-gray .map-slide__type span {
  background: #222222;
}

.map-slide--white .map-slide__type span {
  background: #ffffff;
}

.map-slide--light-gray .map-slide__type span {
  background: #f0f0f0;
}

.marker {
  cursor: pointer;
  width: 6.4rem;
  height: 6.4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.marker svg {
  width: 2.6rem;
  height: 3.755rem;
}

.marker.fastfood svg path {
  fill: #b5bf3d;
}

.marker.culinary svg path {
  fill: #fff4da;
}

.marker.shawerma svg path {
  fill: #ff6d2f;
}

.marker.red svg path {
  fill: #ff0000;
}

.marker.dark-red svg path {
  fill: #cd5c5c;
}

.marker.brick svg path {
  fill: #8b0000;
}

.marker.orange svg path {
  fill: #ffa500;
}

.marker.dark-orange svg path {
  fill: #ff8c00;
}

.marker.golden svg path {
  fill: #ff4500;
}

.marker.yellow svg path {
  fill: #ffff00;
}

.marker.sunny svg path {
  fill: #ffd700;
}

.marker.amber svg path {
  fill: #ffb900;
}

.marker.green svg path {
  fill: #008000;
}

.marker.dark-green svg path {
  fill: #006400;
}

.marker.forest svg path {
  fill: #004d00;
}

.marker.blue svg path {
  fill: #00bfff;
}

.marker.bluish-gray svg path {
  fill: #87ceeb;
}

.marker.royal svg path {
  fill: #1e90ff;
}

.marker.azure svg path {
  fill: #4169e1;
}

.marker.dark-blue svg path {
  fill: #00008b;
}

.marker.purple svg path {
  fill: #8a2be2;
}

.marker.lilac-purple svg path {
  fill: #9400d3;
}

.marker.indigo svg path {
  fill: #4b0082;
}

.marker.pink svg path {
  fill: #ffc0cb;
}

.marker.pink-purple svg path {
  fill: #ff69b4;
}

.marker.dustypink svg path {
  fill: #db7093;
}

.marker.black svg path {
  fill: #000000;
}

.marker.dark-gray svg path {
  fill: #111111;
}

.marker.charcoal-gray svg path {
  fill: #222222;
}

.marker.white svg path {
  fill: #ffffff;
}

.marker.light-gray svg path {
  fill: #f0f0f0;
}

.marker.active.fastfood {
  background-color: #b5bf3d;
}

.marker.active.fastfood svg path {
  fill: #fff4da;
}

.marker.active.culinary {
  background-color: #fff4da;
}

.marker.active.culinary svg path {
  fill: rgba(51, 13, 3, 0.3);
}

.marker.active.shawerma {
  background-color: #ff6d2f;
}

.marker.active.shawerma svg path {
  fill: #fff4da;
}

.marker.active.red {
  background-color: #ff0000;
}

.marker.active.dark-red {
  background-color: #cd5c5c;
}

.marker.active.brick {
  background-color: #8b0000;
}

.marker.active.orange {
  background-color: #ffa500;
}

.marker.active.dark-orange {
  background-color: #ff8c00;
}

.marker.active.golden {
  background-color: #ff4500;
}

.marker.active.yellow {
  background-color: #ffff00;
}

.marker.active.sunny {
  background-color: #ffd700;
}

.marker.active.amber {
  background-color: #ffb900;
}

.marker.active.green {
  background-color: #008000;
}

.marker.active.dark-green {
  background-color: #006400;
}

.marker.active.forest {
  background-color: #004d00;
}

.marker.active.blue {
  background-color: #00bfff;
}

.marker.active.bluish-gray {
  background-color: #87ceeb;
}

.marker.active.royal {
  background-color: #1e90ff;
}

.marker.active.azure {
  background-color: #4169e1;
}

.marker.active.dark-blue {
  background-color: #00008b;
}

.marker.active.purple {
  background-color: #8a2be2;
}

.marker.active.lilac-purple {
  background-color: #9400d3;
}

.marker.active.indigo {
  background-color: #4b0082;
}

.marker.active.pink {
  background-color: #ffc0cb;
}

.marker.active.pink-purple {
  background-color: #ff69b4;
}

.marker.active.dustypink {
  background-color: #db7093;
}

.marker.active.black {
  background-color: #000000;
}

.marker.active.dark-gray {
  background-color: #111111;
}

.marker.active.charcoal-gray {
  background-color: #222222;
}

.marker.active.white {
  background-color: #ffffff;
}

.marker.active.light-gray {
  background-color: #f0f0f0;
}

[class*="--map-copyrights"] {
  display: none !important;
}

[class*="--main-engine-container"] {
  filter: contrast(60%) grayscale(100%) invert(100%);
}

@media (max-width: 48em) {
  .main-map__inner {
    padding: 0 3.2rem;
  }
  .main-map__title strong {
    margin-right: 0;
    margin-left: -1rem;
    width: 10.2rem;
    height: 10.8rem;
  }
  .main-map__title strong img {
    width: 6.7rem;
    height: 8.6rem;
  }
  .main-map__wrapper {
    position: relative;
    display: flex;
    width: 100%;
    gap: 0;
  }
  .main-map__wrapper::after {
    display: none;
  }
  .main-map__map {
    width: 100%;
    height: 90rem;
  }
  .main-map__map-header {
    max-width: 100%;
    overflow: auto;
    width: 100%;
    height: auto;
    justify-content: flex-start;
    padding: 3.2rem 3.2rem 4.2rem;
  }
  .main-map__map-btn {
    width: max-content;
    font-size: 4rem;
    line-height: 100%;
    letter-spacing: -0.16rem;
  }
  .main-map__slider {
    display: none;
  }
  .map-btn {
    position: relative;
    transition: color 0.3s linear;
  }
  .map-btn:not(:first-child) {
    padding-left: 3.2rem;
  }
  .map-btn::after {
    bottom: -0.8rem;
  }
  .map-btn span {
    width: 1.6rem;
    height: 1.6rem;
  }
  .map-slide__img {
    width: 100%;
    height: 40rem;
  }
  .map-slide__content {
    padding: 3.2rem;
  }
  .map-slide__type {
    font-size: 3.6rem;
    line-height: normal; /* 116.667% */
    letter-spacing: 0.072rem;
    margin-bottom: 3.2rem;
  }
  .map-slide__type span {
    margin-right: 1.6rem;
    width: 1.6rem;
    height: 1.6rem;
  }
  .map-slide__address {
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
    margin-bottom: 3.2rem;
  }
  .map-slide__time {
    font-size: 3.6rem;
    line-height: normal; /* 116.667% */
    letter-spacing: 0.072rem;
    margin-bottom: 3.2rem;
  }
  .map-slide__underground {
    gap: 1rem 4.8rem;
    margin-bottom: 3.2rem;
  }
  .map-slide__underground p {
    gap: 1.6rem;
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .map-slide__underground p span {
    width: 4.6rem;
    height: 3.8rem;
  }
  .marker {
    width: 8.8rem;
    height: 8.8rem;
  }
  .marker svg {
    width: 3.6rem;
    height: 5.2rem;
  }
}
.contacts-banner__inner {
  display: flex;
  max-width: 192rem;
  margin: 0 auto;
  min-height: 70.9rem;
}
.contacts-banner__left {
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  max-width: 96rem;
  width: 100%;
  padding: 2rem 4.8rem;
  font-family: "Alumni Sans";
  text-transform: uppercase;
  border-bottom: 0.1rem solid #330d03;
}
.contacts-banner__left-title {
  color: #ff6d2f;
}
.contacts-banner__left-subtitle {
  color: #4c0d00;
}
.contacts-banner__right {
  display: flex;
  flex-wrap: wrap;
}
.contacts-banner__right-element {
  width: 50%;
  padding: 6rem;
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  border-bottom: 0.1rem solid #330d03;
  border-left: 0.1rem solid #330d03;
}
.contacts-banner__right-subtitle {
  text-transform: uppercase;
}
.contacts-banner__right-wrapper {
  color: rgba(51, 13, 3, 0.6);
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}
.contacts-banner__right-wrapper a:hover {
  text-decoration: underline;
}
.contacts-banner__right-name {
  color: #ff6d2f;
}
.contacts-banner__right-mail {
  text-transform: uppercase;
}
.contacts-banner__right-mail a:hover {
  text-decoration: underline;
}

@media (max-width: 48em) {
  .contacts-banner__inner {
    padding-top: 9.2rem;
    flex-direction: column;
    margin: 0;
    min-height: auto;
    gap: 8rem;
  }
  .contacts-banner__left {
    gap: 2rem;
    max-width: 100%;
    padding: 0 3.2rem;
    border-bottom: none;
  }
  .contacts-banner__left-title {
    font-size: 24rem;
    letter-spacing: -1.44rem;
  }
  .contacts-banner__left-subtitle {
    font-size: 8rem;
    letter-spacing: -0.24rem;
  }
  .contacts-banner__right {
    flex-direction: column;
    flex-wrap: wrap;
    padding: 0 3.2rem;
  }
  .contacts-banner__right-element {
    width: 100%;
    padding: 4.8rem 0;
    gap: 2rem;
    border: none;
    border-top: 0.2rem solid #330d03;
  }
  .contacts-banner__right-subtitle {
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
  .contacts-banner__right-wrapper {
    letter-spacing: -0.072rem;
  }
  .contacts-banner__right-name {
    color: #ff6d2f;
  }
  .contacts-banner__right-mail {
    text-transform: uppercase;
  }
  .contacts-banner__right-mail a:hover {
    text-decoration: underline;
  }
}
.vacancy-banner__inner {
  max-width: 192rem;
  width: 100%;
  margin: 0 auto;
}
.vacancy-banner__wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-left: 12rem;
  gap: 17.6rem;
}
.vacancy-banner__main {
  display: flex;
  flex-direction: column;
  gap: 20rem;
  padding-top: 12rem;
}
.vacancy-banner__top {
  display: flex;
  gap: 4.5rem;
}
.vacancy-banner__slider {
  overflow: hidden;
  min-width: 26rem;
  max-width: 35rem;
  max-height: 28rem;
}
.vacancy-banner__slider-slide.swiper-slide {
  padding-bottom: 0.5rem;
}
.vacancy-banner__footer {
  display: flex;
  gap: 2.125rem;
  padding-bottom: 4.6rem;
}
.vacancy-banner__footer span {
  display: block;
  color: rgba(51, 13, 3, 0.6);
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
}
.vacancy-banner__title span {
  display: block;
}
.vacancy-banner__title span.h1 {
  color: #ff6d2f;
  text-transform: uppercase;
  line-height: 60%;
}
.vacancy-banner__title span.h2 {
  margin-top: -12rem;
  margin-left: -1rem;
}
.vacancy-banner__image {
  position: absolute;
  right: 0;
  top: 0;
  width: 50%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
}
.vacancy-banner__buttons {
  display: flex;
  justify-content: space-between;
  width: 86.7rem;
}
.vacancy-banner__navigation {
  gap: 0.4rem;
  flex-direction: row-reverse;
}

.vacancy-banner-slide__header {
  color: rgba(51, 13, 3, 0.6);
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
  margin-bottom: 2.8rem;
}
.vacancy-banner-slide__main {
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
}
.vacancy-banner-slide__title {
  color: #330d03;
  margin-bottom: 1.2rem;
}
.vacancy-banner-slide__salary {
  color: #ff6d2f;
  margin-bottom: 6.6rem;
}
.vacancy-banner-slide__salary span {
  position: relative;
}
.vacancy-banner-slide__salary sup {
  position: static;
  font-size: 2.8rem;
  margin-left: 0.5rem;
}
.vacancy-banner-slide__btn::after {
  bottom: 0;
}

.vacancy-list__inner {
  max-width: 192rem;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.vacancy-list__title {
  display: flex;
  margin-bottom: 7rem;
}
.vacancy-list__title strong {
  display: block;
  width: 11rem;
  height: 8.9rem;
  margin: 0 1rem 0 2rem;
}
.vacancy-list__content {
  width: 100%;
  margin-bottom: 5.6rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5.6rem 1rem;
  padding: 0 1rem;
}

.vacancy-list-item {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  border: 0.1rem solid #330d03;
  transition: color 0.2s linear, border 0.2s linear;
}
.vacancy-list-item:hover {
  transition: color 0.2s linear, border 0.2s linear;
  border: 0.1rem solid #ff6d2f;
  color: #fff4da;
}
.vacancy-list-item:hover .vacancy-list-item__bg-circle {
  transition: opacity 0.6s linear, transform 0.8s linear;
  opacity: 1;
  transform: scale(20);
}
.vacancy-list-item:hover .vacancy-list-item__header {
  transition: border 0.2s linear;
  border-bottom: 0.1rem solid #fff4da;
}
.vacancy-list-item:hover .vacancy-list-item__title {
  transition: color 0.2s linear;
  color: #fff4da;
}
.vacancy-list-item:hover .vacancy-list-item__salary {
  transition: color 0.2s linear;
  color: #4c0d00;
}
.vacancy-list-item:hover .vacancy-list-item__experience {
  transition: color 0.2s linear;
  color: #fff4da;
}
.vacancy-list-item:hover .vacancy-list-item__btn .small-btn {
  transition: color 0.2s linear;
  color: #fff4da;
}
.vacancy-list-item:hover .vacancy-list-item__btn .small-btn::after {
  transition: width 0.3s linear, background 0.3s linear;
  background: #fff4da;
}
.vacancy-list-item__header {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 1.5rem 2.4rem;
  border-bottom: 0.1rem solid #330d03;
  transition: border 0.3s linear;
}
.vacancy-list-item__header span {
  text-align: right;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
}
.vacancy-list-item__content {
  padding: 2.4rem 2.4rem 3rem;
}
.vacancy-list-item__title {
  transition: color 0.2s linear;
  margin-bottom: 2.4rem;
  color: #330d03;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
}
.vacancy-list-item__salary {
  transition: color 0.2s linear;
  margin-bottom: 2.8rem;
  color: #ff6d2f;
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 93.333% */
  letter-spacing: -0.06rem;
  text-transform: uppercase;
}
.vacancy-list-item__salary span {
  position: relative;
}
.vacancy-list-item__salary sup {
  position: absolute;
  font-size: 1.8rem;
  right: -1.2rem;
  top: -0.2rem;
}
.vacancy-list-item__experience {
  transition: color 0.2s linear;
  margin-bottom: 3.6rem;
  color: rgba(51, 13, 3, 0.6);
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
}
.vacancy-list-item__btn .small-btn {
  transition: color 0.2s linear;
}
.vacancy-list-item__btn .small-btn::after {
  bottom: 0;
  transition: width 0.3s linear, background 0.3s linear;
}
.vacancy-list-item__bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.vacancy-list-item__bg-circle {
  transition: opacity 0.6s linear, transform 0.8s linear;
  position: absolute;
  border-radius: 50%;
  background-color: #ff6d2f;
  width: 5rem;
  height: 5rem;
  transform: scale(0);
  opacity: 0;
  z-index: 1;
}
.vacancy-list-item__bg-circle--first {
  bottom: 2.5rem;
  left: 6rem;
}
.vacancy-list-item__bg-circle--second {
  top: 5rem;
  left: 10rem;
}
.vacancy-list-item__bg-circle--third {
  top: 20rem;
  right: 5rem;
}

@media (max-width: 48em) {
  .vacancy-banner {
    overflow: hidden;
  }
  .vacancy-banner__inner {
    max-width: 100%;
    margin: 0;
    padding: 0 3.2rem;
  }
  .vacancy-banner__wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    padding-left: 0;
    gap: 0;
  }
  .vacancy-banner__main {
    display: flex;
    flex-direction: column;
    gap: 3.2rem;
    padding-top: 10.4rem;
  }
  .vacancy-banner__top {
    display: flex;
    flex-direction: column;
    gap: 4.8rem;
  }
  .vacancy-banner__top-wrapper {
    order: 3;
    display: flex;
    justify-content: space-between;
  }
  .vacancy-banner__slider {
    min-width: 30rem;
    max-width: 40rem;
  }
  .vacancy-banner__slider-slide.swiper-slide {
    padding-bottom: 1rem;
  }
  .vacancy-banner__footer.mobile {
    display: flex;
    flex-direction: column;
    text-align: right;
    gap: 2rem;
    padding-bottom: 0;
  }
  .vacancy-banner__footer span {
    font-size: 3.6rem;
    line-height: normal; /* 116.667% */
    letter-spacing: -0.072rem;
  }
  .vacancy-banner__title {
    order: 1;
  }
  .vacancy-banner__title span.h1 {
    font-size: 24rem;
    letter-spacing: -1.44rem;
  }
  .vacancy-banner__title span.h2 {
    font-size: 14rem;
    line-height: 90%; /* 63px */
    letter-spacing: -0.56rem;
    margin-left: 0;
    margin-top: -8rem;
  }
  .vacancy-banner__image {
    position: static;
    width: 100%;
    height: 35.2rem;
    order: 2;
  }
  .vacancy-banner__buttons {
    width: 100%;
  }
  .vacancy-banner__navigation {
    gap: 0.8rem;
    flex-direction: row;
  }
  .vacancy-banner-slide__header {
    font-size: 3.6rem;
    line-height: normal; /* 116.667% */
    letter-spacing: -0.072rem;
    margin-bottom: 2rem;
  }
  .vacancy-banner-slide__main {
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
  .vacancy-banner-slide__title {
    margin-bottom: 0.8rem;
  }
  .vacancy-banner-slide__salary {
    margin-bottom: 3.6rem;
  }
  .vacancy-banner-slide__salary sup {
    font-size: 3.2rem;
    margin-left: 0.8rem;
  }
  .vacancy-banner-slide__btn::after {
    bottom: -0.8rem;
  }
  .vacancy-list__inner {
    max-width: 100%;
    margin: 0;
  }
  .vacancy-list__title {
    margin-bottom: 8.4rem;
  }
  .vacancy-list__title strong {
    width: 8.6rem;
    height: 7rem;
    margin: 0 0.5rem 0 1.5rem;
  }
  .vacancy-list__content {
    margin-bottom: 6.4rem;
    gap: 6.4rem;
    padding: 0 3.2rem;
    grid-template-columns: 1fr;
  }
  .vacancy-list-item {
    border: 0.2rem solid #330d03;
  }
  .vacancy-list-item:hover {
    border: 0.2rem solid #ff6d2f;
  }
  .vacancy-list-item:hover .vacancy-list-item__header {
    border-bottom: 0.2rem solid #fff4da;
  }
  .vacancy-list-item__header {
    padding: 4rem;
    border-bottom: 0.2rem solid #330d03;
  }
  .vacancy-list-item__header span {
    font-size: 3.6rem;
    line-height: normal; /* 116.667% */
    letter-spacing: 0.072rem;
  }
  .vacancy-list-item__content {
    padding: 4rem 4rem 6rem;
  }
  .vacancy-list-item__title {
    margin-bottom: 3rem;
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
  .vacancy-list-item__salary {
    margin-bottom: 2rem;
    font-size: 3.6rem;
    line-height: normal; /* 93.333% */
    letter-spacing: 0.072rem;
  }
  .vacancy-list-item__salary sup {
    position: absolute;
    font-size: 3rem;
    right: -2rem;
    top: -0.2rem;
  }
  .vacancy-list-item__experience {
    margin-bottom: 8rem;
    font-size: 3.6rem;
    line-height: normal; /* 93.333% */
    letter-spacing: 0.072rem;
  }
}
.vacancy-detail__inner {
  padding-top: 10.5rem;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.vacancy-detail__main {
  max-width: 94.5rem;
  width: 100%;
}
.vacancy-detail__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 5.6rem;
  border-bottom: 0.1rem solid #330d03;
}
.vacancy-detail__header-main {
  display: flex;
  flex-direction: column;
  gap: 3.6rem;
  text-transform: uppercase;
}
.vacancy-detail__header-main--title {
  color: #ff6d2f;
}
.vacancy-detail__header-main--info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.vacancy-detail__header-main--info span {
  color: rgba(51, 13, 3, 0.6);
}
.vacancy-detail__header-main--salary span {
  position: relative;
}
.vacancy-detail__header-main--salary sup {
  position: absolute;
  font-size: 1.8rem;
  right: -1rem;
  top: -0.4rem;
}
.vacancy-detail__info {
  display: flex;
  flex-direction: column;
  gap: 3.6rem;
  padding-top: 5.6rem;
}
.vacancy-detail__info p {
  color: #330d03;
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
}
.vacancy-detail__info-list span {
  display: block;
  color: #330d03;
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
  margin-bottom: 2.4rem;
}
.vacancy-detail__info-list ul {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.vacancy-detail__info-list ul li {
  position: relative;
  padding-left: 2.6rem;
  color: #330d03;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}
.vacancy-detail__info-list ul li::after {
  content: "";
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 1;
  transform: translateY(-50%);
  background: #b5bf3d;
}
.vacancy-detail__slider {
  width: 46.8rem;
  overflow: hidden;
}
.vacancy-detail__slider-wrapper.swiper-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, auto);
  grid-auto-flow: column;
  margin-bottom: 1rem;
}
.vacancy-detail__slider-slide.swiper-slide {
  height: auto !important;
}
.vacancy-detail__slider-slide.swiper-slide .vacancy-list-item__experience {
  margin-bottom: 5rem;
}
.vacancy-detail__slider-slide.swiper-slide .vacancy-list-item__title {
  margin-bottom: 2.5rem;
}
.vacancy-detail__slider-navigation {
  flex-direction: row-reverse;
  justify-content: flex-end;
}

@media (max-width: 48em) {
  .vacancy-detail__inner {
    padding-top: 9.2rem;
    flex-direction: column;
    gap: 20rem;
  }
  .vacancy-detail__main {
    max-width: 100%;
  }
  .vacancy-detail__header {
    padding-bottom: 4.8rem;
    border-bottom: 0.2rem solid #330d03;
  }
  .vacancy-detail__header-main {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    text-transform: uppercase;
  }
  .vacancy-detail__header-main--title {
    margin-bottom: 4.8rem;
  }
  .vacancy-detail__header-main--title span {
    text-transform: uppercase;
    font-size: 8rem;
    letter-spacing: -0.24rem;
  }
  .vacancy-detail__header-main--info {
    gap: 2rem;
  }
  .vacancy-detail__header-main--salary sup {
    position: absolute;
    font-size: 3rem;
    right: -1.5rem;
    top: -1rem;
  }
  .vacancy-detail__info {
    display: flex;
    flex-direction: column;
    gap: 4.8rem;
    padding-top: 4.8rem;
  }
  .vacancy-detail__info p {
    font-size: 2.8rem;
    line-height: 4rem; /* 127.273% */
    letter-spacing: -0.056rem;
  }
  .vacancy-detail__info-list span {
    font-size: 3.6rem;
    line-height: 5.8rem; /* 127.273% */
    margin-bottom: 3.2rem;
  }
  .vacancy-detail__info-list ul {
    gap: 1.6rem;
  }
  .vacancy-detail__info-list ul li {
    position: relative;
    padding-left: 5.2rem;
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .vacancy-detail__info-list ul li::after {
    content: "";
    width: 2rem;
    height: 2rem;
    top: 1.2rem;
    transform: none;
  }
  .vacancy-detail__slider {
    position: relative;
    width: 68.6rem;
  }
  .vacancy-detail__slider-wrapper.swiper-wrapper {
    display: flex;
    margin-bottom: 6.4rem;
  }
  .vacancy-detail__slider-slide.swiper-slide {
    width: 68.6rem;
    height: auto !important;
  }
  .vacancy-detail__slider-slide.swiper-slide .vacancy-list-item__experience {
    margin-bottom: 8rem;
  }
  .vacancy-detail__slider-slide.swiper-slide .vacancy-list-item__title {
    margin-bottom: 3rem;
  }
  .vacancy-detail__slider-navigation {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .vacancy-detail__slider-navigation-more.mobile {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    bottom: 2.4rem;
    left: 0;
  }
}
.news-detail__inner {
  padding-top: 12rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.news-detail__header {
  display: flex;
  flex-direction: column;
  gap: 4rem;
  max-width: 90.3rem;
  width: 100%;
  margin-bottom: 6.4rem;
}
.news-detail__title {
  color: #ff6d2f;
  text-transform: uppercase;
}
.news-detail__date {
  text-transform: uppercase;
}
.news-detail__picture {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  margin-bottom: 8.1rem;
}
.news-detail__navigation-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.news-detail__navigation--next {
  right: 0;
}
.news-detail__navigation--prev {
  left: 0;
}
.news-detail__image {
  width: 142.2rem;
  height: 50.8rem;
}
.news-detail__content {
  max-width: 94.5rem;
  width: 100%;
  font-family: "Euclid Circular A";
  color: rgba(51, 13, 3, 0.6);
  font-style: normal;
  line-height: 2.8rem; /* 155.556% */
}
.news-detail__content div {
  font-size: 2.2rem;
  font-weight: 500;
}
.news-detail__content div:not(:last-child) {
  margin-bottom: 4rem;
}
.news-detail__content p {
  font-size: 1.8rem;
  letter-spacing: -0.036rem;
}
.news-detail__content p:not(:last-child) {
  margin-bottom: 4rem;
}

@media (max-width: 48em) {
  .news-detail__inner {
    position: relative;
    padding-top: 10.4rem;
    padding-bottom: 15.2rem;
  }
  .news-detail__header {
    gap: 2rem;
    max-width: 100%;
    margin-bottom: 4.8rem;
  }
  .news-detail__title {
    font-size: 8rem;
  }
  .news-detail__picture {
    position: static;
    margin-bottom: 4.8rem;
  }
  .news-detail__navigation-btn {
    position: absolute;
    top: unset;
    transform: translateY(0);
    bottom: 0;
  }
  .news-detail__image {
    width: 100%;
    height: 51.6rem;
  }
  .news-detail__image img {
    object-position: center;
  }
  .news-detail__content {
    max-width: 100%;
    line-height: 5.6rem; /* 155.556% */
  }
  .news-detail__content div {
    font-size: 3.6rem;
  }
  .news-detail__content div:not(:last-child) {
    margin-bottom: 3.2rem;
  }
  .news-detail__content p {
    font-size: 2.8rem;
    letter-spacing: -0.056rem;
    line-height: 4rem;
  }
  .news-detail__content p:not(:last-child) {
    margin-bottom: 3.2rem;
  }
}
.service-delivery .container {
  width: 189rem;
  padding: 0 1rem;
}
.service-delivery__wrapper {
  display: flex;
  justify-content: space-between;
}
.service-delivery__block {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6.1rem;
}
.service-delivery__title {
  color: #330d03;
  font-family: "Alumni Sans", sans-serif;
  font-size: 9rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%;
  letter-spacing: -2.7px;
  text-transform: uppercase;
  padding: 0 4rem;
}
.service-delivery__block-w {
  display: flex;
  padding-right: 6rem;
  padding-top: 1rem;
}
.service-delivery__partner {
  display: flex;
  align-items: center;
  margin-right: 5rem;
}
.service-delivery__partner-icon {
  width: 5.5rem;
  height: 5.5rem;
  margin-right: 1rem;
}
.service-delivery__partner-text {
  color: #1e1121;
  font-family: "Alumni Sans", sans-serif;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
}
.service-delivery__partner:last-child {
  margin-right: 0;
}
.service-delivery__image {
  width: 52rem;
  height: 52rem;
  border-radius: 50%;
  position: relative;
  z-index: 2;
}
.service-delivery__image img {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.service-delivery__inner {
  display: flex;
  width: 94.5rem;
  position: relative;
  margin-right: 1rem;
}
.service-delivery__inner:last-child {
  margin-right: 0;
}
.service-delivery__info {
  width: 52rem;
  height: 52rem;
  border-radius: 50%;
  position: relative;
  z-index: 1;
  border: 0.1rem solid #330d03;
  display: flex;
  justify-content: center;
  padding-left: 18rem;
  flex-direction: column;
  position: absolute;
  right: 0;
}
.service-delivery__info-number {
  color: #ff6d2f;
  font-family: "Alumni Sans", sans-serif;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
  margin-bottom: 2.8rem;
}
.service-delivery__info-text {
  font-family: "Euclid Circular A", sans-serif;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem;
  letter-spacing: -0.36px;
  max-width: 23.6rem;
}
.service-delivery__info-title {
  color: #330d03;
  font-family: "Alumni Sans", sans-serif;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
  margin-bottom: 2.8rem;
}
.service-delivery__btn--mob {
  display: none;
}

@media (max-width: 48em) {
  .service-delivery {
    margin-bottom: 10rem;
  }
  .service-delivery .container {
    width: 100%;
    padding: 0 3.2rem;
  }
  .service-delivery__title {
    padding: 0;
    font-size: 8rem;
    line-height: 90%;
    margin-bottom: 4rem;
    letter-spacing: -1.2px;
    text-transform: uppercase;
  }
  .service-delivery__block {
    flex-direction: column;
    margin-bottom: 8rem;
  }
  .service-delivery__block-w {
    padding-right: 0;
    padding-top: 0;
    display: flex;
    justify-content: space-between;
  }
  .service-delivery__partner {
    margin-right: 0;
    flex-direction: column;
  }
  .service-delivery__partner-icon {
    margin-right: 0;
    margin-bottom: 1.6rem;
    width: 8.8rem;
    height: 8.8rem;
  }
  .service-delivery__partner-text {
    font-size: 4.8rem;
    line-height: 100%;
  }
  .service-delivery__wrapper {
    flex-direction: column;
  }
  .service-delivery__inner {
    width: 100%;
    margin-right: 0;
    flex-direction: column;
    margin-bottom: 0rem;
  }
  .service-delivery__inner:last-child {
    margin-bottom: 0;
  }
  .service-delivery__image {
    width: 100%;
    height: 68.4rem;
  }
  .service-delivery__info {
    position: relative;
    width: 100%;
    height: 68.4rem;
    transition: 0.5s;
    padding: 6.4rem;
    top: -68.4rem;
  }
  .service-delivery__info-number {
    font-size: 4.8rem;
    position: absolute;
    top: 22rem;
  }
  .service-delivery__info-title {
    font-size: 4.8rem;
    margin-bottom: 3.2rem;
    padding-left: 5rem;
  }
  .service-delivery__info-text {
    font-family: "Euclid Circular A";
    font-size: 2.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: 4rem;
    letter-spacing: -0.28px;
    max-width: 100%;
  }
  .service-delivery__info.active {
    top: -14rem;
    transition: 0.5s;
  }
}
.main-delivery {
  margin-bottom: 18.5rem;
  padding-top: 21rem;
  position: relative;
}
.main-delivery__wrapper {
  display: flex;
}
.main-delivery__left-text {
  width: 19.3rem;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem;
  letter-spacing: -0.36px;
  color: #330d03;
  font-family: "Euclid Circular A", sans-serif;
}
.main-delivery__left {
  margin-right: 23.5rem;
  display: flex;
  flex-direction: column;
}
.main-delivery__right {
  display: flex;
}
.main-delivery__image {
  width: 70.6rem;
  height: 61.6rem;
  margin-right: 6rem;
}
.main-delivery__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-delivery__title {
  position: absolute;
  width: 83rem;
  right: 19rem;
  top: 9rem;
  margin-bottom: 12.1rem;
}
.main-delivery__title strong {
  display: block;
  color: #ff6d2f;
  font-family: "Alumni Sans";
  font-size: 25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%;
  letter-spacing: -1.5rem;
  text-transform: uppercase;
  position: relative;
  z-index: 2;
}
.main-delivery__title span {
  color: #330d03;
  font-family: "Literata";
  font-size: 19rem;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: -7.6px;
  position: absolute;
  z-index: 3;
  text-align: right;
  right: 0;
  top: 7.8rem;
}
.main-delivery__title--mob {
  display: none;
}
.main-delivery__inner {
  padding-top: 24.2rem;
}
.main-delivery__text {
  color: rgba(51, 13, 3, 0.6);
  font-family: "Euclid Circular A", sans-serif;
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem;
  width: 37.4rem;
  margin-bottom: 5.6rem;
}
.main-delivery__icon {
  width: 11.6rem;
  height: 8.4rem;
  position: absolute;
  right: 6rem;
  bottom: 0;
}
.main-delivery .btn {
  width: 19rem;
}
.main-delivery__scroll {
  margin-top: auto;
}
.main-delivery__left-text.mob {
  display: none;
}

@media (max-width: 48em) {
  .main-delivery {
    padding-top: 7.4rem;
  }
  .main-delivery .container {
    width: 100%;
    padding: 0 3.2rem;
  }
  .main-delivery__left {
    display: none;
  }
  .main-delivery__right {
    flex-direction: column;
  }
  .main-delivery__title {
    position: relative;
    top: initial;
    width: 100%;
    right: initial;
    margin-bottom: 7.8rem;
  }
  .main-delivery__title strong {
    font-size: 24rem;
    letter-spacing: -1.3rem;
  }
  .main-delivery__title span {
    left: 0;
    right: initial;
    font-size: 19rem;
    top: 8rem;
  }
  .main-delivery__title--mob {
    display: block;
  }
  .main-delivery__inner {
    padding-top: 2rem;
  }
  .main-delivery__inner .main-delivery__title {
    display: none;
  }
  .main-delivery__image {
    width: 100%;
    height: 35.2rem;
    margin-right: 0;
  }
  .main-delivery__wrapper {
    flex-direction: column;
  }
  .main-delivery__text {
    color: var(--dark-secondary, rgba(51, 13, 3, 0.6));
    font-family: "Euclid Circular A";
    font-size: 2.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: 4rem;
    letter-spacing: -0.28px;
    width: 100%;
  }
  .main-delivery__left-text.mob {
    display: block;
    color: var(--dark, #330d03);
    font-family: "Euclid Circular A";
    font-size: 2.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: 4rem;
    letter-spacing: -0.28px;
    width: 100%;
    margin-bottom: 2rem;
  }
  .main-delivery .btn {
    width: auto;
  }
}
.sliders-delivery {
  overflow: hidden;
}
.sliders-delivery .container {
  width: 190rem;
  padding: 0 1rem;
}
.sliders-delivery__block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8.3rem;
  padding: 0 5rem;
}
.sliders-delivery__block .btn {
  width: 16.7rem;
}
.sliders-delivery__btn--mob {
  display: none;
}
.sliders-delivery__title {
  color: #330d03;
  font-family: "Literata", sans-serif;
  font-size: 8rem;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
  letter-spacing: -1.6px;
  display: flex;
}
.sliders-delivery__title-icon {
  width: 10rem;
  height: 10rem;
  margin: 0 3rem;
}
.sliders-delivery__title-icon img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.sliders-delivery__navigation {
  display: flex;
  flex-direction: initial;
}
.sliders-delivery__swiper {
  margin-bottom: 19rem;
}
.sliders-delivery__swiper:last-child {
  margin-bottom: 0;
}

@media (max-width: 48em) {
  .sliders-delivery .container {
    width: 100%;
    padding: 0;
  }
  .sliders-delivery__block {
    margin-bottom: 8rem;
    padding: 0;
  }
  .sliders-delivery__block .btn {
    display: none;
  }
  .sliders-delivery__navigation {
    display: none;
  }
  .sliders-delivery__title {
    font-size: 5.6rem;
    justify-content: center;
    margin: 0 auto;
    line-height: 124%;
  }
  .sliders-delivery__title-icon {
    width: 8.8rem;
    height: 8.8rem;
  }
  .sliders-delivery__swiper {
    margin-bottom: 6.4rem;
    padding-left: 3.2rem;
  }
  .sliders-delivery__btn--mob {
    display: flex;
    width: 20rem;
    margin: 0 auto;
    margin-bottom: 20rem;
  }
  .sliders-delivery__btn--mob:last-child {
    margin-bottom: 0;
  }
}
.delivery-box {
  padding: 7rem 6rem;
  width: 93rem;
  height: 61rem;
  position: relative;
  display: block;
  overflow: hidden;
}
.delivery-box__par {
  display: flex;
  align-items: center;
  margin-bottom: 2.4rem;
  position: relative;
  z-index: 2;
}
.delivery-box__par-icon {
  width: 3.7rem;
  height: 3.7rem;
  margin-right: 0.8rem;
}
.delivery-box__par-text {
  color: #fff4da;
  font-family: "Alumni Sans", sans-serif;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  text-transform: uppercase;
}
.delivery-box__date {
  color: #fff4da;
  margin-bottom: 2.4rem;
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
  position: relative;
  z-index: 2;
}
.delivery-box__title {
  font-family: "Alumni Sans";
  font-size: 9rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%;
  margin-bottom: 2.4rem;
  text-transform: uppercase;
  position: relative;
  z-index: 2;
}
.delivery-box__title span {
  font-style: italic;
  font-size: 7.8rem;
}
.delivery-box__price-block {
  display: flex;
  margin-bottom: 2.4rem;
  position: relative;
  z-index: 2;
}
.delivery-box__image-m {
  display: none;
}
.delivery-box__image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
  left: 0;
}
.delivery-box__price {
  color: var(--beige, #fff4da);
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -0.18rem;
  text-transform: uppercase;
  padding-right: 1.5rem;
  margin-right: 1.2rem;
  position: relative;
  z-index: 2;
}
.delivery-box__price::before {
  position: absolute;
  content: "₽";
  color: var(--beige, #fff4da);
  font-family: "Alumni Sans";
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -0.18rem;
  text-transform: uppercase;
  right: 0;
}
.delivery-box__price b {
  color: var(--white, #fff);
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem;
  letter-spacing: -0.36px;
  margin-right: 0.4rem;
}
.delivery-box .btn {
  z-index: 2;
}
.delivery-box__sale {
  margin-top: 0.6rem;
  position: relative;
  color: rgba(255, 244, 218, 0.6);
  z-index: 2;
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -0.18rem;
  text-transform: uppercase;
  padding-right: 1.5rem;
  margin-right: 1.2rem;
  text-decoration: line-through;
}
.delivery-box__sale::before {
  position: absolute;
  content: "₽";
  color: rgba(255, 244, 218, 0.6);
  font-family: "Alumni Sans";
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -0.18rem;
  text-transform: uppercase;
  right: 0;
}
.delivery-box--first {
  background: #4c0d00;
}
.delivery-box--first .delivery-box__title {
  color: var(--orange, #ff6d2f);
}
.delivery-box--second {
  background: var(--green, #b5bf3d);
}
.delivery-box--second .delivery-box__title {
  color: var(--beige, #fff4da);
}
.delivery-box--second .delivery-box__price-block {
  display: none;
}
.delivery-box--second .delivery-box__dop-text {
  color: var(--beige, #fff4da);
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
  position: absolute;
  top: 36rem;
  left: 26.3rem;
}
.delivery-box--second .delivery-box__dop-text span {
  font-family: "Alumni", sans-serif;
}

@media (max-width: 48em) {
  .delivery-box {
    width: 63.8rem;
    height: 78rem;
    padding: 9.2rem 4.8rem;
  }
  .delivery-box__image {
    display: none;
  }
  .delivery-box__price-block {
    margin-bottom: 5rem;
  }
  .delivery-box__image-m {
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    left: 0;
  }
  .delivery-box__par {
    margin-bottom: 5rem;
  }
  .delivery-box__par-icon {
    width: 6rem;
    height: 6rem;
    margin-right: 1.6rem;
  }
  .delivery-box__par-text {
    font-size: 4rem;
  }
  .delivery-box__title {
    font-size: 8rem;
  }
  .delivery-box__dop-text {
    display: none;
    font-size: 4.8rem;
    top: 37rem;
    left: 25.3rem;
    width: 31rem;
    letter-spacing: -0.9 0.6rem;
  }
  .delivery-box__dop-text span {
    padding: 0 0.5rem;
  }
}
.stock {
  padding-top: 20rem;
}
.stock .container {
  width: 100%;
  padding: 0 1rem;
}
.stock__title {
  color: #330d03;
  font-family: "Literata", sans-serif;
  font-size: 8rem;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
  letter-spacing: -1.6px;
  display: flex;
  justify-content: center;
  margin-bottom: 7rem;
}
.stock__title br {
  display: none;
}
.stock__title-icon {
  width: 18.9rem;
  height: 9rem;
  margin: 0 3rem;
}
.stock__title-icon img {
  width: 100%;
  height: 100%;
}
.stock__inner {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 5.6rem;
}
.stock .delivery-box {
  margin-right: 1rem;
  margin-bottom: 5.6rem;
}
.stock .delivery-box:nth-child(2n) {
  margin-right: 0;
}
.stock .delivery-box:nth-last-child(-n+2) {
  margin-bottom: 0;
}
.stock__btn {
  color: var(--dark, #330d03);
  text-align: center;
  font-family: "Alumni Sans";
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  letter-spacing: -0.6px;
  text-transform: uppercase;
  position: relative;
  padding-bottom: 0.8rem;
  display: block;
  margin: 0 auto;
  margin-bottom: 21rem;
}
.stock__btn::before {
  position: absolute;
  content: "";
  width: 100%;
  background: var(--dark, #330d03);
  height: 0.2rem;
  bottom: 0;
}
.stock__btn-all {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin-bottom: 20rem;
}

@media (max-width: 48em) {
  .stock .container {
    padding: 0 3.2rem;
  }
  .stock__title {
    color: var(--dark, #330d03);
    font-family: "Literata";
    font-size: 5.6rem;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    letter-spacing: -0.56px;
    position: relative;
    text-align: left;
    flex-direction: column;
    display: flex;
  }
  .stock__title br {
    display: block;
  }
  .stock__title-icon {
    position: absolute;
    width: 16.8rem;
    height: 8rem;
    right: 0;
  }
  .stock .delivery-box {
    width: 100%;
    margin-right: 0;
    margin-bottom: 4rem;
  }
  .stock .delivery-box:nth-last-child(2n) {
    margin-bottom: 4rem;
  }
}
.detailed-promotions {
  padding-top: 10rem;
  margin-bottom: 20rem;
}
.detailed-promotions .container {
  width: 100%;
  padding-left: 6rem;
}
.detailed-promotions__wrapper {
  display: flex;
  justify-content: space-between;
}
.detailed-promotions__left {
  position: relative;
  padding-top: 6rem;
}
.detailed-promotions__title {
  display: flex;
  flex-direction: column;
  font-family: "Alumni Sans";
  font-size: 9rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%;
  letter-spacing: -0.27rem;
  text-transform: uppercase;
  margin-bottom: 4.8rem;
}
.detailed-promotions__title strong {
  display: block;
  color: var(--orange, #ff6d2f);
}
.detailed-promotions__title span {
  display: block;
}
.detailed-promotions__text {
  color: var(--choco, #4c0d00);
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem;
  letter-spacing: -0.36px;
  margin-bottom: 6.4rem;
  width: 70rem;
}
.detailed-promotions__block {
  display: flex;
  margin-bottom: 7.6rem;
}
.detailed-promotions__inner {
  display: flex;
  flex-direction: column;
  margin-right: 4rem;
}
.detailed-promotions__inner:last-child {
  margin-right: 0;
}
.detailed-promotions__foodcore, .detailed-promotions__time-title {
  color: var(--dark, #330d03);
  font-family: "Alumni Sans";
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  letter-spacing: 2.16px;
  text-transform: uppercase;
  position: relative;
  padding-left: 4rem;
  margin-bottom: 1.1rem;
}
.detailed-promotions__foodcore::before, .detailed-promotions__time-title::before {
  position: absolute;
  content: "";
  width: 2.4rem;
  height: 2.4rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
}
.detailed-promotions__time-title::before {
  background-image: url(./assets/images/stock/watch.svg);
}
.detailed-promotions__foodcore::before {
  background-image: url(./assets/images/stock/location.svg);
}
.detailed-promotions__address {
  display: flex;
  padding-left: 4rem;
}
.detailed-promotions__address span {
  display: block;
  color: var(--dark, #330d03);
  font-family: "Alumni Sans";
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  letter-spacing: 2.16px;
  text-transform: uppercase;
  margin-right: 1rem;
}
.detailed-promotions .link {
  color: var(--dark, #330d03);
  text-align: center;
  font-family: "Alumni Sans";
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  letter-spacing: -0.6px;
  text-transform: uppercase;
  position: relative;
  padding-bottom: 0.8rem;
  display: block;
  width: fit-content;
}
.detailed-promotions .link::before {
  position: absolute;
  content: "";
  width: 100%;
  background: var(--dark, #330d03);
  height: 0.2rem;
  bottom: 0;
}
.detailed-promotions__time {
  color: var(--dark, #330d03);
  font-family: "Alumni Sans";
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  letter-spacing: 2.16px;
  text-transform: uppercase;
  padding-left: 4rem;
}
.detailed-promotions__btns {
  display: flex;
  align-items: center;
}
.detailed-promotions__btns .btn {
  margin-right: 6.4rem;
}
.detailed-promotions__btns .link {
  height: fit-content;
}
.detailed-promotions__icon {
  position: absolute;
  width: 16.2rem;
  height: 13.2rem;
  right: -14.2rem;
  bottom: 10.2rem;
}
.detailed-promotions__slide {
  display: block;
}
.detailed-promotions__box {
  width: 70.6rem;
  height: 70rem;
  border-radius: 50rem 50rem 0px 0px;
  background: var(--green, #b5bf3d);
  position: relative;
  display: block;
  padding-top: 12.7rem;
}
.detailed-promotions__box-title {
  display: block;
  color: var(--dark, #330d03);
  text-align: center;
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
  margin-bottom: 2.4rem;
}
.detailed-promotions__box-text {
  color: var(--dark, #330d03);
  text-align: center;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem;
  letter-spacing: -0.36px;
}
.detailed-promotions__box-image {
  width: 36.3rem;
  height: 24.3rem;
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 37.7rem;
  transform: translate(-50%, 0);
}
.detailed-promotions__box-tri {
  position: absolute;
  z-index: 1;
  bottom: 0;
  width: 100%;
}
.detailed-promotions__swiper {
  position: relative;
  width: 95.3rem;
  overflow: hidden;
}
.detailed-promotions__navigation {
  display: flex;
  flex-direction: initial;
  position: absolute;
  right: 31rem;
  top: 46rem;
  z-index: 3;
  justify-content: space-between;
  width: 59rem;
}
.detailed-promotions__navigation-btn::after {
  background: var(--orange, #ff6d2f);
}
.detailed-promotions__btns--mob {
  display: none;
}

@media (max-width: 48em) {
  .detailed-promotions {
    padding-top: 4rem;
  }
  .detailed-promotions .container {
    width: 100%;
    padding-left: 3.2rem;
    padding-right: 0;
  }
  .detailed-promotions__left {
    position: initial;
  }
  .detailed-promotions__wrapper {
    flex-direction: column;
    position: relative;
  }
  .detailed-promotions__title {
    font-size: 8rem;
    line-height: 90%;
    margin-bottom: 2rem;
  }
  .detailed-promotions__text {
    color: var(--dark, #330d03);
    font-family: "Euclid Circular A";
    font-size: 2.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: 142.857%;
    letter-spacing: -0.028rem;
    margin-bottom: 4.8rem;
  }
  .detailed-promotions__block {
    flex-direction: column;
  }
  .detailed-promotions__inner {
    margin-right: 0;
    margin-bottom: 4.6rem;
  }
  .detailed-promotions__inner:last-child {
    margin-bottom: 0;
  }
  .detailed-promotions__foodcore {
    margin-bottom: 1.6rem;
    color: var(--dark, #330d03);
    font-family: "Alumni Sans";
    font-size: 3.6rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.36px;
    text-transform: uppercase;
    padding-left: 7rem;
  }
  .detailed-promotions__foodcore::before {
    width: 3.6rem;
    height: 4rem;
  }
  .detailed-promotions__address {
    padding-left: 7rem;
  }
  .detailed-promotions__address span {
    font-size: 3.6rem;
    font-style: normal;
    margin-right: 2.4rem;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.036rem;
    text-transform: uppercase;
  }
  .detailed-promotions__time-title {
    margin-bottom: 1.6rem;
    color: var(--dark, #330d03);
    font-family: "Alumni Sans";
    font-size: 3.6rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.36px;
    text-transform: uppercase;
    padding-left: 7rem;
  }
  .detailed-promotions__time-title::before {
    width: 4rem;
    height: 4rem;
  }
  .detailed-promotions__time {
    padding-left: 7rem;
    font-size: 3.6rem;
    font-style: normal;
    margin-right: 2.4rem;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.036rem;
    text-transform: uppercase;
  }
  .detailed-promotions__swiper {
    width: 100%;
    margin-bottom: 6.4rem;
  }
  .detailed-promotions .swiper-wrapper {
    height: auto;
  }
  .detailed-promotions__btns--mob {
    display: flex;
    justify-content: space-between;
    padding-right: 3.6rem;
  }
  .detailed-promotions__icon {
    display: none;
  }
  .detailed-promotions__btns--desk {
    display: none;
  }
  .detailed-promotions__box {
    width: 63.4rem;
    height: 77.6rem;
  }
  .detailed-promotions__box-title {
    font-size: 4.8rem;
    line-height: 100%;
    letter-spacing: -0.96px;
    margin-bottom: 2rem;
  }
  .detailed-promotions__box-text {
    font-size: 2.8rem;
    font-weight: 400;
    line-height: 142.857%;
    letter-spacing: -0.28px;
  }
  .detailed-promotions__box-image {
    width: 42.6rem;
    height: 28.6rem;
  }
  .detailed-promotions__navigation {
    display: none;
  }
}
.other-promotions .container {
  width: 100%;
  padding: 0 1rem;
}
.other-promotions__block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8.3rem;
  padding: 0 3.2rem;
}
.other-promotions__title {
  color: #330d03;
  font-family: "Literata", sans-serif;
  font-size: 8rem;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
  letter-spacing: -1.6px;
  display: flex;
}
.other-promotions__title-icon {
  width: 18rem;
  height: 13rem;
  margin: 0 1rem;
}
.other-promotions__title-icon img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.other-promotions__navigation {
  display: flex;
  flex-direction: initial;
}
.other-promotions__swiper {
  width: 100%;
}
.other-promotions__mob {
  display: none;
}

@media (max-width: 48em) {
  .other-promotions {
    overflow: hidden;
  }
  .other-promotions .container {
    width: 100%;
    padding: 0 3.6rem;
  }
  .other-promotions__swiper {
    display: none;
  }
  .other-promotions__block {
    padding: 0 3.2rem;
  }
  .other-promotions__mob {
    display: block;
  }
  .other-promotions__mob-wrapper {
    display: block;
  }
  .other-promotions__mob-wrapper .delivery-box {
    width: 100%;
    margin-bottom: 4rem;
  }
  .other-promotions__navigation {
    display: none;
  }
  .other-promotions__btn {
    display: none;
  }
  .other-promotions__title {
    font-size: 5.6rem;
    font-weight: 500;
    line-height: 110%;
    letter-spacing: -0.56px;
    margin: 0 auto;
    margin-bottom: 4rem;
  }
  .other-promotions__title-icon {
    width: 11rem;
    height: 8rem;
  }
  .other-promotions__mob-btn {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
  }
}
.about {
  margin-bottom: 20rem;
}
.about .container {
  width: 100%;
}
.about__wrapper {
  display: flex;
  flex-wrap: wrap;
}
.about__wrapper.mob {
  display: none;
}
.about__image {
  width: 50%;
  height: 84rem;
}
.about__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.about__one {
  padding-top: 11rem;
  padding-bottom: 18rem;
  padding-left: 0.8rem;
  position: relative;
  height: 84rem;
}
.about__one-title {
  margin-bottom: 5.5rem;
  position: relative;
}
.about__one-title strong {
  display: block;
  color: #ff6d2f;
  font-family: "Alumni Sans";
  font-size: 25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%;
  letter-spacing: -1.5rem;
  text-transform: uppercase;
  position: relative;
  z-index: 2;
}
.about__one-title span {
  color: #330d03;
  font-family: "Literata";
  font-size: 19rem;
  font-style: normal;
  font-weight: 400;
  line-height: 110%;
  letter-spacing: -7.6px;
  position: absolute;
  z-index: 3;
  text-align: right;
  right: 6rem;
  bottom: -3rem;
}
.about__one-text {
  color: var(--dark-secondary, rgba(51, 13, 3, 0.6));
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  width: 42.5rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem;
  margin-bottom: 8.6rem;
  margin-left: 1rem;
}
.about__one-icon {
  width: 22.9rem;
  height: 27.8rem;
  position: absolute;
  bottom: 20rem;
  right: 6rem;
}
.about__two {
  height: 100.1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.about__two-image {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
}
.about__two-age {
  color: var(--dark, #330d03);
  font-family: "Literata";
  font-size: 3rem;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
  letter-spacing: -0.6px;
  padding-top: 25rem;
}
.about__three {
  background: var(--green, #b5bf3d);
  padding: 19.3rem 6rem;
  height: 100.1rem;
}
.about__three-inner {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5.3rem;
}
.about__three-inner:last-child {
  margin-bottom: 0;
}
.about__three-title {
  color: var(--beige, #fff4da);
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -0.18rem;
  text-transform: uppercase;
}
.about__three-text {
  width: 41.7rem;
  color: var(--beige, #fff4da);
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem;
  letter-spacing: -0.36px;
}
.about__four {
  height: 54.8rem;
}
.about__four img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.about__six {
  height: 54.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.about__six-title {
  color: var(--choco, #4c0d00);
  text-align: center;
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
  margin-bottom: 3.2rem;
  width: 54.5rem;
  position: relative;
}
.about__six-title::before {
  position: absolute;
  content: "";
  width: 4.2rem;
  height: 3rem;
  background-image: url(./assets/images/icons/gright.svg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  right: -13.4rem;
  top: 4.7rem;
}
.about__six-title::after {
  position: absolute;
  content: "";
  width: 4.2rem;
  height: 3.3rem;
  background-image: url(./assets/images/icons/gleft.svg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  left: -15.1rem;
  top: 4.4rem;
}
.about__six-title span {
  color: var(--orange, #ff6d2f);
}
.about__six-text {
  color: var(--dark-secondary, rgba(51, 13, 3, 0.6));
  text-align: center;
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem;
  width: 43.5rem;
}
.about__one, .about__two, .about__three, .about__four, .about__six {
  width: 50%;
}

@media (max-width: 48em) {
  .about {
    padding-top: 4rem;
  }
  .about .container {
    padding: 0;
  }
  .about__wrapper {
    display: none;
  }
  .about__wrapper.mob {
    display: block;
  }
  .about__wrapper-content {
    display: flex;
    flex-direction: column;
  }
  .about__one {
    width: 100%;
    padding: 0;
    height: auto;
    margin-bottom: 2rem;
    padding: 0 3.2rem;
  }
  .about__one-title {
    margin-bottom: 7.2rem;
    padding-top: 9rem;
  }
  .about__one-title strong {
    font-size: 20rem;
    letter-spacing: -1.1rem;
  }
  .about__one-title span {
    left: 0;
    right: initial;
    font-size: 16rem;
    top: 14rem;
  }
  .about__one-text {
    width: 100%;
    font-size: 3.6rem;
    font-style: normal;
    font-weight: 500;
    line-height: 155.556%;
    margin-bottom: 0;
  }
  .about__image {
    width: 100%;
    height: 46rem;
    margin-bottom: 10rem;
    padding: 0 3.2rem;
  }
  .about__two {
    height: auto;
    width: 100%;
    margin-bottom: 10rem;
  }
  .about__two-age {
    font-size: 4.8rem;
    padding-top: 20rem;
  }
  .about__two-image {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
  }
  .about__three {
    width: 100%;
    height: auto;
    padding: 10rem 3.2rem;
  }
  .about__three-inner {
    flex-direction: column;
    margin-bottom: 6.4rem;
  }
  .about__three-inner:last-child {
    margin-bottom: 0;
  }
  .about__three-title {
    font-family: "Alumni Sans";
    font-size: 4.8rem;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    letter-spacing: -0.96px;
    text-transform: uppercase;
    margin-bottom: 2rem;
    width: 100%;
  }
  .about__three-text {
    width: 100%;
    font-size: 2.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: 142.857%;
    letter-spacing: -0.28px;
  }
  .about__six {
    width: 100%;
    padding: 10rem 3.2rem;
    padding-top: 6rem;
  }
  .about__six-title {
    font-size: 4.8rem;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    letter-spacing: -0.96px;
    text-transform: uppercase;
  }
  .about__six-title::before {
    right: -7rem;
  }
  .about__six-title::after {
    left: -7.1rem;
    top: 1.4rem;
  }
  .about__six-text {
    color: var(--dark-secondary, rgba(51, 13, 3, 0.6));
    text-align: center;
    font-family: "Euclid Circular A";
    font-size: 3.6rem;
    font-style: normal;
    font-weight: 500;
    line-height: 155.556%;
    width: 100%;
  }
  .about__four {
    width: 100%;
    height: 40rem;
  }
}
.menu-main {
  margin-bottom: 20rem;
}
.menu-main .container {
  width: 100%;
}
.menu-main__wrapper {
  display: flex;
}
.menu-main__left {
  width: 50%;
  background-image: url(./assets/images/menu/bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 90.7rem;
  padding: 3rem;
  position: relative;
}
.menu-main__swiper-title {
  height: 17rem;
  margin-bottom: 1rem;
  padding-left: 3rem;
  padding-top: 1rem;
}
.menu-main__swiper-wrapper-title {
  height: auto;
}
.menu-main__left-content {
  width: 48rem;
  height: 48rem;
  position: relative;
  border-radius: 50%;
  background: var(--beige, #fff4da);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 10.6rem;
}
.menu-main__left-swiper {
  overflow: hidden;
  width: 34.5rem;
  height: 28.7rem;
}
.menu-main__left-swiper-wrapper {
  height: auto;
}
.menu-main__left-slide-image {
  width: 34.5rem;
  height: 28.7rem;
}
.menu-main__left-slide-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.menu-main__navigation {
  position: absolute;
  width: 100%;
  flex-direction: initial;
  justify-content: space-between;
  width: 88%;
  left: 5rem;
  top: 50%;
  transform: translate(0, -50%);
}
.menu-main__swiper-title-slide-text {
  color: var(--white, #fff);
  font-family: "Alumni Sans";
  font-size: 9rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%; /* 81px */
  letter-spacing: -2.7px;
  text-transform: uppercase;
}
.menu-main__swiper-title-slide-text span {
  padding-left: 11rem;
  display: block;
}
.menu-main .link {
  color: var(--beige, #fff4da);
  text-align: center;
  font-family: "Alumni Sans";
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  letter-spacing: -0.6px;
  text-transform: uppercase;
  padding-bottom: 0.8rem;
  display: block;
  margin: 0 auto;
  position: relative;
  height: fit-content;
  width: fit-content;
}
.menu-main .link::before {
  position: absolute;
  content: "";
  width: 100%;
  background: var(--beige, #fff4da);
  height: 0.2rem;
  bottom: 0;
}
.menu-main__right {
  width: 50%;
  padding-top: 5rem;
  padding-left: 19rem;
  padding-right: 19rem;
}
.menu-main__right-title {
  margin-bottom: 11.2rem;
  position: relative;
}
.menu-main__right-title strong {
  display: block;
  color: #ff6d2f;
  font-family: "Alumni Sans";
  font-size: 25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%;
  letter-spacing: -1.5rem;
  text-transform: uppercase;
  position: relative;
  z-index: 2;
}
.menu-main__right-title span {
  color: #330d03;
  font-feature-settings: "dnom" on;
  font-family: "Literata";
  font-size: 19rem;
  font-style: normal;
  font-weight: 400;
  line-height: 110%;
  letter-spacing: -0.76rem;
  position: absolute;
  z-index: 3;
  text-align: right;
  right: -3rem;
  bottom: -3rem;
}
.menu-main__right-rang {
  display: flex;
  align-items: center;
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  justify-content: center;
  text-transform: uppercase;
  width: 100%;
  margin-bottom: 3.6rem;
}
.menu-main__right-rang p {
  position: relative;
  padding-right: 5.2rem;
  margin-right: 2.4rem;
}
.menu-main__right-rang p::before {
  position: absolute;
  content: "";
  right: 0;
  width: 2.8rem;
  height: 0.2rem;
  top: 50%;
  transform: translate(0, -50%);
  background: var(--choco, #4c0d00);
}
.menu-main__right-rang span {
  display: block;
  position: relative;
  padding-left: 3.3rem;
}
.menu-main__right-rang span::before {
  position: absolute;
  content: "";
  width: 2.7rem;
  height: 2.7rem;
  left: 0;
  background-image: url(./assets/images/menu/iconstar.svg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  top: 50%;
  transform: translate(0, -50%);
}
.menu-main__right-text {
  color: var(--dark-secondary, rgba(51, 13, 3, 0.6));
  text-align: center;
  margin-bottom: 7.2rem;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem;
  letter-spacing: -0.36px;
}
.menu-main__right-text p {
  margin-bottom: 2rem;
}
.menu-main__right-text p:last-child {
  margin-bottom: 0;
}
.menu-main__btn-slider {
  height: 4rem !important;
}
.menu-main__btn {
  margin: 0 auto;
  display: flex;
  width: fit-content;
  color: var(--white, #fff);
}
.menu-main__btn::after {
  background: var(--white, #fff);
}
.menu-main__fraction {
  color: var(--white, #fff);
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem;
  top: 17.4rem;
  position: absolute;
  left: 7.2rem;
}
.menu-main .navigation-btn {
  background-color: var(--beige, #fff4da);
}
.menu-main .navigation-btn:hover::after {
  background-color: #4c0d00;
}
.menu-main .navigation-btn:hover svg path {
  fill: var(--beige, #fff4da);
}
.menu-main .navigation-btn svg path {
  fill: #4c0d00;
}
.menu-main__btn-buy {
  display: none;
}
.menu-main__btn-right {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
}

@media (max-width: 48em) {
  .menu-main {
    padding-top: 9rem;
  }
  .menu-main__left {
    display: none;
  }
  .menu-main__swiper-title {
    display: none;
  }
  .menu-main__right {
    width: 100%;
    padding: 6.6rem 3.2rem;
  }
  .menu-main__right-title {
    margin-bottom: 8.5rem;
    position: relative;
    right: -3rem;
  }
  .menu-main__right-title strong {
    font-size: 20rem;
    font-style: normal;
    font-weight: 600;
    line-height: 90%;
    letter-spacing: -1.1rem;
    text-transform: uppercase;
  }
  .menu-main__right-title span {
    font-size: 18rem;
    letter-spacing: -2.96px;
    line-height: 90%;
    font-weight: 400;
    right: 7rem;
    bottom: -4rem;
  }
  .menu-main__right .main-menu__categories {
    max-width: 100%;
  }
  .menu-main__right-rang {
    font-size: 4.8rem;
  }
  .menu-main__right-text {
    font-size: 2.8rem;
  }
  .menu-main__btn-buy {
    display: flex;
    position: fixed;
    bottom: 3rem;
    right: 3.2rem;
    z-index: 10;
  }
}
.position-card {
  margin-bottom: 20rem;
}
.position-card .container {
  width: 100%;
}
.position-card__wrapper {
  display: flex;
  position: relative;
}
.position-card__left {
  padding-top: 6rem;
  padding-left: 6rem;
  width: 50%;
}
.position-card .small-btn {
  width: fit-content;
  position: absolute;
  right: 7.1rem;
  color: var(--beige, #fff4da);
  top: 6.8rem;
}
.position-card .small-btn:after {
  background: var(--beige, #fff4da);
}
.position-card__inner {
  display: flex;
  margin-bottom: 13.5rem;
}
.position-card__info {
  display: flex;
  flex-direction: column;
  margin-right: 2.6rem;
}
.position-card__info strong {
  color: var(--dark, #330d03);
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
  display: block;
}
.position-card__info span {
  color: var(--dark-secondary, rgba(51, 13, 3, 0.6));
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem;
  letter-spacing: -0.36px;
  display: block;
}
.position-card__info:last-child {
  margin-right: 0;
}
.position-card__title {
  display: flex;
  flex-direction: column;
  margin-bottom: 19.1rem;
  max-width: 55rem;
}
.position-card__title strong {
  display: block;
  color: var(--choco, #4c0d00);
  font-family: "Alumni Sans";
  font-size: 9rem;
  font-style: normal;
  font-weight: 600;
  line-height: 90%;
  letter-spacing: -2.7px;
  text-transform: uppercase;
}
.position-card__title span {
  display: block;
  color: var(--choco, #4c0d00);
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
}
.position-card__image {
  width: 59.7rem;
  height: 43.9rem;
  position: absolute;
  top: 13%;
  left: 32%;
}
.position-card__image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.position-card__description {
  background: var(--green, #b5bf3d);
  padding: 6rem;
  color: var(--dark, #330d03);
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem;
  letter-spacing: -0.36px;
  width: fit-content;
}
.position-card__description p {
  max-width: 30rem;
}
.position-card__block {
  display: flex;
  position: absolute;
  bottom: 7rem;
  left: 50%;
  transform: translate(-50%, 0);
}
.position-card__price {
  border: 0.12rem solid var(--green, #b5bf3d);
  width: 16.1rem;
  height: 7rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.position-card__price span {
  position: relative;
  color: var(--dark, #330d03);
  display: block;
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
  padding-right: 1rem;
}
.position-card__price span::before {
  position: absolute;
  content: "₽";
  font-family: "Alumni Sans";
  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
  right: 0;
}
.position-card__gram {
  width: 16.1rem;
  height: 7rem;
  background: var(--green, #b5bf3d);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--beige, #fff4da);
  text-align: center;
  font-family: "Alumni Sans";
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  letter-spacing: -0.6px;
  text-transform: uppercase;
}
.position-card__right {
  width: 50%;
}
.position-card__right-block {
  background: var(--choco, #4c0d00);
  width: 100%;
  height: 100%;
  padding-top: 22.2rem;
  padding-left: 27.8rem;
}
.position-card__right-title {
  color: var(--beige, #fff4da);
  font-family: "Alumni Sans";
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  letter-spacing: -0.6px;
  text-transform: uppercase;
  margin-bottom: 2.4rem;
}
.position-card__lists {
  display: grid;
  grid-template-columns: 1fr 2fr;
}
.position-card__item {
  display: flex;
  align-items: center;
  margin-bottom: 1.6rem;
}
.position-card__item-compound {
  color: var(--white, #fff);
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem;
  margin-right: 1rem;
}
.position-card__item-price {
  color: var(--white-secondary, rgba(255, 255, 255, 0.7));
  font-family: "Alumni Sans";
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  letter-spacing: 2.16px;
  text-transform: uppercase;
  position: relative;
  padding-right: 1rem;
}
.position-card__item-price::before {
  position: absolute;
  content: "₽";
  color: var(--white-secondary, rgba(255, 255, 255, 0.7));
  font-family: "Alumni Sans";
  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  text-transform: uppercase;
  right: 0;
}
.position-card__aside {
  position: absolute;
  width: 38.4rem;
  height: 32.4rem;
  background: var(--orange, #ff6d2f);
  padding: 6rem;
  right: 6rem;
  bottom: 0;
}
.position-card__aside-basket {
  color: var(--dark, #330d03);
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem;
  margin-bottom: 1.4rem;
}
.position-card__aside-name {
  color: var(--dark, #330d03);
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
  margin-bottom: 0rem;
}
.position-card__aside-price {
  color: var(--white-secondary, rgba(255, 255, 255, 0.7));
  font-family: "Alumni Sans";
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  letter-spacing: 2.16px;
  text-transform: uppercase;
  position: relative;
  padding-right: 1rem;
  margin-bottom: 2.9rem;
  width: fit-content;
}
.position-card__aside-price::before {
  position: absolute;
  content: "₽";
  right: 0;
}
.position-card__aside-image {
  width: 16.5rem;
  height: 17.4rem;
  position: absolute;
  bottom: 5.1rem;
  right: 6rem;
}
.position-card__aside-btn {
  background: none;
  border: 0.1rem solid var(--dark, #330d03);
}
.position-card__aside-btn:hover {
  border: 0.1rem solid var(--green, #b5bf3d);
}
.position-card__aside-btn:hover svg path {
  fill: var(--beige, #fff4da);
}
.position-card__aside-btn svg path {
  fill: #330d03;
}

@media (max-width: 48em) {
  .position-card .container {
    padding: 0;
    width: 100%;
  }
  .position-card__wrapper {
    flex-direction: column;
  }
  .position-card__left {
    width: 100%;
    padding: 10.8rem 3.6rem;
    display: flex;
    flex-direction: column;
  }
  .position-card .small-btn {
    position: relative;
    color: var(--dark, #330d03);
    right: initial;
    top: initial;
    left: initial;
    margin: initial;
    margin-bottom: 4rem;
  }
  .position-card .small-btn::after {
    background: var(--dark, #330d03);
  }
  .position-card__title {
    order: 1;
    margin-bottom: 2rem;
  }
  .position-card__title strong {
    font-size: 8rem;
    margin-bottom: 2rem;
    width: 100%;
    letter-spacing: -1.2px;
  }
  .position-card__title strong br {
    display: none;
  }
  .position-card__title span {
    font-size: 4.8rem;
  }
  .position-card__inner {
    order: 2;
    margin-bottom: 4.8rem;
  }
  .position-card__info {
    margin-right: 4.8rem;
  }
  .position-card__info strong {
    font-size: 4.8rem;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    letter-spacing: -0.96px;
  }
  .position-card__info span {
    font-size: 2.8rem;
    font-style: normal;
    font-weight: 400;
  }
  .position-card__image {
    position: initial;
    width: 100%;
    height: 50rem;
    order: 3;
    margin-bottom: 3.2rem;
  }
  .position-card__description {
    order: 4;
    width: 100%;
    padding: 3.2rem;
    font-size: 2.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: 142.857%;
    margin-bottom: 3.2rem;
  }
  .position-card__description p {
    width: 100%;
    max-width: 100%;
  }
  .position-card__block {
    position: initial;
    order: 5;
    transform: initial;
  }
  .position-card__price {
    width: 50%;
    height: 12rem;
  }
  .position-card__price span {
    font-size: 4.8rem;
    padding-right: 2rem;
  }
  .position-card__price span::before {
    font-size: 4rem;
  }
  .position-card__gram {
    width: 50%;
    height: 12rem;
  }
  .position-card__gram span {
    font-size: 4.8rem;
  }
  .position-card__right {
    width: 100%;
  }
  .position-card__right-block {
    padding: 10rem 3.2rem;
  }
  .position-card__right-title {
    font-size: 4.8rem;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    letter-spacing: -0.96px;
    text-transform: uppercase;
    margin-bottom: 4.8rem;
  }
  .position-card__aside {
    position: relative;
    margin-top: 10rem;
    width: 68.6rem;
    right: initial;
    bottom: initial;
    margin: 0 auto;
    margin-top: 10rem;
    display: block;
    height: auto;
  }
  .position-card__aside-basket {
    font-size: 3.6rem;
    margin-bottom: 4.8rem;
  }
  .position-card__aside-name {
    margin-bottom: 1.6rem;
    font-size: 4.8rem;
  }
  .position-card__aside-price {
    font-size: 4.8rem;
    padding-right: 3rem;
    margin-bottom: 4.4rem;
  }
  .position-card__aside-image {
    width: 22.5rem;
    height: 30.4rem;
  }
  .position-card__lists {
    grid-template-columns: 1fr;
  }
  .position-card__item {
    margin-bottom: 3.2rem;
  }
  .position-card__item-compound {
    font-size: 3.2rem;
    font-style: normal;
    font-weight: 500;
    line-height: 155.556%;
    margin-right: 1.6rem;
  }
  .position-card__item-price {
    font-size: 4.8rem;
  }
}
.vacancy-detail__inner {
  padding-top: 10.5rem;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.vacancy-detail__main {
  max-width: 94.5rem;
  width: 100%;
}
.vacancy-detail__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 5.6rem;
  border-bottom: 0.1rem solid #330d03;
}
.vacancy-detail__header-main {
  display: flex;
  flex-direction: column;
  gap: 3.6rem;
  text-transform: uppercase;
}
.vacancy-detail__header-main--title {
  color: #ff6d2f;
}
.vacancy-detail__header-main--info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.vacancy-detail__header-main--info span {
  color: rgba(51, 13, 3, 0.6);
}
.vacancy-detail__header-main--salary span {
  position: relative;
}
.vacancy-detail__header-main--salary sup {
  position: absolute;
  font-size: 1.8rem;
  right: -1rem;
  top: -0.4rem;
}
.vacancy-detail__info {
  display: flex;
  flex-direction: column;
  gap: 3.6rem;
  padding-top: 5.6rem;
}
.vacancy-detail__info p {
  color: #330d03;
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
}
.vacancy-detail__info-list span {
  display: block;
  color: #330d03;
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem; /* 127.273% */
  margin-bottom: 2.4rem;
}
.vacancy-detail__info-list ul {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.vacancy-detail__info-list ul li {
  position: relative;
  padding-left: 2.6rem;
  color: #330d03;
  font-family: "Euclid Circular A";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.8rem; /* 155.556% */
  letter-spacing: -0.036rem;
}
.vacancy-detail__info-list ul li::after {
  content: "";
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 1;
  transform: translateY(-50%);
  background: #b5bf3d;
}
.vacancy-detail__slider {
  width: 46.8rem;
  overflow: hidden;
}
.vacancy-detail__slider-wrapper.swiper-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, auto);
  grid-auto-flow: column;
  margin-bottom: 1rem;
}
.vacancy-detail__slider-slide.swiper-slide {
  height: auto !important;
}
.vacancy-detail__slider-slide.swiper-slide .vacancy-list-item__experience {
  margin-bottom: 5rem;
}
.vacancy-detail__slider-slide.swiper-slide .vacancy-list-item__title {
  margin-bottom: 2.5rem;
}
.vacancy-detail__slider-navigation {
  flex-direction: row-reverse;
  justify-content: flex-end;
}

@media (max-width: 48em) {
  .vacancy-detail__inner {
    padding-top: 9.2rem;
    flex-direction: column;
    gap: 20rem;
  }
  .vacancy-detail__main {
    max-width: 100%;
  }
  .vacancy-detail__header {
    padding-bottom: 4.8rem;
    border-bottom: 0.2rem solid #330d03;
  }
  .vacancy-detail__header-main {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    text-transform: uppercase;
  }
  .vacancy-detail__header-main--title {
    margin-bottom: 4.8rem;
  }
  .vacancy-detail__header-main--title span {
    text-transform: uppercase;
    font-size: 8rem;
    letter-spacing: -0.24rem;
  }
  .vacancy-detail__header-main--info {
    gap: 2rem;
  }
  .vacancy-detail__header-main--salary sup {
    position: absolute;
    font-size: 3rem;
    right: -1.5rem;
    top: -1rem;
  }
  .vacancy-detail__info {
    display: flex;
    flex-direction: column;
    gap: 4.8rem;
    padding-top: 4.8rem;
  }
  .vacancy-detail__info p {
    font-size: 2.8rem;
    line-height: 4rem; /* 127.273% */
    letter-spacing: -0.056rem;
  }
  .vacancy-detail__info-list span {
    font-size: 3.6rem;
    line-height: 5.8rem; /* 127.273% */
    margin-bottom: 3.2rem;
  }
  .vacancy-detail__info-list ul {
    gap: 1.6rem;
  }
  .vacancy-detail__info-list ul li {
    position: relative;
    padding-left: 5.2rem;
    font-size: 2.8rem;
    line-height: 4rem; /* 155.556% */
    letter-spacing: -0.056rem;
  }
  .vacancy-detail__info-list ul li::after {
    content: "";
    width: 2rem;
    height: 2rem;
    top: 1.2rem;
    transform: none;
  }
  .vacancy-detail__slider {
    position: relative;
    width: 68.6rem;
  }
  .vacancy-detail__slider-wrapper.swiper-wrapper {
    display: flex;
    margin-bottom: 6.4rem;
  }
  .vacancy-detail__slider-slide.swiper-slide {
    width: 68.6rem;
    height: auto !important;
  }
  .vacancy-detail__slider-slide.swiper-slide .vacancy-list-item__experience {
    margin-bottom: 8rem;
  }
  .vacancy-detail__slider-slide.swiper-slide .vacancy-list-item__title {
    margin-bottom: 3rem;
  }
  .vacancy-detail__slider-navigation {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .vacancy-detail__slider-navigation-more.mobile {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    bottom: 2.4rem;
    left: 0;
  }
}
.vacancy-banner__inner {
  max-width: 192rem;
  width: 100%;
  margin: 0 auto;
}
.vacancy-banner__wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-left: 12rem;
  gap: 17.6rem;
}
.vacancy-banner__main {
  display: flex;
  flex-direction: column;
  gap: 20rem;
  padding-top: 12rem;
}
.vacancy-banner__top {
  display: flex;
  gap: 4.5rem;
}
.vacancy-banner__slider {
  overflow: hidden;
  min-width: 26rem;
  max-width: 35rem;
  max-height: 28rem;
}
.vacancy-banner__slider-slide.swiper-slide {
  padding-bottom: 0.5rem;
}
.vacancy-banner__footer {
  display: flex;
  gap: 2.125rem;
  padding-bottom: 4.6rem;
}
.vacancy-banner__footer span {
  display: block;
  color: rgba(51, 13, 3, 0.6);
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
}
.vacancy-banner__title span {
  display: block;
}
.vacancy-banner__title span.h1 {
  color: #ff6d2f;
  text-transform: uppercase;
  line-height: 60%;
}
.vacancy-banner__title span.h2 {
  margin-top: -12rem;
  margin-left: -1rem;
}
.vacancy-banner__image {
  position: absolute;
  right: 0;
  top: 0;
  width: 50%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
}
.vacancy-banner__buttons {
  display: flex;
  justify-content: space-between;
  width: 86.7rem;
}
.vacancy-banner__navigation {
  gap: 0.4rem;
  flex-direction: row-reverse;
}

.vacancy-banner-slide__header {
  color: rgba(51, 13, 3, 0.6);
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
  margin-bottom: 2.8rem;
}
.vacancy-banner-slide__main {
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
}
.vacancy-banner-slide__title {
  color: #330d03;
  margin-bottom: 1.2rem;
}
.vacancy-banner-slide__salary {
  color: #ff6d2f;
  margin-bottom: 6.6rem;
}
.vacancy-banner-slide__salary span {
  position: relative;
}
.vacancy-banner-slide__salary sup {
  position: static;
  font-size: 2.8rem;
  margin-left: 0.5rem;
}
.vacancy-banner-slide__btn::after {
  bottom: 0;
}

.vacancy-list__inner {
  max-width: 192rem;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.vacancy-list__title {
  display: flex;
  margin-bottom: 7rem;
}
.vacancy-list__title strong {
  display: block;
  width: 11rem;
  height: 8.9rem;
  margin: 0 1rem 0 2rem;
}
.vacancy-list__content {
  width: 100%;
  margin-bottom: 5.6rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5.6rem 1rem;
  padding: 0 1rem;
}

.vacancy-list-item {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  border: 0.1rem solid #330d03;
  transition: color 0.2s linear, border 0.2s linear;
}
.vacancy-list-item:hover {
  transition: color 0.2s linear, border 0.2s linear;
  border: 0.1rem solid #ff6d2f;
  color: #fff4da;
}
.vacancy-list-item:hover .vacancy-list-item__bg-circle {
  transition: opacity 0.6s linear, transform 0.8s linear;
  opacity: 1;
  transform: scale(20);
}
.vacancy-list-item:hover .vacancy-list-item__header {
  transition: border 0.2s linear;
  border-bottom: 0.1rem solid #fff4da;
}
.vacancy-list-item:hover .vacancy-list-item__title {
  transition: color 0.2s linear;
  color: #fff4da;
}
.vacancy-list-item:hover .vacancy-list-item__salary {
  transition: color 0.2s linear;
  color: #4c0d00;
}
.vacancy-list-item:hover .vacancy-list-item__experience {
  transition: color 0.2s linear;
  color: #fff4da;
}
.vacancy-list-item:hover .vacancy-list-item__btn .small-btn {
  transition: color 0.2s linear;
  color: #fff4da;
}
.vacancy-list-item:hover .vacancy-list-item__btn .small-btn::after {
  transition: width 0.3s linear, background 0.3s linear;
  background: #fff4da;
}
.vacancy-list-item__header {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 1.5rem 2.4rem;
  border-bottom: 0.1rem solid #330d03;
  transition: border 0.3s linear;
}
.vacancy-list-item__header span {
  text-align: right;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
}
.vacancy-list-item__content {
  padding: 2.4rem 2.4rem 3rem;
}
.vacancy-list-item__title {
  transition: color 0.2s linear;
  margin-bottom: 2.4rem;
  color: #330d03;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 45px */
  letter-spacing: -0.18rem;
  text-transform: uppercase;
}
.vacancy-list-item__salary {
  transition: color 0.2s linear;
  margin-bottom: 2.8rem;
  color: #ff6d2f;
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 93.333% */
  letter-spacing: -0.06rem;
  text-transform: uppercase;
}
.vacancy-list-item__salary span {
  position: relative;
}
.vacancy-list-item__salary sup {
  position: absolute;
  font-size: 1.8rem;
  right: -1.2rem;
  top: -0.2rem;
}
.vacancy-list-item__experience {
  transition: color 0.2s linear;
  margin-bottom: 3.6rem;
  color: rgba(51, 13, 3, 0.6);
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem; /* 116.667% */
  letter-spacing: 0.216rem;
  text-transform: uppercase;
}
.vacancy-list-item__btn .small-btn {
  transition: color 0.2s linear;
}
.vacancy-list-item__btn .small-btn::after {
  bottom: 0;
  transition: width 0.3s linear, background 0.3s linear;
}
.vacancy-list-item__bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.vacancy-list-item__bg-circle {
  transition: opacity 0.6s linear, transform 0.8s linear;
  position: absolute;
  border-radius: 50%;
  background-color: #ff6d2f;
  width: 5rem;
  height: 5rem;
  transform: scale(0);
  opacity: 0;
  z-index: 1;
}
.vacancy-list-item__bg-circle--first {
  bottom: 2.5rem;
  left: 6rem;
}
.vacancy-list-item__bg-circle--second {
  top: 5rem;
  left: 10rem;
}
.vacancy-list-item__bg-circle--third {
  top: 20rem;
  right: 5rem;
}

@media (max-width: 48em) {
  .vacancy-banner {
    overflow: hidden;
  }
  .vacancy-banner__inner {
    max-width: 100%;
    margin: 0;
    padding: 0 3.2rem;
  }
  .vacancy-banner__wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    padding-left: 0;
    gap: 0;
  }
  .vacancy-banner__main {
    display: flex;
    flex-direction: column;
    gap: 3.2rem;
    padding-top: 10.4rem;
  }
  .vacancy-banner__top {
    display: flex;
    flex-direction: column;
    gap: 4.8rem;
  }
  .vacancy-banner__top-wrapper {
    order: 3;
    display: flex;
    justify-content: space-between;
  }
  .vacancy-banner__slider {
    min-width: 30rem;
    max-width: 40rem;
  }
  .vacancy-banner__slider-slide.swiper-slide {
    padding-bottom: 1rem;
  }
  .vacancy-banner__footer.mobile {
    display: flex;
    flex-direction: column;
    text-align: right;
    gap: 2rem;
    padding-bottom: 0;
  }
  .vacancy-banner__footer span {
    font-size: 3.6rem;
    line-height: normal; /* 116.667% */
    letter-spacing: -0.072rem;
  }
  .vacancy-banner__title {
    order: 1;
  }
  .vacancy-banner__title span.h1 {
    font-size: 24rem;
    letter-spacing: -1.44rem;
  }
  .vacancy-banner__title span.h2 {
    font-size: 14rem;
    line-height: 90%; /* 63px */
    letter-spacing: -0.56rem;
    margin-left: 0;
    margin-top: -8rem;
  }
  .vacancy-banner__image {
    position: static;
    width: 100%;
    height: 35.2rem;
    order: 2;
  }
  .vacancy-banner__buttons {
    width: 100%;
  }
  .vacancy-banner__navigation {
    gap: 0.8rem;
    flex-direction: row;
  }
  .vacancy-banner-slide__header {
    font-size: 3.6rem;
    line-height: normal; /* 116.667% */
    letter-spacing: -0.072rem;
    margin-bottom: 2rem;
  }
  .vacancy-banner-slide__main {
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
  .vacancy-banner-slide__title {
    margin-bottom: 0.8rem;
  }
  .vacancy-banner-slide__salary {
    margin-bottom: 3.6rem;
  }
  .vacancy-banner-slide__salary sup {
    font-size: 3.2rem;
    margin-left: 0.8rem;
  }
  .vacancy-banner-slide__btn::after {
    bottom: -0.8rem;
  }
  .vacancy-list__inner {
    max-width: 100%;
    margin: 0;
  }
  .vacancy-list__title {
    margin-bottom: 8.4rem;
  }
  .vacancy-list__title strong {
    width: 8.6rem;
    height: 7rem;
    margin: 0 0.5rem 0 1.5rem;
  }
  .vacancy-list__content {
    margin-bottom: 6.4rem;
    gap: 6.4rem;
    padding: 0 3.2rem;
    grid-template-columns: 1fr;
  }
  .vacancy-list-item {
    border: 0.2rem solid #330d03;
  }
  .vacancy-list-item:hover {
    border: 0.2rem solid #ff6d2f;
  }
  .vacancy-list-item:hover .vacancy-list-item__header {
    border-bottom: 0.2rem solid #fff4da;
  }
  .vacancy-list-item__header {
    padding: 4rem;
    border-bottom: 0.2rem solid #330d03;
  }
  .vacancy-list-item__header span {
    font-size: 3.6rem;
    line-height: normal; /* 116.667% */
    letter-spacing: 0.072rem;
  }
  .vacancy-list-item__content {
    padding: 4rem 4rem 6rem;
  }
  .vacancy-list-item__title {
    margin-bottom: 3rem;
    font-size: 4.8rem;
    letter-spacing: -0.192rem;
  }
  .vacancy-list-item__salary {
    margin-bottom: 2rem;
    font-size: 3.6rem;
    line-height: normal; /* 93.333% */
    letter-spacing: 0.072rem;
  }
  .vacancy-list-item__salary sup {
    position: absolute;
    font-size: 3rem;
    right: -2rem;
    top: -0.2rem;
  }
  .vacancy-list-item__experience {
    margin-bottom: 8rem;
    font-size: 3.6rem;
    line-height: normal; /* 93.333% */
    letter-spacing: 0.072rem;
  }
}
.stock-main {
  margin-bottom: 0rem;
}
.stock-main .container {
  width: 100%;
}
.stock-main__wrapper {
  display: flex;
  position: relative;
}
.stock-main__left {
  position: relative;
  width: 50%;
}
.stock-main__left-text {
  position: absolute;
  top: 10.2rem;
  left: 6rem;
  color: #330d03;
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
  z-index: 3;
}
.stock-main__left-swiper {
  overflow: hidden;
  width: 100%;
  height: 89rem;
}
.stock-main__left-swiper-wrapper {
  height: auto;
}
.stock-main__left-slide-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.stock-main__title-swiper {
  width: 81.9rem;
  overflow: hidden;
  position: absolute;
  top: 6.2rem;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 3;
  height: 16.2rem;
}
.stock-main__title-swiper-wrapper {
  height: auto;
}
.stock-main__slide-title-text {
  color: #330d03;
  font-family: "Alumni Sans", sans-serif;
  font-size: 9rem;
  text-align: center;
  font-weight: 600;
  line-height: 90%;
  letter-spacing: -2.7px;
  text-transform: uppercase;
}
.stock-main__slide-title-text span {
  font-style: italic;
}
.stock-main__right {
  width: 50%;
  position: relative;
  padding-top: 25.4rem;
  height: 89rem;
  padding-left: 6rem;
  padding-right: 4rem;
}
.stock-main__right-swiper {
  width: 39.7rem;
  height: 33.9rem;
  overflow: hidden;
  z-index: 3;
  margin-bottom: 11.6rem;
}
.stock-main__right-swiper-wrapper {
  height: auto;
}
.stock-main__right-content-bg {
  width: 39.7rem;
  height: 33.9rem;
}
.stock-main__right-content-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.stock-main__right-text-slide-inner {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.stock-main__right-text-slide-inner-text {
  color: var(--dark, #330d03);
  font-family: "Euclid Circular A";
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.8rem;
  width: 27.3rem;
}
.stock-main__right-text-swiper {
  height: 8.4rem;
  overflow: hidden;
}
.stock-main__right-text-swiper-wrapper {
  height: auto;
}
.stock-main__navigation {
  position: absolute;
  flex-direction: initial;
  z-index: 3;
  top: 11.2rem;
  right: 6rem;
}
.stock-main__right-text-slide-inner-link {
  height: fit-content;
}

@media (max-width: 48em) {
  .stock-main {
    overflow: hidden;
  }
  .stock-main .container {
    width: 100%;
    padding: 0;
  }
  .stock-main__wrapper {
    flex-direction: column;
  }
  .stock-main__left {
    width: 100%;
  }
  .stock-main__left-swiper {
    height: 72rem;
  }
  .stock-main__right {
    width: 100%;
    padding-top: 0;
    height: 60rem;
    padding: 0 3.2rem;
    padding-top: 9rem;
  }
  .stock-main__right-swiper {
    width: 42.6rem;
    height: 36rem;
    margin-bottom: 0;
  }
  .stock-main__left-text {
    font-size: 4.8rem;
    left: 3.2rem;
    top: 8.4rem;
    letter-spacing: -0.18rem;
  }
  .stock-main__left-text br {
    display: none;
  }
  .stock-main__title-swiper {
    width: 100%;
    height: 14.4rem;
    left: 3.2rem;
    transform: initial;
    top: 15.2rem;
  }
  .stock-main__slide-title-text {
    font-size: 8rem;
    font-weight: 600;
    line-height: 90%;
    letter-spacing: -1.2px;
    text-transform: uppercase;
    width: 60rem;
    text-align: left;
  }
  .stock-main__slide-title-text br {
    display: none;
  }
  .stock-main__right-text-swiper {
    overflow: hidden;
    position: absolute;
    height: 100%;
    top: 0;
  }
  .stock-main__right-text-slide-inner {
    height: 100%;
    height: 57rem;
  }
  .stock-main__right-text-slide-inner-link {
    position: absolute;
    bottom: 2rem;
    right: 3.6rem;
  }
  .stock-main__right-text-slide-inner-text {
    width: 100%;
    color: var(--dark, #330d03);
    font-family: "Euclid Circular A";
    font-size: 3.2rem;
    font-style: normal;
    font-weight: 500;
    line-height: 155.556%;
  }
  .stock-main__navigation {
    flex-direction: row-reverse;
    z-index: 3;
    top: initial;
    right: initial;
    left: 3.2rem;
    bottom: 1rem;
  }
}
.menu .container {
  width: 100%;
  padding: 0 1rem;
}
.menu__title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.6rem;
  color: var(--dark, #330d03);
  text-align: center;
  font-family: "Literata";
  font-size: 8rem;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
  letter-spacing: -1.6px;
}
.menu__title-icon {
  width: 12rem;
  height: 9rem;
  margin-right: 2rem;
  margin-left: 2rem;
}
.menu__title-icon img {
  width: 100%;
  height: 100%;
}
.menu .main-menu__header {
  margin-bottom: 4.4rem;
}
.menu .main-menu__categories {
  max-width: 146rem;
}
.menu .main-menu__categories-btn.active {
  position: relative;
  color: #ff6d2f;
}
.menu .link {
  color: var(--dark, #330d03);
  text-align: center;
  font-family: "Alumni Sans";
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  letter-spacing: -0.6px;
  text-transform: uppercase;
  padding-bottom: 0.8rem;
  display: block;
  margin: 0 auto;
  position: relative;
  height: fit-content;
  width: fit-content;
  margin-bottom: 20rem;
}
.menu .link::before {
  position: absolute;
  content: "";
  width: 100%;
  background: var(--dark, #330d03);
  height: 0.2rem;
  bottom: 0;
}
.menu__popular {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 100%;
  margin-bottom: 7.4rem;
}
.menu__popular .menu-card:hover .menu-card__name {
  color: var(--dark, #330d03);
}
.menu__popular .menu-card:hover .menu-card__price {
  color: var(--dark, #330d03);
}
.menu__popular .menu-card:hover .menu-card__description {
  color: var(--dark, #330d03);
}
.menu__popular .menu-card__bg {
  background: var(--choco, #4c0d00);
}
.menu__popular .menu-card__name {
  color: var(--beige, #fff4da);
}
.menu__popular .menu-card__price {
  color: var(--beige, #fff4da);
}
.menu__popular .menu-card__description {
  color: var(--beige, #fff4da);
}
.menu__popular .menu-card .btn {
  background: var(--orange, #ff6d2f);
}
.menu .main-menu__inner {
  margin-bottom: 7.4rem;
}
.menu__chapter-title {
  color: var(--dark, #330d03);
  text-align: center;
  margin-bottom: 4.8rem;
  font-family: "Alumni Sans";
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.8px;
  text-transform: uppercase;
}
.menu__chapter {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 7.4rem;
}
.menu__chapter .menu-card {
  margin-right: 0.5rem;
}
.menu__chapter .menu-card:nth-child(4n) {
  margin-right: 0;
}
.menu__all {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 20rem;
}

@media (max-width: 48em) {
  .menu .container {
    padding: 0 3.2rem;
  }
  .menu__title {
    position: relative;
    font-size: 5.6rem;
    display: flex;
    flex-direction: column;
    align-items: initial;
    justify-content: initial;
    text-align: left;
  }
  .menu__title-icon {
    width: 14.4rem;
    height: 8rem;
    position: absolute;
    margin-right: 0;
    margin-left: 0;
    bottom: 0;
    right: 0;
  }
  .menu__popular {
    display: flex;
    flex-direction: column;
  }
  .menu__popular .menu-card:hover .menu-card__name {
    color: #fff;
  }
  .menu__popular .menu-card:hover .menu-card__price {
    color: #fff;
  }
  .menu__popular .menu-card:hover .menu-card__description {
    color: #fff;
  }
  .menu .main-menu__cards-slide {
    width: 100%;
  }
  .menu .main-menu__categories {
    max-width: 100%;
  }
}
.error-four {
  margin-bottom: 20rem;
}
.error-four__wrapper {
  padding-top: 20rem;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.error-four__image {
  width: 96.4rem;
  height: 48.4rem;
  margin: 0 auto;
  margin-bottom: 5.6rem;
}
.error-four__text {
  color: #1c1c1c;
  text-align: center;
  font-family: "Alumni Sans";
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2.8rem;
  letter-spacing: 2.16px;
  text-transform: uppercase;
  max-width: 65.5rem;
  margin-bottom: 2.1rem;
}
.error-four .btn {
  margin: 0 auto;
}

@media (max-width: 48em) {
  .error-four__image {
    width: 100%;
    height: 29.6rem;
  }
  .error-four__text {
    font-size: 4rem;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    letter-spacing: -0.8px;
    text-transform: uppercase;
    margin-bottom: 3.2rem;
  }
}
.mobile {
  display: none;
}

@media (max-width: 48em) {
  .mobile {
    display: block;
  }
  .desktop {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/scss/_fonts.scss","webpack://./src/scss/libs/_set.scss","webpack://./src/scss/libs/_settings.scss","webpack://./src/scss/_style.scss","webpack://./src/scss/components/_header.scss","webpack://./src/scss/components/_footer.scss","webpack://./src/scss/components/_modal.scss","webpack://./src/scss/components/_ticker.scss","webpack://./src/scss/pages/main-page/_main-banner.scss","webpack://./src/scss/pages/main-page/_main-news.scss","webpack://./src/scss/pages/main-page/_main-menu.scss","webpack://./src/scss/pages/main-page/_main-sale.scss","webpack://./src/scss/pages/main-page/_main-advantages.scss","webpack://./src/scss/pages/main-page/_main-reviews.scss","webpack://./src/scss/pages/main-page/_main-map.scss","webpack://./src/scss/pages/_contacts.scss","webpack://./src/scss/pages/_vacancy.scss","webpack://./src/scss/pages/_vacancy-detail.scss","webpack://./src/scss/pages/_news-detail.scss","webpack://./src/scss/pages/main-page/_service-delivery.scss","webpack://./src/scss/pages/_main-delivery.scss","webpack://./src/scss/pages/main-page/_sliders-delivery.scss","webpack://./src/scss/pages/main-page/_delivery-box.scss","webpack://./src/scss/pages/main-page/_stock.scss","webpack://./src/scss/pages/_detailed-promotions.scss","webpack://./src/scss/pages/_other-promotions.scss","webpack://./src/scss/pages/_about.scss","webpack://./src/scss/pages/_menu-main.scss","webpack://./src/scss/pages/_position-card.scss","webpack://./src/scss/pages/_stock-main.scss","webpack://./src/scss/pages/_menu.scss","webpack://./src/scss/pages/_error-four.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACC,0BAAA;EACA,wMAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADCD;ACCA;EACC,0BAAA;EACA,0NAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADAD;ACEA;EACC,gCAAA;EACA,iNAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADDD;ACGA;EACC,gCAAA;EACA,oNAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;ADFD;ACIA;EACC,uBAAA;EACA,4LAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADHD;ACKA;EACC,uBAAA;EACA,+LAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADJD;AE1CA;;;EAGC,sBAAA;AF4CD;;AE1CA;EACC,0BCLM;EDMN,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;AF6CD;;AE1CA;EACC,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,cCtBW;EDuBX,yBCdI;AH2DL;;AE1CA;;EAEC,qCAAA;EACA,oBAAA;EACA,SAAA;EACA,UAAA;EACA,6BAAA;EACA,YAAA;EACA,cAAA;AF6CD;;AE3CA;EACC,YAAA;AF8CD;;AE5CA;;EAEC,qBAAA;AF+CD;;AE5CA;;;;EAIC,aAAA;EACA,eAAA;EACA,aAAA;AF+CD;AE9CC;;;;EACC,aAAA;AFmDF;AEjDC;;;;EACC,aAAA;AFsDF;;AElDA;;;;;;EAMC,aAAA;EACA,SAAA;EACA,UAAA;AFqDD;;AEnDA;EACC,aAAA;EACA,gBAAA;AFsDD;;AEnDA;;EAEC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AFsDD;;AEnDA;EACC,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;AFsDD;;AEpDA;EACC,UAAA;EACA,SAAA;AFuDD;;AEpDA;EACC,SAAA;EACA,UAAA;EACA,gBAAA;AFuDD;;AEpDA;EACC,aCnFgB;EDoFhB,cAAA;AFuDD;;AEpDA;EACC,oBC5Fe;AHmJhB;;AEpDA;;EAEC,wBAAA;EACA,SAAA;AFuDD;;AEpDA;EACC,0BAAA;AFuDD;;AEpDA;EACC;IACC,eAAA;EFuDA;AACF;AEpDA;EACC;IACC,cAAA;IACA,mBAAA;IACA,yBAAA;IACA,8BAAA;EFsDA;EEnDD;IACC,8BAAA;EFqDA;EElDD;IACC,oBC3HoB;EH+KpB;EEjDD;IACC,iBAAA;IACA,WAAA;EFmDA;AACF;AItMA;EACC,aAAA;AJwMD;;AIrMC;EACC,gBAAA;EACA,kBAAA;AJwMF;;AIrMA;EACC,uBAAA;AJwMD;;AItMA;EACC,iBAAA;AJyMD;;AIvMA;EACC,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA,EAAA,UAAA;EACA,uBAAA;AJ0MD;;AIxMA;EACC,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA,EAAA,UAAA;EACA,wBAAA;AJ2MD;;AIzMA;EACC,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA,EAAA,SAAA;EACA,wBAAA;AJ4MD;;AI1MA;EACC,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;AJ6MD;;AI3MA;EACC,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;AJ8MD;;AI5MA;EACC,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,YAAA;EACA,wBAAA;AJ+MD;;AI7MA;EACC,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;AJgND;;AI9MA;EACC,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;AJiND;;AI/MA;EACC,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;AJkND;;AIhNA;EACC,cD7EM;EC8EN,kBAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,YAAA;EACA,wBAAA;EACA,yBAAA;EAEA,oBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,mBD5FQ;EC8FR,kBAAA;EACA,gBAAA;AJgND;AI/MC;EACC,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBDjGM;ECkGN,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,2CAAA;AJiNF;AI/MC;EACC,cD5GO;EC6GP,cAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,sCAAA;AJiNF;AI7ME;EACC,sCAAA;EACA,wBAAA;AJ+MH;AI7ME;EACC,2CAAA;EACA,wBAAA;AJ+MH;AI3MC;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,kCAAA;AJ6MF;AI3ME;EACC,4BAAA;AJ6MH;AI1ME;EACC,kCAAA;EACA,mBDhJI;AH4VP;AI1MG;EACC,4BAAA;EACA,aDlJK;AH8VT;;AIvMA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AJ0MD;AIzMC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBDvKK;ECwKL,kCAAA;AJ0MF;AIxME;EACC,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBD9KK;EC+KL,kBAAA;EACA,2BAAA;EACA,sCAAA;AJ0MH;AIxME;EACC,kBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;AJ0MH;AIxME;EACC,yBDzLM;EC0LN,eAAA;AJ0MH;AIxMG;EACC,yBD7LK;AHuYT;AIzMI;EACC,2BAAA;AJ2ML;AItME;EACC,wCAAA;EACA,yBDvMK;AH+YR;AIvMG;EACC,sCAAA;EACA,wBAAA;AJyMJ;;AIpMA;EACC,kBAAA;EACA,cDlNM;ECmNN,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,YAAA;EACA,wBAAA;EACA,yBAAA;AJuMD;AIrMC;EACC,6BAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,mBD/NK;ECgOL,kBAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;AJuMF;AInME;EACC,6BAAA;EACA,UAAA;AJqMH;;AIjMA;EACC;IACC,oBAAA;EJoMA;EIjMD;IACC,aAAA;IACA,mBAAA;IACA,WAAA;EJmMA;EIlMA;IACC,aAAA;IACA,cAAA;EJoMD;EIlMC;IACC,QAAA;EJoMF;EIjMC;IACC,aAAA;IACA,cAAA;EJmMF;EIjMC;IACC,aAAA;IACA,cAAA;EJmMF;EI9LD;IACC,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,yBAAA;EJgMA;EI7LD;IACC,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA,EAAA,SAAA;IACA,wBAAA;EJ+LA;EI5LD;IACC,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,wBAAA;IACA,yBAAA;EJ8LA;EI3LD;IACC,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;EJ6LA;EI3LD;IACC,kBAAA;IACA,iBAAA;IACA,mBAAA;IACA,yBAAA;IACA,yBAAA;EJ6LA;AACF;AKjfA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,yBFGO;AHgfR;AKhfC;EACC,aAAA;EACA,kBAAA;EAEA,eAAA;EACA,mBAAA;EACA,8BAAA;ALifF;AK9eC;EACC,cAAA;EACA,YAAA;ALgfF;AK9eE;EACC,cAAA;EACA,WAAA;EACA,YAAA;ALgfH;AK9eG;EACC,YAAA;ALgfJ;AK3eC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;AL6eF;AK1eC;EACC,SAAA;AL4eF;AKteA;EACC,aAAA;ALweD;AKteC;EACC,cAAA;EACA,cF3CM;EE4CN,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;ALweF;;AKpeC;EACC,aAAA;ALueF;AKreC;EACC,aAAA;ALueF;;AKpeA;EAIE;IACC,iBAAA;ELoeD;EKjeA;IACC,kBAAA;IACA,aAAA;IACA,YAAA;IACA,YAAA;ELmeD;EKheA;IACC,aAAA;ELkeD;EK/dA;IACC,SAAA;ELieD;EK9dD;IACC,aAAA;ELgeA;EK9dA;IACC,cAAA;IACA,cFvFK;IEwFL,gCAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA,EAAA,aAAA;ELgeD;EK5dA;IACC,kBAAA;IACA,aAAA;IACA,aAAA;IACA,uBAAA;IACA,iBAAA;IACA,uBAAA;IACA,sBAAA;IACA,aAAA;IACA,cAAA;IACA,kBAAA;IACA,yBF3GK;IE4GL,SAAA;EL8dD;EK1dG;IACC,aAAA;IACA,iCAAA;IACA,wBAAA;IACA,2CAAA;EL4dJ;EK1dG;IACC,aAAA;EL4dJ;EK1dG;IACC,iCAAA;IACA,wBAAA;IACA,6CAAA;EL4dJ;EKvdC;IACC,cAAA;IACA,aAAA;IACA,cAAA;IACA,yBFxIG;IEyIH,oBAAA;IACA,iCAAA;ELydF;EKvdE;IACC,aAAA;ELydH;EKrdA;IACC,aAAA;IACA,YAAA;IACA,aAAA;IACA,oBAAA;IAEA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;IACA,oBAAA;IACA,2BAAA;IACA,sCAAA;ELsdD;EKrdC;IACC,wBAAA;IACA,sCAAA;ELudF;EKpdC;IACC,aAAA;IACA,kBAAA;IACA,WAAA;IACA,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,yBFvKI;IEwKJ,uBAAA;ELsdF;EKndC;IACC,sBAAA;IACA,WAAA;IACA,sBAAA;ELqdF;EKpdE;IACC,cFnLE;IEoLF,0BAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;IACA,yBAAA;IACA,yBAAA;ELsdH;EKldC;IACC,kBAAA;IACA,WAAA;ELodF;EKjdC;IACC,aAAA;IACA,mBAAA;IACA,WAAA;IACA,mBAAA;ELmdF;EKldE;IACC,cAAA;IACA,cF1ME;IE2MF,kBAAA;IACA,0BAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;IACA,wBAAA;IACA,yBAAA;ELodH;EKjdC;IACC,kBAAA;ELmdF;EKldE;IACC,YAAA;IACA,aAAA;IACA,WAAA;IACA,cAAA;ELodH;EKldE;IACC,YAAA;IACA,aAAA;IACA,qCAAA;IACA,YAAA;IACA,UAAA;ELodH;AACF;AM1rBC;EACC,cAAA;EACA,WAAA;EACA,iBAAA;AN4rBF;AMxrBC;EACC,aAAA;EACA,mBAAA;AN0rBF;AMxrBE;EACC,kBAAA;AN0rBH;AMvrBE;EACC,oBAAA;EACA,WAAA;ANyrBH;AMprBC;EACC,kBAAA;ANsrBF;AMprBE;EACC,YAAA;EACA,YAAA;ANsrBH;AMjrBC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;ANmrBF;AM/qBC;EACC,cHtCK;EGuCL,yBAAA;ANirBF;AM7qBC;EACC,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,gCAAA;AN+qBF;AM3qBC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AN6qBF;AMzqBC;EACC,WAAA;AN2qBF;AMvqBC;EACC,yBAAA;EACA,gBAAA;ANyqBF;AMvqBE;EACC,2BH7DY;AHsuBf;AMpqBC;EACC,eAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;ANsqBF;AMpqBE;EACC,aAAA;EACA,cAAA;ANsqBH;AMjqBC;EACC,kBAAA;ANmqBF;AM/pBC;EACC,WAAA;EACA,iBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;ANiqBF;AM7pBC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AN+pBF;AM3pBC;EACC,WAAA;EACA,yBAAA;AN6pBF;AM5pBE;EACC,2BH1Gc;AHwwBjB;AMzpBC;EACC,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EAEA,0CAAA;AN0pBF;AMxpBE;EACC,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA,EAAA,aAAA;EACA,kBAAA;EACA,2BH9Hc;AHwxBjB;AMvpBE;EACC,cAAA;EACA,2BHnIc;EGoId,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;ANypBH;;AMppBA;EAGE;IACC,kBAAA;ENqpBD;EMjpBA;IACC,QAAA;IACA,sBAAA;ENmpBD;EMjpBC;IACC,kBAAA;ENmpBF;EMhpBC;IACC,aAAA;IACA,sBAAA;IACA,cAAA;IACA,WAAA;ENkpBF;EM7oBA;IACC,kBAAA;EN+oBD;EM7oBC;IACC,YAAA;IACA,YAAA;EN+oBF;EM1oBA;IACC,aAAA;EN4oBD;EMxoBA;IACC,mBAAA;IACA,QAAA;IACA,kBAAA;IACA,aAAA;IACA,sBAAA;IACA,sBAAA;IACA,gCAAA;EN0oBD;EMtoBA;IACC,aAAA;IACA,sBAAA;IACA,SAAA;ENwoBD;EMpoBA;IACC,WAAA;ENsoBD;EMloBA;IACC,gBAAA;ENooBD;EMloBC;IACC,2BHjNW;EHq1Bb;EM/nBA;IACC,kBAAA;IACA,QAAA;IACA,cAAA;ENioBD;EM/nBC;IACC,aAAA;IACA,cAAA;ENioBF;EM5nBA;IACC,QAAA;IACA,kBAAA;EN8nBD;EM1nBA;IACC,WAAA;IACA,WAAA;IACA,eAAA;IACA,8BAAA;IACA,aAAA;IACA,mBAAA;IACA,eAAA;EN4nBD;EMxnBA;IACC,kBAAA;IACA,SAAA;EN0nBD;EMtnBA;IACC,kBAAA;IACA,2BAAA;ENwnBD;EMtnBC;IACC,WAAA;IACA,eAAA;IACA,WAAA;IACA,aAAA;IACA,sBAAA;ENwnBF;AACF;AOt4BC;EACC,cJKM;EIJN,yBAAA;APw4BF;AOr4BC;EACC,cAAA;EACA,kBAAA;APu4BF;AOr4BC;EACC,cAAA;EACA,eAAA;EACA,qBAAA;APu4BF;AOr4BC;EACC,aAAA;EACA,gBAAA;APu4BF;AOr4BC;EACC,kBAAA;EACA,gBAAA;EACA,cJfM;EIgBN,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EAEA,oBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;APs4BF;AOp4BC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;APs4BF;;AOj4BC;EACC,gBAAA;EACA,cAAA;EACA,eAAA;APo4BF;AOj4BC;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;APm4BF;AOh4BC;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;APk4BF;AOj4BE;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,yBJjEM;EIkEN,kBAAA;APm4BH;AO/3BC;EACC,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBJ1EM;AH28BR;AO93BC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,cJrFK;EIsFL,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,YAAA;EACA,wBAAA;EACA,yBAAA;AP+3BF;AO93BE;EACC,cAAA;EACA,aAAA;EACA,cAAA;APg4BH;AO53BC;EACC,aAAA;EACA,uBAAA;EACA,8BAAA;AP83BF;AO33BC;EACC,cJvGM;EIwGN,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;AP63BF;AO13BC;EACC,cJjHM;EIkHN,iBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;AP43BF;AO13BC;EACC,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,cJ9HM;EIgIN,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;EACA;6BAAA;EAEA,qBAAA;EACA,gCAAA;EAEA,2BAAA;AP03BF;AOz3BE;EACC,aAAA;AP23BH;AOz3BE;EACC,yBJnJI;EIoJJ,oBAAA;AP23BH;AOv3BC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;APy3BF;AOt3BC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,cJjKM;EIkKN,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;APu3BF;AOr3BE;EACC,cAAA;EACA,aAAA;EACA,cAAA;APu3BH;AOl3BE;EACC,kBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;APo3BH;AOl3BE;EACC,yBJzLK;AH6iCR;AOl3BG;EACC,aJ3LI;AH+iCR;;AO72BC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;APg3BF;AO72BC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AP+2BF;AO52BC;EACC,cAAA;EACA,qBAAA;AP82BF;AO32BC;EACC,cJvNM;EIwNN,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AP62BF;AO12BC;EACC,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,cJnOM;EIoON,uBAAA;AP42BF;;AOz2BA;EACC,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EAEA,WAAA;EACA,aAAA;AP22BD;AO12BC;EACC,cAAA;AP42BF;AO12BC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EAEA,WAAA;EACA,YAAA;EACA,gCJtPa;EIuPb,6BAAA;EACA,UAAA;EACA,oCAAA;AP22BF;AOz2BC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,mBJrQM;EIsQN,UAAA;EACA,oCAAA;AP02BF;AOx2BC;EACC,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EAEA,WAAA;EACA,YAAA;APy2BF;AOv2BE;EACC,WAAA;EACA,YAAA;APy2BH;AOt2BC;EACC,aAAA;EACA,kBAAA;APw2BF;AOt2BE;EACC,cAAA;EACA,mBAAA;APw2BH;;AOn2BC;EACC,kBAAA;EACA,SAAA;EACA,eAAA;EACA,OAAA;APs2BF;;AOl2BC;EACC,yBAAA;EACA,cAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,yBAAA;APq2BF;;AOj2BC;EACC,mBAAA;EACA,WAAA;EACA,eAAA;EACA,cJ/TK;EIgUL,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;APo2BF;AOl2BE;EACC,2BJ/Tc;AHmqCjB;AOj2BC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EAEA,eAAA;EACA,cJlVK;EImVL,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;EAMA;6BAAA;EAEA,qBAAA;EACA,gCAAA;EAEA,2BAAA;AP41BF;AOr2BE;EACC,2BJlVc;AHyrCjB;AO91BE;EACC,aAAA;APg2BH;AO91BE;EACC,yBJxWI;EIyWJ,oBAAA;APg2BH;AO51BC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;AP81BF;AO71BE;EACC,aAAA;EACA,SAAA;AP+1BH;AO71BE;EACC,WAAA;AP+1BH;AO31BC;EACC,OAAA;AP61BF;AO11BC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AP41BF;;AOz1BA;EACC,aAAA;EACA,mBAAA;EACA,WAAA;AP41BD;AO31BC;EACC,cJvYM;EIwYN,yBAAA;AP61BF;AO11BC;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AP41BF;AO31BE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AP61BH;AO31BG;EACC,eAAA;AP61BJ;AO11BG;EACC,UAAA;EACA,eAAA;AP41BJ;AOz1BI;EACC,aAAA;AP21BL;AOv1BE;EACC,aAAA;APy1BH;AOt1BE;EACC,aAAA;APw1BH;AOp1BG;;EAEC,aAAA;APs1BJ;AOj1BG;EACC,aAAA;APm1BJ;AO/0BI;;EAEC,aAAA;APi1BL;AO70BE;EACC,aAAA;AP+0BH;;AOz0BC;EACC,aAAA;EACA,gBAAA;AP40BF;AOz0BC;EACC,cJ/cM;EIgdN,yBAAA;AP20BF;AOx0BC;EACC,eAAA;EACA,kBAAA;AP00BF;AOv0BC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;APy0BF;AOt0BC;EACC,cAAA;EACA,eAAA;EACA,qBAAA;APw0BF;AOr0BC;EACC,kBAAA;EACA,gBAAA;EACA,cJxeM;EIyeN,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EAEA,oBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;APs0BF;;AOn0BA;EACC,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;APs0BD;;AOp0BA;EACC,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;APu0BD;AOt0BC;EACC,cJpgBM;EIqgBN,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;APw0BF;AOr0BC;EACC,aAAA;EACA,cAAA;APu0BF;AOt0BE;EACC,eJhhBK;AHw1CR;;AOp0BA;EACC,aAAA;EACA,mBAAA;APu0BD;AOr0BC;EACC,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;APu0BF;AOp0BC;EACC,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cJpiBM;EIqiBN,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;APs0BF;AOn0BC;EACC,cJ9iBO;EI+iBP,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,mBAAA;APq0BF;;AOj0BC;EACC,gBAAA;EACA,cAAA;EACA,eAAA;APo0BF;AOj0BE;EACC,aJjkBI;AHo4CP;AOh0BG;EACC,aJnkBK;AHq4CT;AO7zBC;EACC,oBAAA;EACA,yBJzkBM;EI6kBN,SAAA;AP4zBF;AO/zBE;EACC,aAAA;APi0BH;AO7zBC;EACC,YAAA;EACA,eAAA;EACA,gBAAA;AP+zBF;AO5zBC;EACC,WAAA;EACA,YAAA;AP8zBF;AO5zBC;EACC,WAAA;EACA,YAAA;AP8zBF;AO3zBC;EACC,YAAA;EACA,cAAA;EACA,4BAAA;AP6zBF;;AOzzBA;EAEE;IACC,eAAA;EP2zBD;EOvzBA;IACC,yBAAA;IACA,iBAAA;IACA,mBAAA,EAAA,WAAA;IACA,yBAAA;EPyzBD;EOpzBA;IACC,kBAAA;IACA,eAAA;IACA,wBAAA;IACA,gBAAA;EPszBD;EOnzBA;IACC,WAAA;IACA,kBAAA;EPqzBD;EOnzBA;IACC,cAAA;IACA,eAAA;IACA,gBAAA;EPqzBD;EOnzBA;IACC,mBAAA;EPqzBD;EOnzBA;IACC,aAAA;IACA,cAAA;IACA,kBAAA;IACA,kBAAA;IACA,iBAAA;IACA,mBAAA,EAAA,aAAA;EPqzBD;EOnzBA;IACC,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,WAAA;IACA,WAAA;EPqzBD;EOhzBA;IACC,gBAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;EPkzBD;EO/yBA;IACC,WAAA;IACA,aAAA;IACA,UAAA;IACA,sBAAA;IACA,WAAA;EPizBD;EO7yBC;IACC,aAAA;IACA,eAAA;IAEA,cAAA;IACA,eAAA;EP8yBF;EO1yBA;IACC,cAAA;IACA,eAAA;IACA,eAAA;EP4yBD;EOzyBA;IACC,WAAA;IACA,iBAAA;IACA,iBAAA,EAAA,YAAA;IACA,yBAAA;EP2yBD;EO1yBC;IACC,aAAA;IACA,cAAA;EP4yBF;EOxyBA;IACC,iBAAA;IACA,yBAAA;EP0yBD;EOvyBA;IACC,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;EPyyBD;EOvyBA;IACC,iBAAA;IACA,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;EPyyBD;EOxyBC;IACC,aAAA;EP0yBF;EOxyBC;IACC,oBAAA;EP0yBF;EOtyBA;IACC,YAAA;EPwyBD;EOryBA;IACC,WAAA;IAEA,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;EPsyBD;EOpyBC;IACC,aAAA;IACA,cAAA;EPsyBF;EOjyBC;IACC,gBAAA;IACA,2BAAA;IACA,8BAAA;IACA,kBAAA;EPmyBF;EO7xBA;IACC,mBAAA;IACA,WAAA;EP+xBD;EO5xBA;IACC,WAAA;EP8xBD;EO3xBA;IACC,cAAA;IACA,gBAAA;EP6xBD;EO1xBA;IACC,gBAAA;IACA,WAAA;EP4xBD;EOzxBA;IACC,cAAA;IACA,kBAAA;IACA,iBAAA;IACA,mBAAA,EAAA,aAAA;EP2xBD;EOvxBA;IACC,cAAA;EPyxBD;EOvxBA;IACC,WAAA;IACA,aAAA;IAEA,aAAA;IACA,cAAA;EPwxBD;EOpxBA;IACC,sBAAA;IACA,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;EPsxBD;EOpxBA;IACC,eAAA;IACA,sBAAA;IACA,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;EPsxBD;EOnxBA;IACC,SAAA;IACA,qBAAA;EPqxBD;EOpxBC;IACC,aAAA;IACA,sBAAA;IACA,SAAA;EPsxBF;EOpxBC;IACC,WAAA;EPsxBF;EOlxBA;IACC,OAAA;EPoxBD;EOjxBA;IACC,aAAA;IACA,sBAAA;IACA,8BAAA;IACA,mBAAA;IACA,WAAA;EPmxBD;EOhxBA;IACC,WAAA;EPkxBD;EOjxBC;IACC,WAAA;EPmxBF;EO/wBD;IACC,WAAA;EPixBA;EOhxBA;IACC,iBAAA;IACA,yBAAA;EPkxBD;EO9wBC;IACC,aAAA;IACA,cAAA;IAEA,oBAAA;EP+wBF;EOzwBA;IACC,mBAAA;EP2wBD;EOxwBA;IACC,kBAAA;IACA,eAAA;IACA,wBAAA;IACA,gBAAA;EP0wBD;EOvwBA;IACC,WAAA;IACA,kBAAA;EPywBD;EOtwBA;IACC,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,WAAA;IACA,WAAA;EPwwBD;EOrwBA;IACC,cAAA;IACA,eAAA;IACA,gBAAA;EPuwBD;EOpwBA;IACC,aAAA;IACA,cAAA;IACA,kBAAA;IACA,kBAAA;IACA,iBAAA;IACA,mBAAA,EAAA,aAAA;EPswBD;EOnwBD;IACC,WAAA;EPqwBA;EOpwBA;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;EPswBD;EOnwBA;IACC,aAAA;IACA,cAAA;EPqwBD;EOlwBD;IACC,aAAA;IACA,mBAAA;EPowBA;EOlwBA;IACC,WAAA;IACA,YAAA;IACA,iBAAA;EPowBD;EOjwBA;IACC,gBAAA;IACA,iBAAA;IACA,mBAAA,EAAA,aAAA;EPmwBD;EOhwBA;IACC,mBAAA;IACA,iBAAA;IACA,mBAAA,EAAA,aAAA;EPkwBD;EO9vBA;IACC,YAAA;IACA,yBJ16BK;EH0qDN;EO9vBA;IACC,aAAA;IACA,cAAA;IACA,YAAA;IACA,SAAA;IACA,YAAA;EPgwBD;EO/vBC;IACC,gBAAA;IACA,qBAAA;EPiwBF;EO9vBC;IACC,WAAA;IACA,YAAA;IACA,eAAA;EPgwBF;EO7vBC;IACC,aAAA;IACA,cAAA;EP+vBF;EO3vBA;IACC,aAAA;IACA,oBAAA;EP6vBD;EO5vBC;IACC,cAAA;IACA,sBAAA;IACA,WAAA;EP8vBF;EO3vBA;IACC,gBAAA;IACA,WAAA;IACA,aAAA;EP6vBD;EO3vBC;IACC,aAAA;EP6vBF;EO1vBA;IACC,UAAA;IACA,WAAA;IACA,aAAA;EP4vBD;EO1vBA;IACC,UAAA;IACA,oBAAA;EP4vBD;EOzvBA;IACC,YAAA;IACA,WAAA;IACA,4BAAA;EP2vBD;AACF;AQtuDA;EACC,iBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;ARwuDD;AQvuDC;EACC,aAAA;EACA,SAAA;EACA,WAAA;EACA,qCAAA;ARyuDF;AQvuDC;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;ARyuDF;AQvuDC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;ARyuDF;AQxuDE;EACC,cAAA;EACA,kBAAA;EACA,iBAAA;EAEA,cLxBI;EKyBJ,eAAA;EACA,gBAAA;EACA,mBAAA,EAAA,YAAA;EACA,wBAAA;EACA,yBAAA;ARyuDH;AQvuDE;EACC,cAAA;EACA,aAAA;EACA,cAAA;ARyuDH;;AQruDA;EACC;IACC,yBAAA;ERwuDA;EQtuDD;IACC,2CAAA;ERwuDA;AACF;AQruDA;EACC;IACC,cAAA;ERuuDA;EQtuDA;IACC,SAAA;IACA,WAAA;ERwuDD;EQtuDA;IACC,SAAA;ERwuDD;EQtuDA;IACC,SAAA;ERwuDD;EQvuDC;IACC,iBAAA;IACA,mBAAA,EAAA,YAAA;IACA,yBAAA;ERyuDF;EQvuDC;IACC,aAAA;IACA,cAAA;ERyuDF;EQruDD;IACC;MACC,yBAAA;IRuuDC;IQruDF;MACC,0CAAA;IRuuDC;EACF;AACF;AStzDE;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;ATwzDH;AStzDE;EACC,aAAA;ATwzDH;ASpzDC;EACC,kBAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;ATszDF;ASrzDE;EACC,aAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;ATuzDH;ASrzDG;EACC,cAAA;EACA,cN1BG;EM2BH,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;ATuzDJ;ASlzDC;EACC,aAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;ATozDF;ASnzDE;EACC,WAAA;EACA,kBAAA;ATqzDH;ASnzDE;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;ATqzDH;ASnzDE;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;ATqzDH;ASjzDC;EACC,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;ATmzDF;ASjzDG;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;ATmzDJ;ASlzDI;EACC,WAAA;EACA,WAAA;EACA,YAAA;EAEA,uFAAA;EAEA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;ATkzDL;AS/yDG;EACC,cAAA;EACA,eAAA;ATizDJ;AS/yDI;EACC,WAAA;EACA,YAAA;EACA,iBAAA;ATizDL;AS7yDE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;AT+yDH;AS7yDE;EACC,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AT+yDH;AS9yDG;EACC,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,4BAAA;AT+yDJ;AS7yDI;EACC,aAAA;EACA,cAAA;AT+yDL;AS3yDE;EACC,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AT6yDH;AS5yDG;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AT6yDJ;AS3yDI;EACC,iBAAA;AT6yDL;AS1yDG;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,2BAAA;EAEA,cN3JI;EM4JJ,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;AT2yDJ;;AStyDA;EACC,cAAA;EACA,eAAA;EACA,gBAAA;ATyyDD;;ASvyDA;EACC,gCAAA;AT0yDD;;ASxyDA;EACC,eN9KO;EM+KP,8CAAA;EACA,yCAAA;EACA,2CAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AT2yDD;;ASxyDC;EACC,gBAAA;EACA,eAAA;AT2yDF;ASxyDC;EACC,cN9LO;EM+LP,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA,EAAA,UAAA;EACA,uBAAA;EACA,yBAAA;AT0yDF;;AStyDC;EACC,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;ATyyDF;AStyDC;EACC,cNnNK;EMoNL,gCAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA,EAAA,UAAA;EACA,wBAAA;ATwyDF;;ASpyDC;EACC,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;ATuyDF;ASpyDC;EACC,WAAA;EACA,YAAA;ATsyDF;ASnyDC;EACC,gBAAA;EACA,cAAA;EACA,eAAA;ATqyDF;ASnyDE;EACC,mBAAA;ATqyDH;;AShyDC;EACC,gBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;ATmyDF;AShyDC;EACC,cAAA;EAEA,cN/PK;EMgQL,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;ATiyDF;AS/xDE;EACC,kBAAA;EACA,gBAAA;EACA,wBAAA;ATiyDH;;AS5xDC;EACC,gBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;AT+xDF;AS5xDC;EACC,cAAA;EACA,cNxRK;EMyRL,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;AT8xDF;;AS1xDA;EACC;IACC,yBAAA;ET6xDA;ES3xDD;IACC,2CAAA;ET6xDA;AACF;AS1xDA;EAIG;IACC,aAAA;ETyxDF;ESvxDC;IACC,WAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,WAAA;IACA,mBAAA;ETyxDF;ESvxDC;IACC,gBAAA;IACA,aAAA;IACA,oBAAA;IACA,WAAA;ETyxDF;ESvxDC;IACC,aAAA;IACA,mBAAA;IACA,8BAAA;ETyxDF;ESrxDC;IACC,qBAAA;ETuxDF;ESrxDC;IACC,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,SAAA;IACA,SAAA;ETuxDF;ESjxDE;IACC,cAAA;IACA,eAAA;ETmxDH;ESjxDE;IACC,cAAA;IACA,eAAA;ETmxDH;ES7wDA;IACC,gBAAA;IACA,mBAAA;ET+wDD;ES5wDA;IACC,cNrWM;IMsWN,gBAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA,EAAA,UAAA;IACA,wBAAA;IACA,yBAAA;ET8wDD;ES1wDA;IACC,WAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;IACA,WAAA;ET4wDD;ESzwDA;IACC,cN1XI;IM2XJ,gCAAA;IACA,uBAAA;IACA,gBAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA,EAAA,UAAA;IACA,wBAAA;ET2wDD;ESvwDA;IACC,SAAA;IACA,kBAAA;IACA,cAAA;IACA,mBAAA;IACA,gBAAA;ETywDD;EStwDA;IACC,WAAA;IACA,YAAA;ETwwDD;ESrwDA;IACC,gBAAA;IACA,cAAA;ETuwDD;ESrwDC;IACC,mBAAA;ETuwDF;ESlwDA;IACC,gBAAA;IACA,kBAAA;IACA,cAAA;IACA,SAAA;ETowDD;ESjwDA;IACC,cAAA;IAEA,cNtaI;IMuaJ,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;IACA,yBAAA;IACA,yBAAA;ETkwDD;EShwDC;IACC,kBAAA;IACA,gBAAA;IACA,yBAAA;ETkwDF;ES7vDA;IACC,gBAAA;IACA,SAAA;IACA,cAAA;IACA,iBAAA;ET+vDD;ES5vDA;IACC,cAAA;IACA,cN/bI;IMgcJ,gCAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;ET8vDD;ES3vDD;IACC,iBAAA;IACA,gBAAA;IACA,mBAAA,EAAA,YAAA;IACA,yBAAA;IAEA,cAAA;IACA,oBAAA;IACA,SAAA;ET4vDA;ES1vDD;IACC;MACC,yBAAA;IT4vDC;IS1vDF;MACC,0CAAA;IT4vDC;EACF;AACF;AUxtEC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AV0tEF;AUvtEC;EACC,aAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AVytEF;AUxtEE;EACC,cAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AV0tEH;AUttEC;EACC,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AVwtEF;AUttEC;EACC,SAAA;EACA,aAAA;EACA,eAAA;AVwtEF;AUrtEC;EACC,YAAA;EACA,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,kCAAA;AVstEF;;AUntEA;EACC,kBAAA;EACA,gBAAA;EACA,4BAAA;AVstED;AUrtEC;EACC,6BAAA;EACA,cPxCM;AH+vER;AUttEE;EACC,sDAAA;EACA,UAAA;EACA,oBAAA;AVwtEH;AUrtEE;EACC,6BAAA;EACA,cPjDK;AHwwER;AUptEE;EACC,6BAAA;EACA,cPtDK;AH4wER;AUrtEG;EACC,qDAAA;EACA,mBPzDI;AHgxER;AUltEE;EACC,WAAA;EACA,aAAA;AVotEH;AUhtEC;EACC,6BAAA;EACA,cPzEK;EO0EL,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;EAEA,6BAAA;AVitEF;AU9sEC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AVgtEF;AU7sEC;EACC,WAAA;EACA,eAAA;AV+sEF;AU5sEC;EACC,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AV8sEF;AU3sEC;EACC,wBAAA;EACA,gBAAA;AV6sEF;AU1sEC;EACC,6BAAA;AV4sEF;AU3sEE;EACC,qDAAA;AV6sEH;AUzsEC;EACC,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AV2sEF;AU1sEE;EACC,sDAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBPjIM;EOkIN,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;AV4sEH;AU3sEG;EACC,YAAA;EACA,WAAA;AV6sEJ;AU3sEG;EACC,UAAA;EACA,WAAA;AV6sEJ;AU3sEG;EACC,UAAA;EACA,YAAA;AV6sEJ;;AUvsEA;EAGE;IACC,aAAA;IACA,WAAA;IACA,mBAAA;IACA,qBAAA;EVwsED;EUvsEC;IACC,aAAA;IACA,aAAA;IACA,cAAA;EVysEF;EUrsEA;IACC,iBAAA;IACA,qBAAA;EVusED;EUrsEA;IACC,SAAA;EVusED;EUpsEA;IACC,WAAA;IACA,eAAA;EVssED;EUnsED;IACC,mBPnLM;IOoLN,4BAAA;EVqsEA;EUnsEC;IACC,eAAA;EVqsEF;EUjsEA;IACC,6BAAA;IACA,cPhMI;EHm4EL;EUlsEC;IACC,sDAAA;IACA,UAAA;IACA,oBAAA;EVosEF;EUjsEC;IACC,cPxMG;EH24EL;EUhsEC;IACC,6BAAA;IACA,cP7MG;EH+4EL;EU9rEA;IACC,iBAAA;IACA,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,wBAAA;IAEA,6BAAA;EV+rED;EU5rEA;IACC,WAAA;EV8rED;EU3rEA;IACC,WAAA;IACA,aAAA;EV6rED;EU1rEA;IACC,iBAAA;IACA,iBAAA;EV4rED;EUzrEA;IACC,oBAAA;EV2rED;AACF;AWx6EC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AX06EF;AWv6EC;EACC,qBAAA;AXy6EF;AWt6EC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;AXw6EF;AWt6EE;EACC,cAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AXw6EH;AWt6EG;EACC,WAAA;EACA,eAAA;EACA,wBAAA;AXw6EJ;AWn6EC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AXq6EF;AWp6EE;EACC,6BAAA;EACA,cRtCI;EQuCJ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,YAAA;EACA,wBAAA;EACA,yBAAA;AXs6EH;AWr6EG;EACC,WAAA;EACA,QAAA;AXu6EJ;AWr6EG;EACC,kBAAA;EACA,cRjDK;AHw9ET;AWt6EI;EACC,WAAA;EACA,6BAAA;EACA,WAAA;EACA,cAAA;EACA,mBRvDI;EQwDJ,kBAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;AXw6EL;AWn6EC;EACC,kBAAA;AXq6EF;AWj6EE;EACC,iBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AXm6EH;AWj6EE;EACC,SAAA;AXm6EH;AWj6EE;EACC,cAAA;EACA,aAAA;EACA,aAAA;AXm6EH;AWh6EC;EACC,kBAAA;AXk6EF;;AW/5EA;EACC,aAAA;EACA,aAAA;AXk6ED;AWh6EE;EACC,sCAAA;EACA,yDAAA;AXk6EH;AWh6EE;EACC,sDAAA;EACA,UAAA;EACA,oBAAA;AXk6EH;AWh6EE;EACC,8BAAA;EACA,qBAAA;EACA,aAAA;AXk6EH;AW95EC;EACC,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EAEA,SAAA;EACA,SAAA;EACA,UAAA;EACA,2BAAA;EACA,+BAAA;AX+5EF;AW75EC;EACC,kBAAA;EACA,uCAAA;EACA,oBAAA;EACA,mBR7HM;EQ8HN,WAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;AX+5EF;AW55EC;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AX85EF;AW75EE;EACC,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;AX+5EH;AW75EE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AX+5EH;AW35EC;EACC,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,cRlKK;EQmKL,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;AX45EF;AWx5EC;EACC,qBAAA;EACA,kBAAA;EACA,cR/KK;EQgLL,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;AX05EF;AWx5EE;EACC,kBAAA;EACA,YAAA;EACA,QAAA;EACA,iBAAA;AX05EH;AWt5EC;EACC,8BAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,cAAA;EACA,cRvMK;EQwML,uBAAA;EACA,gBAAA;EAEA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;AXu5EF;AWp5EC;EACC,mBRpNK;EQqNL,WRhNM;AHsmFR;AWn5EC;EACC,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AXq5EF;AWp5EE;EACC,sDAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBRhOK;EQiOL,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;AXs5EH;AWr5EG;EACC,YAAA;EACA,WAAA;AXu5EJ;AWr5EG;EACC,UAAA;EACA,WAAA;AXu5EJ;AWr5EG;EACC,UAAA;EACA,WAAA;AXu5EJ;AWl5EC;EACC,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AXo5EF;;AWh5EA;EAGE;IACC,mBAAA;EXi5ED;EW94EA;IACC,aAAA;IACA,mBAAA;IACA,WAAA;IACA,iBAAA;EXg5ED;EW94EC;IACC,aAAA;IACA,WAAA;IACA,YAAA;EXg5EF;EW94EE;IACC,aAAA;IACA,cAAA;IACA,wBAAA;EXg5EH;EW34EA;IACC,aAAA;EX64ED;EW54EC;IACC,aAAA;EX84EF;EW14EA;IACC,2BAAA;IACA,eAAA;IACA,cAAA;IACA,iBAAA;IACA,iBAAA;IACA,YAAA;IACA,qBAAA;EX44ED;EW34EC;IACC,kBAAA;IACA,cR3SG;IQ4SH,eAAA;IACA,kBAAA;IACA,iBAAA,EAAA,YAAA;IACA,wBAAA;EX64EF;EW34EE;IACC,cAAA;IACA,kBAAA;IACA,iBAAA;EX64EH;EWv4EC;IACC,eAAA;IACA,iBAAA;EXy4EF;EWv4EC;IACC,MAAA;EXy4EF;EWv4EC;IACC,WAAA;IACA,eAAA;IACA,aAAA;EXy4EF;EWr4EA;IACC,aAAA;IACA,iBAAA;IACA,mBAAA,EAAA,YAAA;IACA,yBAAA;EXu4ED;EWr4EC;IACC,WAAA;IACA,WAAA;IACA,cAAA;IACA,mBRlVG;IQmVH,kBAAA;IACA,eAAA;EXu4EF;EWn4EA;IACC,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;EXq4ED;EWh4EC;IACC,2BAAA;EXk4EF;EWh4EC;IACC,UAAA;IACA,mBAAA;EXk4EF;EWh4EC;IACC,8BAAA;IACA,qBAAA;IACA,aAAA;EXk4EF;EW93EA;IACC,SAAA;IACA,cAAA;IACA,aAAA;IACA,SAAA;EXg4ED;EW93EA;IACC,oBAAA;IACA,mBRxXK;IQyXL,WAAA;IACA,eAAA;IACA,aAAA;IACA,aAAA;EXg4ED;EW73EA;IACC,WAAA;IACA,oBAAA;IACA,aAAA;IACA,sBAAA;IACA,WAAA;EX+3ED;EW73EC;IACC,qBAAA;EX+3EF;EW33EA;IACC,gBAAA;IACA,iBAAA;IACA,yBAAA;EX63ED;EW13EA;IACC,qBAAA;IACA,iBAAA;IACA,yBAAA;EX43ED;EWz3EA;IACC,gBAAA;IACA,qBAAA;IACA,aAAA;IAEA,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;EX03ED;EWv3EA;IACC,mBRnaI;IQoaJ,WR/ZK;EHwxFN;AACF;AYnyFA;EACC,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;AZqyFD;AYlyFE;EACC,kBAAA;EACA,aAAA;EACA,SAAA;AZoyFH;AYlyFE;EACC,aAAA;AZoyFH;AYjyFC;EACC,kBAAA;EACA,UAAA;EACA,YAAA;AZmyFF;AYjyFC;EACC,aAAA;EACA,mBAAA;AZmyFF;AYjyFE;EACC,cAAA;EACA,0BAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AZmyFH;AYjyFG;EACC,WAAA;EACA,YAAA;AZmyFJ;AY9xFC;EACC,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;AZgyFF;AY7xFC;EACC,mBAAA;AZ+xFF;;AY3xFC;EACC,gBAAA;EACA,cAAA;EACA,mBAAA;AZ8xFF;AY3xFC;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AZ6xFF;;AYxxFC;EACC,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AZ2xFF;AYxxFC;EACC,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,cTzFO;ES0FP,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;AZyxFF;AYvxFE;EACC,kBAAA;AZyxFH;AYrxFC;EACC,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,WTvGM;ESwGN,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;AZuxFF;AYrxFE;EACC,oBAAA;EACA,kBAAA;EACA,cTpHK;ESqHL,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;AZuxFH;AYtxFG;EACC,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AZwxFJ;AYpxFE;EACC,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;AZsxFH;AYpxFG;EACC,WAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;AZsxFJ;AYpxFG;EACC,kBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AZsxFJ;AYjxFC;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AZmxFF;;AY/wFC;EACC,gBAAA;EACA,cAAA;AZkxFF;AY/wFC;EACC,WAAA;EACA,aAAA;AZixFF;;AY9wFA;EACC,gBAAA;EACA,kBAAA;EACA,aAAA;AZixFD;AY/wFC;EACC,kBAAA;AZixFF;AY9wFC;EACC,cTlMM;ESmMN,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;EAEA,qBAAA;AZ+wFF;AY5wFC;EACC,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,uBAAA;EACA,cTtNM;ESuNN,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;AZ8wFF;AY7wFE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;AZ+wFH;AY9wFG;EACC,kBAAA;EACA,gBAAA;AZgxFJ;AY3wFC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EAEA,WAAA;EACA,YAAA;AZ4wFF;;AYxwFC;EACC,gBAAA;EACA,cAAA;AZ2wFF;AYxwFC;EACC,WAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AZ0wFF;;AYvwFA;EACC,kBAAA;AZ0wFD;AYxwFC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AZ0wFF;AYvwFC;EACC,qBAAA;EACA,eAAA;EACA,cTlRM;ESmRN,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA,EAAA,WAAA;EACA,wBAAA;EACA,yBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AZwwFF;AYrwFC;EACC,qBAAA;EACA,yBTvSK;ESwSL,WTnSM;AH0iGR;AYpwFC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;AZswFF;;AYnwFA;EACC;IACC,kBAAA;EZswFA;EYnwFC;IACC,aAAA;EZqwFF;EYnwFC;IACC,cAAA;EZqwFF;EYlwFA;IACC,gBAAA;IACA,mBAAA;EZowFD;EYlwFA;IACC,aAAA;IACA,uBAAA;IACA,mBAAA;IAEA,iBAAA;EZmwFD;EYjwFC;IACC,aAAA;IACA,cAAA;IACA,cAAA;IACA,0BAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EZmwFF;EYjwFE;IACC,WAAA;IACA,YAAA;EZmwFH;EY9vFA;IACC,gBAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,iBAAA;EZgwFD;EY7vFA;IACC,kBAAA;IACA,iBAAA;IACA,mBAAA,EAAA,YAAA;IACA,yBAAA;IACA,yBAAA;EZ+vFD;EY1vFA;IACC,WAAA;IACA,YAAA;IACA,sBAAA;EZ4vFD;EYzvFA;IACC,cAAA;IACA,gBAAA;IACA,eAAA;IACA,wBAAA;EZ2vFD;EYzvFC;IACC,kBAAA;IACA,gBAAA;EZ2vFF;EYvvFA;IACC,qBAAA;IACA,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;EZyvFD;EYvvFC;IACC,kBAAA;IACA,iBAAA;IACA,yBAAA;EZyvFF;EYxvFE;IACC,iBAAA;EZ0vFH;EYtvFC;IACC,mBAAA;IACA,iBAAA;IACA,yBAAA;EZwvFF;EYtvFE;IACC,iBAAA;EZwvFH;EYjvFA;IACC,aAAA;EZmvFD;EYhvFD;IACC,eAAA;EZkvFA;EYhvFA;IACC,kBAAA;IACA,WAAA;IACA,QAAA;IACA,UAAA;IAEA,YAAA;IACA,eAAA;EZivFD;EY9uFA;IACC,kBAAA;EZgvFD;EY7uFA;IACC,cThbK;ISibL,iBAAA;IACA,yBAAA;IAEA,qBAAA;EZ8uFD;EY3uFA;IACC,qBAAA;IACA,eAAA;IACA,eAAA;IACA,wBAAA;EZ6uFD;EY5uFC;IACC,kBAAA;IACA,cAAA;IACA,WAAA;IACA,aAAA;IACA,iBAAA;IACA,iBAAA,EAAA,SAAA;IACA,wBAAA;EZ8uFF;EY7uFE;IACC,kBAAA;EZ+uFH;EY1uFD;IACC,kBAAA;IACA,2BAAA;EZ4uFA;EY1uFA;IACC,aAAA;IACA,sBAAA;IACA,mBAAA;EZ4uFD;EYzuFA;IACC,qBAAA;IACA,eAAA;IACA,wBAAA;EZ2uFD;EYxuFA;IACC,mBAAA;EZ0uFD;EYruFA;IACC,aAAA;IACA,cAAA;EZuuFD;EYnuFA;IACC,WAAA;IACA,aAAA;IACA,iBAAA;IACA,mBAAA;EZquFD;EYluFA;IACC,cAAA;IACA,YAAA;EZouFD;AACF;Aa1tGC;EACC,iBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;Ab2tGF;AaztGC;EACC,sBAAA;Ab2tGF;AaxtGC;EACC,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;Ab0tGF;AavtGC;EACC,cAAA;EACA,kBAAA;EACA,eAAA;AbytGF;AattGC;EAIC,sBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AbqtGF;Aa5tGE;EACC,eAAA;Ab8tGH;AavtGE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBV1CI;AHmwGP;AavtGE;EACC,+BAAA;EACA,kBAAA;EACA,UAAA;AbytGH;AartGC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBVzDM;EU2DN,aAAA;EACA,mBAAA;EACA,uBAAA;AbstGF;AaptGE;EACC,aAAA;EACA,cAAA;AbstGH;;AaltGA;EACC,4BAAA;EACA,mBVvEO;AH4xGR;AantGE;EACC,cV3EM;EU4EN,6BAAA;AbqtGH;AantGE;EACC,iCAAA;EACA,qBAAA;AbqtGH;AajtGC;EACC,iCAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AbmtGF;AaltGE;EACC,cAAA;EACA,eAAA;AbotGH;AaltGE;EACC,YAAA;EACA,aAAA;AbotGH;AaltGE;EACC,cAAA;EACA,aAAA;AbotGH;AahtGC;EACC,kBAAA;EACA,MAAA;EACA,aAAA;EACA,UAAA;EAEA,gBAAA;EACA,cAAA;EACA,cAAA;AbitGF;Aa/sGE;EACC,cAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AbitGH;Aa7sGC;EACC,eAAA;EACA,4BAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EAEA,cVvIK;EUwIL,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;Ab6sGF;;AazsGA;EAGE;IACC,iBAAA;Eb0sGD;EaxsGA;IACC,sBAAA;Eb0sGD;EavsGA;IACC,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,WAAA;EbysGD;EatsGA;IACC,WAAA;IACA,cAAA;IACA,eAAA;EbwsGD;EarsGA;IACC,eAAA;EbusGD;EarsGC;IACC,iBAAA;EbusGF;EansGA;IACC,aAAA;IACA,cAAA;EbqsGD;EansGC;IACC,WAAA;IACA,YAAA;EbqsGF;EajsGD;IACC,4BAAA;EbmsGA;EajsGA;IACC,kBAAA;IACA,UAAA;IACA,UAAA;EbmsGD;EalsGC;IACC,YAAA;IACA,aAAA;EbosGF;EalsGC;IACC,YAAA;IACA,aAAA;EbosGF;EalsGC;IACC,YAAA;IACA,aAAA;EbosGF;EahsGA;IACC,cAAA;IACA,cAAA;IACA,aAAA;EbksGD;EahsGC;IACC,WAAA;IACA,eAAA;EbksGF;Ea9rGA;IACC,cAAA;IACA,kBAAA;IACA,aAAA;IACA,YAAA;IAEA,iBAAA;IACA,yBAAA;Eb+rGD;AACF;Acz6GC;EACC,iBAAA;EACA,WAAA;EACA,cAAA;Ad26GF;Acx6GC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qBAAA;Ad06GF;Act6GE;EACC,aAAA;EACA,mBAAA;EACA,WAAA;Adw6GH;Acp6GC;EACC,aAAA;EACA,cAAA;EACA,oBAAA;Ads6GF;Acr6GE;EACC,cAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;Adu6GH;Acn6GC;EACC,mBAAA;EACA,kBAAA;Adq6GF;Acn6GE;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBXtCK;EWuCL,kBAAA;EAEA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;Ado6GH;Acj6GE;EACC,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,iFAAA;Adm6GH;Ac/5GC;EACC,gBAAA;EACA,eAAA;Adi6GF;Ac95GC;EACC,WAAA;Adg6GF;Ac75GC;EACC,cAAA;EACA,aAAA;EACA,eAAA;Ad+5GF;Ac55GC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;Ad85GF;Ac35GC;EACC,cXpFK;EWqFL,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;Ad65GF;Acz5GE;EACC,aAAA;EACA,SAAA;Ad25GH;Acv5GC;EACC,YAAA;Ady5GF;;Acp5GC;EACC,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EAEA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBXpHK;EWsHL,aAAA;EACA,mBAAA;EACA,uBAAA;Adq5GF;Acn5GE;EACC,WAAA;EACA,YAAA;Adq5GH;Acj5GC;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cXpIK;EWqIL,kBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;Adm5GF;Ach5GC;EACC,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;EACA,mBXjJM;EWkJN,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;Adi5GF;Ac/4GC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;Adi5GF;Ac94GC;EACC,cXlKK;EWmKL,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;Adg5GF;Ac94GC;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,2BAAA;EACA,MAAA;Adg5GF;Ac74GC;EACC,WAAA;EACA,gBAAA;EACA,cXxLK;EWyLL,kBAAA;EACA,uBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;Ad84GF;Ac34GC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;Ad64GF;Ac54GE;EACC,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,yBX/MM;EWiNN,kBAAA;EACA,cAAA;EACA,YAAA;Ad64GH;Acz4GC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;Ad24GF;Acz4GE;EACC,cAAA;EACA,aAAA;EACA,cAAA;Ad24GH;Acx4GE;EACC,cAAA;EACA,cXtOI;EWuOJ,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;Ad04GH;Act4GC;EACC,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;Adw4GF;Acv4GE;EACC,cAAA;EACA,aAAA;EACA,cAAA;Ady4GH;Acv4GE;EACC,cXzPK;EW0PL,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;Ady4GH;;Acr4GA;EACC,aAAA;Adw4GD;Act4GC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,4BAAA;EACA,eAAA;Adw4GF;Act4GE;EACC,cAAA;EACA,aAAA;EACA,cAAA;Adw4GH;Act4GE;EACC,cXtRI;EWuRJ,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;Adw4GH;Acp4GC;EACC,mBX/RO;EWgSP,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;Ads4GF;Acr4GE;EACC,cAAA;EACA,aAAA;EACA,cAAA;Adu4GH;Acp4GE;EACC,cX1SK;EW2SL,kBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;Ads4GH;;Acj4GA;EACC;IACC,gBAAA;Edo4GA;Ecl4GA;IACC,iBAAA;IACA,WAAA;IACA,cAAA;Edo4GD;Ecj4GA;IACC,iBAAA;IACA,mBAAA;Edm4GD;Ec/3GC;IACC,aAAA;Edi4GF;Ec73GA;IACC,uBAAA;IACA,cAAA;Ed+3GD;Ec93GC;IACC,WAAA;IACA,kBAAA;IACA,uBAAA;Edg4GF;Ec53GA;IACC,wBAAA;IACA,qBAAA;IACA,kBAAA;Ed83GD;Ec53GC;IACC,YAAA;IACA,aAAA;Ed83GF;Ec33GC;IACC,aAAA;Ed63GF;Ecz3GA;IACC,aAAA;IACA,iBAAA;Ed23GD;Ecx3GA;IACC,cAAA;IACA,YAAA;Ed03GD;Ecv3GA;IACC,cAAA;IAEA,uBAAA;IACA,MAAA;IACA,iBAAA;Edw3GD;Ecv3GC;IACC,WAAA;IACA,aAAA;IACA,8BAAA;IACA,mBAAA;Edy3GF;Ecr3GA;IACC,iBAAA;IACA,yBAAA;IACA,qBAAA;Edu3GD;Ecp3GA;IACC,cAAA;IACA,iBAAA;Eds3GD;Ecr3GC;IACC,kBAAA;IACA,WAAA;Edu3GF;Ecn3GA;IACC,cAAA;Edq3GD;Ech3GA;IACC,YAAA;IACA,YAAA;IACA,aAAA;Edk3GD;Ech3GC;IACC,WAAA;IACA,YAAA;Edk3GF;Ec92GA;IACC,aAAA;IACA,WAAA;IACA,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;Edg3GD;Ec72GA;IACC,8BAAA;IACA,eAAA;Ed+2GD;Ec52GA;IACC,iBAAA;IACA,yBAAA;Ed82GD;Ec32GA;IACC,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;Ed62GD;Ecz2GC;IACC,WAAA;IACA,cAAA;IACA,eAAA;IACA,eAAA;IACA,UAAA;Ed22GF;Ecv2GA;IACC,WAAA;Edy2GD;Ecv2GC;IACC,aAAA;IACA,cAAA;Edy2GF;Ect2GC;IACC,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;Edw2GF;Ecp2GA;IACC,WAAA;Eds2GD;Ecr2GC;IACC,aAAA;IACA,cAAA;Edu2GF;Ecr2GC;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;Edu2GF;Ecj2GA;IACC,WAAA;IACA,eAAA;IACA,4BAAA;IACA,eAAA;Edm2GD;Ecj2GC;IACC,aAAA;IACA,cAAA;Edm2GF;Ecj2GC;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,wBAAA;Edm2GF;Ec/1GA;IACC,WAAA;IACA,kBAAA;Edi2GD;Ech2GC;IACC,aAAA;IACA,cAAA;Edk2GF;Ec/1GC;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,iBAAA;Edi2GF;AACF;Ae/1HC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;Afi2HF;Ae91HC;EACC,aAAA;EACA,mBAAA;Afg2HF;Ae91HE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EAEA,cAAA;EACA,eAAA;Af+1HH;Ae71HG;EACC,aAAA;EACA,cAAA;EACA,wBAAA;Af+1HJ;Ae11HC;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;Af41HF;Ae11HE;EACC,WAAA;EACA,eAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;Af41HH;Aex1HC;EACC,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;Af01HF;Aez1HE;EACC,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,gCAAA;EACA,6BAAA;Afy1HH;Aev1HE;EACC,aAAA;EACA,mBAAA;EACA,WAAA;Afy1HH;Aev1HE;EACC,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,YAAA;EACA,wBAAA;EACA,yBAAA;Afy1HH;Aev1HE;EACC,WAAA;EACA,YAAA;Afy1HH;Aer1HC;EACC,gBAAA;EACA,cAAA;EACA,eAAA;Afu1HF;Aep1HC;EACC,WAAA;EACA,YAAA;EACA,4BAAA;EACA,mBZ/FM;EYgGN,aAAA;EACA,sBAAA;EACA,WAAA;Afs1HF;Aen1HC;EACC,kBAAA;EACA,SAAA;EACA,aAAA;Afq1HF;Ael1HC;EACC,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EAEA,cZvHK;EYwHL,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;Afm1HF;;Aeh1HA;EACC,kBAAA;EAEA,6BAAA;Afk1HD;Aej1HC;EACC,oBAAA;Afm1HF;Aej1HC;EACC,WAAA;EACA,6BAAA;EACA,QAAA;EACA,cAAA;EACA,sBZtIM;EYwIN,kBAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;Afk1HF;Aeh1HC;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EAEA,aAAA;EACA,cAAA;EACA,kBAAA;Afi1HF;Ae/0HC;EACC,WZxJM;AHy+HR;Aeh1HE;EACC,WAAA;EACA,6BAAA;Afk1HH;Ae/0HC;EACC,6BAAA;EACA,WZhKM;AHi/HR;Ae90HC;EACC,kBAAA;Afg1HF;Ae70HE;EACC,yBZ3KM;AH0/HT;Ae30HE;EACC,yBZjLK;AH8/HR;Aez0HE;EACC,yBZpLK;AH+/HR;;Aep0HC;EACC,WAAA;EACA,eAAA;Afu0HF;Aep0HC;EACC,gBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;Afs0HF;Aen0HC;EACC,cZ5MK;EY6ML,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;Afq0HF;Aep0HE;EACC,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;Afs0HH;Ael0HC;EACC,cZ/NK;EYgOL,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,uBAAA;EACA,gBAAA;EAEA,mBAAA;Afk0HF;Ae/zHC;EACC,cZjPK;EYkPL,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;EAEA,mBAAA;Afg0HF;Ae7zHC;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;Af+zHF;Ae7zHE;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,cZxQI;EYyQJ,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;Af8zHH;Ae5zHG;EACC,aAAA;EACA,cAAA;Af8zHJ;;AezzHA;EACC,mBAAA;Af4zHD;;Ae1zHA;EACC,mBAAA;Af6zHD;;Ae3zHA;EACC,gCAAA;Af8zHD;;Ae5zHA;EACC,mBAAA;Af+zHD;;Ae7zHA;EACC,mBAAA;Afg0HD;;Ae9zHA;EACC,mBAAA;Afi0HD;;Ae/zHA;EACC,mBAAA;Afk0HD;;Aeh0HA;EACC,mBAAA;Afm0HD;;Aej0HA;EACC,mBAAA;Afo0HD;;Ael0HA;EACC,mBAAA;Afq0HD;;Aen0HA;EACC,mBAAA;Afs0HD;;Aep0HA;EACC,mBAAA;Afu0HD;;Aer0HA;EACC,mBAAA;Afw0HD;;Aet0HA;EACC,mBAAA;Afy0HD;;Aev0HA;EACC,mBAAA;Af00HD;;Aex0HA;EACC,mBAAA;Af20HD;;Aez0HA;EACC,mBAAA;Af40HD;;Ae10HA;EACC,mBAAA;Af60HD;;Ae30HA;EACC,mBAAA;Af80HD;;Ae50HA;EACC,mBAAA;Af+0HD;;Ae70HA;EACC,mBAAA;Afg1HD;;Ae90HA;EACC,mBAAA;Afi1HD;;Ae/0HA;EACC,mBAAA;Afk1HD;;Aeh1HA;EACC,mBAAA;Afm1HD;;Aej1HA;EACC,mBAAA;Afo1HD;;Ael1HA;EACC,mBAAA;Afq1HD;;Aen1HA;EACC,mBAAA;Afs1HD;;Aep1HA;EACC,mBAAA;Afu1HD;;Aer1HA;EACC,mBAAA;Afw1HD;;Aet1HA;EACC,mBAAA;Afy1HD;;Aev1HA;EACC,mBAAA;Af01HD;;Aev1HA;EACC,eAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;Af01HD;Aex1HC;EACC,aAAA;EACA,gBAAA;Af01HF;;Aev1HA;EACC,aAAA;Af01HD;;Aex1HA;EACC,aAAA;Af21HD;;Aez1HA;EACC,aAAA;Af41HD;;Ae11HA;EACC,aAAA;Af61HD;;Ae31HA;EACC,aAAA;Af81HD;;Ae51HA;EACC,aAAA;Af+1HD;;Ae71HA;EACC,aAAA;Afg2HD;;Ae91HA;EACC,aAAA;Afi2HD;;Ae/1HA;EACC,aAAA;Afk2HD;;Aeh2HA;EACC,aAAA;Afm2HD;;Aej2HA;EACC,aAAA;Afo2HD;;Ael2HA;EACC,aAAA;Afq2HD;;Aen2HA;EACC,aAAA;Afs2HD;;Aep2HA;EACC,aAAA;Afu2HD;;Aer2HA;EACC,aAAA;Afw2HD;;Aet2HA;EACC,aAAA;Afy2HD;;Aev2HA;EACC,aAAA;Af02HD;;Aex2HA;EACC,aAAA;Af22HD;;Aez2HA;EACC,aAAA;Af42HD;;Ae12HA;EACC,aAAA;Af62HD;;Ae32HA;EACC,aAAA;Af82HD;;Ae52HA;EACC,aAAA;Af+2HD;;Ae72HA;EACC,aAAA;Afg3HD;;Ae92HA;EACC,aAAA;Afi3HD;;Ae/2HA;EACC,aAAA;Afk3HD;;Aeh3HA;EACC,aAAA;Afm3HD;;Aej3HA;EACC,aAAA;Afo3HD;;Ael3HA;EACC,aAAA;Afq3HD;;Aen3HA;EACC,aAAA;Afs3HD;;Aep3HA;EACC,aAAA;Afu3HD;;Aer3HA;EACC,aAAA;Afw3HD;;Aet3HA;EACC,yBAAA;Afy3HD;;Aev3HA;EACC,aAAA;Af03HD;;Aex3HA;EACC,yBAAA;Af23HD;;Aez3HA;EACC,0BAAA;Af43HD;;Ae13HA;EACC,yBAAA;Af63HD;;Ae33HA;EACC,aAAA;Af83HD;;Ae53HA;EACC,yBAAA;Af+3HD;;Ae73HA;EACC,yBAAA;Afg4HD;;Ae93HA;EACC,yBAAA;Afi4HD;;Ae/3HA;EACC,yBAAA;Afk4HD;;Aeh4HA;EACC,yBAAA;Afm4HD;;Aej4HA;EACC,yBAAA;Afo4HD;;Ael4HA;EACC,yBAAA;Afq4HD;;Aen4HA;EACC,yBAAA;Afs4HD;;Aep4HA;EACC,yBAAA;Afu4HD;;Aer4HA;EACC,yBAAA;Afw4HD;;Aet4HA;EACC,yBAAA;Afy4HD;;Aev4HA;EACC,yBAAA;Af04HD;;Aex4HA;EACC,yBAAA;Af24HD;;Aez4HA;EACC,yBAAA;Af44HD;;Ae14HA;EACC,yBAAA;Af64HD;;Ae34HA;EACC,yBAAA;Af84HD;;Ae54HA;EACC,yBAAA;Af+4HD;;Ae74HA;EACC,yBAAA;Afg5HD;;Ae94HA;EACC,yBAAA;Afi5HD;;Ae/4HA;EACC,yBAAA;Afk5HD;;Aeh5HA;EACC,yBAAA;Afm5HD;;Aej5HA;EACC,yBAAA;Afo5HD;;Ael5HA;EACC,yBAAA;Afq5HD;;Aen5HA;EACC,yBAAA;Afs5HD;;Aep5HA;EACC,yBAAA;Afu5HD;;Aer5HA;EACC,yBAAA;Afw5HD;;Aet5HA;EACC,yBAAA;Afy5HD;;Aev5HA;EACC,yBAAA;Af05HD;;Aex5HA;EACC,wBAAA;Af25HD;;Aez5HA;EACC,kDAAA;Af45HD;;Ae15HA;EAGE;IACC,iBAAA;Ef25HD;Eev5HC;IACC,eAAA;IACA,kBAAA;IAEA,cAAA;IACA,eAAA;Efw5HF;Eet5HE;IACC,aAAA;IACA,cAAA;Efw5HH;Een5HA;IACC,kBAAA;IACA,aAAA;IACA,WAAA;IACA,MAAA;Efq5HD;Een5HC;IACC,aAAA;Efq5HF;Eej5HA;IACC,WAAA;IACA,aAAA;Efm5HD;Eel5HC;IACC,eAAA;IACA,cAAA;IACA,WAAA;IACA,YAAA;IACA,2BAAA;IACA,6BAAA;Efo5HF;Eel5HC;IACC,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,wBAAA;Efo5HF;Eeh5HA;IACC,aAAA;Efk5HD;Ee/4HD;IACC,kBAAA;IACA,6BAAA;Efi5HA;Eeh5HA;IACC,oBAAA;Efk5HD;Eeh5HA;IACC,eAAA;Efk5HD;Eeh5HA;IACC,aAAA;IACA,cAAA;Efk5HD;Ee74HA;IACC,WAAA;IACA,aAAA;Ef+4HD;Ee54HA;IACC,eAAA;Ef84HD;Ee34HA;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,wBAAA;IACA,qBAAA;Ef64HD;Ee54HC;IACC,oBAAA;IACA,aAAA;IACA,cAAA;Ef84HF;Ee14HA;IACC,iBAAA;IACA,yBAAA;IACA,qBAAA;Ef44HD;Eez4HA;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,wBAAA;IACA,qBAAA;Ef24HD;Eex4HA;IACC,gBAAA;IACA,qBAAA;Ef04HD;Eex4HC;IACC,WAAA;IACA,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;Ef04HF;Eez4HE;IACC,aAAA;IACA,cAAA;Ef24HH;Eet4HD;IACC,aAAA;IACA,cAAA;Efw4HA;Eet4HA;IACC,aAAA;IACA,cAAA;Efw4HD;AACF;AgBxlJC;EACC,aAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AhB0lJF;AgBvlJC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EAEA,oBAAA;EACA,0BAAA;EACA,yBAAA;EACA,mCAAA;AhBwlJF;AgBrlJE;EACC,cbhBM;AHumJT;AgBplJE;EACC,cblBK;AHwmJR;AgBllJC;EACC,aAAA;EACA,eAAA;AhBolJF;AgBllJE;EACC,UAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;EACA,iCAAA;AhBolJH;AgBjlJE;EACC,yBAAA;AhBmlJH;AgBhlJE;EACC,2BbpCc;EaqCd,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AhBklJH;AgBhlJG;EACC,0BAAA;AhBklJJ;AgB9kJE;EACC,cbvDM;AHuoJT;AgB7kJE;EACC,yBAAA;AhB+kJH;AgB9kJG;EACC,0BAAA;AhBglJJ;;AgB1kJA;EAGE;IACC,mBAAA;IACA,sBAAA;IACA,SAAA;IACA,gBAAA;IACA,SAAA;EhB2kJD;EgBxkJA;IACC,SAAA;IACA,eAAA;IACA,iBAAA;IACA,mBAAA;EhB0kJD;EgBvkJC;IACC,gBAAA;IACA,wBAAA;EhBykJF;EgBtkJC;IACC,eAAA;IACA,wBAAA;EhBwkJF;EgBpkJA;IACC,sBAAA;IACA,eAAA;IACA,iBAAA;EhBskJD;EgBpkJC;IACC,WAAA;IACA,iBAAA;IACA,SAAA;IACA,YAAA;IACA,gCAAA;EhBskJF;EgBnkJC;IACC,iBAAA;IACA,yBAAA;EhBqkJF;EgBlkJC;IACC,yBAAA;EhBokJF;EgBjkJC;IACC,cbvHK;EH0rJP;EgBhkJC;IACC,yBAAA;EhBkkJF;EgBjkJE;IACC,0BAAA;EhBmkJH;AACF;AiBtsJC;EACC,iBAAA;EACA,WAAA;EACA,cAAA;AjBwsJF;AiBrsJC;EACC,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AjBusJF;AiBpsJC;EACC,aAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;AjBssJF;AiBnsJC;EACC,aAAA;EACA,WAAA;AjBqsJF;AiBlsJC;EACC,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AjBosJF;AiBjsJC;EACC,sBAAA;AjBmsJF;AiBhsJC;EACC,aAAA;EACA,aAAA;EACA,sBAAA;AjBksJF;AiBjsJE;EACC,cAAA;EACA,2Bd/Bc;EcgCd,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;AjBmsJH;AiB9rJE;EACC,cAAA;AjBgsJH;AiB9rJE;EACC,cdrDM;EcsDN,yBAAA;EACA,gBAAA;AjBgsJH;AiB9rJE;EACC,kBAAA;EACA,kBAAA;AjBgsJH;AiB5rJC;EACC,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AjB8rJF;AiB3rJC;EACC,aAAA;EACA,8BAAA;EACA,cAAA;AjB6rJF;AiB1rJC;EACC,WAAA;EACA,2BAAA;AjB4rJF;;AiBvrJC;EACC,2BdhFe;EciFf,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;AjB0rJF;AiBvrJC;EACC,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;AjByrJF;AiBtrJC;EACC,cd7GK;Ec8GL,qBAAA;AjBwrJF;AiBrrJC;EACC,cdhHO;EciHP,qBAAA;AjBurJF;AiBtrJE;EACC,kBAAA;AjBwrJH;AiBtrJE;EACC,gBAAA;EACA,iBAAA;EACA,mBAAA;AjBwrJH;AiBprJE;EACC,SAAA;AjBsrJH;;AiBhrJC;EACC,iBAAA;EACA,WAAA;EACA,cAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;AjBkrJF;AiB/qJC;EACC,aAAA;EACA,mBAAA;AjBirJF;AiBhrJE;EACC,cAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AjBkrJH;AiB9qJC;EACC,WAAA;EACA,qBAAA;EACA,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,eAAA;AjBgrJF;;AiB7qJA;EACC,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,iDAAA;AjBgrJD;AiB/qJC;EACC,iDAAA;EACA,4BAAA;EACA,cd1KM;AH21JR;AiBhrJE;EACC,sDAAA;EACA,UAAA;EACA,oBAAA;AjBkrJH;AiBhrJE;EACC,8BAAA;EACA,mCAAA;AjBkrJH;AiBhrJE;EACC,6BAAA;EACA,cdtLK;AHw2JR;AiBhrJE;EACC,6BAAA;EACA,cdzLK;AH22JR;AiBhrJE;EACC,6BAAA;EACA,cd9LK;AHg3JR;AiB/qJG;EACC,6BAAA;EACA,cdnMI;AHo3JR;AiBhrJI;EACC,qDAAA;EACA,mBdtMG;AHw3JR;AiB5qJC;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,mCAAA;EACA,8BAAA;AjB8qJF;AiB7qJE;EACC,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;AjB+qJH;AiB3qJC;EACC,2BAAA;AjB6qJF;AiB1qJC;EACC,6BAAA;EAEA,qBAAA;EACA,cdzOK;Ec0OL,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;AjB2qJF;AiBxqJC;EACC,6BAAA;EACA,qBAAA;EACA,cdnPO;EcoPP,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,YAAA;EACA,wBAAA;EACA,yBAAA;AjB0qJF;AiBxqJE;EACC,kBAAA;AjB0qJH;AiBxqJE;EACC,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AjB0qJH;AiBtqJC;EACC,6BAAA;EACA,qBAAA;EAEA,2BdnQe;EcoQf,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;AjBuqJF;AiBnqJE;EACC,6BAAA;AjBqqJH;AiBpqJG;EACC,SAAA;EACA,qDAAA;AjBsqJJ;AiBjqJC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AjBmqJF;AiBjqJE;EACC,sDAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBdzSM;Ec0SN,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;AjBmqJH;AiBlqJG;EACC,cAAA;EACA,UAAA;AjBoqJJ;AiBlqJG;EACC,SAAA;EACA,WAAA;AjBoqJJ;AiBlqJG;EACC,UAAA;EACA,WAAA;AjBoqJJ;;AiB9pJA;EACC;IACC,gBAAA;EjBiqJA;EiB/pJA;IACC,eAAA;IACA,SAAA;IACA,iBAAA;EjBiqJD;EiB9pJA;IACC,kBAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,MAAA;EjBgqJD;EiB7pJA;IACC,aAAA;IACA,sBAAA;IACA,WAAA;IACA,oBAAA;EjB+pJD;EiB5pJA;IACC,aAAA;IACA,sBAAA;IACA,WAAA;EjB8pJD;EiB7pJC;IACC,QAAA;IACA,aAAA;IACA,8BAAA;EjB+pJF;EiB3pJA;IACC,gBAAA;IACA,gBAAA;EjB6pJD;EiB1pJA;IACC,oBAAA;EjB4pJD;EiBxpJC;IACC,aAAA;IACA,sBAAA;IACA,iBAAA;IACA,SAAA;IACA,iBAAA;EjB0pJF;EiBxpJC;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,yBAAA;EjB0pJF;EiBtpJA;IACC,QAAA;EjBwpJD;EiBvpJC;IACC,gBAAA;IACA,wBAAA;EjBypJF;EiBvpJC;IACC,gBAAA;IACA,gBAAA,EAAA,SAAA;IACA,wBAAA;IACA,cAAA;IACA,iBAAA;EjBypJF;EiBrpJA;IACC,gBAAA;IACA,WAAA;IACA,eAAA;IACA,QAAA;EjBupJD;EiBppJA;IACC,WAAA;EjBspJD;EiBnpJA;IACC,WAAA;IACA,mBAAA;EjBqpJD;EiBhpJA;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,yBAAA;IACA,mBAAA;EjBkpJD;EiB/oJA;IACC,iBAAA;IACA,yBAAA;EjBipJD;EiB9oJA;IACC,qBAAA;EjBgpJD;EiB7oJA;IACC,qBAAA;EjB+oJD;EiB9oJC;IACC,iBAAA;IACA,mBAAA;EjBgpJF;EiB5oJC;IACC,eAAA;EjB8oJF;EiBxoJA;IACC,eAAA;IACA,SAAA;EjB0oJD;EiBvoJA;IACC,qBAAA;EjByoJD;EiBxoJC;IACC,aAAA;IACA,YAAA;IACA,yBAAA;EjB0oJF;EiBtoJA;IACC,qBAAA;IACA,WAAA;IACA,iBAAA;IACA,0BAAA;EjBwoJD;EiBroJD;IACC,4BAAA;EjBuoJA;EiBtoJA;IACC,4BAAA;EjBwoJD;EiBvoJC;IACC,mCAAA;EjByoJF;EiBroJA;IACC,aAAA;IACA,mCAAA;EjBuoJD;EiBtoJC;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,wBAAA;EjBwoJF;EiBpoJA;IACC,uBAAA;EjBsoJD;EiBnoJA;IACC,mBAAA;IACA,iBAAA;IACA,yBAAA;EjBqoJD;EiBloJA;IACC,mBAAA;IACA,iBAAA;IACA,mBAAA,EAAA,YAAA;IACA,wBAAA;EjBooJD;EiBloJC;IACC,kBAAA;IACA,eAAA;IACA,YAAA;IACA,YAAA;EjBooJF;EiBhoJA;IACC,mBAAA;IACA,iBAAA;IACA,mBAAA,EAAA,YAAA;IACA,wBAAA;EjBkoJD;AACF;AkBvoKC;EACC,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AlByoKF;AkBtoKC;EACC,kBAAA;EACA,WAAA;AlBwoKF;AkBroKC;EACC,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,mCAAA;AlBuoKF;AkBtoKE;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;AlBwoKH;AkBtoKG;EACC,cfpBK;AH4pKT;AkBtoKG;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AlBwoKJ;AkBtoKI;EACC,2BfrBY;AH6pKjB;AkBpoKI;EACC,kBAAA;AlBsoKL;AkBpoKI;EACC,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;AlBsoKL;AkBhoKC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AlBkoKF;AkBjoKE;EACC,cfrDI;EesDJ,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;AlBmoKH;AkBhoKG;EACC,cAAA;EACA,cf/DG;EegEH,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,qBAAA;AlBkoKJ;AkBhoKG;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AlBkoKJ;AkBjoKI;EACC,kBAAA;EACA,oBAAA;EAEA,cf/EE;EegFF,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;AlBkoKL;AkBhoKK;EACC,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,2BAAA;EACA,mBfhGE;AHkuKR;AkB3nKC;EACC,cAAA;EACA,gBAAA;AlB6nKF;AkB1nKC;EACC,aAAA;EACA,0BAAA;EACA,mCAAA;EACA,sBAAA;EACA,mBAAA;AlB4nKF;AkBznKC;EACC,uBAAA;AlB2nKF;AkB1nKE;EACC,mBAAA;AlB4nKH;AkB1nKE;EACC,qBAAA;AlB4nKH;AkBxnKC;EACC,2BAAA;EACA,yBAAA;AlB0nKF;;AkBvnKA;EAGE;IACC,mBAAA;IACA,sBAAA;IACA,UAAA;ElBwnKD;EkBrnKA;IACC,eAAA;ElBunKD;EkBpnKA;IACC,sBAAA;IACA,mCAAA;ElBsnKD;EkBrnKC;IACC,aAAA;IACA,sBAAA;IACA,SAAA;IACA,yBAAA;ElBunKF;EkBrnKE;IACC,qBAAA;ElBunKH;EkBtnKG;IACC,yBAAA;IACA,eAAA;IACA,wBAAA;ElBwnKJ;EkBrnKE;IACC,SAAA;ElBunKH;EkBpnKG;IACC,kBAAA;IACA,eAAA;IACA,cAAA;IACA,UAAA;ElBsnKJ;EkBhnKA;IACC,aAAA;IACA,sBAAA;IACA,WAAA;IACA,mBAAA;ElBknKD;EkBjnKC;IACC,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;ElBmnKF;EkBhnKE;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,qBAAA;ElBknKH;EkBhnKE;IACC,WAAA;ElBknKH;EkBjnKG;IACC,kBAAA;IACA,oBAAA;IAEA,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;ElBknKJ;EkBhnKI;IACC,WAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,eAAA;ElBknKL;EkB3mKA;IACC,kBAAA;IACA,cAAA;ElB6mKD;EkB1mKA;IACC,aAAA;IACA,qBAAA;ElB4mKD;EkBzmKA;IACC,cAAA;IACA,uBAAA;ElB2mKD;EkB1mKC;IACC,mBAAA;ElB4mKF;EkB1mKC;IACC,mBAAA;ElB4mKF;EkBxmKA;IACC,mBAAA;IACA,mBAAA;IACA,2BAAA;ElB0mKD;EkBxmKC;IACC,aAAA;IACA,yBAAA;IACA,WAAA;IACA,kBAAA;IACA,cAAA;IACA,OAAA;ElB0mKF;AACF;AmBp2KC;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AnBs2KF;AmBn2KC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AnBq2KF;AmBl2KC;EACC,chBbO;EgBcP,yBAAA;AnBo2KF;AmBj2KC;EACC,yBAAA;AnBm2KF;AmBh2KC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EAEA,qBAAA;AnBi2KF;AmB91KC;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;AnBg2KF;AmB71KC;EACC,QAAA;AnB+1KF;AmB51KC;EACC,OAAA;AnB81KF;AmB31KC;EACC,eAAA;EACA,eAAA;AnB61KF;AmB11KC;EACC,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,2BhB/Ce;EgBgDf,kBAAA;EACA,mBAAA,EAAA,aAAA;AnB41KF;AmB11KE;EACC,iBAAA;EACA,gBAAA;AnB41KH;AmB31KG;EACC,mBAAA;AnB61KJ;AmBz1KE;EACC,iBAAA;EACA,yBAAA;AnB21KH;AmB11KG;EACC,mBAAA;AnB41KJ;;AmBv1KA;EAGE;IACC,kBAAA;IACA,oBAAA;IACA,uBAAA;EnBw1KD;EmBr1KA;IACC,SAAA;IACA,eAAA;IACA,qBAAA;EnBu1KD;EmBp1KA;IACC,eAAA;EnBs1KD;EmBn1KA;IACC,gBAAA;IACA,qBAAA;EnBq1KD;EmBl1KA;IACC,kBAAA;IACA,UAAA;IACA,wBAAA;IACA,SAAA;EnBo1KD;EmBj1KA;IACC,WAAA;IACA,eAAA;EnBm1KD;EmBl1KC;IACC,uBAAA;EnBo1KF;EmBh1KA;IACC,eAAA;IACA,mBAAA,EAAA,aAAA;EnBk1KD;EmBh1KC;IACC,iBAAA;EnBk1KF;EmBj1KE;IACC,qBAAA;EnBm1KH;EmB/0KC;IACC,iBAAA;IACA,yBAAA;IACA,iBAAA;EnBi1KF;EmBh1KE;IACC,qBAAA;EnBk1KH;AACF;AoB39KC;EACC,aAAA;EACA,eAAA;ApB69KF;AoB39KC;EACC,aAAA;EACA,8BAAA;ApB69KF;AoB19KC;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;ApB49KF;AoBz9KC;EACC,cjBZK;EiBaL,sCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;ApB29KF;AoBx9KC;EACC,aAAA;EACA,mBAAA;EACA,iBAAA;ApB09KF;AoBv9KC;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;ApBy9KF;AoBx9KE;EACC,aAAA;EACA,cAAA;EACA,kBAAA;ApB09KH;AoBv9KE;EACC,cAAA;EACA,sCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;ApBy9KH;AoBr9KC;EACC,eAAA;ApBu9KF;AoBp9KC;EACC,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;ApBs9KF;AoBr9KE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ApBu9KH;AoBn9KC;EACC,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;ApBq9KF;AoBl9KC;EACC,eAAA;ApBo9KF;AoBj9KC;EACC,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;ApBm9KF;AoBl9KE;EACC,cjB5FM;EiB6FN,sCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;ApBo9KH;AoBj9KE;EACC,4CAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;ApBm9KH;AoBh9KE;EACC,cjBpHI;EiBqHJ,sCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;ApBk9KH;AoB98KC;EACC,aAAA;ApBg9KF;;AoB58KA;EACC;IACC,oBAAA;EpB+8KA;EoB98KA;IACC,WAAA;IACA,iBAAA;EpBg9KD;EoB78KA;IACC,UAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;IACA,sBAAA;IACA,yBAAA;EpB+8KD;EoB58KA;IACC,sBAAA;IACA,mBAAA;EpB88KD;EoB38KA;IACC,gBAAA;IACA,cAAA;IACA,aAAA;IACA,8BAAA;EpB68KD;EoB18KA;IACC,eAAA;IACA,sBAAA;EpB48KD;EoB38KC;IACC,eAAA;IACA,qBAAA;IACA,aAAA;IACA,cAAA;EpB68KF;EoB18KC;IACC,iBAAA;IACA,iBAAA;EpB48KF;EoBx8KA;IACC,sBAAA;EpB08KD;EoBv8KA;IACC,WAAA;IACA,eAAA;IACA,sBAAA;IACA,mBAAA;EpBy8KD;EoBt8KA;IACC,gBAAA;EpBw8KD;EoBr8KA;IACC,WAAA;IACA,eAAA;EpBu8KD;EoBp8KA;IACC,kBAAA;IACA,WAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;IACA,aAAA;EpBs8KD;EoBr8KC;IACC,iBAAA;IACA,kBAAA;IACA,UAAA;EpBu8KF;EoBp8KC;IACC,iBAAA;IACA,qBAAA;IACA,kBAAA;EpBs8KF;EoBn8KC;IACC,gCAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,uBAAA;IACA,eAAA;EpBq8KF;EoBj8KA;IACC,WAAA;IACA,gBAAA;EpBm8KD;AACF;AqB/qLA;EACC,sBAAA;EACA,kBAAA;EACA,kBAAA;ArBirLD;AqBhrLC;EACC,aAAA;ArBkrLF;AqB/qLC;EACC,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,clBVK;EkBWL,4CAAA;ArBirLF;AqB9qLC;EACC,qBAAA;EACA,aAAA;EACA,sBAAA;ArBgrLF;AqB7qLC;EACC,aAAA;ArB+qLF;AqB5qLC;EACC,cAAA;EACA,eAAA;EACA,kBAAA;ArB8qLF;AqB7qLE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;ArB+qLH;AqB3qLC;EACC,kBAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;ArB6qLF;AqB3qLE;EACC,cAAA;EACA,clB1CM;EkB2CN,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;ArB6qLH;AqB1qLE;EACC,clBzDI;EkB0DJ,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,QAAA;EACA,WAAA;ArB4qLH;AqBxqLC;EACC,aAAA;ArB0qLF;AqBvqLC;EACC,oBAAA;ArByqLF;AqBtqLC;EACC,2BAAA;EACA,4CAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;ArBwqLF;AqBrqLC;EACC,cAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;ArBuqLF;AqBpqLC;EACC,YAAA;ArBsqLF;AqBnqLC;EACC,gBAAA;ArBqqLF;AqBlqLC;EACC,aAAA;ArBoqLF;;AqBhqLA;EACC;IACC,mBAAA;ErBmqLA;EqBlqLA;IACC,WAAA;IACA,iBAAA;ErBoqLD;EqBjqLA;IACC,aAAA;ErBmqLD;EqBhqLA;IACC,sBAAA;ErBkqLD;EqB/pLA;IACC,kBAAA;IACA,YAAA;IACA,WAAA;IACA,cAAA;IACA,qBAAA;ErBiqLD;EqB/pLC;IACC,gBAAA;IACA,uBAAA;ErBiqLF;EqB9pLC;IACC,OAAA;IACA,cAAA;IACA,gBAAA;IACA,SAAA;ErBgqLF;EqB5pLA;IACC,cAAA;ErB8pLD;EqB3pLA;IACC,iBAAA;ErB6pLD;EqB5pLC;IACC,aAAA;ErB8pLF;EqB1pLA;IACC,WAAA;IACA,eAAA;IACA,eAAA;ErB4pLD;EqBzpLA;IACC,sBAAA;ErB2pLD;EqBxpLA;IACC,kDAAA;IACA,gCAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,uBAAA;IACA,WAAA;ErB0pLD;EqBvpLA;IACC,cAAA;IACA,2BAAA;IACA,gCAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,uBAAA;IACA,WAAA;IACA,mBAAA;ErBypLD;EqBtpLA;IACC,WAAA;ErBwpLD;AACF;AsBh2LA;EACC,gBAAA;AtBk2LD;AsBj2LC;EACC,aAAA;EACA,eAAA;AtBm2LF;AsBj2LC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AtBm2LF;AsBl2LE;EACC,cAAA;AtBo2LH;AsBh2LC;EACC,aAAA;AtBk2LF;AsB/1LC;EACC,cnBjBK;EmBkBL,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;AtBi2LF;AsB/1LE;EACC,YAAA;EACA,aAAA;EACA,cAAA;AtBi2LH;AsBh2LG;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AtBk2LJ;AsB71LC;EACC,aAAA;EACA,uBAAA;AtB+1LF;AsB51LC;EACC,oBAAA;AtB81LF;AsB31LC;EACC,gBAAA;AtB61LF;;AsBz1LA;EAEE;IACC,WAAA;IACA,UAAA;EtB21LD;EsBx1LA;IACC,mBAAA;IACA,UAAA;EtB01LD;EsBx1LC;IACC,aAAA;EtB01LF;EsBt1LA;IACC,aAAA;EtBw1LD;EsBr1LA;IACC,iBAAA;IACA,uBAAA;IACA,cAAA;IACA,iBAAA;EtBu1LD;EsBt1LC;IACC,aAAA;IACA,cAAA;EtBw1LF;EsBp1LA;IACC,qBAAA;IACA,oBAAA;EtBs1LD;EsBn1LA;IACC,aAAA;IACA,YAAA;IACA,cAAA;IACA,oBAAA;EtBq1LD;EsBl1LA;IACC,gBAAA;EtBo1LD;AACF;AuB17LA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AvB47LD;AuB37LC;EACC,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AvB67LF;AuB57LE;EACC,aAAA;EACA,cAAA;EACA,oBAAA;AvB87LH;AuB37LE;EACC,cpBZK;EoBaL,sCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,yBAAA;AvB47LH;AuBx7LC;EACC,cAAA;EACA,qBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AvB07LF;AuBv7LC;EACC,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AvBy7LF;AuBv7LE;EACC,kBAAA;EACA,iBAAA;AvBy7LH;AuBr7LC;EACC,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AvBu7LF;AuBp7LC;EACC,aAAA;AvBs7LF;AuBn7LC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,OAAA;AvBq7LF;AuBl7LC;EACC,4BAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;AvBo7LF;AuBn7LE;EACC,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,QAAA;AvBq7LH;AuBn7LE;EACC,yBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AvBq7LH;AuBj7LC;EACC,UAAA;AvBm7LF;AuBh7LC;EACC,kBAAA;EACA,kBAAA;EACA,+BAAA;EACA,UAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,6BAAA;AvBk7LF;AuBh7LE;EACC,kBAAA;EACA,YAAA;EACA,+BAAA;EAEA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,QAAA;AvBi7LH;AuB96LC;EACC,mBAAA;AvBg7LF;AuB96LG;EACC,6BAAA;AvBg7LJ;AuB36LC;EACC,iCAAA;AvB66LF;AuB16LG;EACC,4BAAA;AvB46LJ;AuBz6LG;EACC,aAAA;AvB26LJ;AuBx6LG;EACC,4BAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AvB06LJ;AuBx6LI;EACC,iCAAA;AvB06LL;;AuBn6LA;EACC;IACC,cAAA;IACA,aAAA;IACA,sBAAA;EvBs6LA;EuBr6LA;IACC,aAAA;EvBu6LD;EuBp6LA;IACC,mBAAA;EvBs6LD;EuBn6LA;IACC,cAAA;IACA,kBAAA;IACA,MAAA;IACA,WAAA;IACA,YAAA;IACA,OAAA;EvBq6LD;EuBl6LA;IACC,mBAAA;EvBo6LD;EuBl6LC;IACC,WAAA;IACA,YAAA;IACA,oBAAA;EvBo6LF;EuBj6LC;IACC,eAAA;EvBm6LF;EuB/5LA;IACC,eAAA;EvBi6LD;EuB95LA;IACC,aAAA;IACA,iBAAA;IACA,UAAA;IACA,aAAA;IACA,YAAA;IACA,2BAAA;EvBg6LD;EuB/5LC;IACC,iBAAA;EvBi6LF;AACF;AwBvpMA;EACC,kBAAA;AxBypMD;AwBxpMC;EACC,WAAA;EACA,eAAA;AxB0pMF;AwBxpMC;EACC,crBFK;EqBGL,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AxB0pMF;AwBxpME;EACC,aAAA;AxB0pMH;AwBxpME;EACC,cAAA;EACA,YAAA;EACA,cAAA;AxB0pMH;AwBzpMG;EACC,WAAA;EACA,YAAA;AxB2pMJ;AwBtpMC;EACC,aAAA;EACA,eAAA;EACA,qBAAA;AxBwpMF;AwBrpMC;EACC,kBAAA;EAEA,qBAAA;AxBspMF;AwBnpMC;EACC,eAAA;AxBqpMF;AwBlpMC;EACC,gBAAA;AxBopMF;AwBjpMC;EACC,2BAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;AxBmpMF;AwBlpME;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,cAAA;EACA,SAAA;AxBopMH;AwBhpMC;EACC,cAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;AxBkpMF;;AwB9oMA;EAEE;IACC,iBAAA;ExBgpMD;EwB9oMA;IACC,2BAAA;IACA,uBAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,uBAAA;IACA,kBAAA;IACA,gBAAA;IACA,sBAAA;IACA,aAAA;ExBgpMD;EwB/oMC;IACC,cAAA;ExBipMF;EwB/oMC;IACC,kBAAA;IACA,cAAA;IACA,YAAA;IACA,QAAA;ExBipMF;EwB7oMA;IACC,WAAA;IACA,eAAA;IACA,mBAAA;ExB+oMD;EwB5oMA;IACC,mBAAA;ExB8oMD;AACF;AyBvwMA;EACC,kBAAA;EACA,oBAAA;AzBywMD;AyBxwMC;EACC,WAAA;EACA,kBAAA;AzB0wMF;AyBxwMC;EACC,aAAA;EACA,8BAAA;AzB0wMF;AyBvwMC;EACC,kBAAA;EACA,iBAAA;AzBywMF;AyBtwMC;EACC,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;AzBwwMF;AyBvwME;EACC,cAAA;EACA,6BAAA;AzBywMH;AyBtwME;EACC,cAAA;AzBwwMH;AyBpwMC;EACC,4BAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;AzBswMF;AyBnwMC;EACC,aAAA;EACA,qBAAA;AzBqwMF;AyBlwMC;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;AzBowMF;AyBjwMC;EACC,eAAA;AzBmwMF;AyBhwMC;EAEC,2BAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AzBiwMF;AyBhwME;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,4BAAA;EACA,0BAAA;EACA,OAAA;EACA,QAAA;EACA,6BAAA;AzBkwMH;AyB7vME;EACC,sDAAA;AzB+vMH;AyB1vME;EACC,yDAAA;AzB4vMH;AyBxvMC;EACC,aAAA;EACA,kBAAA;AzB0vMF;AyBzvME;EACC,cAAA;EACA,2BAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AzB2vMH;AyBvvMC;EACC,2BAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AzByvMF;AyBxvME;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,cAAA;EACA,SAAA;AzB0vMH;AyBtvMC;EACC,2BAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AzBwvMF;AyBrvMC;EACC,aAAA;EACA,mBAAA;AzBuvMF;AyBtvME;EACC,oBAAA;AzBwvMH;AyBtvME;EACC,mBAAA;AzBwvMH;AyBpvMC;EACC,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;AzBsvMF;AyBnvMC;EACC,cAAA;AzBqvMF;AyBlvMC;EACC,cAAA;EACA,aAAA;EACA,kCAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AzBovMF;AyBnvME;EACC,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;AzBqvMH;AyBlvME;EACC,2BAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AzBovMH;AyBlvME;EACC,cAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;AzBovMH;AyBjvME;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AzBmvMH;AyB/uMC;EACC,kBAAA;EACA,cAAA;EACA,gBAAA;AzBivMF;AyB9uMC;EACC,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,8BAAA;EACA,YAAA;AzBgvMF;AyB5uME;EACC,kCAAA;AzB8uMH;AyB1uMC;EACC,aAAA;AzB4uMF;;AyBxuMA;EACC;IACC,iBAAA;EzB2uMA;EyB1uMA;IACC,WAAA;IACA,oBAAA;IACA,gBAAA;EzB4uMD;EyBzuMA;IACC,iBAAA;EzB2uMD;EyBxuMA;IACC,sBAAA;IACA,kBAAA;EzB0uMD;EyBvuMA;IACC,eAAA;IACA,gBAAA;IACA,mBAAA;EzByuMD;EyBtuMA;IACC,2BAAA;IACA,gCAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,qBAAA;IACA,yBAAA;IACA,qBAAA;EzBwuMD;EyBtuMA;IACC,sBAAA;EzBwuMD;EyBruMA;IACC,eAAA;IACA,qBAAA;EzBuuMD;EyBpuMA;IACC,gBAAA;EzBsuMD;EyBnuMA;IACC,qBAAA;IACA,2BAAA;IACA,0BAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,uBAAA;IACA,yBAAA;IACA,kBAAA;EzBquMD;EyBpuMC;IACC,aAAA;IACA,YAAA;EzBsuMF;EyBluMA;IACC,kBAAA;EzBouMD;EyBluMC;IACC,iBAAA;IACA,kBAAA;IACA,oBAAA;IACA,gBAAA;IACA,mBAAA;IACA,yBAAA;IACA,yBAAA;EzBouMF;EyBhuMA;IACC,qBAAA;IACA,2BAAA;IACA,0BAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,uBAAA;IACA,yBAAA;IACA,kBAAA;EzBkuMD;EyBjuMC;IACC,WAAA;IACA,YAAA;EzBmuMF;EyB/tMA;IACC,kBAAA;IAEA,iBAAA;IACA,kBAAA;IACA,oBAAA;IACA,gBAAA;IACA,mBAAA;IACA,yBAAA;IACA,yBAAA;EzBguMD;EyB7tMA;IACC,WAAA;IACA,qBAAA;EzB+tMD;EyB5tMA;IACC,YAAA;EzB8tMD;EyB3tMA;IACC,aAAA;IACA,8BAAA;IACA,qBAAA;EzB6tMD;EyB1tMA;IACC,aAAA;EzB4tMD;EyBztMA;IACC,aAAA;EzB2tMD;EyBxtMA;IACC,cAAA;IACA,eAAA;EzB0tMD;EyBxtMC;IACC,iBAAA;IACA,iBAAA;IACA,uBAAA;IACA,mBAAA;EzB0tMF;EyBvtMC;IACC,iBAAA;IACA,gBAAA;IACA,qBAAA;IACA,uBAAA;EzBytMF;EyBttMC;IACC,cAAA;IACA,eAAA;EzBwtMF;EyBptMA;IACC,aAAA;EzBstMD;AACF;A0BlnNC;EACC,WAAA;EACA,eAAA;A1BonNF;A0BlnNC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;A1BonNF;A0BlnNC;EACC,cvBRK;EuBSL,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;A1BonNF;A0BnnNE;EACC,YAAA;EACA,aAAA;EACA,cAAA;A1BqnNH;A0BpnNG;EACC,WAAA;EACA,YAAA;EACA,kBAAA;A1BsnNJ;A0BjnNC;EACC,aAAA;EACA,uBAAA;A1BmnNF;A0BhnNC;EACC,WAAA;A1BknNF;A0B/mNC;EACC,aAAA;A1BinNF;;A0B7mNA;EACC;IACC,gBAAA;E1BgnNA;E0B/mNA;IACC,WAAA;IACA,iBAAA;E1BinND;E0B/mNA;IACC,aAAA;E1BinND;E0B9mNA;IACC,iBAAA;E1BgnND;E0B7mNA;IACC,cAAA;E1B+mND;E0B5mNA;IACC,cAAA;E1B8mND;E0B5mNC;IACC,WAAA;IACA,mBAAA;E1B8mNF;E0B1mNA;IACC,aAAA;E1B4mND;E0BzmNA;IACC,aAAA;E1B2mND;E0BxmNA;IACC,iBAAA;IACA,gBAAA;IACA,iBAAA;IACA,uBAAA;IACA,cAAA;IACA,mBAAA;E1B0mND;E0BxmNC;IACC,YAAA;IACA,YAAA;E1B0mNF;E0BtmNA;IACC,cAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,kBAAA;E1BwmND;AACF;A2B/sNA;EACC,oBAAA;A3BitND;A2BhtNC;EACC,WAAA;A3BktNF;A2B/sNC;EACC,aAAA;EACA,eAAA;A3BitNF;A2B9sNC;EACC,aAAA;A3BgtNF;A2B7sNC;EACC,UAAA;EACA,aAAA;A3B+sNF;A2B9sNE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;A3BgtNH;A2B5sNC;EACC,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;A3B8sNF;A2B7sNE;EACC,qBAAA;EACA,kBAAA;A3B+sNH;A2B9sNG;EACC,cAAA;EACA,cxB7BK;EwB8BL,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;A3BgtNJ;A2B7sNG;EACC,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;A3B+sNJ;A2B3sNE;EACC,kDAAA;EACA,gCAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;A3B6sNH;A2B1sNE;EACC,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;A3B4sNH;A2BxsNC;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;A3B0sNF;A2BzsNE;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;A3B2sNH;A2BxsNE;EACC,2BAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;A3B0sNH;A2BtsNC;EACC,iCAAA;EACA,qBAAA;EACA,gBAAA;A3BwsNF;A2BtsNE;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;A3BwsNH;A2BrsNE;EACC,gBAAA;A3BusNH;A2BpsNE;EACC,4BAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;A3BssNH;A2BnsNE;EACC,cAAA;EACA,4BAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;A3BqsNH;A2BjsNC;EACC,eAAA;A3BmsNF;A2BlsNE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;A3BosNH;A2BhsNC;EACC,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;A3BksNF;A2BhsNE;EACC,4BAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;A3BksNH;A2BjsNG;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,uDAAA;EACA,4BAAA;EACA,0BAAA;EACA,eAAA;EACA,WAAA;A3BmsNJ;A2BhsNG;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,sDAAA;EACA,4BAAA;EACA,0BAAA;EACA,cAAA;EACA,WAAA;A3BksNJ;A2BhsNG;EACC,6BAAA;A3BksNJ;A2B9rNE;EACC,kDAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;A3BgsNH;A2B7rNC;EAKC,UAAA;A3B2rNF;;A2BvrNA;EACC;IACC,iBAAA;E3B0rNA;E2BzrNA;IACC,UAAA;E3B2rND;E2BzrNA;IACC,aAAA;E3B2rND;E2BxrNA;IACC,cAAA;E3B0rND;E2BvrNA;IACC,aAAA;IACA,sBAAA;E3ByrND;E2BtrNA;IACC,WAAA;IACA,UAAA;IACA,YAAA;IACA,mBAAA;IACA,iBAAA;E3BwrND;E2BvrNC;IACC,qBAAA;IACA,iBAAA;E3ByrNF;E2BxrNE;IACC,gBAAA;IACA,uBAAA;E3B0rNH;E2BvrNE;IACC,OAAA;IACA,cAAA;IACA,gBAAA;IACA,UAAA;E3ByrNH;E2BrrNC;IACC,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,qBAAA;IACA,gBAAA;E3BurNF;E2BnrNA;IACC,WAAA;IACA,aAAA;IACA,oBAAA;IACA,iBAAA;E3BqrND;E2BlrNA;IACC,YAAA;IACA,WAAA;IACA,oBAAA;E3BorND;E2BjrNA;IACC,iBAAA;IACA,kBAAA;E3BmrND;E2BhrNA;IACC,WAAA;IACA,YAAA;IACA,kBAAA;IACA,WAAA;E3BkrND;E2B/qNA;IACC,WAAA;IACA,YAAA;IACA,qBAAA;E3BirND;E2BhrNC;IACC,sBAAA;IACA,qBAAA;E3BkrNF;E2B/qNC;IACC,gBAAA;E3BirNF;E2B9qNC;IACC,0BAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,uBAAA;IACA,yBAAA;IACA,mBAAA;IACA,WAAA;E3BgrNF;E2B7qNC;IACC,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,qBAAA;IACA,uBAAA;E3B+qNF;E2B3qNA;IACC,WAAA;IACA,qBAAA;IACA,iBAAA;E3B6qND;E2B5qNC;IACC,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,uBAAA;IACA,yBAAA;E3B8qNF;E2B5qNE;IACC,YAAA;E3B8qNH;E2B3qNE;IACC,aAAA;IACA,WAAA;E3B6qNH;E2BzqNC;IACC,kDAAA;IACA,kBAAA;IACA,gCAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,qBAAA;IACA,WAAA;E3B2qNF;E2BvqNA;IACC,WAAA;IACA,aAAA;E3ByqND;AACF;A4B/hOA;EACC,oBAAA;A5BiiOD;A4BhiOC;EACC,WAAA;A5BkiOF;A4B/hOC;EACC,aAAA;A5BiiOF;A4B9hOC;EACC,UAAA;EACA,kDAAA;EACA,4BAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;A5BgiOF;A4B7hOC;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;A5B+hOF;A4B5hOC;EACC,YAAA;A5B8hOF;A4B3hOC;EACC,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;A5B6hOF;A4B1hOC;EACC,gBAAA;EACA,cAAA;EACA,eAAA;A5B4hOF;A4BzhOC;EACC,YAAA;A5B2hOF;A4BxhOC;EACC,cAAA;EACA,eAAA;A5B0hOF;A4BzhOE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;A5B2hOH;A4BvhOC;EACC,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,8BAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,6BAAA;A5ByhOF;A4BthOC;EACC,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA,EAAA,SAAA;EACA,sBAAA;EACA,yBAAA;A5BwhOF;A4BthOE;EACC,mBAAA;EACA,cAAA;A5BwhOH;A4BphOC;EACC,4BAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;A5BshOF;A4BrhOE;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,iCAAA;EACA,cAAA;EACA,SAAA;A5BuhOH;A4BnhOC;EACC,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;A5BqhOF;A4BnhOE;EACC,sBAAA;EACA,kBAAA;A5BqhOH;A4BphOG;EACC,cAAA;EACA,czBzHK;EyB0HL,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;A5BshOJ;A4BnhOG;EACC,czBxIG;EyByIH,gCAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;A5BqhOJ;A4BjhOE;EACC,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;A5BmhOH;A4BlhOG;EACC,kBAAA;EACA,qBAAA;EACA,oBAAA;A5BohOJ;A4BnhOI;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,QAAA;EACA,6BAAA;EACA,iCAAA;A5BqhOL;A4BjhOG;EACC,cAAA;EACA,kBAAA;EACA,oBAAA;A5BmhOJ;A4BlhOI;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,OAAA;EACA,wDAAA;EACA,4BAAA;EACA,0BAAA;EACA,QAAA;EACA,6BAAA;A5BohOL;A4B/gOE;EACC,kDAAA;EACA,kBAAA;EACA,qBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;A5BihOH;A4B/gOG;EACC,mBAAA;A5BihOJ;A4B/gOG;EACC,gBAAA;A5BihOJ;A4B5gOC;EACC,uBAAA;A5B8gOF;A4B3gOC;EACC,cAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;A5B6gOF;A4B5gOE;EACC,8BAAA;A5B8gOH;A4B1gOC;EACC,yBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;A5B4gOF;A4BzgOC;EACC,uCAAA;A5B2gOF;A4BzgOG;EACC,yBAAA;A5B2gOJ;A4BvgOI;EACC,2BAAA;A5BygOL;A4BpgOG;EACC,aAAA;A5BsgOJ;A4BjgOC;EACC,aAAA;A5BmgOF;A4BhgOC;EACC,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;A5BkgOF;;A4B9/NA;EACC;IACC,iBAAA;E5BigOA;E4BhgOA;IACC,aAAA;E5BkgOD;E4B//NA;IACC,aAAA;E5BigOD;E4B9/NA;IACC,WAAA;IACA,sBAAA;E5BggOD;E4B9/NC;IACC,qBAAA;IACA,kBAAA;IACA,YAAA;E5BggOF;E4B//NE;IACC,gBAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,uBAAA;IACA,yBAAA;E5BigOH;E4B9/NE;IACC,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,gBAAA;IACA,WAAA;IACA,aAAA;E5BggOH;E4B5/NC;IACC,eAAA;E5B8/NF;E4B3/NC;IACC,iBAAA;E5B6/NF;E4B1/NC;IACC,iBAAA;E5B4/NF;E4Bx/NA;IACC,aAAA;IACA,eAAA;IACA,YAAA;IACA,aAAA;IACA,WAAA;E5B0/ND;AACF;A6B/0OA;EACC,oBAAA;A7Bi1OD;A6Bh1OC;EACC,WAAA;A7Bk1OF;A6B/0OC;EACC,aAAA;EACA,kBAAA;A7Bi1OF;A6B90OC;EACC,iBAAA;EACA,kBAAA;EACA,UAAA;A7Bg1OF;A6B70OC;EACC,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,4BAAA;EACA,WAAA;A7B+0OF;A6B70OE;EACC,iCAAA;A7B+0OH;A6B30OC;EACC,aAAA;EACA,sBAAA;A7B60OF;A6B10OC;EACC,aAAA;EACA,sBAAA;EACA,oBAAA;A7B40OF;A6B30OE;EACC,2BAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;A7B60OH;A6B10OE;EACC,kDAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;A7B40OH;A6Bx0OC;EACC,eAAA;A7B00OF;A6Bv0OC;EACC,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;A7By0OF;A6Bx0OE;EACC,cAAA;EACA,4BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;A7B00OH;A6Bv0OE;EACC,cAAA;EACA,4BAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;A7By0OH;A6Br0OC;EACC,cAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;A7Bu0OF;A6Br0OE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;A7Bu0OH;A6Bn0OC;EACC,iCAAA;EACA,aAAA;EACA,2BAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A7Bq0OF;A6Bp0OE;EACC,gBAAA;A7Bs0OH;A6Bl0OC;EACC,aAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;A7Bo0OF;A6Bj0OC;EACC,2CAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A7Bm0OF;A6Bj0OE;EACC,kBAAA;EACA,2BAAA;EACA,cAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;A7Bm0OH;A6Bl0OG;EACC,kBAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,QAAA;A7Bo0OJ;A6B/zOC;EACC,cAAA;EACA,YAAA;EACA,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;A7Bi0OF;A6B9zOC;EACC,UAAA;A7Bg0OF;A6B/zOE;EACC,iCAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;A7Bi0OH;A6B9zOE;EACC,4BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;A7Bg0OH;A6B5zOC;EACC,aAAA;EACA,8BAAA;A7B8zOF;A6B3zOC;EACC,aAAA;EACA,mBAAA;EACA,qBAAA;A7B6zOF;A6B5zOE;EACC,yBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;A7B8zOH;A6B3zOE;EACC,uDAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;A7B6zOH;A6B5zOG;EACC,kBAAA;EACA,YAAA;EACA,uDAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,yBAAA;EACA,QAAA;A7B6zOJ;A6BxzOC;EACC,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kCAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;A7B0zOF;A6BxzOE;EACC,2BAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;A7B0zOH;A6BvzOE;EACC,2BAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;A7ByzOH;A6BtzOE;EACC,uDAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;A7BwzOH;A6BvzOG;EACC,kBAAA;EACA,YAAA;EACA,QAAA;A7ByzOJ;A6BrzOE;EACC,cAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;A7BuzOH;A6BpzOE;EACC,gBAAA;EACA,yCAAA;A7BszOH;A6BrzOG;EACC,0CAAA;A7BuzOJ;A6BrzOK;EACC,2BAAA;A7BuzON;A6BjzOI;EACC,a1BpUE;AHunPP;;A6B5yOA;EAEE;IACC,UAAA;IACA,WAAA;E7B8yOD;E6B3yOA;IACC,sBAAA;E7B6yOD;E6B1yOA;IACC,WAAA;IACA,uBAAA;IACA,aAAA;IACA,sBAAA;E7B4yOD;E6BzyOA;IACC,kBAAA;IACA,2BAAA;IACA,cAAA;IACA,YAAA;IACA,aAAA;IACA,eAAA;IACA,mBAAA;E7B2yOD;E6BzyOC;IACC,gCAAA;E7B2yOF;E6BvyOA;IACC,QAAA;IACA,mBAAA;E7ByyOD;E6BvyOC;IACC,eAAA;IACA,mBAAA;IACA,WAAA;IACA,sBAAA;E7ByyOF;E6BvyOE;IACC,aAAA;E7ByyOH;E6BryOC;IACC,iBAAA;E7BuyOF;E6BpyOA;IACC,QAAA;IACA,qBAAA;E7BsyOD;E6BnyOA;IACC,oBAAA;E7BqyOD;E6BpyOC;IACC,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,uBAAA;E7BsyOF;E6BnyOC;IACC,iBAAA;IACA,kBAAA;IACA,gBAAA;E7BqyOF;E6BjyOA;IACC,iBAAA;IACA,WAAA;IACA,aAAA;IACA,QAAA;IACA,qBAAA;E7BmyOD;E6BhyOA;IACC,QAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,qBAAA;IACA,qBAAA;E7BkyOD;E6BhyOC;IACC,WAAA;IACA,eAAA;E7BkyOF;E6B9xOA;IACC,iBAAA;IACA,QAAA;IACA,kBAAA;E7BgyOD;E6B7xOA;IACC,UAAA;IACA,aAAA;E7B+xOD;E6B7xOC;IACC,iBAAA;IACA,mBAAA;E7B+xOF;E6B9xOE;IACC,eAAA;E7BgyOH;E6B3xOA;IACC,UAAA;IACA,aAAA;E7B6xOD;E6B5xOC;IACC,iBAAA;E7B8xOF;E6B1xOA;IACC,WAAA;E7B4xOD;E6B3xOC;IACC,qBAAA;E7B6xOF;E6B1xOC;IACC,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,uBAAA;IACA,yBAAA;IACA,qBAAA;E7B4xOF;E6BxxOA;IACC,kBAAA;IACA,iBAAA;IACA,cAAA;IACA,cAAA;IACA,eAAA;IACA,cAAA;IACA,iBAAA;IACA,cAAA;IACA,YAAA;E7B0xOD;E6BzxOC;IACC,iBAAA;IACA,qBAAA;E7B2xOF;E6BxxOC;IACC,qBAAA;IACA,iBAAA;E7B0xOF;E6BvxOC;IACC,iBAAA;IACA,mBAAA;IACA,qBAAA;E7ByxOF;E6BtxOC;IACC,cAAA;IACA,eAAA;E7BwxOF;E6BpxOA;IACC,0BAAA;E7BsxOD;E6BnxOA;IACC,qBAAA;E7BqxOD;E6BnxOC;IACC,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,qBAAA;IACA,oBAAA;E7BqxOF;E6BlxOC;IACC,iBAAA;E7BoxOF;AACF;AkBhyPC;EACC,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AlBkyPF;AkB/xPC;EACC,kBAAA;EACA,WAAA;AlBiyPF;AkB9xPC;EACC,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,mCAAA;AlBgyPF;AkB/xPE;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;AlBiyPH;AkB/xPG;EACC,cfpBK;AHqzPT;AkB/xPG;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AlBiyPJ;AkB/xPI;EACC,2BfrBY;AHszPjB;AkB7xPI;EACC,kBAAA;AlB+xPL;AkB7xPI;EACC,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;AlB+xPL;AkBzxPC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AlB2xPF;AkB1xPE;EACC,cfrDI;EesDJ,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;AlB4xPH;AkBzxPG;EACC,cAAA;EACA,cf/DG;EegEH,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,qBAAA;AlB2xPJ;AkBzxPG;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AlB2xPJ;AkB1xPI;EACC,kBAAA;EACA,oBAAA;EAEA,cf/EE;EegFF,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,yBAAA;AlB2xPL;AkBzxPK;EACC,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,2BAAA;EACA,mBfhGE;AH23PR;AkBpxPC;EACC,cAAA;EACA,gBAAA;AlBsxPF;AkBnxPC;EACC,aAAA;EACA,0BAAA;EACA,mCAAA;EACA,sBAAA;EACA,mBAAA;AlBqxPF;AkBlxPC;EACC,uBAAA;AlBoxPF;AkBnxPE;EACC,mBAAA;AlBqxPH;AkBnxPE;EACC,qBAAA;AlBqxPH;AkBjxPC;EACC,2BAAA;EACA,yBAAA;AlBmxPF;;AkBhxPA;EAGE;IACC,mBAAA;IACA,sBAAA;IACA,UAAA;ElBixPD;EkB9wPA;IACC,eAAA;ElBgxPD;EkB7wPA;IACC,sBAAA;IACA,mCAAA;ElB+wPD;EkB9wPC;IACC,aAAA;IACA,sBAAA;IACA,SAAA;IACA,yBAAA;ElBgxPF;EkB9wPE;IACC,qBAAA;ElBgxPH;EkB/wPG;IACC,yBAAA;IACA,eAAA;IACA,wBAAA;ElBixPJ;EkB9wPE;IACC,SAAA;ElBgxPH;EkB7wPG;IACC,kBAAA;IACA,eAAA;IACA,cAAA;IACA,UAAA;ElB+wPJ;EkBzwPA;IACC,aAAA;IACA,sBAAA;IACA,WAAA;IACA,mBAAA;ElB2wPD;EkB1wPC;IACC,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;ElB4wPF;EkBzwPE;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,qBAAA;ElB2wPH;EkBzwPE;IACC,WAAA;ElB2wPH;EkB1wPG;IACC,kBAAA;IACA,oBAAA;IAEA,iBAAA;IACA,iBAAA,EAAA,aAAA;IACA,yBAAA;ElB2wPJ;EkBzwPI;IACC,WAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,eAAA;ElB2wPL;EkBpwPA;IACC,kBAAA;IACA,cAAA;ElBswPD;EkBnwPA;IACC,aAAA;IACA,qBAAA;ElBqwPD;EkBlwPA;IACC,cAAA;IACA,uBAAA;ElBowPD;EkBnwPC;IACC,mBAAA;ElBqwPF;EkBnwPC;IACC,mBAAA;ElBqwPF;EkBjwPA;IACC,mBAAA;IACA,mBAAA;IACA,2BAAA;ElBmwPD;EkBjwPC;IACC,aAAA;IACA,yBAAA;IACA,WAAA;IACA,kBAAA;IACA,cAAA;IACA,OAAA;ElBmwPF;AACF;AiB7/PC;EACC,iBAAA;EACA,WAAA;EACA,cAAA;AjB+/PF;AiB5/PC;EACC,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AjB8/PF;AiB3/PC;EACC,aAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;AjB6/PF;AiB1/PC;EACC,aAAA;EACA,WAAA;AjB4/PF;AiBz/PC;EACC,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AjB2/PF;AiBx/PC;EACC,sBAAA;AjB0/PF;AiBv/PC;EACC,aAAA;EACA,aAAA;EACA,sBAAA;AjBy/PF;AiBx/PE;EACC,cAAA;EACA,2Bd/Bc;EcgCd,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;AjB0/PH;AiBr/PE;EACC,cAAA;AjBu/PH;AiBr/PE;EACC,cdrDM;EcsDN,yBAAA;EACA,gBAAA;AjBu/PH;AiBr/PE;EACC,kBAAA;EACA,kBAAA;AjBu/PH;AiBn/PC;EACC,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AjBq/PF;AiBl/PC;EACC,aAAA;EACA,8BAAA;EACA,cAAA;AjBo/PF;AiBj/PC;EACC,WAAA;EACA,2BAAA;AjBm/PF;;AiB9+PC;EACC,2BdhFe;EciFf,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;AjBi/PF;AiB9+PC;EACC,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;AjBg/PF;AiB7+PC;EACC,cd7GK;Ec8GL,qBAAA;AjB++PF;AiB5+PC;EACC,cdhHO;EciHP,qBAAA;AjB8+PF;AiB7+PE;EACC,kBAAA;AjB++PH;AiB7+PE;EACC,gBAAA;EACA,iBAAA;EACA,mBAAA;AjB++PH;AiB3+PE;EACC,SAAA;AjB6+PH;;AiBv+PC;EACC,iBAAA;EACA,WAAA;EACA,cAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;AjBy+PF;AiBt+PC;EACC,aAAA;EACA,mBAAA;AjBw+PF;AiBv+PE;EACC,cAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AjBy+PH;AiBr+PC;EACC,WAAA;EACA,qBAAA;EACA,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,eAAA;AjBu+PF;;AiBp+PA;EACC,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,iDAAA;AjBu+PD;AiBt+PC;EACC,iDAAA;EACA,4BAAA;EACA,cd1KM;AHkpQR;AiBv+PE;EACC,sDAAA;EACA,UAAA;EACA,oBAAA;AjBy+PH;AiBv+PE;EACC,8BAAA;EACA,mCAAA;AjBy+PH;AiBv+PE;EACC,6BAAA;EACA,cdtLK;AH+pQR;AiBv+PE;EACC,6BAAA;EACA,cdzLK;AHkqQR;AiBv+PE;EACC,6BAAA;EACA,cd9LK;AHuqQR;AiBt+PG;EACC,6BAAA;EACA,cdnMI;AH2qQR;AiBv+PI;EACC,qDAAA;EACA,mBdtMG;AH+qQR;AiBn+PC;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,mCAAA;EACA,8BAAA;AjBq+PF;AiBp+PE;EACC,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;AjBs+PH;AiBl+PC;EACC,2BAAA;AjBo+PF;AiBj+PC;EACC,6BAAA;EAEA,qBAAA;EACA,cdzOK;Ec0OL,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;EACA,yBAAA;AjBk+PF;AiB/9PC;EACC,6BAAA;EACA,qBAAA;EACA,cdnPO;EcoPP,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,YAAA;EACA,wBAAA;EACA,yBAAA;AjBi+PF;AiB/9PE;EACC,kBAAA;AjBi+PH;AiB/9PE;EACC,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AjBi+PH;AiB79PC;EACC,6BAAA;EACA,qBAAA;EAEA,2BdnQe;EcoQf,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA,EAAA,aAAA;EACA,wBAAA;EACA,yBAAA;AjB89PF;AiB19PE;EACC,6BAAA;AjB49PH;AiB39PG;EACC,SAAA;EACA,qDAAA;AjB69PJ;AiBx9PC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AjB09PF;AiBx9PE;EACC,sDAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBdzSM;Ec0SN,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;AjB09PH;AiBz9PG;EACC,cAAA;EACA,UAAA;AjB29PJ;AiBz9PG;EACC,SAAA;EACA,WAAA;AjB29PJ;AiBz9PG;EACC,UAAA;EACA,WAAA;AjB29PJ;;AiBr9PA;EACC;IACC,gBAAA;EjBw9PA;EiBt9PA;IACC,eAAA;IACA,SAAA;IACA,iBAAA;EjBw9PD;EiBr9PA;IACC,kBAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,MAAA;EjBu9PD;EiBp9PA;IACC,aAAA;IACA,sBAAA;IACA,WAAA;IACA,oBAAA;EjBs9PD;EiBn9PA;IACC,aAAA;IACA,sBAAA;IACA,WAAA;EjBq9PD;EiBp9PC;IACC,QAAA;IACA,aAAA;IACA,8BAAA;EjBs9PF;EiBl9PA;IACC,gBAAA;IACA,gBAAA;EjBo9PD;EiBj9PA;IACC,oBAAA;EjBm9PD;EiB/8PC;IACC,aAAA;IACA,sBAAA;IACA,iBAAA;IACA,SAAA;IACA,iBAAA;EjBi9PF;EiB/8PC;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,yBAAA;EjBi9PF;EiB78PA;IACC,QAAA;EjB+8PD;EiB98PC;IACC,gBAAA;IACA,wBAAA;EjBg9PF;EiB98PC;IACC,gBAAA;IACA,gBAAA,EAAA,SAAA;IACA,wBAAA;IACA,cAAA;IACA,iBAAA;EjBg9PF;EiB58PA;IACC,gBAAA;IACA,WAAA;IACA,eAAA;IACA,QAAA;EjB88PD;EiB38PA;IACC,WAAA;EjB68PD;EiB18PA;IACC,WAAA;IACA,mBAAA;EjB48PD;EiBv8PA;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,yBAAA;IACA,mBAAA;EjBy8PD;EiBt8PA;IACC,iBAAA;IACA,yBAAA;EjBw8PD;EiBr8PA;IACC,qBAAA;EjBu8PD;EiBp8PA;IACC,qBAAA;EjBs8PD;EiBr8PC;IACC,iBAAA;IACA,mBAAA;EjBu8PF;EiBn8PC;IACC,eAAA;EjBq8PF;EiB/7PA;IACC,eAAA;IACA,SAAA;EjBi8PD;EiB97PA;IACC,qBAAA;EjBg8PD;EiB/7PC;IACC,aAAA;IACA,YAAA;IACA,yBAAA;EjBi8PF;EiB77PA;IACC,qBAAA;IACA,WAAA;IACA,iBAAA;IACA,0BAAA;EjB+7PD;EiB57PD;IACC,4BAAA;EjB87PA;EiB77PA;IACC,4BAAA;EjB+7PD;EiB97PC;IACC,mCAAA;EjBg8PF;EiB57PA;IACC,aAAA;IACA,mCAAA;EjB87PD;EiB77PC;IACC,iBAAA;IACA,mBAAA,EAAA,aAAA;IACA,wBAAA;EjB+7PF;EiB37PA;IACC,uBAAA;EjB67PD;EiB17PA;IACC,mBAAA;IACA,iBAAA;IACA,yBAAA;EjB47PD;EiBz7PA;IACC,mBAAA;IACA,iBAAA;IACA,mBAAA,EAAA,YAAA;IACA,wBAAA;EjB27PD;EiBz7PC;IACC,kBAAA;IACA,eAAA;IACA,YAAA;IACA,YAAA;EjB27PF;EiBv7PA;IACC,mBAAA;IACA,iBAAA;IACA,mBAAA,EAAA,YAAA;IACA,wBAAA;EjBy7PD;AACF;A8Bh8QA;EACC,mBAAA;A9Bk8QD;A8Bj8QC;EACC,WAAA;A9Bm8QF;A8Bh8QC;EACC,aAAA;EACA,kBAAA;A9Bk8QF;A8B/7QC;EACC,kBAAA;EACA,UAAA;A9Bi8QF;A8Bh8QE;EACC,kBAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,UAAA;A9Bk8QH;A8B/7QE;EACC,gBAAA;EACA,WAAA;EACA,aAAA;A9Bi8QH;A8B97QE;EACC,YAAA;A9Bg8QH;A8B77QE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;A9B+7QH;A8B37QC;EACC,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;EACA,UAAA;EACA,eAAA;A9B67QF;A8B17QC;EACC,YAAA;A9B47QF;A8Bz7QC;EACC,cAAA;EACA,sCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;A9B27QF;A8B17QE;EACC,kBAAA;A9B47QH;A8Bx7QC;EACC,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;A9B07QF;A8Bz7QE;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,sBAAA;A9B27QH;A8Bx7QE;EACC,YAAA;A9B07QH;A8Bv7QE;EACC,cAAA;EACA,eAAA;A9By7QH;A8Bv7QG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;A9By7QJ;A8Br7QE;EACC,WAAA;EACA,aAAA;EACA,8BAAA;A9Bu7QH;A8Bp7QE;EACC,2BAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;A9Bs7QH;A8Bl7QC;EACC,cAAA;EACA,gBAAA;A9Bo7QF;A8Bj7QC;EACC,YAAA;A9Bm7QF;A8Bh7QC;EACC,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;A9Bk7QF;A8B/6QC;EACC,mBAAA;A9Bi7QF;;A8B76QA;EACC;IACC,gBAAA;E9Bg7QA;E8B/6QA;IACC,WAAA;IACA,UAAA;E9Bi7QD;E8B96QA;IACC,sBAAA;E9Bg7QD;E8B76QA;IACC,WAAA;E9B+6QD;E8B76QC;IACC,aAAA;E9B+6QF;E8B36QA;IACC,WAAA;IACA,cAAA;IACA,aAAA;IACA,iBAAA;IACA,iBAAA;E9B66QD;E8B56QC;IACC,cAAA;IACA,aAAA;IACA,gBAAA;E9B86QF;E8B16QA;IACC,iBAAA;IACA,YAAA;IACA,WAAA;IACA,wBAAA;E9B46QD;E8B36QC;IACC,aAAA;E9B66QF;E8Bz6QA;IACC,WAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;IACA,YAAA;E9B26QD;E8Bx6QA;IACC,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,sBAAA;IACA,yBAAA;IACA,YAAA;IACA,gBAAA;E9B06QD;E8Bz6QC;IACC,aAAA;E9B26QF;E8Bv6QA;IACC,gBAAA;IACA,kBAAA;IACA,YAAA;IACA,MAAA;E9By6QD;E8Bt6QA;IACC,YAAA;IACA,aAAA;E9Bw6QD;E8Br6QA;IACC,kBAAA;IACA,YAAA;IACA,aAAA;E9Bu6QD;E8Bp6QA;IACC,WAAA;IACA,2BAAA;IACA,gCAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,qBAAA;E9Bs6QD;E8Bn6QA;IACC,2BAAA;IACA,UAAA;IACA,YAAA;IACA,cAAA;IACA,YAAA;IACA,YAAA;E9Bq6QD;AACF;A+BvpRC;EACC,WAAA;EACA,eAAA;A/BypRF;A+BvpRC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;A/BypRF;A+BxpRE;EACC,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;A/B0pRH;A+BzpRG;EACC,WAAA;EACA,YAAA;A/B2pRJ;A+BvpRC;EACC,qBAAA;A/BypRF;A+BtpRC;EACC,iBAAA;A/BwpRF;A+BrpRC;EACC,kBAAA;EACA,cAAA;A/BupRF;A+BrpRC;EACC,2BAAA;EAEA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;A/BspRF;A+BrpRE;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,cAAA;EACA,SAAA;A/BupRH;A+BnpRC;EACC,aAAA;EACA,qCAAA;EACA,WAAA;EACA,qBAAA;A/BqpRF;A+BhpRK;EACC,2BAAA;A/BkpRN;A+B/oRK;EACC,2BAAA;A/BipRN;A+B9oRK;EACC,2BAAA;A/BgpRN;A+B5oRG;EACC,iCAAA;A/B8oRJ;A+B3oRG;EACC,4BAAA;A/B6oRJ;A+B1oRG;EACC,4BAAA;A/B4oRJ;A+BzoRG;EACC,4BAAA;A/B2oRJ;A+BxoRG;EACC,kCAAA;A/B0oRJ;A+BroRC;EACC,qBAAA;A/BuoRF;A+BpoRC;EACC,2BAAA;EACA,kBAAA;EACA,qBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;A/BsoRF;A+BnoRC;EACC,aAAA;EACA,eAAA;EACA,qBAAA;A/BqoRF;A+BpoRE;EACC,oBAAA;A/BsoRH;A+BnoRE;EACC,eAAA;A/BqoRH;A+BjoRC;EACC,aAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;A/BmoRF;;A+B/nRA;EAEE;IACC,iBAAA;E/BioRD;E+B9nRA;IACC,kBAAA;IACA,iBAAA;IACA,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,wBAAA;IACA,gBAAA;E/BgoRD;E+B/nRC;IACC,cAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;IACA,cAAA;IACA,SAAA;IACA,QAAA;E/BioRF;E+B9nRA;IACC,aAAA;IACA,sBAAA;E/BgoRD;E+B3nRI;IACC,W5B7KC;EH0yRN;E+B1nRI;IACC,W5BjLC;EH6yRN;E+BznRI;IACC,W5BrLC;EHgzRN;E+BpnRA;IACC,WAAA;E/BsnRD;E+BnnRA;IACC,eAAA;E/BqnRD;AACF;AgCj0RA;EACC,oBAAA;AhCm0RD;AgCj0RC;EACC,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AhCm0RF;AgCh0RC;EACC,cAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AhCk0RF;AgC/zRC;EACC,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AhCi0RF;AgC9zRC;EACC,cAAA;AhCg0RF;;AgC7zRA;EAEE;IACC,WAAA;IACA,eAAA;EhC+zRD;EgC5zRA;IACC,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,sBAAA;IACA,yBAAA;IACA,qBAAA;EhC8zRD;AACF;AA10RA;EACC,aAAA;AA40RD;;AAz0RA;EACC;IACC,cAAA;EA40RA;EA10RD;IACC,aAAA;EA40RA;AACF","sourcesContent":["@import \"./scss/fonts\";\n@import \"./scss/libs/settings\";\n@import \"./scss/libs/set\";\n@import \"./scss/style\";\n\n@import \"./scss/components/header\";\n@import \"./scss/components/footer\";\n@import \"./scss/components/modal\";\n@import \"./scss/components/ticker\";\n\n@import \"./scss/pages/main-page/main-banner\";\n@import \"./scss/pages/main-page/main-news\";\n@import \"./scss/pages/main-page/main-menu\";\n@import \"./scss/pages/main-page/main-sale\";\n@import \"./scss/pages/main-page/main-advantages\";\n@import \"./scss/pages/main-page/main-reviews\";\n@import \"./scss/pages/main-page/main-map\";\n@import \"./scss/pages/contacts\";\n@import \"./scss/pages/vacancy\";\n@import \"./scss/pages/vacancy-detail\";\n@import \"./scss/pages/news-detail\";\n@import \"./scss/pages/main-page/service-delivery\";\n@import \"./scss/pages/main-delivery\";\n@import \"./scss/pages/main-page/sliders-delivery\";\n@import \"./scss/pages/main-page/delivery-box\";\n@import \"./scss/pages/main-page/stock\";\n@import \"./scss/pages/detailed-promotions\";\n@import \"./scss/pages/other-promotions\";\n@import \"./scss/pages/about\";\n@import \"./scss/pages/menu-main\";\n@import \"./scss/pages/position-card\";\n@import \"./scss/pages/vacancy-detail.scss\";\n@import \"./scss/pages/vacancy.scss\";\n@import \"./scss/pages/stock-main\";\n@import \"./scss/pages/menu\";\n@import \"./scss/pages/error-four\";\n\n\n\n.mobile {\n\tdisplay: none;\n}\n\n@media (max-width: 48em) {\n\t.mobile {\n\t\tdisplay: block;\n\t}\n\t.desktop {\n\t\tdisplay: none;\n\t}\n}\n","@font-face {\n\tfont-family: \"Alumni Sans\";\n\tsrc: url(\"../assets/fonts/AlumniSans-SemiBold.woff2\") format(\"woff2\"), url(\"../assets/fonts/AlumniSans-SemiBold.woff\") format(\"woff\"),\n\t\turl(\"../assets/fonts/AlumniSans-SemiBold.ttf\") format(\"truetype\");\n\tfont-weight: 600;\n\tfont-style: normal;\n\tfont-display: swap;\n}\n@font-face {\n\tfont-family: \"Alumni Sans\";\n\tsrc: url(\"../assets/fonts/AlumniSans-SemiBoldItalic.woff2\") format(\"woff2\"), url(\"../assets/fonts/AlumniSans-SemiBoldItalic.woff\") format(\"woff\"),\n\t\turl(\"../assets/fonts/AlumniSans-SemiBoldItalic.ttf\") format(\"truetype\");\n\tfont-weight: 600;\n\tfont-style: italic;\n\tfont-display: swap;\n}\n@font-face {\n\tfont-family: \"Euclid Circular A\";\n\tsrc: url(\"../assets/fonts/EuclidCircularA-Medium.woff2\") format(\"woff2\"), url(\"../assets/fonts/EuclidCircularA-Medium.woff\") format(\"woff\"),\n\t\turl(\"../assets/fonts/EuclidCircularA-Medium.ttf\") format(\"truetype\");\n\tfont-weight: 500;\n\tfont-style: normal;\n\tfont-display: swap;\n}\n@font-face {\n\tfont-family: \"Euclid Circular A\";\n\tsrc: url(\"../assets/fonts/EuclidCircularA-Regular.woff2\") format(\"woff2\"), url(\"../assets/fonts/EuclidCircularA-Regular.woff\") format(\"woff\"),\n\t\turl(\"../assets/fonts/EuclidCircularA-Regular.ttf\") format(\"truetype\");\n\tfont-weight: normal;\n\tfont-style: normal;\n\tfont-display: swap;\n}\n@font-face {\n\tfont-family: \"Literata\";\n\tsrc: url(\"../assets/fonts/Literata-Medium.woff2\") format(\"woff2\"), url(\"../assets/fonts/Literata-Medium.woff\") format(\"woff\"),\n\t\turl(\"../assets/fonts/Literata-Medium.ttf\") format(\"truetype\");\n\tfont-weight: 500;\n\tfont-style: normal;\n\tfont-display: swap;\n}\n@font-face {\n\tfont-family: \"Literata\";\n\tsrc: url(\"../assets/fonts/Literata-Regular.woff2\") format(\"woff2\"), url(\"../assets/fonts/Literata-Regular.woff\") format(\"woff\"),\n\t\turl(\"../assets/fonts/Literata-Regular.ttf\") format(\"truetype\");\n\tfont-weight: 400;\n\tfont-style: normal;\n\tfont-display: swap;\n}\n","*,\n*::before,\n*::after {\n\tbox-sizing: border-box;\n}\nhtml {\n\tfont-family: $font; // шрифт по умолчанию по сайту\n\tfont-size: 0.5208335vw; // на разрешении 1920 0.520835vw === 10px\n\tfont-style: normal;\n\tfont-weight: normal;\n\t-webkit-animation: bugfix infinite 1s;\n\tline-height: normal;\n\tmargin: 0;\n\tpadding: 0;\n}\n\nbody {\n\tfont-optical-sizing: none;\n\tfont-style: normal;\n\tfont-weight: normal;\n\t-webkit-animation: bugfix infinite 1s;\n\tline-height: normal;\n\tmargin: 0;\n\tpadding: 0;\n\tcolor: $fontColor; // цвет по умолчанию текста по сайту\n\tbackground-color: $bg;\n}\n\ninput,\ntextarea {\n\t-webkit-animation: bugfix infinite 1s;\n\tline-height: inherit;\n\tmargin: 0;\n\tpadding: 0;\n\tbackground-color: transparent;\n\tborder: none;\n\tcolor: inherit;\n}\na {\n\tcolor: unset;\n}\na,\na:hover {\n\ttext-decoration: none;\n}\n\nbutton,\ninput,\na,\ntextarea {\n\toutline: none;\n\tcursor: pointer;\n\tfont: inherit;\n\t&:focus {\n\t\toutline: none;\n\t}\n\t&:active {\n\t\toutline: none;\n\t}\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\tfont: inherit;\n\tmargin: 0;\n\tpadding: 0;\n}\np {\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n}\n\nimg,\nsvg {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n\tdisplay: block;\n}\n\nbutton {\n\tborder: none;\n\tcolor: inherit;\n\tfont: inherit;\n\ttext-align: inherit;\n\tpadding: 0;\n\tbackground-color: transparent;\n}\nul {\n\tpadding: 0;\n\tmargin: 0;\n}\n\nul li {\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style: none;\n}\n\n.container {\n\twidth: $containerWidth;\n\tmargin: 0 auto;\n}\n\nsection {\n\tmargin-bottom: $sectionMargin;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n\t-webkit-appearance: none;\n\tmargin: 0;\n}\n\ninput[type=\"number\"] {\n\t-moz-appearance: textfield;\n}\n\n@media (min-width: 1920px) {\n\thtml {\n\t\tfont-size: 10px;\n\t}\n}\n\n@media (max-width: 48em) {\n\thtml {\n\t\tfont-size: 5px;\n\t\tfont-size: 1.5625vw;\n\t\tfont-size: calc((100 / $mobileLayout) * 5vw); // где 375 это ширина моб версии макета\n\t\t-webkit-text-size-adjust: none;\n\t}\n\n\tbody {\n\t\t-webkit-text-size-adjust: none;\n\t}\n\n\tsection {\n\t\tmargin-bottom: $sectionMarginMobile;\n\t}\n\n\t.container {\n\t\tpadding: 0 $containerPadding; // в моб версии отступ от края задаем для всех контейнеров, а там где не нужно можем точечно убрать\n\t\twidth: 100%;\n\t}\n}\n","// Шрифты ==================================================\n$font: \"Alumni Sans\"; // шрифт по умолчанию\n$fontColor: #330d03; // цвет текста по умолчанию\n\n// Цвета ==================================================\n$dark: #330d03;\n$green: #b5bf3d;\n$orange: #ff6d2f;\n$beige: #fff4da;\n$choco: #4c0d00;\n$white: #fff;\n$bg: #fff4da;\n\n$dark-tertiary:rgba(51, 13, 3, 0.30);\n$dark-secondary: rgba(51, 13, 3, 0.60);\n\n// Настройки ==============================================\n$sectionMargin: 20rem; // Отступ у секций\n$sectionMarginMobile: 20rem; // (x2) Отступ у секций на телефоне\n$mobileLayout: 375; // Размер мобильного макета\n$containerPadding: 3.2rem; // (x2) Отсутп контейнера на мобильной версии\n$containerWidth: 180rem; // Ширина контейнера\n",".index-list {\n\tpadding: 5rem;\n}\nbody {\n\t&.lock {\n\t\toverflow: hidden;\n\t\ttouch-action: none;\n\t}\n}\nhtml {\n\tscroll-behavior: smooth;\n}\nmain {\n\tpadding-top: 9rem;\n}\n.h1 {\n\tfont-size: 25rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 90%; /* 225px */\n\tletter-spacing: -1.5rem;\n}\n.h2 {\n\tfont-family: \"Literata\";\n\tfont-size: 19rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 90%; /* 171px */\n\tletter-spacing: -0.76rem;\n}\n.h3 {\n\tfont-size: 9rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 90%; /* 81px */\n\tletter-spacing: -0.27rem;\n}\n.h4 {\n\tfont-family: \"Literata\";\n\tfont-size: 8rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 110%; /* 88px */\n\tletter-spacing: -0.16rem;\n}\n.text-45 {\n\tfont-size: 4.5rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 100%; /* 45px */\n\tletter-spacing: -0.18rem;\n}\n.text-30 {\n\tfont-size: 3rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 2.8rem; /* 93.333% */\n\tletter-spacing: -0.06rem;\n}\n.text-24 {\n\tfont-size: 2.4rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 2.8rem; /* 116.667% */\n\tletter-spacing: 0.216rem;\n}\n.text-22 {\n\tfont-family: \"Euclid Circular A\";\n\tfont-size: 2.2rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 2.8rem; /* 127.273% */\n}\n.text-18 {\n\tfont-family: \"Euclid Circular A\";\n\tfont-size: 1.8rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 2.8rem; /* 155.556% */\n\tletter-spacing: -0.036rem;\n}\n.btn {\n\tcolor: $dark;\n\ttext-align: center;\n\n\tfont-size: 3rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 2.8rem; /* 93.333% */\n\tletter-spacing: -0.06rem;\n\ttext-transform: uppercase;\n\n\tdisplay: inline-flex;\n\theight: 7rem;\n\tpadding: 2.6rem 4rem;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 1rem;\n\tflex-shrink: 0;\n\tbackground: $orange;\n\n\tposition: relative;\n\toverflow: hidden;\n\t&::after {\n\t\tcontent: \"\";\n\t\twidth: 110%;\n\t\theight: 300%;\n\t\tbackground: $white;\n\t\tborder-radius: 50%;\n\t\tposition: absolute;\n\t\tz-index: 1;\n\t\ttransform: translateY(100%);\n\t\ttransition: transform 0.3s ease-in-out 0.2s;\n\t}\n\tspan {\n\t\tcolor: $orange;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tz-index: 2;\n\t\ttransform: translateY(250%);\n\t\ttransition: transform 0.3s ease-in-out;\n\t}\n\n\t&:hover {\n\t\t&::after {\n\t\t\ttransition: transform 0.3s ease-in-out;\n\t\t\ttransform: translateY(0);\n\t\t}\n\t\tspan {\n\t\t\ttransition: transform 0.3s ease-in-out 0.2s;\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n\n\t&-circle {\n\t\tdisplay: block;\n\t\twidth: 7rem;\n\t\theight: 7rem;\n\t\tpadding: 2.3rem;\n\t\tborder-radius: 50%;\n\t\tborder: 0.1rem solid $dark;\n\t\ttransition: background 0.2s linear;\n\n\t\tsvg path {\n\t\t\ttransition: fill 0.2s linear;\n\t\t}\n\n\t\t&:hover {\n\t\t\ttransition: background 0.2s linear;\n\t\t\tbackground: $dark;\n\n\t\t\tsvg path {\n\t\t\t\ttransition: fill 0.2s linear;\n\t\t\t\tfill: $orange;\n\t\t\t}\n\t\t}\n\t}\n}\n.navigation {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.5rem;\n\t&-btn {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tposition: relative;\n\t\toverflow: hidden;\n\n\t\twidth: 7rem;\n\t\theight: 7rem;\n\t\tborder-radius: 50%;\n\t\tbackground-color: $dark;\n\t\ttransition: background 0.1s linear;\n\n\t\t&::after {\n\t\t\tcontent: \"\";\n\t\t\twidth: 7rem;\n\t\t\theight: 7rem;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground-color: $green;\n\t\t\tposition: absolute;\n\t\t\ttransform: translateY(100%);\n\t\t\ttransition: transform 0.3s ease-in-out;\n\t\t}\n\t\tsvg {\n\t\t\tposition: relative;\n\t\t\tz-index: 2;\n\t\t\twidth: 2.4rem;\n\t\t\theight: 2.4rem;\n\t\t}\n\t\t&.swiper-button-disabled {\n\t\t\tbackground-color: $orange;\n\t\t\tcursor: default;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: $orange;\n\t\t\t\t&::after {\n\t\t\t\t\ttransform: translateY(100%);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\ttransition: background 0.3s linear 0.15s;\n\t\t\tbackground-color: $green;\n\t\t\t&::after {\n\t\t\t\ttransition: transform 0.3s ease-in-out;\n\t\t\t\ttransform: translateY(0);\n\t\t\t}\n\t\t}\n\t}\n}\n.small-btn {\n\tposition: relative;\n\tcolor: $dark;\n\tfont-size: 3rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 2.8rem; /* 93.333% */\n\tletter-spacing: -0.06rem;\n\ttext-transform: uppercase;\n\n\t&::after {\n\t\ttransition: width 0.3s linear;\n\t\tcontent: \"\";\n\t\twidth: 100%;\n\t\theight: 0.2rem;\n\t\tbackground: $dark;\n\t\tposition: absolute;\n\t\tbottom: -0.5rem;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t}\n\n\t&:hover {\n\t\t&::after {\n\t\t\ttransition: width 0.3s linear;\n\t\t\twidth: 20%;\n\t\t}\n\t}\n}\n@media (max-width: 48em) {\n\tmain {\n\t\tpadding-top: 13.6rem;\n\t}\n\n\t.navigation {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tgap: 0.8rem;\n\t\t&-btn {\n\t\t\twidth: 8.8rem;\n\t\t\theight: 8.8rem;\n\n\t\t\t&:nth-child(1) {\n\t\t\t\torder: 2;\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\twidth: 8.8rem;\n\t\t\t\theight: 8.8rem;\n\t\t\t}\n\t\t\tsvg {\n\t\t\t\twidth: 3.2rem;\n\t\t\t\theight: 3.2rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t.h4 {\n\t\tfont-size: 5.6rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 110%;\n\t\tletter-spacing: -0.112rem;\n\t}\n\n\t.text-30 {\n\t\tfont-size: 4rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 5.6rem; /* 140% */\n\t\tletter-spacing: -0.08rem;\n\t}\n\n\t.text-24 {\n\t\tfont-size: 3.6rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: normal;\n\t\tletter-spacing: 0.216rem;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.text-18 {\n\t\tfont-size: 2.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 4rem; /* 142.857% */\n\t\tletter-spacing: -0.056rem;\n\t}\n\t.small-btn {\n\t\tposition: relative;\n\t\tfont-size: 3.6rem;\n\t\tline-height: normal;\n\t\tletter-spacing: -0.072rem;\n\t\ttext-transform: uppercase;\n\t}\n}\n",".header {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 1000;\n\twidth: 100%;\n\tbackground-color: $choco;\n\n\t// .header__inner\n\t&__inner {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\n\t\tpadding: 1rem 0;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t}\n\t// .header__logo\n\t&__logo {\n\t\twidth: 21.9rem;\n\t\theight: 7rem;\n\n\t\ta {\n\t\t\tdisplay: block;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\n\t\t\timg {\n\t\t\t\theight: auto;\n\t\t\t}\n\t\t}\n\t}\n\t// .header__navigation\n\t&__navigation {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 5.6rem;\n\t}\n\t// .header__nav\n\t&__nav {\n\t\tgap: 3rem;\n\t}\n\t// .header__btn\n\t&__btn {\n\t}\n}\n.nav {\n\tdisplay: flex;\n\t// .nav__link\n\t&__link {\n\t\tdisplay: block;\n\t\tcolor: $beige;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 2.2rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 2.8rem; /* 127.273% */\n\t}\n}\n.burger {\n\t&-btn {\n\t\tdisplay: none;\n\t}\n\t&-menu {\n\t\tdisplay: none;\n\t}\n}\n@media (max-width: 48em) {\n\t.header {\n\t\t// .header__inner\n\n\t\t&__inner {\n\t\t\tpadding: 2.4rem 0;\n\t\t}\n\t\t// .header__logo\n\t\t&__logo {\n\t\t\tposition: relative;\n\t\t\tz-index: 1002;\n\t\t\twidth: 24rem;\n\t\t\theight: 8rem;\n\t\t}\n\t\t// .header__navigation\n\t\t&__navigation {\n\t\t\tdisplay: none;\n\t\t}\n\t\t// .header__nav\n\t\t&__nav {\n\t\t\tgap: 3rem;\n\t\t}\n\t}\n\t.nav {\n\t\tdisplay: flex;\n\t\t// .nav__link\n\t\t&__link {\n\t\t\tdisplay: block;\n\t\t\tcolor: $beige;\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 2.2rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 2.8rem; /* 127.273% */\n\t\t}\n\t}\n\t.burger {\n\t\t&-btn {\n\t\t\tposition: relative;\n\t\t\tz-index: 1002;\n\t\t\tdisplay: flex;\n\t\t\talign-items: flex-start;\n\t\t\tpadding: 0 2.4rem;\n\t\t\tjustify-content: center;\n\t\t\tflex-direction: column;\n\t\t\twidth: 8.8rem;\n\t\t\theight: 8.8rem;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground-color: $beige;\n\t\t\tgap: 1rem;\n\n\t\t\t&.active {\n\t\t\t\tspan {\n\t\t\t\t\t&:nth-child(1) {\n\t\t\t\t\t\twidth: 4.1rem;\n\t\t\t\t\t\ttransition: transform 0.3s linear;\n\t\t\t\t\t\ttransform-origin: center;\n\t\t\t\t\t\ttransform: translateY(0.7rem) rotate(45deg);\n\t\t\t\t\t}\n\t\t\t\t\t&:nth-child(2) {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t\t&:nth-child(3) {\n\t\t\t\t\t\ttransition: transform 0.3s linear;\n\t\t\t\t\t\ttransform-origin: center;\n\t\t\t\t\t\ttransform: translateY(-0.6rem) rotate(-45deg);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tdisplay: block;\n\t\t\t\twidth: 4.1rem;\n\t\t\t\theight: 0.4rem;\n\t\t\t\tbackground-color: $dark;\n\t\t\t\tborder-radius: 10rem;\n\t\t\t\ttransition: transform 0.2s linear;\n\n\t\t\t\t&:nth-child(1) {\n\t\t\t\t\twidth: 2.5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&-menu {\n\t\t\tdisplay: flex;\n\t\t\twidth: 100vw;\n\t\t\theight: 100vh;\n\t\t\tmargin-left: -3.2rem;\n\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tz-index: 999;\n\t\t\tpadding-top: 13.6rem;\n\t\t\ttransform: translateY(100%);\n\t\t\ttransition: transform 0.5s ease-in-out;\n\t\t\t&.show {\n\t\t\t\ttransform: translateY(0);\n\t\t\t\ttransition: transform 0.5s ease-in-out;\n\t\t\t}\n\t\t\t// .burger-menu__inner\n\t\t\t&__inner {\n\t\t\t\tdisplay: flex;\n\t\t\t\tposition: relative;\n\t\t\t\twidth: 100%;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t\ttext-align: center;\n\t\t\t\tbackground-color: $beige;\n\t\t\t\tpadding: 10.4rem 0 8rem;\n\t\t\t}\n\t\t\t// .burger-menu__nav\n\t\t\t&__nav {\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 6.4rem;\n\t\t\t\tmargin-bottom: 13.2rem;\n\t\t\t\t.nav__link {\n\t\t\t\t\tcolor: $dark;\n\t\t\t\t\tfont-family: \"Alumni Sans\";\n\t\t\t\t\tfont-size: 4.8rem;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tline-height: 100%; /* 24px */\n\t\t\t\t\tletter-spacing: -0.192rem;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t}\n\t\t\t}\n\t\t\t// .burger-menu__btn\n\t\t\t&__btn {\n\t\t\t\tmax-width: 50.4rem;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\t// .burger-menu__social\n\t\t\t&__social {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 6.4rem;\n\t\t\t\tmargin-top: 10.4rem;\n\t\t\t\ta {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tcolor: $dark;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tfont-family: \"Alumni Sans\";\n\t\t\t\t\tfont-size: 4rem;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tline-height: 100%; /* 20px */\n\t\t\t\t\tletter-spacing: -0.16rem;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&__icon {\n\t\t\t\tposition: absolute;\n\t\t\t\t&-cucumber {\n\t\t\t\t\twidth: 27rem;\n\t\t\t\t\theight: 23rem;\n\t\t\t\t\ttop: 1.3rem;\n\t\t\t\t\tright: -7.4rem;\n\t\t\t\t}\n\t\t\t\t&-tacos {\n\t\t\t\t\twidth: 32rem;\n\t\t\t\t\theight: 22rem;\n\t\t\t\t\ttransform: rotate(25deg) scale(-1, 1);\n\t\t\t\t\tleft: -13rem;\n\t\t\t\t\ttop: 50rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",".footer {\n\t// .footer__container\n\t&__container {\n\t\tmargin: 0 auto;\n\t\twidth: 100%;\n\t\tmax-width: 180rem;\n\t}\n\n\t// .footer__top\n\t&__top {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\n\t\t&-left {\n\t\t\twidth: fit-content;\n\t\t}\n\n\t\t&-right {\n\t\t\tmargin-left: 19.8rem;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t// .footer__logo-container\n\t&__logo-container {\n\t\tmargin-top: 3.5rem;\n\n\t\timg {\n\t\t\twidth: 22rem;\n\t\t\theight: 7rem;\n\t\t}\n\t}\n\n\t// .footer__socials\n\t&__socials {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tjustify-content: space-between;\n\t\tmargin-top: 6.7rem;\n\t}\n\n\t// .footer__social\n\t&__social {\n\t\tcolor: $dark;\n\t\ttext-transform: uppercase;\n\t}\n\n\t// .footer__form\n\t&__form {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding-bottom: 2.4rem;\n\t\tborder-bottom: 1px $dark solid;\n\t}\n\n\t// .footer__input-container\n\t&__input-container {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 2rem;\n\t}\n\n\t// .footer__form-label\n\t&__form-title {\n\t\twidth: 100%;\n\t}\n\n\t// .footer__form-input\n\t&__form-input {\n\t\ttext-transform: uppercase;\n\t\tmargin-top: 2rem;\n\n\t\t&::placeholder {\n\t\t\tcolor: $dark-tertiary;\n\t\t}\n\t}\n\n\t// .footer__form-submit\n\t&__form-submit {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\tright: 0;\n\t\tbottom: 2.4rem;\n\n\t\tsvg {\n\t\t\twidth: 2.4rem;\n\t\t\theight: 2.4rem;\n\t\t}\n\t}\n\n\t// .footer__bottom\n\t&__bottom {\n\t\tmargin-top: 6.4rem;\n\t}\n\n\t// .footer__menu\n\t&__menu {\n\t\twidth: 100%;\n\t\tmax-width: 128rem;\n\t\tjustify-content: space-between;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tflex-wrap: wrap;\n\t}\n\n\t// .footer__menu-item\n\t&__menu-item {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\tmax-width: 20.4rem;\n\t\tgap: 3.2rem;\n\t}\n\n\t// .footer__link\n\t&__link {\n\t\twidth: 100%;\n\t\ttext-transform: uppercase;\n\t\t&--light {\n\t\t\tcolor: $dark-secondary;\n\t\t}\n\t}\n\n\t// .footer__copyright\n\t&__copyright {\n\t\tmargin-top: 2.4rem;\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\tpadding: 3.2rem 0 2.45rem;\n\n\t\tborder-top: 1px solid $dark-tertiary;\n\n\t\t&-text {\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 1.8rem;\n\t\t\tfont-weight: 400;\n\t\t\tletter-spacing: -0.036rem;\n\t\t\tline-height: 2.8rem; /* 155.556% */\n\t\t\tfont-style: normal;\n\t\t\tcolor: $dark-secondary;\n\t\t}\n\n\t\t&-inner {\n\t\t\tmargin: 0 auto;\n\t\t\tcolor: $dark-secondary;\n\t\t\twidth: 100%;\n\t\t\tmax-width: 180rem;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tjustify-content: space-between;\n\t\t}\n\t}\n}\n\n@media (max-width: 48em) {\n\t.footer {\n\t\t// .footer__container\n\t\t&__container {\n\t\t\tmax-width: 68.2rem;\n\t\t}\n\n\t\t// .footer__top\n\t\t&__top {\n\t\t\torder: 2;\n\t\t\tflex-direction: column;\n\n\t\t\t&-left {\n\t\t\t\twidth: fit-content;\n\t\t\t}\n\n\t\t\t&-right {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tmargin-left: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\n\t\t// .footer__logo-container\n\t\t&__logo-container {\n\t\t\tmargin-top: 3.5rem;\n\n\t\t\tsvg {\n\t\t\t\twidth: 24rem;\n\t\t\t\theight: 8rem;\n\t\t\t}\n\t\t}\n\n\t\t// .footer__socials\n\t\t&__socials {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t// .footer__form\n\t\t&__form {\n\t\t\tmargin-top: 10.4rem;\n\t\t\torder: 2;\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tpadding-bottom: 2.4rem;\n\t\t\tborder-bottom: 1px $dark solid;\n\t\t}\n\n\t\t// .footer__input-container\n\t\t&__input-container {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 2rem;\n\t\t}\n\n\t\t// .footer__form-label\n\t\t&__form-title {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t// .footer__form-input\n\t\t&__form-input {\n\t\t\tmargin-top: 2rem;\n\n\t\t\t&::placeholder {\n\t\t\t\tcolor: $dark-tertiary;\n\t\t\t}\n\t\t}\n\n\t\t// .footer__form-submit\n\t\t&__form-submit {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\tbottom: 2.4rem;\n\n\t\t\tsvg {\n\t\t\t\twidth: 3.2rem;\n\t\t\t\theight: 3.2rem;\n\t\t\t}\n\t\t}\n\n\t\t// .footer__bottom\n\t\t&__bottom {\n\t\t\torder: 1;\n\t\t\tmargin-top: 6.4rem;\n\t\t}\n\n\t\t// .footer__menu\n\t\t&__menu {\n\t\t\tgap: 3.4rem;\n\t\t\twidth: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tjustify-content: space-between;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t// .footer__menu-item\n\t\t&__menu-item {\n\t\t\tmax-width: 28.8rem;\n\t\t\tgap: 3rem;\n\t\t}\n\n\t\t// .footer__copyright\n\t\t&__copyright {\n\t\t\tmargin-top: 6.4rem;\n\t\t\tpadding: 4rem 3.2rem 3.2rem;\n\n\t\t\t&-inner {\n\t\t\t\twidth: 100%;\n\t\t\t\tmax-width: 100%;\n\t\t\t\tgap: 1.6rem;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t}\n\t\t}\n\t}\n}\n",".review-modal {\n\t// .review-modal__title\n\t&__title {\n\t\tcolor: $beige;\n\t\ttext-transform: uppercase;\n\t}\n\t// .review-modal__form\n\t&__form {\n\t\twidth: 96.6rem;\n\t\tmargin-top: 5.1rem;\n\t}\n\t&__icon {\n\t\twidth: 18.7rem;\n\t\theight: 12.6rem;\n\t\tmargin-bottom: 6.4rem;\n\t}\n\t&__content {\n\t\tpadding: 6rem;\n\t\toverflow: hidden;\n\t}\n\t&__description {\n\t\tmargin-top: 4.8rem;\n\t\toverflow: hidden;\n\t\tcolor: $beige;\n\t\ttext-overflow: ellipsis;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-line-clamp: 1;\n\n\t\t/* Desktop/text 22 */\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 2.2rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 2.8rem; /* 127.273% */\n\t}\n\t&__wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\twidth: 96.6rem;\n\t}\n}\n.review-modal-detail {\n\t// .review-modal-detail__slider\n\t&__slider {\n\t\toverflow: hidden;\n\t\twidth: 92.6rem;\n\t\theight: 62.5rem;\n\t}\n\t// .review-modal-detail__slide\n\t&__slide.swiper-slide {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tpadding: 6rem 6rem 4.2rem;\n\t\tflex-direction: column;\n\t\tgap: 4.8rem;\n\t}\n\t// .review-modal-detail__header\n\t&__header {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\t&::after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: -13.2rem;\n\t\t\tright: -13rem;\n\t\t\tz-index: -1;\n\t\t\twidth: 25.2rem;\n\t\t\theight: 25.2rem;\n\t\t\tbackground-color: $orange;\n\t\t\tborder-radius: 50%;\n\t\t}\n\t}\n\t// .review-modal-detail__icon\n\t&__icon {\n\t\twidth: 9.6rem;\n\t\theight: 9.6rem;\n\t\tpadding: 2.8rem;\n\t\tborder-radius: 50%;\n\t\tbackground: $beige;\n\t}\n\t// .review-modal-detail__rating\n\t&__rating {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 0.6rem;\n\n\t\tcolor: $dark;\n\t\tfont-size: 3rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem; /* 93.333% */\n\t\tletter-spacing: -0.06rem;\n\t\ttext-transform: uppercase;\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\twidth: 2.4rem;\n\t\t\theight: 2.4rem;\n\t\t}\n\t}\n\t// .review-modal-detail__info\n\t&__info {\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\t\tjustify-content: space-between;\n\t}\n\t// .review-modal-detail__name\n\t&__name {\n\t\tcolor: $beige;\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%; /* 45px */\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\t}\n\t// .review-modal-detail__date\n\t&__date {\n\t\tcolor: $beige;\n\t\ttext-align: right;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem; /* 155.556% */\n\t\tletter-spacing: -0.036rem;\n\t}\n\t&__main {\n\t\tposition: relative;\n\t\toverflow: auto;\n\t\tmax-height: 17rem;\n\t\tcolor: $beige;\n\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem; /* 155.556% */\n\t\tletter-spacing: -0.036rem;\n\t\t/* W3C standard\n\t\tсейчас только для Firefox */\n\t\tscrollbar-width: thin;\n\t\tscrollbar-color: $dark $orange;\n\n\t\t/* для Chrome/Edge/Safari */\n\t\t&::-webkit-scrollbar {\n\t\t\twidth: 0.3rem;\n\t\t}\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\tbackground-color: $dark;\n\t\t\tborder-radius: 10rem;\n\t\t}\n\t}\n\t// .review-modal-detail__footer\n\t&__footer {\n\t\theight: 7rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t}\n\t// .review-modal-detail__address\n\t&__address {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 0.6rem;\n\n\t\tcolor: $beige;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem; /* 155.556% */\n\t\tletter-spacing: -0.036rem;\n\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\twidth: 2.4rem;\n\t\t\theight: 2.4rem;\n\t\t}\n\t}\n\t// .review-modal-detail__navigation\n\t&__navigation {\n\t\t&.navigation {\n\t\t\tposition: absolute;\n\t\t\tright: 6rem;\n\t\t\tbottom: 4.2rem;\n\t\t\tz-index: 100;\n\t\t\tflex-direction: row;\n\t\t}\n\t\t&-btn {\n\t\t\tbackground-color: $beige;\n\n\t\t\tsvg path {\n\t\t\t\tfill: $choco;\n\t\t\t}\n\t\t}\n\t}\n}\n.subscribe {\n\t// .subscribe__content\n\t&__content {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tpadding: 8rem;\n\t\twidth: 108.6rem;\n\t}\n\t// .subscribe__wrapper\n\t&__wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\t// .subscribe__icon\n\t&__icon {\n\t\twidth: 18.5rem;\n\t\tmargin-bottom: 6.4rem;\n\t}\n\t// .subscribe__title\n\t&__title {\n\t\tcolor: $beige;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 4.8rem;\n\t\twidth: 79.6rem;\n\t}\n\t// .subscribe__description\n\t&__description {\n\t\tdisplay: -webkit-box;\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-line-clamp: 1;\n\t\toverflow: hidden;\n\t\tcolor: $beige;\n\t\ttext-overflow: ellipsis;\n\t}\n}\n.modal {\n\tdisplay: none;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 2010;\n\n\twidth: 100%;\n\theight: 100vh;\n\t&.active {\n\t\tdisplay: block;\n\t}\n\t&-back {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tz-index: -1;\n\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tbackground: $dark-tertiary;\n\t\tbackdrop-filter: blur(0.5rem);\n\t\topacity: 0;\n\t\ttransition: opacity 0.4s ease-in-out;\n\t}\n\t&-wrapper {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\n\t\tbackground: $choco;\n\t\topacity: 0;\n\t\ttransition: opacity 0.4s ease-in-out;\n\t}\n\t&-exit {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\ttop: 2.2rem;\n\t\tright: 2.2rem;\n\t\tz-index: 1000;\n\n\t\twidth: 2rem;\n\t\theight: 2rem;\n\n\t\tsvg {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t}\n\t}\n\t&-content {\n\t\tdisplay: none;\n\t\tvisibility: hidden;\n\n\t\t&.active {\n\t\t\tdisplay: block;\n\t\t\tvisibility: visible;\n\t\t}\n\t}\n}\n.footer__input-container.error {\n\t.error-text {\n\t\tposition: absolute;\n\t\tmargin: 0;\n\t\tbottom: -2.8rem;\n\t\tleft: 0;\n\t}\n}\n.error {\n\t&-text {\n\t\tmargin: 0.6rem 0 0 3.2rem;\n\t\tcolor: #ff2f2f;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.4rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 120%; /* 16.8px */\n\t\tletter-spacing: -0.028rem;\n\t}\n}\n.form {\n\t&-input {\n\t\tbackground: #a5806d;\n\t\twidth: 100%;\n\t\tpadding: 3.2rem;\n\t\tcolor: $dark;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem; /* 155.556% */\n\t\tletter-spacing: -0.036rem;\n\n\t\t&::placeholder {\n\t\t\tcolor: $dark-secondary;\n\t\t}\n\t}\n\t&-textarea {\n\t\twidth: 100%;\n\t\theight: 15.5rem;\n\t\tresize: none;\n\t\tbackground: #a5806d;\n\n\t\tpadding: 3.2rem;\n\t\tcolor: $dark;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem; /* 155.556% */\n\t\tletter-spacing: -0.036rem;\n\n\t\t&::placeholder {\n\t\t\tcolor: $dark-secondary;\n\t\t}\n\n\t\t/* W3C standard\n\t\tсейчас только для Firefox */\n\t\tscrollbar-width: thin;\n\t\tscrollbar-color: $dark $orange;\n\n\t\t/* для Chrome/Edge/Safari */\n\t\t&::-webkit-scrollbar {\n\t\t\twidth: 0.3rem;\n\t\t}\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\tbackground-color: $dark;\n\t\t\tborder-radius: 10rem;\n\t\t}\n\t}\n\t// .form__main\n\t&__main {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1rem;\n\t\tmargin-bottom: 4.1rem;\n\t\t&-top {\n\t\t\tdisplay: flex;\n\t\t\tgap: 1rem;\n\t\t}\n\t\t&-bottom {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\t// .form__label\n\t&__label {\n\t\tflex: 1;\n\t}\n\t// .form__footer\n\t&__footer {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n}\n.rating {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 3.2rem;\n\t&__title {\n\t\tcolor: $beige;\n\t\ttext-transform: uppercase;\n\t}\n\n\t&__main {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-direction: row-reverse;\n\t\tposition: relative;\n\t\tlabel {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\twidth: 3.2rem;\n\t\t\theight: 3.2rem;\n\t\t\tcursor: pointer;\n\t\t\tmargin-right: 0.8rem;\n\n\t\t\t&:nth-child(2) {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\n\t\t\tsvg path {\n\t\t\t\tfill: none;\n\t\t\t\tstroke: #fff4da;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tsvg path {\n\t\t\t\t\tfill: #fff4da;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tinput {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\tinput:checked ~ label svg path {\n\t\t\tfill: #fff4da;\n\t\t}\n\n\t\tlabel:hover {\n\t\t\tsvg,\n\t\t\t~ label svg path {\n\t\t\t\tfill: #fff4da;\n\t\t\t}\n\t\t}\n\n\t\tinput:checked {\n\t\t\t+ label:hover svg path {\n\t\t\t\tfill: #fff4da;\n\t\t\t}\n\n\t\t\t~ label:hover {\n\t\t\t\tsvg,\n\t\t\t\t~ label svg path {\n\t\t\t\t\tfill: #fff4da;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tlabel:hover ~ input:checked ~ label svg path {\n\t\t\tfill: #fff4da;\n\t\t}\n\t}\n}\n.vacancy-modal {\n\t// .vacancy-modal__content\n\t&__content {\n\t\tpadding: 6rem;\n\t\toverflow: hidden;\n\t}\n\t// .vacancy-modal__title\n\t&__title {\n\t\tcolor: $beige;\n\t\ttext-transform: uppercase;\n\t}\n\t// .vacancy-modal__form\n\t&__form {\n\t\twidth: 108.6rem;\n\t\tmargin-top: 5.1rem;\n\t}\n\t// .vacancy-modal__wrapper\n\t&__wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\twidth: 96.6rem;\n\t}\n\t// .vacancy-modal__icon\n\t&__icon {\n\t\twidth: 18.7rem;\n\t\theight: 12.6rem;\n\t\tmargin-bottom: 6.4rem;\n\t}\n\t// .vacancy-modal__description\n\t&__description {\n\t\tmargin-top: 4.8rem;\n\t\toverflow: hidden;\n\t\tcolor: $beige;\n\t\ttext-overflow: ellipsis;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-line-clamp: 1;\n\n\t\t/* Desktop/text 22 */\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 2.2rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 2.8rem; /* 127.273% */\n\t}\n}\n.input-file {\n\tdisplay: none;\n\tappearance: none;\n\topacity: 0;\n\tvisibility: hidden;\n\tposition: absolute;\n\tz-index: -1;\n}\n.custom-file {\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 1.6rem;\n\tspan {\n\t\tcolor: $beige;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 2.2rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 2.8rem; /* 127.273% */\n\t}\n\n\tsvg {\n\t\twidth: 3.2rem;\n\t\theight: 3.2rem;\n\t\tpath {\n\t\t\tstroke: $beige;\n\t\t}\n\t}\n}\n.custom-preview {\n\tdisplay: none;\n\talign-items: center;\n\t// .custom-preview__close\n\t&__close {\n\t\tcursor: pointer;\n\t\twidth: 2rem;\n\t\theight: 2rem;\n\t\tmargin-left: 1.6rem;\n\t}\n\t// .custom-preview__name\n\t&__name {\n\t\tmax-width: 15rem;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\ttext-wrap: nowrap;\n\t\tcolor: $beige;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 2.2rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 2.8rem; /* 127.273% */\n\t}\n\t// .custom-preview__size\n\t&__size {\n\t\tcolor: $orange;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 2.2rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 2.8rem; /* 127.273% */\n\t\tmargin-left: 1.2rem;\n\t}\n}\n.map-modal {\n\t&__slider {\n\t\toverflow: hidden;\n\t\twidth: 50.1rem;\n\t\theight: 61.4rem;\n\t}\n\t.modal-exit {\n\t\tsvg path {\n\t\t\tfill: $dark;\n\t\t}\n\t\t&:hover {\n\t\t\tsvg path {\n\t\t\t\tfill: $orange;\n\t\t\t}\n\t\t}\n\t}\n\t// .map-modal__content\n\t&__content {\n\t\tpadding: 6.5rem 6rem;\n\t\tbackground-color: $beige;\n\t\t&.active {\n\t\t\tdisplay: flex;\n\t\t}\n\t\tgap: 1rem;\n\t}\n\t&__left {\n\t\twidth: 79rem;\n\t\theight: 61.4rem;\n\t\toverflow: hidden;\n\t}\n\t// .map-modal__left\n\t&__left-wrapper {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n\t&__map {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n\t// .map-modal__card\n\t&__card {\n\t\theight: 100%;\n\t\twidth: 50.1rem;\n\t\tborder: 0.1rem solid $dark;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.footer__input-container.error {\n\t\t.error-text {\n\t\t\tbottom: -4.2rem;\n\t\t}\n\t}\n\t.error {\n\t\t&-text {\n\t\t\tmargin: 0.6rem 0 0 3.2rem;\n\t\t\tfont-size: 2.4rem;\n\t\t\tline-height: normal; /* 16.8px */\n\t\t\tletter-spacing: -0.056rem;\n\t\t}\n\t}\n\t.review-modal {\n\t\t// .review-modal__title\n\t\t&__title {\n\t\t\ttext-align: center;\n\t\t\tfont-size: 8rem;\n\t\t\tletter-spacing: -0.24rem;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t\t// .review-modal__form\n\t\t&__form {\n\t\t\twidth: 100%;\n\t\t\tmargin-top: 4.8rem;\n\t\t}\n\t\t&__icon {\n\t\t\twidth: 21.4rem;\n\t\t\theight: 14.4rem;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t\t&__content {\n\t\t\tpadding: 13rem 6rem;\n\t\t}\n\t\t&__description {\n\t\t\tmargin-top: 0;\n\t\t\tdisplay: block;\n\t\t\ttext-align: center;\n\t\t\tmax-width: 38.8rem;\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: 5.6rem; /* 127.273% */\n\t\t}\n\t\t&__wrapper {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\tgap: 4.8rem;\n\t\t\twidth: auto;\n\t\t}\n\t}\n\t.review-modal-detail {\n\t\t// .review-modal-detail__slider\n\t\t&__slider {\n\t\t\toverflow: hidden;\n\t\t\twidth: 100%;\n\t\t\theight: auto;\n\t\t\tpadding: 13rem 6rem;\n\t\t}\n\t\t// .review-modal-detail__slide\n\t\t&__slide.swiper-slide {\n\t\t\twidth: 100%;\n\t\t\tdisplay: flex;\n\t\t\tpadding: 0;\n\t\t\tflex-direction: column;\n\t\t\tgap: 4.8rem;\n\t\t}\n\t\t// .review-modal-detail__header\n\t\t&__header {\n\t\t\t&::after {\n\t\t\t\ttop: -17.6rem;\n\t\t\t\tright: -14.2rem;\n\n\t\t\t\twidth: 32.8rem;\n\t\t\t\theight: 32.8rem;\n\t\t\t}\n\t\t}\n\t\t// .review-modal-detail__icon\n\t\t&__icon {\n\t\t\twidth: 12.4rem;\n\t\t\theight: 12.4rem;\n\t\t\tpadding: 3.6rem;\n\t\t}\n\t\t// .review-modal-detail__rating\n\t\t&__rating {\n\t\t\tgap: 1.2rem;\n\t\t\tfont-size: 4.8rem;\n\t\t\tline-height: 100%; /* 93.333% */\n\t\t\tletter-spacing: -0.192rem;\n\t\t\tspan {\n\t\t\t\twidth: 4.8rem;\n\t\t\t\theight: 4.8rem;\n\t\t\t}\n\t\t}\n\t\t// .review-modal-detail__name\n\t\t&__name {\n\t\t\tfont-size: 4.8rem;\n\t\t\tletter-spacing: -0.192rem;\n\t\t}\n\t\t// .review-modal-detail__date\n\t\t&__date {\n\t\t\tfont-size: 2.8rem;\n\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\tletter-spacing: -0.056rem;\n\t\t}\n\t\t&__main {\n\t\t\tmax-height: 45rem;\n\t\t\tfont-size: 2.8rem;\n\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\tletter-spacing: -0.056rem;\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\twidth: 0.6rem;\n\t\t\t}\n\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\tborder-radius: 20rem;\n\t\t\t}\n\t\t}\n\t\t// .review-modal-detail__footer\n\t\t&__footer {\n\t\t\theight: auto;\n\t\t}\n\t\t// .review-modal-detail__address\n\t\t&__address {\n\t\t\tgap: 1.2rem;\n\n\t\t\tfont-size: 2.8rem;\n\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\tletter-spacing: -0.056rem;\n\n\t\t\tspan {\n\t\t\t\twidth: 4.8rem;\n\t\t\t\theight: 4.8rem;\n\t\t\t}\n\t\t}\n\t\t// .review-modal-detail__navigation\n\t\t&__navigation {\n\t\t\t&.navigation {\n\t\t\t\tposition: static;\n\t\t\t\tflex-direction: row-reverse;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tmargin-top: 4.8rem;\n\t\t\t}\n\t\t}\n\t}\n\t.subscribe {\n\t\t// .subscribe__content\n\t\t&__content {\n\t\t\tpadding: 13rem 6rem;\n\t\t\twidth: auto;\n\t\t}\n\t\t// .subscribe__wrapper\n\t\t&__wrapper {\n\t\t\tgap: 4.8rem;\n\t\t}\n\t\t// .subscribe__icon\n\t\t&__icon {\n\t\t\twidth: 18.5rem;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t\t// .subscribe__title\n\t\t&__title {\n\t\t\tmargin-bottom: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t\t// .subscribe__description\n\t\t&__description {\n\t\t\tdisplay: block;\n\t\t\ttext-align: center;\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: 5.6rem; /* 155.556% */\n\t\t}\n\t}\n\t.modal {\n\t\t&-wrapper {\n\t\t\twidth: 68.6rem;\n\t\t}\n\t\t&-exit {\n\t\t\ttop: 2.6rem;\n\t\t\tright: 2.6rem;\n\n\t\t\twidth: 3.4rem;\n\t\t\theight: 3.4rem;\n\t\t}\n\t}\n\t.form {\n\t\t&-input {\n\t\t\tpadding: 3.2rem 4.8rem;\n\t\t\tfont-size: 2.8rem;\n\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\tletter-spacing: -0.056rem;\n\t\t}\n\t\t&-textarea {\n\t\t\theight: 37.2rem;\n\t\t\tpadding: 3.2rem 4.8rem;\n\t\t\tfont-size: 2.8rem;\n\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\tletter-spacing: -0.056rem;\n\t\t}\n\t\t// .form__main\n\t\t&__main {\n\t\t\tgap: 2rem;\n\t\t\tmargin-bottom: 4.8rem;\n\t\t\t&-top {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 2rem;\n\t\t\t}\n\t\t\t&-bottom {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t\t// .form__label\n\t\t&__label {\n\t\t\tflex: 1;\n\t\t}\n\t\t// .form__footer\n\t\t&__footer {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tgap: 3.2rem;\n\t\t}\n\t\t// .form__btn\n\t\t&__btn {\n\t\t\twidth: 100%;\n\t\t\t.btn {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t}\n\t.rating {\n\t\tgap: 4.8rem;\n\t\t&__title {\n\t\t\tfont-size: 4.8rem;\n\t\t\tletter-spacing: -0.192rem;\n\t\t}\n\n\t\t&__main {\n\t\t\tlabel {\n\t\t\t\twidth: 4.8rem;\n\t\t\t\theight: 4.8rem;\n\n\t\t\t\tmargin-right: 1.2rem;\n\t\t\t}\n\t\t}\n\t}\n\t.vacancy-modal {\n\t\t// .vacancy-modal__content\n\t\t&__content {\n\t\t\tpadding: 13rem 6rem;\n\t\t}\n\t\t// .vacancy-modal__title\n\t\t&__title {\n\t\t\ttext-align: center;\n\t\t\tfont-size: 8rem;\n\t\t\tletter-spacing: -0.24rem;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t\t// .vacancy-modal__form\n\t\t&__form {\n\t\t\twidth: 100%;\n\t\t\tmargin-top: 4.8rem;\n\t\t}\n\t\t// .vacancy-modal__wrapper\n\t\t&__wrapper {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\tgap: 4.8rem;\n\t\t\twidth: auto;\n\t\t}\n\t\t// .vacancy-modal__icon\n\t\t&__icon {\n\t\t\twidth: 21.4rem;\n\t\t\theight: 14.4rem;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t\t// .vacancy-modal__description\n\t\t&__description {\n\t\t\tmargin-top: 0;\n\t\t\tdisplay: block;\n\t\t\ttext-align: center;\n\t\t\tmax-width: 38.8rem;\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: 5.6rem; /* 127.273% */\n\t\t}\n\t}\n\t.custom-file {\n\t\tgap: 3.2rem;\n\t\tspan {\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: 5.6rem; /* 127.273% */\n\t\t}\n\n\t\tsvg {\n\t\t\twidth: 4.8rem;\n\t\t\theight: 4.8rem;\n\t\t}\n\t}\n\t.custom-preview {\n\t\tdisplay: none;\n\t\talign-items: center;\n\t\t// .custom-preview__close\n\t\t&__close {\n\t\t\twidth: 3rem;\n\t\t\theight: 3rem;\n\t\t\tmargin-left: 4rem;\n\t\t}\n\t\t// .custom-preview__name\n\t\t&__name {\n\t\t\tmax-width: 20rem;\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: 5.6rem; /* 127.273% */\n\t\t}\n\t\t// .custom-preview__size\n\t\t&__size {\n\t\t\tmargin-left: 2.4rem;\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: 5.6rem; /* 127.273% */\n\t\t}\n\t}\n\t.map-modal {\n\t\t.modal-wrapper {\n\t\t\twidth: 100vw;\n\t\t\tbackground-color: $beige;\n\t\t}\n\t\t.modal-exit {\n\t\t\twidth: 8.8rem;\n\t\t\theight: 8.8rem;\n\t\t\tright: unset;\n\t\t\ttop: 4rem;\n\t\t\tleft: 3.2rem;\n\t\t\t&.mobile {\n\t\t\t\tposition: static;\n\t\t\t\tmargin-bottom: 1.6rem;\n\t\t\t}\n\n\t\t\t.btn-circle {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tpadding: 2.8rem;\n\t\t\t}\n\n\t\t\tsvg {\n\t\t\t\twidth: 3.2rem;\n\t\t\t\theight: 3.2rem;\n\t\t\t}\n\t\t}\n\t\t// .map-modal__content\n\t\t&__content {\n\t\t\theight: 100vh;\n\t\t\tpadding: 4rem 3.2rem;\n\t\t\t&.active {\n\t\t\t\toverflow: auto;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 4.8rem;\n\t\t\t}\n\t\t}\n\t\t&__slider.swiper {\n\t\t\toverflow: hidden;\n\t\t\twidth: 100%;\n\t\t\theight: 85rem;\n\n\t\t\t.main-map__slider-slide.swiper-slide {\n\t\t\t\theight: 85rem;\n\t\t\t}\n\t\t}\n\t\t&__left {\n\t\t\tflex: none;\n\t\t\twidth: 100%;\n\t\t\theight: 80rem;\n\t\t}\n\t\t&__right {\n\t\t\tflex: none;\n\t\t\tpadding-bottom: 4rem;\n\t\t}\n\t\t// .map-modal__card\n\t\t&__card {\n\t\t\theight: 100%;\n\t\t\twidth: 100%;\n\t\t\tborder: 0.2rem solid $dark;\n\t\t}\n\t}\n}\n",".ticker {\n\tmax-width: 192rem;\n\tmargin: 0 auto;\n\theight: 6rem;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: $green;\n\toverflow: hidden;\n\t&-content {\n\t\tdisplay: flex;\n\t\tgap: 3rem;\n\t\twidth: 200%;\n\t\tanimation: ticker 20s linear infinite;\n\t}\n\t&-wrapper {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 3rem;\n\t}\n\t&-element {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 3rem;\n\t\tstrong {\n\t\t\tdisplay: block;\n\t\t\twidth: max-content;\n\t\t\ttext-wrap: nowrap;\n\n\t\t\tcolor: $dark;\n\t\t\tfont-size: 3rem;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 2.8rem; /* 93.333% */\n\t\t\tletter-spacing: -0.06rem;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\twidth: 0.4rem;\n\t\t\theight: 0.4rem;\n\t\t}\n\t}\n}\n@keyframes ticker {\n\t0% {\n\t\ttransform: translateX(0%);\n\t}\n\t100% {\n\t\ttransform: translateX(calc(-50% - 23.3rem));\n\t}\n}\n\n@media (max-width: 48em) {\n\t.ticker {\n\t\theight: 7.2rem;\n\t\t&-content {\n\t\t\tgap: 4rem;\n\t\t\twidth: 350%;\n\t\t}\n\t\t&-wrapper {\n\t\t\tgap: 4rem;\n\t\t}\n\t\t&-element {\n\t\t\tgap: 4rem;\n\t\t\tstrong {\n\t\t\t\tfont-size: 3.6rem;\n\t\t\t\tline-height: normal; /* 93.333% */\n\t\t\t\tletter-spacing: -0.072rem;\n\t\t\t}\n\t\t\tspan {\n\t\t\t\twidth: 0.8rem;\n\t\t\t\theight: 0.8rem;\n\t\t\t}\n\t\t}\n\t}\n\t@keyframes ticker {\n\t\t0% {\n\t\t\ttransform: translateX(0%);\n\t\t}\n\t\t100% {\n\t\t\ttransform: translateX(calc(-50% - 135rem));\n\t\t}\n\t}\n}\n",".main-banner {\n\t// .main-banner__inner\n\t&__inner {\n\t\t&.desktop {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\tpadding-left: 2.3rem;\n\t\t\tmargin: 0 auto;\n\t\t\tmax-width: 192rem;\n\t\t\theight: 90.7rem;\n\t\t}\n\t\t&.mobile {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t// .main-banner__social\n\t&__social {\n\t\tposition: relative;\n\t\twidth: 2.8rem;\n\t\theight: 2.8rem;\n\t\ttransform: rotate(-90deg);\n\t\t&-wrapper {\n\t\t\tdisplay: flex;\n\t\t\tgap: 4.8rem;\n\t\t\tposition: absolute;\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\n\t\t\ta {\n\t\t\t\tdisplay: block;\n\t\t\t\tcolor: $dark;\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-size: 2.4rem;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 2.8rem; /* 116.667% */\n\t\t\t\tletter-spacing: 0.216rem;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t}\n\t\t}\n\t}\n\t// .main-banner__left\n\t&__left {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 80.1rem;\n\t\theight: 81.7rem;\n\t\tmargin-left: 0.9rem;\n\t\t&-header {\n\t\t\twidth: 100%;\n\t\t\tposition: relative;\n\t\t}\n\t\t&-main {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\tpadding-left: 6.8rem;\n\t\t\tmargin-top: -1.5rem;\n\t\t}\n\t\t&-footer {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\tmargin-top: auto;\n\t\t}\n\t}\n\t// .main-banner__right\n\t&__right {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\twidth: 95.5rem;\n\t\theight: 90.7rem;\n\t\tmargin-left: auto;\n\t\t&-back {\n\t\t\t&.swiper {\n\t\t\t\theight: 90.7rem;\n\t\t\t\toverflow: hidden;\n\t\t\t\tposition: relative;\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\n\t\t\t\t\tbackground: linear-gradient(180deg, rgba(0, 0, 0, 0) 54.32%, rgba(0, 0, 0, 0.2) 81.02%);\n\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tz-index: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&--slide.swiper-slide {\n\t\t\t\twidth: 95.5rem;\n\t\t\t\theight: 90.7rem;\n\n\t\t\t\timg {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tobject-fit: cover;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&-footer {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\t\t\tposition: absolute;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tz-index: 2;\n\t\t}\n\t\t&-wrapper {\n\t\t\theight: 18.7rem;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tpadding: 0 6rem;\n\t\t\twidth: 100%;\n\t\t\tmargin-top: 4rem;\n\t\t\t&--btn {\n\t\t\t\tdisplay: flex;\n\t\t\t\twidth: 7rem;\n\t\t\t\theight: 7rem;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tborder: 0.1rem solid $beige;\n\n\t\t\t\tsvg {\n\t\t\t\t\twidth: 2.4rem;\n\t\t\t\t\theight: 2.4rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&-controls {\n\t\t\tposition: relative;\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: 19rem;\n\t\t\twidth: 31.5rem;\n\t\t\theight: 18.7rem;\n\t\t\t&--progressbar {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\n\t\t\t\twidth: 31.5rem;\n\t\t\t\theight: 31.5rem;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tflex-shrink: 0;\n\n\t\t\t\tsvg {\n\t\t\t\t\toverflow: visible;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&--fraction.swiper-pagination-fraction {\n\t\t\t\twidth: auto;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\tbottom: 5.6rem;\n\t\t\t\ttop: unset;\n\t\t\t\ttransform: translateX(-50%);\n\n\t\t\t\tcolor: $beige;\n\t\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\t\tfont-size: 2.2rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 2.8rem; /* 127.273% */\n\t\t\t}\n\t\t}\n\t}\n}\n.main-banner__right-controls--progressbar.swiper-pagination-progressbar.swiper-pagination-vertical {\n\twidth: 31.5rem;\n\theight: 31.5rem;\n\tbackground: none;\n}\n.pagination-swiper-up__bg {\n\tstroke: rgba(255, 244, 218, 0.2);\n}\n.pagination-swiper-up__progress {\n\tstroke: $beige;\n\ttransition: stroke-dashoffset 0.8s ease-in-out;\n\tstroke-dasharray: var(--stroke-dasharray);\n\tstroke-dashoffset: var(--stroke-dashoffset);\n\tstroke-linecap: round;\n\ttransform: rotate(-190deg);\n\ttransform-origin: center;\n}\n.top-title {\n\t&.swiper {\n\t\toverflow: hidden;\n\t\theight: 22.5rem;\n\t}\n\t// .top-title__slide\n\t&__slide.swiper-slide {\n\t\tcolor: $orange;\n\t\tfont-size: 25rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 90%; /* 225px */\n\t\tletter-spacing: -1.5rem;\n\t\ttext-transform: uppercase;\n\t}\n}\n.bottom-title {\n\t&.swiper {\n\t\twidth: 100%;\n\t\theight: 17.1rem;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\t\ttop: 7rem;\n\t}\n\t// .bottom-title__slide\n\t&__slide.swiper-slide {\n\t\tcolor: $dark;\n\t\tfont-feature-settings: \"dnom\" on;\n\t\tfont-family: \"Literata\";\n\t\tfont-size: 19rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 90%; /* 171px */\n\t\tletter-spacing: -0.76rem;\n\t}\n}\n.banner-illustration {\n\t&.swiper {\n\t\tmargin: 0;\n\t\twidth: 60.2rem;\n\t\theight: 39.7rem;\n\t\toverflow: hidden;\n\t}\n\t// .banner-illustration__wrapper\n\t&__wrapper.swiper-wrapper {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n\t// .banner-illustration__slide\n\t&__slide.swiper-slide {\n\t\toverflow: hidden;\n\t\twidth: 60.2rem;\n\t\theight: 39.7rem;\n\n\t\timg {\n\t\t\tobject-fit: contain;\n\t\t}\n\t}\n}\n.banner-footer-left {\n\t&.swiper {\n\t\toverflow: hidden;\n\t\theight: 10rem;\n\t\twidth: 27.3rem;\n\t\tmargin: 0;\n\t}\n\t// .banner-footer-left__slide\n\t&__slide.swiper-slide {\n\t\twidth: 27.3rem;\n\n\t\tcolor: $dark;\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%; /* 45px */\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\n\t\tspan {\n\t\t\tfont-style: italic;\n\t\t\tfont-weight: 700;\n\t\t\tletter-spacing: -0.09rem;\n\t\t}\n\t}\n}\n.banner-footer-right {\n\t&.swiper {\n\t\toverflow: hidden;\n\t\tmargin: 0;\n\t\twidth: 31.1rem;\n\t\theight: 12rem;\n\t}\n\t// .banner-footer-right__slide\n\t&__slide.swiper-slide {\n\t\twidth: 31.1rem;\n\t\tcolor: $dark;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem; /* 155.556% */\n\t\tletter-spacing: -0.036rem;\n\t}\n}\n\n@keyframes ticker {\n\t0% {\n\t\ttransform: translateX(0%);\n\t}\n\t100% {\n\t\ttransform: translateX(calc(-50% - 23.3rem));\n\t}\n}\n\n@media (max-width: 48em) {\n\t.main-banner {\n\t\t// .main-banner__inner\n\t\t&__inner {\n\t\t\t&.desktop {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t&.mobile {\n\t\t\t\twidth: 100%;\n\t\t\t\toverflow: hidden;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 4.8rem;\n\t\t\t\tpadding-top: 6.6rem;\n\t\t\t}\n\t\t\t&-main {\n\t\t\t\toverflow: hidden;\n\t\t\t\tdisplay: flex;\n\t\t\t\tpadding-left: 3.2rem;\n\t\t\t\tgap: 9.2rem;\n\t\t\t}\n\t\t\t&-footer {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t}\n\t\t}\n\t\t&__left {\n\t\t\t&-header {\n\t\t\t\tmargin-bottom: 5.4rem;\n\t\t\t}\n\t\t\t&-footer {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tjustify-content: flex-start;\n\t\t\t\tgap: 4rem;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\t\t// .main-banner__right\n\t\t&__right {\n\t\t\t&-back-mobile {\n\t\t\t\t&.swiper {\n\t\t\t\t\twidth: 68.6rem;\n\t\t\t\t\theight: 35.2rem;\n\t\t\t\t}\n\t\t\t\t&--slide.swiper-slide {\n\t\t\t\t\twidth: 68.6rem;\n\t\t\t\t\theight: 35.2rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.top-title-mobile {\n\t\t&.swiper {\n\t\t\toverflow: hidden;\n\t\t\tmax-height: 21.6rem;\n\t\t}\n\t\t// .top-title__slide\n\t\t&__slide.swiper-slide {\n\t\t\tcolor: $orange;\n\t\t\tfont-size: 24rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 90%; /* 225px */\n\t\t\tletter-spacing: -1.44rem;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\t.bottom-title-mobile {\n\t\t&.swiper {\n\t\t\twidth: 100%;\n\t\t\tmax-height: 16.2rem;\n\t\t\toverflow: hidden;\n\t\t\tposition: absolute;\n\t\t\ttop: 6.4rem;\n\t\t}\n\t\t// .bottom-title__slide\n\t\t&__slide.swiper-slide {\n\t\t\tcolor: $dark;\n\t\t\tfont-feature-settings: \"dnom\" on;\n\t\t\tfont-family: \"Literata\";\n\t\t\tfont-size: 18rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 90%; /* 171px */\n\t\t\tletter-spacing: -0.72rem;\n\t\t}\n\t}\n\t.banner-illustration-mobile {\n\t\t&.swiper {\n\t\t\tmargin: 0;\n\t\t\tmargin-top: 2.2rem;\n\t\t\twidth: 35.2rem;\n\t\t\tmax-height: 24.6rem;\n\t\t\toverflow: hidden;\n\t\t}\n\t\t// .banner-illustration__wrapper\n\t\t&__wrapper.swiper-wrapper {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t}\n\t\t// .banner-illustration__slide\n\t\t&__slide.swiper-slide {\n\t\t\toverflow: hidden;\n\t\t\twidth: 35.2rem;\n\n\t\t\timg {\n\t\t\t\tobject-fit: contain;\n\t\t\t}\n\t\t}\n\t}\n\t.banner-footer-left-mobile {\n\t\t&.swiper {\n\t\t\toverflow: hidden;\n\t\t\tmax-height: 9.6rem;\n\t\t\twidth: 39.2rem;\n\t\t\tmargin: 0;\n\t\t}\n\t\t// .banner-footer-left__slide\n\t\t&__slide.swiper-slide {\n\t\t\twidth: 39.2rem;\n\n\t\t\tcolor: $dark;\n\t\t\tfont-size: 4.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%; /* 45px */\n\t\t\tletter-spacing: -0.192rem;\n\t\t\ttext-transform: uppercase;\n\n\t\t\tspan {\n\t\t\t\tfont-style: italic;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tletter-spacing: -0.096rem;\n\t\t\t}\n\t\t}\n\t}\n\t.banner-footer-right-mobile {\n\t\t&.swiper {\n\t\t\toverflow: hidden;\n\t\t\tmargin: 0;\n\t\t\twidth: 39.2rem;\n\t\t\tmax-height: 16rem;\n\t\t}\n\t\t// .banner-footer-right__slide\n\t\t&__slide.swiper-slide {\n\t\t\twidth: 39.2rem;\n\t\t\tcolor: $dark;\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 2.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\tletter-spacing: -0.056rem;\n\t\t}\n\t}\n\t.btn {\n\t\tfont-size: 3.6rem;\n\t\tfont-weight: 600;\n\t\tline-height: normal; /* 93.333% */\n\t\tletter-spacing: -0.072rem;\n\n\t\theight: 8.8rem;\n\t\tpadding: 4rem 4.8rem;\n\t\tgap: 2rem;\n\t}\n\t@keyframes ticker {\n\t\t0% {\n\t\t\ttransform: translateX(0%);\n\t\t}\n\t\t100% {\n\t\t\ttransform: translateX(calc(-50% - 135rem));\n\t\t}\n\t}\n}\n",".main-news {\n\t// .main-news__inner\n\t&__inner {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\t// .main-news__title\n\t&__title {\n\t\tdisplay: flex;\n\t\tgap: 2.5rem;\n\t\talign-items: center;\n\t\tmargin-bottom: 7rem;\n\t\tstrong {\n\t\t\tdisplay: block;\n\t\t\tmargin-top: 1rem;\n\t\t\twidth: 11rem;\n\t\t\theight: 8.9rem;\n\t\t}\n\t}\n\t// .main-news__slider\n\t&__slider {\n\t\tmargin: 0 auto 5.6rem;\n\t\tmax-width: 192rem;\n\t\twidth: 100%;\n\t\tpadding: 0 1rem;\n\t}\n\t&__slider-wrapper {\n\t\tgap: 1rem;\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t}\n\t// .main-news__slider-slide\n\t&__slider-slide {\n\t\twidth: 24.6%;\n\t\theight: 63.2rem;\n\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\ttransition: background 0.3s linear;\n\t}\n}\n.news-slide {\n\tposition: relative;\n\toverflow: hidden;\n\tborder: 0.1rem solid $dark;\n\t&:hover {\n\t\ttransition: color 0.3s linear;\n\t\tcolor: $beige;\n\t\t.news-slide__bg-circle {\n\t\t\ttransition: opacity 0.6s linear, transform 0.8s linear;\n\t\t\topacity: 1;\n\t\t\ttransform: scale(20);\n\t\t}\n\n\t\t.news-slide__date {\n\t\t\ttransition: color 0.3s linear;\n\t\t\tcolor: $beige;\n\t\t}\n\n\t\t.news-slide__btn {\n\t\t\ttransition: color 0.3s linear;\n\t\t\tcolor: $beige;\n\t\t\t&::after {\n\t\t\t\ttransition: width 0.3s linear, background 0.3s linear;\n\t\t\t\tbackground: $beige;\n\t\t\t}\n\t\t}\n\t}\n\t&:nth-child(2n) {\n\t\t.news-slide__img {\n\t\t\twidth: 100%;\n\t\t\theight: 34rem;\n\t\t}\n\t}\n\t// .news-slide__date\n\t&__date {\n\t\ttransition: color 0.3s linear;\n\t\tcolor: $dark;\n\t\ttext-align: right;\n\t\tfont-size: 2.4rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem; /* 116.667% */\n\t\tletter-spacing: 0.216rem;\n\t\ttext-transform: uppercase;\n\n\t\tpadding: 1.7rem 2.4rem 1.3rem;\n\t}\n\t// .news-slide__content\n\t&__content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 2rem;\n\t}\n\t// .news-slide__img\n\t&__img {\n\t\twidth: 100%;\n\t\theight: 21.3rem;\n\t}\n\t// .news-slide__title\n\t&__title {\n\t\ttext-transform: uppercase;\n\t\tpadding: 0 2.4rem;\n\t\twidth: 100%;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 2;\n\t\t-webkit-box-orient: vertical;\n\t}\n\t// .news-slide__footer\n\t&__footer {\n\t\tpadding: 0 2.4rem 3.9rem;\n\t\tmargin-top: auto;\n\t}\n\t// .news-slide__btn\n\t&__btn.small-btn {\n\t\ttransition: color 0.3s linear;\n\t\t&::after {\n\t\t\ttransition: width 0.3s linear, background 0.3s linear;\n\t\t}\n\t}\n\t// .news-slide__bg\n\t&__bg {\n\t\tz-index: -1;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\t&-circle {\n\t\t\ttransition: opacity 0.6s linear, transform 0.8s linear;\n\t\t\tposition: absolute;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground-color: $orange;\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\ttransform: scale(0);\n\t\t\topacity: 0;\n\t\t\tz-index: 1;\n\t\t\t&--first {\n\t\t\t\tbottom: 5rem;\n\t\t\t\tleft: 12rem;\n\t\t\t}\n\t\t\t&--second {\n\t\t\t\ttop: 10rem;\n\t\t\t\tleft: 20rem;\n\t\t\t}\n\t\t\t&--third {\n\t\t\t\ttop: 40rem;\n\t\t\t\tright: 10rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 48em) {\n\t.main-news {\n\t\t// .main-news__title\n\t\t&__title {\n\t\t\tdisplay: flex;\n\t\t\tgap: 1.6rem;\n\t\t\talign-items: center;\n\t\t\tmargin-bottom: 8.6rem;\n\t\t\tstrong {\n\t\t\t\tmargin-top: 0;\n\t\t\t\twidth: 9.4rem;\n\t\t\t\theight: 7.4rem;\n\t\t\t}\n\t\t}\n\t\t// .main-news__slider\n\t\t&__slider {\n\t\t\tpadding: 0 3.2rem;\n\t\t\tmargin-bottom: 6.4rem;\n\t\t}\n\t\t&__slider-wrapper {\n\t\t\tgap: 2rem;\n\t\t}\n\t\t// .main-news__slider-slide\n\t\t&__slider-slide {\n\t\t\twidth: 100%;\n\t\t\theight: 67.4rem;\n\t\t}\n\t}\n\t.news-slide {\n\t\tbackground: $beige;\n\t\tborder: 0.2rem solid $dark;\n\t\t&:nth-child(2n) {\n\t\t\t.news-slide__img {\n\t\t\t\theight: 33.5rem;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\ttransition: color 0.3s linear;\n\t\t\tcolor: $dark;\n\t\t\t.news-slide__bg-circle {\n\t\t\t\ttransition: opacity 0.6s linear, transform 0.8s linear;\n\t\t\t\topacity: 1;\n\t\t\t\ttransform: scale(20);\n\t\t\t}\n\n\t\t\t.news-slide__date {\n\t\t\t\tcolor: $dark;\n\t\t\t}\n\n\t\t\t.news-slide__btn {\n\t\t\t\ttransition: color 0.3s linear;\n\t\t\t\tcolor: $dark;\n\t\t\t}\n\t\t}\n\t\t// .news-slide__date\n\t\t&__date {\n\t\t\ttext-align: right;\n\t\t\tfont-size: 3.2rem;\n\t\t\tline-height: normal; /* 116.667% */\n\t\t\tletter-spacing: 0.288rem;\n\n\t\t\tpadding: 2.2rem 3.2rem 1.4rem;\n\t\t}\n\t\t// .news-slide__content\n\t\t&__content {\n\t\t\tgap: 1.2rem;\n\t\t}\n\t\t// .news-slide__img\n\t\t&__img {\n\t\t\twidth: 100%;\n\t\t\theight: 22rem;\n\t\t}\n\t\t// .news-slide__title\n\t\t&__title {\n\t\t\tpadding: 0 3.2rem;\n\t\t\tfont-size: 4.8rem;\n\t\t}\n\t\t// .news-slide__footer\n\t\t&__footer {\n\t\t\tpadding: 0 4rem 5rem;\n\t\t}\n\t}\n}\n",".main-menu {\n\t// .main-menu__inner\n\t&__inner {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\t// .main-menu__header\n\t&__header {\n\t\tmargin-bottom: 6.4rem;\n\t}\n\t// .main-menu__title\n\t&__title {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 1.8rem;\n\n\t\tstrong {\n\t\t\tdisplay: block;\n\t\t\twidth: 10rem;\n\t\t\theight: 13.1rem;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\timg {\n\t\t\t\twidth: 5rem;\n\t\t\t\theight: 12.5rem;\n\t\t\t\ttransform: rotate(30deg);\n\t\t\t}\n\t\t}\n\t}\n\t// .main-menu__categories\n\t&__categories {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmax-width: 140rem;\n\t\tflex-wrap: wrap;\n\t\tgap: 5rem 8.8rem;\n\t\tmargin-bottom: 2rem;\n\t\t&-btn {\n\t\t\ttransition: color 0.2s linear;\n\t\t\tcolor: $dark;\n\t\t\tfont-size: 3rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 2.8rem; /* 93.333% */\n\t\t\tletter-spacing: -0.06rem;\n\t\t\ttext-transform: uppercase;\n\t\t\t&::after {\n\t\t\t\tcontent: \"\";\n\t\t\t\twidth: 0;\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tposition: relative;\n\t\t\t\tcolor: $orange;\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\ttransition: width 0.2s linear;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 0.2rem;\n\t\t\t\t\tbackground: $orange;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tbottom: -0.8rem;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\ttransform: translateX(-50%);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&__footer {\n\t\tmargin-top: 6.6rem;\n\t}\n\t// .main-menu__cards\n\t&__cards {\n\t\t&.swiper {\n\t\t\tmax-width: 192rem;\n\t\t\tmargin: 0 auto;\n\t\t\twidth: 100%;\n\t\t\tpadding: 0 1rem;\n\t\t}\n\t\t&-wrapper.swiper-wrapper {\n\t\t\tgap: 1rem;\n\t\t}\n\t\t&-slide.swiper-slide {\n\t\t\twidth: 46.3rem;\n\t\t\theight: 55rem;\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n\t&__btn {\n\t\tmargin-top: 6.6rem;\n\t}\n}\n.menu-card {\n\theight: 55rem;\n\tdisplay: flex;\n\t&:hover {\n\t\t.menu-card__img {\n\t\t\ttransition: transform 0.3s ease-in-out;\n\t\t\ttransform: translateX(-50%) scale(1.05) translateY(-5rem);\n\t\t}\n\t\t.menu-card__bg-circle {\n\t\t\ttransition: opacity 0.6s linear, transform 0.8s linear;\n\t\t\topacity: 1;\n\t\t\ttransform: scale(20);\n\t\t}\n\t\t.menu-card__description {\n\t\t\ttransition: height 0.5s linear;\n\t\t\t-webkit-line-clamp: 4;\n\t\t\theight: 11rem;\n\t\t}\n\t}\n\t// .menu-card__img\n\t&__img {\n\t\ttransition: transform 0.2s ease-in-out;\n\t\tposition: absolute;\n\t\twidth: 34.5rem;\n\t\theight: 28.7rem;\n\n\t\tleft: 50%;\n\t\ttop: 6rem;\n\t\tz-index: 2;\n\t\ttransform: translateX(-50%);\n\t\ttransform-origin: center bottom;\n\t}\n\t&__wrapper {\n\t\tposition: relative;\n\t\ttransition: background 0.3s ease-in-out;\n\t\talign-self: flex-end;\n\t\tbackground: $green;\n\t\twidth: 100%;\n\t\theight: 38.4rem;\n\t\tpadding: 3rem;\n\t\tdisplay: flex;\n\t}\n\t// .menu-card__info\n\t&__info {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\twidth: 100%;\n\t\talign-self: flex-end;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1.7rem;\n\t\t&-header {\n\t\t\tdisplay: flex;\n\t\t\talign-items: flex-end;\n\t\t\tjustify-content: space-between;\n\t\t\tgap: 2rem;\n\t\t}\n\t\t&-footer {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\t// .menu-card__name\n\t&__name {\n\t\tflex: 1;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 2;\n\t\t-webkit-box-orient: vertical;\n\n\t\tcolor: $dark;\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%; /* 45px */\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\t}\n\n\t// .menu-card__price\n\t&__price {\n\t\tpadding-right: 1.5rem;\n\t\tposition: relative;\n\t\tcolor: $dark;\n\t\ttext-align: right;\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%; /* 45px */\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\n\t\tsup {\n\t\t\tposition: absolute;\n\t\t\ttop: -0.5rem;\n\t\t\tright: 0;\n\t\t\tfont-size: 3.5rem;\n\t\t}\n\t}\n\t// .menu-card__description\n\t&__description {\n\t\ttransition: height 0.3s linear;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 2;\n\t\t-webkit-box-orient: vertical;\n\t\tmax-width: 20rem;\n\t\theight: 5.5rem;\n\t\tcolor: $dark;\n\t\ttext-overflow: ellipsis;\n\t\toverflow: hidden;\n\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem; /* 155.556% */\n\t\tletter-spacing: -0.036rem;\n\t}\n\t// .menu-card__btn\n\t&__btn {\n\t\tbackground: $dark;\n\t\tcolor: $white;\n\t}\n\t// .main-card__bg\n\t&__bg {\n\t\toverflow: hidden;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\t&-circle {\n\t\t\ttransition: opacity 0.6s linear, transform 0.8s linear;\n\t\t\tposition: absolute;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground-color: $beige;\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\ttransform: scale(0);\n\t\t\topacity: 0;\n\t\t\tz-index: 1;\n\t\t\t&--first {\n\t\t\t\tbottom: 5rem;\n\t\t\t\tleft: 12rem;\n\t\t\t}\n\t\t\t&--second {\n\t\t\t\ttop: 10rem;\n\t\t\t\tleft: 20rem;\n\t\t\t}\n\t\t\t&--third {\n\t\t\t\ttop: 20rem;\n\t\t\t\tleft: 30rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__btn-right {\n\t\tmargin: 0 auto;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.main-menu {\n\t\t// .main-menu__header\n\t\t&__header {\n\t\t\tmargin-bottom: 8rem;\n\t\t}\n\t\t// .main-menu__title\n\t\t&__title {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 1.5rem;\n\t\t\tfont-size: 5.6rem;\n\n\t\t\tstrong {\n\t\t\t\tdisplay: flex;\n\t\t\t\twidth: 7rem;\n\t\t\t\theight: 9rem;\n\n\t\t\t\timg {\n\t\t\t\t\twidth: 3.4rem;\n\t\t\t\t\theight: 8.4rem;\n\t\t\t\t\ttransform: rotate(30deg);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t// .main-menu__navigation\n\t\t&__navigation {\n\t\t\tdisplay: none;\n\t\t\t&.mobile {\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t}\n\t\t// .main-menu__categories\n\t\t&__categories {\n\t\t\tjustify-content: flex-start;\n\t\t\tmax-width: 100%;\n\t\t\toverflow: auto;\n\t\t\tpadding: 0 3.2rem;\n\t\t\tflex-wrap: nowrap;\n\t\t\theight: 6rem;\n\t\t\tmargin-bottom: 4.8rem;\n\t\t\t&-btn {\n\t\t\t\twidth: max-content;\n\t\t\t\tcolor: $dark;\n\t\t\t\tfont-size: 4rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tline-height: 100%; /* 93.333% */\n\t\t\t\tletter-spacing: -0.16rem;\n\n\t\t\t\tspan {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\twidth: max-content;\n\t\t\t\t\ttext-wrap: nowrap;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t// .main-menu__cards\n\t\t&__cards {\n\t\t\t&.swiper {\n\t\t\t\tmax-width: 100%;\n\t\t\t\tpadding: 0 3.2rem;\n\t\t\t}\n\t\t\t&-wrapper.swiper-wrapper {\n\t\t\t\tgap: 0;\n\t\t\t}\n\t\t\t&-slide.swiper-slide {\n\t\t\t\twidth: auto;\n\t\t\t\theight: 68.6rem;\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t}\n\t\t// .main-menu__btn\n\t\t&__btn {\n\t\t\tmargin-top: 0;\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: normal; /* 93.333% */\n\t\t\tletter-spacing: -0.072rem;\n\n\t\t\t&::after {\n\t\t\t\tcontent: \"\";\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 0.2rem;\n\t\t\t\tbackground: $dark;\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: -0.8rem;\n\t\t\t}\n\t\t}\n\t\t// .main-menu__footer\n\t\t&__footer {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\twidth: 100%;\n\t\t\tpadding: 0 3.2rem;\n\t\t\tmargin-top: 6.4rem;\n\t\t}\n\t}\n\t.menu-card {\n\t\t&:hover {\n\t\t\t.menu-card__img {\n\t\t\t\ttransform: translateX(-50%);\n\t\t\t}\n\t\t\t.menu-card__bg-circle {\n\t\t\t\topacity: 0;\n\t\t\t\ttransform: scale(0);\n\t\t\t}\n\t\t\t.menu-card__description {\n\t\t\t\ttransition: height 0.5s linear;\n\t\t\t\t-webkit-line-clamp: 3;\n\t\t\t\theight: 12rem;\n\t\t\t}\n\t\t}\n\t\t// .menu-card__img\n\t\t&__img {\n\t\t\ttop: 4rem;\n\t\t\twidth: 49.4rem;\n\t\t\theight: 41rem;\n\t\t\tleft: 50%;\n\t\t}\n\t\t&__wrapper {\n\t\t\talign-self: flex-end;\n\t\t\tbackground: $green;\n\t\t\twidth: 100%;\n\t\t\theight: 52.2rem;\n\t\t\tpadding: 4rem;\n\t\t\tdisplay: flex;\n\t\t}\n\t\t// .menu-card__info\n\t\t&__info {\n\t\t\twidth: 100%;\n\t\t\talign-self: flex-end;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 1.2rem;\n\n\t\t\t&-footer {\n\t\t\t\talign-items: flex-end;\n\t\t\t}\n\t\t}\n\t\t// .menu-card__name\n\t\t&__name {\n\t\t\tmax-width: 30rem;\n\t\t\tfont-size: 4.8rem;\n\t\t\tletter-spacing: -0.192rem;\n\t\t}\n\t\t// .menu-card__price\n\t\t&__price {\n\t\t\tpadding-right: 1.4rem;\n\t\t\tfont-size: 4.8rem;\n\t\t\tletter-spacing: -0.192rem;\n\t\t}\n\t\t// .menu-card__description\n\t\t&__description {\n\t\t\tmax-width: 30rem;\n\t\t\t-webkit-line-clamp: 3;\n\t\t\theight: 12rem;\n\n\t\t\tfont-size: 2.8rem;\n\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\tletter-spacing: -0.056rem;\n\t\t}\n\t\t// .menu-card__btn\n\t\t&__btn {\n\t\t\tbackground: $dark;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n}\n",".main-sale {\n\twidth: 100%;\n\tmax-width: 192rem;\n\tposition: relative;\n\tmargin: 0 auto 20rem;\n\tpadding: 0 1rem;\n\t// .main-sale__inner\n\t&__inner {\n\t\t&.desktop {\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\tgap: 1rem;\n\t\t}\n\t\t&.mobile {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t&__header {\n\t\tposition: absolute;\n\t\ttop: -2rem;\n\t\tleft: 5.1rem;\n\t}\n\t&__title {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\tstrong {\n\t\t\tdisplay: block;\n\t\t\tmargin: 2rem 3rem 0 1.5rem;\n\t\t\twidth: 8.7rem;\n\t\t\theight: 6.3rem;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\t}\n\t// .main-sale__footer\n\t&__footer {\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tleft: 50%;\n\t\tz-index: 10;\n\t\ttransform: translateX(-50%);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t\tmax-width: 192rem;\n\t\twidth: 100%;\n\t\tpadding: 0 16.5rem 0 6rem;\n\t}\n\t// .main-sale__navigation\n\t&__navigation.navigation {\n\t\tflex-direction: row;\n\t}\n}\n.sale-slider-first {\n\t&.swiper {\n\t\toverflow: hidden;\n\t\twidth: 70.7rem;\n\t\tmargin-top: 12.7rem;\n\t}\n\t// .sale-slider-first__slide\n\t&__slide.swiper-slide {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tgap: 6.4rem;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t}\n}\n.sale-slide-first {\n\t// .sale-slide-first__wrapper\n\t&__wrapper {\n\t\toverflow: hidden;\n\t\twidth: 100%;\n\t\theight: 53.9rem;\n\t\tposition: relative;\n\t\tpadding: 5rem 6rem;\n\t}\n\t// .sale-slide-first__subtitle\n\t&__subtitle {\n\t\tmax-width: 42.7rem;\n\t\tmax-height: 16.5rem;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 2;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tmargin-bottom: 4rem;\n\n\t\tcolor: $orange;\n\t\tfont-size: 9rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 90%; /* 81px */\n\t\tletter-spacing: -0.27rem;\n\t\ttext-transform: uppercase;\n\n\t\tspan {\n\t\t\tfont-style: italic;\n\t\t}\n\t}\n\t// .sale-slide-first__coast\n\t&__coast {\n\t\tmargin-bottom: 6.2rem;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcolor: $white;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem; /* 155.556% */\n\t\tletter-spacing: -0.036rem;\n\n\t\tspan {\n\t\t\tpadding-left: 0.5rem;\n\t\t\tposition: relative;\n\t\t\tcolor: $beige;\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%; /* 45px */\n\t\t\tletter-spacing: -0.18rem;\n\t\t\ttext-transform: uppercase;\n\t\t\tsup {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -0.5rem;\n\t\t\t\tright: -2rem;\n\t\t\t\tfont-size: 3rem;\n\t\t\t}\n\t\t}\n\n\t\tstrong {\n\t\t\tposition: relative;\n\t\t\tdisplay: block;\n\t\t\tmargin-left: 3rem;\n\t\t\tcolor: #b79783;\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%; /* 45px */\n\t\t\tletter-spacing: -0.09rem;\n\t\t\ttext-transform: uppercase;\n\n\t\t\t&::after {\n\t\t\t\tcontent: \"\";\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 0.2rem;\n\t\t\t\tbackground-color: #b79783;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 50%;\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t}\n\t\t\tsup {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -0.5rem;\n\t\t\t\tright: -1.5rem;\n\t\t\t\tfont-size: 3rem;\n\t\t\t}\n\t\t}\n\t}\n\t// .sale-slide-first__img\n\t&__img {\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\tz-index: -1;\n\t\theight: 100%;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n.sale-slider-second {\n\t&.swiper {\n\t\toverflow: hidden;\n\t\twidth: 70.7rem;\n\t}\n\t// .sale-slider-first__slide\n\t&__slide.swiper-slide {\n\t\twidth: 100%;\n\t\theight: 80rem;\n\t}\n}\n.sale-slide-second {\n\toverflow: hidden;\n\tposition: relative;\n\tpadding: 6rem;\n\t// .sale-slide-second__wrapper\n\t&__wrapper {\n\t\tmargin-top: 7.4rem;\n\t}\n\t// .sale-slide-second__date\n\t&__date {\n\t\tcolor: $beige;\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%; /* 45px */\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\n\t\tmargin-bottom: 4.8rem;\n\t}\n\t// .sale-slide-second__title\n\t&__title {\n\t\tposition: relative;\n\t\tmargin-bottom: 6.7rem;\n\t\tmax-width: 100%;\n\t\tmax-height: 30rem;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 3;\n\t\t-webkit-box-orient: vertical;\n\t\ttext-overflow: ellipsis;\n\t\tcolor: $beige;\n\t\tfont-size: 9rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 90%; /* 81px */\n\t\tletter-spacing: -0.27rem;\n\t\ttext-transform: uppercase;\n\t\tstrong {\n\t\t\tposition: absolute;\n\t\t\tright: 2rem;\n\t\t\tbottom: 1rem;\n\t\t\tdisplay: block;\n\t\t\tfont-size: 4.5rem;\n\t\t\tline-height: 100%; /* 45px */\n\t\t\tletter-spacing: -0.18rem;\n\t\t\tspan {\n\t\t\t\tfont-style: italic;\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n\t// .sale-slide-second__bottom-img\n\t&__img {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tz-index: -1;\n\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n}\n.sale-slider-third {\n\t&.swiper {\n\t\toverflow: hidden;\n\t\twidth: 44.9rem;\n\t}\n\t// .sale-slider-first__slide\n\t&__slide.swiper-slide {\n\t\twidth: 100%;\n\t\theight: 66.6rem;\n\t\toverflow: hidden;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tpadding: 4.5rem;\n\t}\n}\n.sale-slide-third {\n\tposition: relative;\n\t// .sale-slide-third__wrapper\n\t&__wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\t// .sale-slide-third__title\n\t&__title {\n\t\tmargin-bottom: 2.7rem;\n\t\tmax-width: 100%;\n\t\tcolor: $beige;\n\t\ttext-align: center;\n\t\tfont-size: 7rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 90%; /* 8.1rem */\n\t\tletter-spacing: -0.27rem;\n\t\ttext-transform: uppercase;\n\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 3;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\t// .sale-slide-third__btn\n\t&__btn {\n\t\tmargin-bottom: 6.1rem;\n\t\tbackground-color: $dark;\n\t\tcolor: $white;\n\t}\n\t// .sale-slide-third__img\n\t&__img {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t\tz-index: -1;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n@media (max-width: 48em) {\n\t.main-sale {\n\t\tposition: relative;\n\t\t// .main-sale__inner\n\t\t&__inner {\n\t\t\t&.desktop {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t&.mobile {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t\t&__header {\n\t\t\tposition: static;\n\t\t\tmargin-bottom: 8rem;\n\t\t}\n\t\t&__title {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\n\t\t\tfont-size: 5.6rem;\n\n\t\t\tstrong {\n\t\t\t\twidth: 6.6rem;\n\t\t\t\theight: 4.8rem;\n\t\t\t\tdisplay: block;\n\t\t\t\tmargin: 2rem 2rem 0 1.5rem;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\n\t\t\t\timg {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t// .main-sale__footer\n\t\t&__footer {\n\t\t\tposition: static;\n\t\t\ttransform: none;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\t\t\tpadding: 0 3.2rem;\n\t\t}\n\t\t// .main-sale__btn\n\t\t&__btn {\n\t\t\tposition: relative;\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: normal; /* 93.333% */\n\t\t\tletter-spacing: -0.072rem;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\t.sale-slide-first {\n\t\t// .sale-slide-first__wrapper\n\t\t&__wrapper {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tpadding: 9.2rem 4.8rem;\n\t\t}\n\t\t// .sale-slide-first__subtitle\n\t\t&__subtitle {\n\t\t\tmax-width: 75%;\n\t\t\tmax-height: auto;\n\t\t\tfont-size: 8rem;\n\t\t\tletter-spacing: -0.24rem;\n\n\t\t\tspan {\n\t\t\t\tfont-style: italic;\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t\t// .sale-slide-first__coast\n\t\t&__coast {\n\t\t\tmargin-bottom: 9.2rem;\n\t\t\tfont-size: 2.8rem;\n\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\tletter-spacing: -0.056rem;\n\n\t\t\tspan {\n\t\t\t\tpadding-left: 1rem;\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tletter-spacing: -0.192rem;\n\t\t\t\tsup {\n\t\t\t\t\tfont-size: 3.5rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tstrong {\n\t\t\t\tmargin-left: 3.2rem;\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tletter-spacing: -0.192rem;\n\n\t\t\t\tsup {\n\t\t\t\t\tfont-size: 3.5rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.sale-slider-second {\n\t\t// .sale-slider-first__slide\n\t\t&__slide.swiper-slide {\n\t\t\theight: 78rem;\n\t\t}\n\t}\n\t.sale-slide-second {\n\t\tpadding: 4.8rem;\n\t\t// .sale-slide-second__top-img\n\t\t&__top-img {\n\t\t\tposition: absolute;\n\t\t\ttop: 4.3rem;\n\t\t\tright: 0;\n\t\t\tz-index: 2;\n\n\t\t\twidth: 24rem;\n\t\t\theight: 16.6rem;\n\t\t}\n\t\t// .sale-slide-second__wrapper\n\t\t&__wrapper {\n\t\t\tmargin-top: 4.6rem;\n\t\t}\n\t\t// .sale-slide-second__date\n\t\t&__date {\n\t\t\tcolor: $beige;\n\t\t\tfont-size: 4.8rem;\n\t\t\tletter-spacing: -0.192rem;\n\n\t\t\tmargin-bottom: 2.6rem;\n\t\t}\n\t\t// .sale-slide-second__title\n\t\t&__title {\n\t\t\tmargin-bottom: 9.2rem;\n\t\t\tmax-width: 100%;\n\t\t\tfont-size: 8rem;\n\t\t\tletter-spacing: -0.24rem;\n\t\t\tstrong {\n\t\t\t\tmax-width: 27.6rem;\n\t\t\t\tdisplay: block;\n\t\t\t\tright: 8rem;\n\t\t\t\tbottom: -2rem;\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tline-height: 100%; /* 45px */\n\t\t\t\tletter-spacing: -0.18rem;\n\t\t\t\tspan {\n\t\t\t\t\tfont-style: italic;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.sale-slide-third {\n\t\tposition: relative;\n\t\tpadding: 9.4rem 9.4rem 4rem;\n\t\t// .sale-slide-third__wrapper\n\t\t&__wrapper {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\t\t// .sale-slide-third__title\n\t\t&__title {\n\t\t\tmargin-bottom: 4.8rem;\n\t\t\tfont-size: 8rem;\n\t\t\tletter-spacing: -0.24rem;\n\t\t}\n\t\t// .sale-slide-third__btn\n\t\t&__btn {\n\t\t\tmargin-bottom: 6rem;\n\t\t}\n\t}\n\t.sale-slider-third {\n\t\t// .sale-slider-first__slide\n\t\t&__slide.swiper-slide {\n\t\t\theight: 78rem;\n\t\t\tpadding: 10rem;\n\t\t}\n\t}\n\t.sale-slider-mobile {\n\t\t&.swiper {\n\t\t\twidth: 100%;\n\t\t\theight: 78rem;\n\t\t\tpadding: 0 3.2rem;\n\t\t\tmargin-bottom: 8rem;\n\t\t}\n\t\t// .sale-slider-first__slide\n\t\t&__slide.swiper-slide {\n\t\t\twidth: 63.6rem;\n\t\t\theight: 100%;\n\t\t}\n\t}\n}\n",".main-advantages {\n\t// .main-advantages__inner\n\t&__inner {\n\t\tmax-width: 192rem;\n\t\twidth: 100%;\n\t\tmargin: 0 auto;\n\t\tpadding: 0 1rem;\n\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\t&__title {\n\t\tmargin-bottom: 12.6rem;\n\t}\n\t// .main-advantages__cards\n\t&__cards {\n\t\tposition: relative;\n\t\tz-index: 200;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 1rem;\n\t\tmargin-bottom: 20rem;\n\t}\n\t// .main-advantages__card\n\t&__card {\n\t\tflex: 1 1 auto;\n\t\tposition: relative;\n\t\theight: 25.4rem;\n\t}\n\t// .main-advantages__video\n\t&__video {\n\t\t&.play {\n\t\t\tcursor: default;\n\t\t}\n\t\twill-change: transform;\n\t\tcursor: pointer;\n\t\twidth: 100%;\n\t\theight: 72rem;\n\t\tposition: relative;\n\t\tvideo {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: contain;\n\t\t\tposition: absolute;\n\t\t\tz-index: 1;\n\t\t\tbackground-color: $dark;\n\t\t}\n\t\timg {\n\t\t\ttransition: opacity 0.3s linear;\n\t\t\tposition: absolute;\n\t\t\tz-index: 2;\n\t\t}\n\t}\n\t// .main-advantages__video-play\n\t&__video-play {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\tz-index: 3;\n\t\ttransform: translate(-50%, -50%);\n\t\twidth: 7rem;\n\t\theight: 7rem;\n\t\tborder-radius: 50%;\n\t\tbackground-color: $beige;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t\tsvg {\n\t\t\twidth: 2.4rem;\n\t\t\theight: 2.4rem;\n\t\t}\n\t}\n}\n.advantages-card {\n\tborder: 0.1rem solid $choco;\n\tbackground: $beige;\n\t&:hover {\n\t\t.advantages-card__text {\n\t\t\tcolor: $orange;\n\t\t\ttransition: color 0.3s linear;\n\t\t}\n\t\t.advantages-card__icon {\n\t\t\ttransition: transform 0.3s linear;\n\t\t\ttransform: scale(0.9);\n\t\t}\n\t}\n\t// .advantages-card__icon\n\t&__icon {\n\t\ttransition: transform 0.3s linear;\n\t\tposition: absolute;\n\t\tleft: 4rem;\n\t\ttop: -6.2rem;\n\t\t&--zoom {\n\t\t\twidth: 21.6rem;\n\t\t\theight: 26.9rem;\n\t\t}\n\t\t&--star {\n\t\t\twidth: 24rem;\n\t\t\theight: 24rem;\n\t\t}\n\t\t&--shield {\n\t\t\twidth: 20.6rem;\n\t\t\theight: 24rem;\n\t\t}\n\t}\n\t// .advantages-card__bg\n\t&__bg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0.8rem;\n\t\tz-index: 1;\n\n\t\toverflow: hidden;\n\t\twidth: 32.9rem;\n\t\theight: 9.4rem;\n\n\t\timg {\n\t\t\twidth: 32.9rem;\n\t\t\theight: 26.9rem;\n\t\t\tposition: absolute;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t}\n\t}\n\t// .advantages-card__text\n\t&__text {\n\t\tcursor: default;\n\t\ttransform-origin: center top;\n\t\ttransition: color 0.3s linear;\n\t\twidth: 22.9rem;\n\t\tmax-height: 9rem;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\t\tright: 5.8rem;\n\t\tbottom: 4rem;\n\n\t\tcolor: $dark;\n\t\ttext-align: center;\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%; /* 45px */\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 2;\n\t\t-webkit-box-orient: vertical;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.main-advantages {\n\t\t// .main-advantages__inner\n\t\t&__inner {\n\t\t\tpadding: 0 3.2rem;\n\t\t}\n\t\t&__title {\n\t\t\tmargin-bottom: 11.4rem;\n\t\t}\n\t\t// .main-advantages__cards\n\t\t&__cards {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: flex-start;\n\t\t\tgap: 9.8rem;\n\t\t}\n\t\t// .main-advantages__card\n\t\t&__card {\n\t\t\twidth: 100%;\n\t\t\tflex: 1 1 auto;\n\t\t\theight: 36.4rem;\n\t\t}\n\t\t// .main-advantages__video\n\t\t&__video {\n\t\t\theight: 44.8rem;\n\n\t\t\tvideo {\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\t\t}\n\t\t// .main-advantages__video-play\n\t\t&__video-play {\n\t\t\twidth: 8.8rem;\n\t\t\theight: 8.8rem;\n\n\t\t\tsvg {\n\t\t\t\twidth: 3rem;\n\t\t\t\theight: 3rem;\n\t\t\t}\n\t\t}\n\t}\n\t.advantages-card {\n\t\tborder: 0.2rem solid $choco;\n\t\t// .advantages-card__icon\n\t\t&__icon {\n\t\t\tposition: absolute;\n\t\t\tleft: 4rem;\n\t\t\ttop: -4rem;\n\t\t\t&--zoom {\n\t\t\t\twidth: 26rem;\n\t\t\t\theight: 32rem;\n\t\t\t}\n\t\t\t&--star {\n\t\t\t\twidth: 28rem;\n\t\t\t\theight: 28rem;\n\t\t\t}\n\t\t\t&--shield {\n\t\t\t\twidth: 24rem;\n\t\t\t\theight: 28rem;\n\t\t\t}\n\t\t}\n\t\t// .advantages-card__bg\n\t\t&__bg {\n\t\t\tright: -0.5rem;\n\t\t\twidth: 35.2rem;\n\t\t\theight: 10rem;\n\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 27.9rem;\n\t\t\t}\n\t\t}\n\t\t// .advantages-card__text\n\t\t&__text {\n\t\t\twidth: 23.4rem;\n\t\t\tmax-height: 9.6rem;\n\t\t\tright: 6.6rem;\n\t\t\tbottom: 4rem;\n\n\t\t\tfont-size: 4.8rem;\n\t\t\tletter-spacing: -0.192rem;\n\t\t}\n\t}\n}\n",".main-reviews {\n\t// .main-reviews__inner\n\t&__inner {\n\t\tmax-width: 192rem;\n\t\twidth: 100%;\n\t\tmargin: 0 auto;\n\t}\n\t// .main-reviews__header\n\t&__header {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tpadding: 0 6.3rem;\n\t\tmargin-bottom: 6.4rem;\n\t}\n\t// .main-reviews__navigation\n\t&__navigation.navigation {\n\t\t&.desktop {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tgap: 0.4rem;\n\t\t}\n\t}\n\t// .main-reviews__title\n\t&__title {\n\t\tdisplay: flex;\n\t\tflex: 1 1 auto;\n\t\tmargin-left: 41.1rem;\n\t\tstrong {\n\t\t\tdisplay: block;\n\t\t\twidth: 12rem;\n\t\t\tmin-height: 8rem;\n\t\t\tmargin: 1.8rem 4rem 0;\n\t\t}\n\t}\n\t// .main-reviews__wrapper\n\t&__wrapper {\n\t\tpadding-top: 8.7rem;\n\t\tposition: relative;\n\n\t\t&::after {\n\t\t\tcontent: \"\";\n\t\t\twidth: 64rem;\n\t\t\theight: 64rem;\n\t\t\tbackground-color: $green;\n\t\t\tborder-radius: 50%;\n\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t\tz-index: -1;\n\t\t}\n\n\t\t&::before {\n\t\t\tcontent: \"\";\n\t\t\twidth: 100%;\n\t\t\theight: 36rem;\n\t\t\tposition: absolute;\n\t\t\tbottom: 6.5rem;\n\t\t\tz-index: -1;\n\t\t\tbackground: url(../assets/images/icons/review-line-bg.svg) center / cover no-repeat;\n\t\t}\n\t}\n\t// .main-reviews__slider\n\t&__slider {\n\t\toverflow: hidden;\n\t\theight: 63.5rem;\n\t}\n\t// .main-reviews__slider-wraper\n\t&__slider-wrapper.swiper-wrapper {\n\t\twidth: 100%;\n\t}\n\t// .main-reviews__slider-slide\n\t&__slider-slide.swiper-slide {\n\t\twidth: 59.1rem;\n\t\theight: 43rem;\n\t\tcursor: pointer;\n\t}\n\t// .main-reviews__footer\n\t&__footer {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 4.8rem;\n\t\tmargin: 0 auto;\n\t}\n\t// .main-reviews__subtitle\n\t&__subtitle {\n\t\tcolor: $dark;\n\t\ttext-align: center;\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%; /* 45px */\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\t}\n\t// .main-reviews__links\n\t&__links {\n\t\t&-wrapper {\n\t\t\tdisplay: flex;\n\t\t\tgap: 4rem;\n\t\t}\n\t}\n\t// .main-reviews__link\n\t&__link {\n\t\theight: 8rem;\n\t}\n}\n.review-slide {\n\t// .review-slide__icon\n\t&__icon {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 4rem;\n\t\tz-index: 2;\n\n\t\twidth: 9.6rem;\n\t\theight: 9.6rem;\n\t\tborder-radius: 50%;\n\t\tbackground: $dark;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t\timg {\n\t\t\twidth: 4rem;\n\t\t\theight: 4rem;\n\t\t}\n\t}\n\t// .review-slide__date\n\t&__date {\n\t\tposition: absolute;\n\t\tright: 4rem;\n\t\ttop: 1.2rem;\n\t\tcolor: $dark;\n\t\ttext-align: center;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem; /* 155.556% */\n\t\tletter-spacing: -0.036rem;\n\t}\n\t// .review-slide__wrapper\n\t&__wrapper {\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\talign-self: flex-end;\n\t\tpadding: 4.5rem 4rem 3rem;\n\t\tborder: 0.1rem solid $dark;\n\t\tbackground: $beige;\n\t\theight: 39.2rem;\n\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t}\n\t&__main {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 4.8rem;\n\t}\n\t// .review-slide__name\n\t&__name {\n\t\tcolor: $dark;\n\t\ttext-align: center;\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%; /* 45px */\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\t}\n\t&__transform {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\toverflow: hidden;\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\ttransition: all 0.6s linear;\n\t\ttop: 0;\n\t}\n\t// .review-slide__content\n\t&__content {\n\t\twidth: 100%;\n\t\toverflow: hidden;\n\t\tcolor: $dark;\n\t\ttext-align: center;\n\t\ttext-overflow: ellipsis;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem; /* 155.556% */\n\t\tletter-spacing: -0.036rem;\n\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 4;\n\t\t-webkit-box-orient: vertical;\n\t}\n\t// .review-slide__footer\n\t&__footer {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tposition: relative;\n\t\t&::after {\n\t\t\tcontent: \"\";\n\t\t\twidth: 18.8rem;\n\t\t\theight: 18.8rem;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground-color: $orange;\n\n\t\t\tposition: absolute;\n\t\t\tright: -7.6rem;\n\t\t\ttop: -6.1rem;\n\t\t}\n\t}\n\t// .review-slide__address\n\t&__address {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 0.6rem;\n\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\twidth: 2.4rem;\n\t\t\theight: 2.4rem;\n\t\t}\n\n\t\tstrong {\n\t\t\tdisplay: block;\n\t\t\tcolor: $dark;\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 1.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 2.8rem; /* 155.556% */\n\t\t\tletter-spacing: -0.036rem;\n\t\t}\n\t}\n\t// .review-slide__rate\n\t&__rate {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 0.6rem;\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\twidth: 2.4rem;\n\t\t\theight: 2.4rem;\n\t\t}\n\t\tstrong {\n\t\t\tcolor: $beige;\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 2.2rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 2.8rem; /* 127.273% */\n\t\t}\n\t}\n}\n.review-link {\n\tdisplay: flex;\n\t// .review-link__text\n\t&__text {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 1.2rem;\n\t\tpadding: 2.4rem;\n\t\tborder: 0.1rem solid $dark;\n\t\tborder-right: 0;\n\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\twidth: 3.2rem;\n\t\t\theight: 3.2rem;\n\t\t}\n\t\tstrong {\n\t\t\tcolor: $dark;\n\t\t\tfont-size: 2.4rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 2.8rem; /* 116.667% */\n\t\t\tletter-spacing: 0.216rem;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\t// .review-link__rate\n\t&__rate {\n\t\tbackground: $orange;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 0.4rem;\n\t\tpadding: 1.35rem;\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\twidth: 2.4rem;\n\t\t\theight: 2.4rem;\n\t\t}\n\n\t\tstrong {\n\t\t\tcolor: $beige;\n\t\t\ttext-align: center;\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 1.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 2.8rem; /* 155.556% */\n\t\t\tletter-spacing: -0.036rem;\n\t\t}\n\t}\n}\n\n@media (max-width: 48em) {\n\t.main-reviews {\n\t\toverflow: hidden;\n\t\t// .main-reviews__inner\n\t\t&__inner {\n\t\t\tmax-width: 192rem;\n\t\t\twidth: 100%;\n\t\t\tmargin: 0 auto;\n\t\t}\n\t\t// .main-reviews__header\n\t\t&__header {\n\t\t\tpadding: 0 3.2rem;\n\t\t\tmargin-bottom: 8rem;\n\t\t}\n\t\t// .main-reviews__navigation\n\t\t&__navigation.navigation {\n\t\t\t&.desktop {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t// .main-reviews__title\n\t\t&__title {\n\t\t\tjustify-content: center;\n\t\t\tmargin-left: 0;\n\t\t\tstrong {\n\t\t\t\twidth: 9rem;\n\t\t\t\tmin-height: 6.2rem;\n\t\t\t\tmargin: 1.3rem 2.2rem 0;\n\t\t\t}\n\t\t}\n\t\t// .main-reviews__wrapper\n\t\t&__wrapper {\n\t\t\tpadding: 4.8rem 0 9.2rem;\n\t\t\tmargin-bottom: 6.4rem;\n\t\t\tposition: relative;\n\n\t\t\t&::after {\n\t\t\t\twidth: 75rem;\n\t\t\t\theight: 75rem;\n\t\t\t}\n\n\t\t\t&::before {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t// .main-reviews__slider\n\t\t&__slider {\n\t\t\theight: 61rem;\n\t\t\tpadding: 0 3.2rem;\n\t\t}\n\t\t// .main-reviews__slider-slide\n\t\t&__slider-slide.swiper-slide {\n\t\t\twidth: 68.4rem;\n\t\t\theight: 100%;\n\t\t}\n\t\t// .main-reviews__footer\n\t\t&__footer {\n\t\t\toverflow: auto;\n\n\t\t\talign-items: flex-start;\n\t\t\tgap: 0;\n\t\t\tpadding: 0 3.2rem;\n\t\t\t&-mobile.mobile {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tmargin-bottom: 8rem;\n\t\t\t}\n\t\t}\n\t\t// .main-reviews__subtitle\n\t\t&__subtitle {\n\t\t\tfont-size: 4.8rem;\n\t\t\tletter-spacing: -0.192rem;\n\t\t\tmargin-bottom: 4.8rem;\n\t\t}\n\t\t// .main-reviews__links\n\t\t&__links {\n\t\t\toverflow: auto;\n\t\t\tpadding: 0 3.2rem;\n\t\t\t&-wrapper {\n\t\t\t\twidth: max-content;\n\t\t\t\tgap: 1.6rem;\n\t\t\t}\n\t\t}\n\t\t// .main-reviews__link\n\t\t&__link {\n\t\t\theight: 9.2rem;\n\t\t}\n\t}\n\t.review-slide {\n\t\t// .review-slide__icon\n\t\t&__icon {\n\t\t\tleft: 6.4rem;\n\t\t\twidth: 14rem;\n\t\t\theight: 14rem;\n\n\t\t\timg {\n\t\t\t\twidth: 6rem;\n\t\t\t\theight: 6rem;\n\t\t\t}\n\t\t}\n\t\t// .review-slide__date\n\t\t&__date {\n\t\t\tright: 6.4rem;\n\t\t\ttop: 3.8rem;\n\t\t\tfont-size: 2.8rem;\n\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\tletter-spacing: -0.056rem;\n\t\t}\n\t\t// .review-slide__wrapper\n\t\t&__wrapper {\n\t\t\tpadding: 10.4rem 6.4rem 6.4rem;\n\t\t\theight: 56.6rem;\n\t\t}\n\t\t// .review-slide__name\n\t\t&__name {\n\t\t\tfont-size: 4.8rem;\n\t\t\tletter-spacing: -0.192rem;\n\t\t}\n\t\t// .review-slide__content\n\t\t&__content {\n\t\t\tfont-size: 2.8rem;\n\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\tletter-spacing: -0.056rem;\n\t\t}\n\t\t// .review-slide__footer\n\t\t&__footer {\n\t\t\t&::after {\n\t\t\t\tcontent: \"\";\n\t\t\t\twidth: 23.4rem;\n\t\t\t\theight: 23.4rem;\n\t\t\t\tright: -10.4rem;\n\t\t\t\ttop: -7rem;\n\t\t\t}\n\t\t}\n\t\t// .review-slide__address\n\t\t&__address {\n\t\t\tgap: 1.2rem;\n\n\t\t\tspan {\n\t\t\t\twidth: 3.2rem;\n\t\t\t\theight: 3.2rem;\n\t\t\t}\n\n\t\t\tstrong {\n\t\t\t\tfont-size: 2.8rem;\n\t\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\t\tletter-spacing: -0.056rem;\n\t\t\t}\n\t\t}\n\t\t// .review-slide__rate\n\t\t&__rate {\n\t\t\tgap: 0.8rem;\n\t\t\tspan {\n\t\t\t\twidth: 3.2rem;\n\t\t\t\theight: 3.2rem;\n\t\t\t}\n\t\t\tstrong {\n\t\t\t\tfont-size: 3.2rem;\n\t\t\t\tline-height: 5.6rem; /* 127.273% */\n\t\t\t}\n\t\t}\n\t}\n\t.review-link {\n\t\t// .review-link__text\n\t\t&__text {\n\t\t\tgap: 1.6rem;\n\t\t\tpadding: 2.4rem;\n\t\t\tborder: 0.2rem solid $dark;\n\t\t\tborder-right: 0;\n\n\t\t\tspan {\n\t\t\t\twidth: 4.8rem;\n\t\t\t\theight: 4.8rem;\n\t\t\t}\n\t\t\tstrong {\n\t\t\t\tfont-size: 3.2rem;\n\t\t\t\tline-height: normal; /* 116.667% */\n\t\t\t\tletter-spacing: 0.288rem;\n\t\t\t}\n\t\t}\n\t\t// .review-link__rate\n\t\t&__rate {\n\t\t\tgap: 0.8rem;\n\t\t\tpadding: 3rem 2rem;\n\t\t\tspan {\n\t\t\t\twidth: 3.2rem;\n\t\t\t\theight: 3.2rem;\n\t\t\t}\n\n\t\t\tstrong {\n\t\t\t\tfont-size: 3.2rem;\n\t\t\t\tline-height: 5.6rem; /* 155.556% */\n\t\t\t\tletter-spacing: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n",".main-map {\n\t// .main-map__inner\n\t&__inner {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tmax-width: 192rem;\n\t\twidth: 100%;\n\t\tmargin: 0 auto;\n\t\tpadding: 0 1rem;\n\t\tgap: 8rem;\n\t}\n\t// .main-map__title\n\t&__title {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\tstrong {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tmargin-top: 2rem;\n\t\t\tmargin-right: 0.6rem;\n\n\t\t\twidth: 11.5rem;\n\t\t\theight: 12.3rem;\n\n\t\t\timg {\n\t\t\t\twidth: 7.6rem;\n\t\t\t\theight: 9.8rem;\n\t\t\t\ttransform: rotate(30deg);\n\t\t\t}\n\t\t}\n\t}\n\t// .main-map__wrapper\n\t&__wrapper {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tgap: 1rem;\n\n\t\t&::after {\n\t\t\tcontent: \"\";\n\t\t\twidth: 166.1rem;\n\t\t\theight: 67.8rem;\n\t\t\tborder: 0.1rem solid $dark;\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\ttop: -3.3rem;\n\t\t\tz-index: -1;\n\t\t}\n\t}\n\t// .main-map__map\n\t&__map {\n\t\tposition: relative;\n\t\twidth: 125.4rem;\n\t\theight: 61.4rem;\n\t\tbackground-color: #919191;\n\t\t&-header {\n\t\t\twidth: 100%;\n\t\t\theight: 9.6rem;\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tz-index: 2;\n\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\tbackground: rgba(51, 13, 3, 0.1);\n\t\t\tbackdrop-filter: blur(0.4rem);\n\t\t}\n\t\t&-nav {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 8.8rem;\n\t\t}\n\t\t&-btn {\n\t\t\tfont-size: 3rem;\n\t\t\tcolor: rgba(255, 255, 255, 0.7);\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 2.8rem; /* 93.333% */\n\t\t\tletter-spacing: -0.06rem;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t\t&-content {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t}\n\t}\n\t// .main-map__slider\n\t&__slider {\n\t\toverflow: hidden;\n\t\twidth: 50.2rem;\n\t\theight: 61.4rem;\n\t}\n\t// .main-map__slider-slide\n\t&__slider-slide.swiper-slide {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder: 0.1rem solid $dark;\n\t\tbackground: $beige;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 0.8rem;\n\t}\n\t// .main-map__slider-navigation\n\t&__slider-navigation {\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tright: 2.4rem;\n\t}\n\t// .main-map__slider-fraction\n\t&__slider-fraction.swiper-pagination-fraction {\n\t\twidth: max-content;\n\t\theight: auto;\n\t\tposition: absolute;\n\t\ttop: 13.4rem;\n\t\tleft: unset;\n\t\tright: 3.8rem;\n\t\tz-index: -1;\n\n\t\tcolor: $dark;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 2.2rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 2.8rem; /* 127.273% */\n\t}\n}\n.map-btn {\n\tposition: relative;\n\n\ttransition: color 0.3s linear;\n\t&:not(:first-child) {\n\t\tpadding-left: 1.6rem;\n\t}\n\t&::after {\n\t\tcontent: \"\";\n\t\ttransition: width 0.2s linear;\n\t\twidth: 0;\n\t\theight: 0.2rem;\n\t\tbackground-color: $white;\n\n\t\tposition: absolute;\n\t\tbottom: -0.4rem;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t}\n\tspan {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\n\t\twidth: 0.8rem;\n\t\theight: 0.8rem;\n\t\tborder-radius: 50%;\n\t}\n\t&.active {\n\t\tcolor: $white;\n\t\t&::after {\n\t\t\twidth: 100%;\n\t\t\ttransition: width 0.2s linear;\n\t\t}\n\t}\n\t&:hover {\n\t\ttransition: color 0.3s linear;\n\t\tcolor: $white;\n\t}\n\n\tspan {\n\t\tposition: absolute;\n\t}\n\t&--shawerma {\n\t\tspan {\n\t\t\tbackground-color: $orange;\n\t\t}\n\t}\n\t&--fastfood {\n\t\tspan {\n\t\t\tbackground-color: $green;\n\t\t}\n\t}\n\t&--culinary {\n\t\tspan {\n\t\t\tbackground-color: $beige;\n\t\t}\n\t}\n}\n\n.map-slide {\n\t// .map-slide__img\n\t&__img {\n\t\twidth: 100%;\n\t\theight: 29.5rem;\n\t}\n\t// .map-slide__content\n\t&__content {\n\t\toverflow: hidden;\n\t\tflex: 1 1 auto;\n\t\tpadding: 2.4rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\t// .map-slide__type\n\t&__type {\n\t\tcolor: $dark;\n\t\tfont-size: 2.4rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem; /* 116.667% */\n\t\tletter-spacing: 0.216rem;\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 1.2rem;\n\t\tspan {\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-right: 0.8rem;\n\t\t\tvertical-align: middle;\n\t\t\twidth: 0.8rem;\n\t\t\theight: 0.8rem;\n\t\t\tborder-radius: 50%;\n\t\t}\n\t}\n\t// .map-slide__address\n\t&__address {\n\t\tcolor: $dark;\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%; /* 45px */\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 2;\n\t\t-webkit-box-orient: vertical;\n\t\ttext-overflow: ellipsis;\n\t\toverflow: hidden;\n\n\t\tmargin-bottom: 2rem;\n\t}\n\t// .map-slide__time\n\t&__time {\n\t\tcolor: $dark;\n\t\tfont-size: 2.4rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem; /* 116.667% */\n\t\tletter-spacing: 0.216rem;\n\t\ttext-transform: uppercase;\n\n\t\tmargin-bottom: 2rem;\n\t}\n\t// .map-slide__underground\n\t&__underground {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\t\tgap: 0.5rem 2.4rem;\n\t\tmargin-bottom: 3.9rem;\n\n\t\tp {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 0.8rem;\n\n\t\t\tcolor: $dark;\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 1.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 2.8rem; /* 155.556% */\n\t\t\tletter-spacing: -0.036rem;\n\n\t\t\tspan {\n\t\t\t\twidth: 2.3rem;\n\t\t\t\theight: 1.9rem;\n\t\t\t}\n\t\t}\n\t}\n}\n.map-slide--fastfood .map-slide__type span {\n\tbackground: #b5bf3d;\n}\n.map-slide--shawerma .map-slide__type span {\n\tbackground: #ff6d2f;\n}\n.map-slide--culinary .map-slide__type span {\n\tbackground: rgba(51, 13, 3, 0.3);\n}\n.map-slide--red .map-slide__type span {\n\tbackground: #ff0000;\n}\n.map-slide--dark-red .map-slide__type span {\n\tbackground: #cd5c5c;\n}\n.map-slide--brick .map-slide__type span {\n\tbackground: #8b0000;\n}\n.map-slide--orange .map-slide__type span {\n\tbackground: #ffa500;\n}\n.map-slide--dark-orange .map-slide__type span {\n\tbackground: #ff8c00;\n}\n.map-slide--golden .map-slide__type span {\n\tbackground: #ff4500;\n}\n.map-slide--yellow .map-slide__type span {\n\tbackground: #ffff00;\n}\n.map-slide--sunny .map-slide__type span {\n\tbackground: #ffd700;\n}\n.map-slide--amber .map-slide__type span {\n\tbackground: #ffb900;\n}\n.map-slide--green .map-slide__type span {\n\tbackground: #008000;\n}\n.map-slide--dark-green .map-slide__type span {\n\tbackground: #006400;\n}\n.map-slide--forest .map-slide__type span {\n\tbackground: #004d00;\n}\n.map-slide--blue .map-slide__type span {\n\tbackground: #00bfff;\n}\n.map-slide--bluish-gray .map-slide__type span {\n\tbackground: #87ceeb;\n}\n.map-slide--royal .map-slide__type span {\n\tbackground: #1e90ff;\n}\n.map-slide--azure .map-slide__type span {\n\tbackground: #4169e1;\n}\n.map-slide--dark-blue .map-slide__type span {\n\tbackground: #00008b;\n}\n.map-slide--purple .map-slide__type span {\n\tbackground: #8a2be2;\n}\n.map-slide--lilac-purple .map-slide__type span {\n\tbackground: #9400d3;\n}\n.map-slide--indigo .map-slide__type span {\n\tbackground: #4b0082;\n}\n.map-slide--pink .map-slide__type span {\n\tbackground: #ffc0cb;\n}\n.map-slide--pink-purple .map-slide__type span {\n\tbackground: #ff69b4;\n}\n.map-slide--dustypink .map-slide__type span {\n\tbackground: #db7093;\n}\n.map-slide--black .map-slide__type span {\n\tbackground: #000000;\n}\n.map-slide--dark-gray .map-slide__type span {\n\tbackground: #111111;\n}\n.map-slide--charcoal-gray .map-slide__type span {\n\tbackground: #222222;\n}\n.map-slide--white .map-slide__type span {\n\tbackground: #ffffff;\n}\n.map-slide--light-gray .map-slide__type span {\n\tbackground: #f0f0f0;\n}\n\n.marker {\n\tcursor: pointer;\n\twidth: 6.4rem;\n\theight: 6.4rem;\n\tborder-radius: 50%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\tsvg {\n\t\twidth: 2.6rem;\n\t\theight: 3.755rem;\n\t}\n}\n.marker.fastfood svg path {\n\tfill: #b5bf3d;\n}\n.marker.culinary svg path {\n\tfill: #fff4da;\n}\n.marker.shawerma svg path {\n\tfill: #ff6d2f;\n}\n.marker.red svg path {\n\tfill: #ff0000;\n}\n.marker.dark-red svg path {\n\tfill: #cd5c5c;\n}\n.marker.brick svg path {\n\tfill: #8b0000;\n}\n.marker.orange svg path {\n\tfill: #ffa500;\n}\n.marker.dark-orange svg path {\n\tfill: #ff8c00;\n}\n.marker.golden svg path {\n\tfill: #ff4500;\n}\n.marker.yellow svg path {\n\tfill: #ffff00;\n}\n.marker.sunny svg path {\n\tfill: #ffd700;\n}\n.marker.amber svg path {\n\tfill: #ffb900;\n}\n.marker.green svg path {\n\tfill: #008000;\n}\n.marker.dark-green svg path {\n\tfill: #006400;\n}\n.marker.forest svg path {\n\tfill: #004d00;\n}\n.marker.blue svg path {\n\tfill: #00bfff;\n}\n.marker.bluish-gray svg path {\n\tfill: #87ceeb;\n}\n.marker.royal svg path {\n\tfill: #1e90ff;\n}\n.marker.azure svg path {\n\tfill: #4169e1;\n}\n.marker.dark-blue svg path {\n\tfill: #00008b;\n}\n.marker.purple svg path {\n\tfill: #8a2be2;\n}\n.marker.lilac-purple svg path {\n\tfill: #9400d3;\n}\n.marker.indigo svg path {\n\tfill: #4b0082;\n}\n.marker.pink svg path {\n\tfill: #ffc0cb;\n}\n.marker.pink-purple svg path {\n\tfill: #ff69b4;\n}\n.marker.dustypink svg path {\n\tfill: #db7093;\n}\n.marker.black svg path {\n\tfill: #000000;\n}\n.marker.dark-gray svg path {\n\tfill: #111111;\n}\n.marker.charcoal-gray svg path {\n\tfill: #222222;\n}\n.marker.white svg path {\n\tfill: #ffffff;\n}\n.marker.light-gray svg path {\n\tfill: #f0f0f0;\n}\n.marker.active.fastfood {\n\tbackground-color: #b5bf3d;\n}\n.marker.active.fastfood svg path {\n\tfill: #fff4da;\n}\n.marker.active.culinary {\n\tbackground-color: #fff4da;\n}\n.marker.active.culinary svg path {\n\tfill: rgba(51, 13, 3, 0.3);\n}\n.marker.active.shawerma {\n\tbackground-color: #ff6d2f;\n}\n.marker.active.shawerma svg path {\n\tfill: #fff4da;\n}\n.marker.active.red {\n\tbackground-color: #ff0000;\n}\n.marker.active.dark-red {\n\tbackground-color: #cd5c5c;\n}\n.marker.active.brick {\n\tbackground-color: #8b0000;\n}\n.marker.active.orange {\n\tbackground-color: #ffa500;\n}\n.marker.active.dark-orange {\n\tbackground-color: #ff8c00;\n}\n.marker.active.golden {\n\tbackground-color: #ff4500;\n}\n.marker.active.yellow {\n\tbackground-color: #ffff00;\n}\n.marker.active.sunny {\n\tbackground-color: #ffd700;\n}\n.marker.active.amber {\n\tbackground-color: #ffb900;\n}\n.marker.active.green {\n\tbackground-color: #008000;\n}\n.marker.active.dark-green {\n\tbackground-color: #006400;\n}\n.marker.active.forest {\n\tbackground-color: #004d00;\n}\n.marker.active.blue {\n\tbackground-color: #00bfff;\n}\n.marker.active.bluish-gray {\n\tbackground-color: #87ceeb;\n}\n.marker.active.royal {\n\tbackground-color: #1e90ff;\n}\n.marker.active.azure {\n\tbackground-color: #4169e1;\n}\n.marker.active.dark-blue {\n\tbackground-color: #00008b;\n}\n.marker.active.purple {\n\tbackground-color: #8a2be2;\n}\n.marker.active.lilac-purple {\n\tbackground-color: #9400d3;\n}\n.marker.active.indigo {\n\tbackground-color: #4b0082;\n}\n.marker.active.pink {\n\tbackground-color: #ffc0cb;\n}\n.marker.active.pink-purple {\n\tbackground-color: #ff69b4;\n}\n.marker.active.dustypink {\n\tbackground-color: #db7093;\n}\n.marker.active.black {\n\tbackground-color: #000000;\n}\n.marker.active.dark-gray {\n\tbackground-color: #111111;\n}\n.marker.active.charcoal-gray {\n\tbackground-color: #222222;\n}\n.marker.active.white {\n\tbackground-color: #ffffff;\n}\n.marker.active.light-gray {\n\tbackground-color: #f0f0f0;\n}\n[class*=\"--map-copyrights\"] {\n\tdisplay: none !important;\n}\n[class*=\"--main-engine-container\"] {\n\tfilter: contrast(60%) grayscale(100%) invert(100%);\n}\n@media (max-width: 48em) {\n\t.main-map {\n\t\t// .main-map__inner\n\t\t&__inner {\n\t\t\tpadding: 0 3.2rem;\n\t\t}\n\t\t// .main-map__title\n\t\t&__title {\n\t\t\tstrong {\n\t\t\t\tmargin-right: 0;\n\t\t\t\tmargin-left: -1rem;\n\n\t\t\t\twidth: 10.2rem;\n\t\t\t\theight: 10.8rem;\n\n\t\t\t\timg {\n\t\t\t\t\twidth: 6.7rem;\n\t\t\t\t\theight: 8.6rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t// .main-map__wrapper\n\t\t&__wrapper {\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\twidth: 100%;\n\t\t\tgap: 0;\n\n\t\t\t&::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t// .main-map__map\n\t\t&__map {\n\t\t\twidth: 100%;\n\t\t\theight: 90rem;\n\t\t\t&-header {\n\t\t\t\tmax-width: 100%;\n\t\t\t\toverflow: auto;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: auto;\n\t\t\t\tjustify-content: flex-start;\n\t\t\t\tpadding: 3.2rem 3.2rem 4.2rem;\n\t\t\t}\n\t\t\t&-btn {\n\t\t\t\twidth: max-content;\n\t\t\t\tfont-size: 4rem;\n\t\t\t\tline-height: 100%;\n\t\t\t\tletter-spacing: -0.16rem;\n\t\t\t}\n\t\t}\n\t\t// .main-map__slider\n\t\t&__slider {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t.map-btn {\n\t\tposition: relative;\n\t\ttransition: color 0.3s linear;\n\t\t&:not(:first-child) {\n\t\t\tpadding-left: 3.2rem;\n\t\t}\n\t\t&::after {\n\t\t\tbottom: -0.8rem;\n\t\t}\n\t\tspan {\n\t\t\twidth: 1.6rem;\n\t\t\theight: 1.6rem;\n\t\t}\n\t}\n\t.map-slide {\n\t\t// .map-slide__img\n\t\t&__img {\n\t\t\twidth: 100%;\n\t\t\theight: 40rem;\n\t\t}\n\t\t// .map-slide__content\n\t\t&__content {\n\t\t\tpadding: 3.2rem;\n\t\t}\n\t\t// .map-slide__type\n\t\t&__type {\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: normal; /* 116.667% */\n\t\t\tletter-spacing: 0.072rem;\n\t\t\tmargin-bottom: 3.2rem;\n\t\t\tspan {\n\t\t\t\tmargin-right: 1.6rem;\n\t\t\t\twidth: 1.6rem;\n\t\t\t\theight: 1.6rem;\n\t\t\t}\n\t\t}\n\t\t// .map-slide__address\n\t\t&__address {\n\t\t\tfont-size: 4.8rem;\n\t\t\tletter-spacing: -0.192rem;\n\t\t\tmargin-bottom: 3.2rem;\n\t\t}\n\t\t// .map-slide__time\n\t\t&__time {\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: normal; /* 116.667% */\n\t\t\tletter-spacing: 0.072rem;\n\t\t\tmargin-bottom: 3.2rem;\n\t\t}\n\t\t// .map-slide__underground\n\t\t&__underground {\n\t\t\tgap: 1rem 4.8rem;\n\t\t\tmargin-bottom: 3.2rem;\n\n\t\t\tp {\n\t\t\t\tgap: 1.6rem;\n\t\t\t\tfont-size: 2.8rem;\n\t\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\t\tletter-spacing: -0.056rem;\n\t\t\t\tspan {\n\t\t\t\t\twidth: 4.6rem;\n\t\t\t\t\theight: 3.8rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.marker {\n\t\twidth: 8.8rem;\n\t\theight: 8.8rem;\n\n\t\tsvg {\n\t\t\twidth: 3.6rem;\n\t\t\theight: 5.2rem;\n\t\t}\n\t}\n}\n",".contacts-banner {\n\t// .contacts-banner__inner\n\t&__inner {\n\t\tdisplay: flex;\n\t\tmax-width: 192rem;\n\t\tmargin: 0 auto;\n\t\tmin-height: 70.9rem;\n\t}\n\t// .contacts-banner__left\n\t&__left {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 3.2rem;\n\t\tmax-width: 96rem;\n\t\twidth: 100%;\n\n\t\tpadding: 2rem 4.8rem;\n\t\tfont-family: \"Alumni Sans\";\n\t\ttext-transform: uppercase;\n\t\tborder-bottom: 0.1rem solid $dark;\n\n\t\t// .contacts-banner__left-title\n\t\t&-title {\n\t\t\tcolor: $orange;\n\t\t}\n\t\t// .contacts-banner__left-subtitle\n\t\t&-subtitle {\n\t\t\tcolor: $choco;\n\t\t}\n\t}\n\t// .contacts-banner__right\n\t&__right {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\t// .contacts-banner__right-element\n\t\t&-element {\n\t\t\twidth: 50%;\n\t\t\tpadding: 6rem;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 3.2rem;\n\t\t\tborder-bottom: 0.1rem solid $dark;\n\t\t\tborder-left: 0.1rem solid $dark;\n\t\t}\n\t\t// .contacts-banner__right-subtitle\n\t\t&-subtitle {\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t\t// .contacts-banner__right-wrapper\n\t\t&-wrapper {\n\t\t\tcolor: $dark-secondary;\n\t\t\ttext-transform: uppercase;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 0.8rem;\n\n\t\t\ta:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t\t// .contacts-banner__right-name\n\t\t&-name {\n\t\t\tcolor: $orange;\n\t\t}\n\t\t// .contacts-banner__right-mail\n\t\t&-mail {\n\t\t\ttext-transform: uppercase;\n\t\t\ta:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 48em) {\n\t.contacts-banner {\n\t\t// .contacts-banner__inner\n\t\t&__inner {\n\t\t\tpadding-top: 9.2rem;\n\t\t\tflex-direction: column;\n\t\t\tmargin: 0;\n\t\t\tmin-height: auto;\n\t\t\tgap: 8rem;\n\t\t}\n\t\t// .contacts-banner__left\n\t\t&__left {\n\t\t\tgap: 2rem;\n\t\t\tmax-width: 100%;\n\t\t\tpadding: 0 3.2rem;\n\t\t\tborder-bottom: none;\n\n\t\t\t// .contacts-banner__left-title\n\t\t\t&-title {\n\t\t\t\tfont-size: 24rem;\n\t\t\t\tletter-spacing: -1.44rem;\n\t\t\t}\n\t\t\t// .contacts-banner__left-subtitle\n\t\t\t&-subtitle {\n\t\t\t\tfont-size: 8rem;\n\t\t\t\tletter-spacing: -0.24rem;\n\t\t\t}\n\t\t}\n\t\t// .contacts-banner__right\n\t\t&__right {\n\t\t\tflex-direction: column;\n\t\t\tflex-wrap: wrap;\n\t\t\tpadding: 0 3.2rem;\n\t\t\t// .contacts-banner__right-element\n\t\t\t&-element {\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding: 4.8rem 0;\n\t\t\t\tgap: 2rem;\n\t\t\t\tborder: none;\n\t\t\t\tborder-top: 0.2rem solid $dark;\n\t\t\t}\n\t\t\t// .contacts-banner__right-subtitle\n\t\t\t&-subtitle {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tletter-spacing: -0.192rem;\n\t\t\t}\n\t\t\t// .contacts-banner__right-wrapper\n\t\t\t&-wrapper {\n\t\t\t\tletter-spacing: -0.072rem;\n\t\t\t}\n\t\t\t// .contacts-banner__right-name\n\t\t\t&-name {\n\t\t\t\tcolor: $orange;\n\t\t\t}\n\t\t\t// .contacts-banner__right-mail\n\t\t\t&-mail {\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\ta:hover {\n\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",".vacancy-banner {\n\t// .vacancy-banner__inner\n\t&__inner {\n\t\tmax-width: 192rem;\n\t\twidth: 100%;\n\t\tmargin: 0 auto;\n\t}\n\t// .vacancy-banner__wrapper\n\t&__wrapper {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding-left: 12rem;\n\t\tgap: 17.6rem;\n\t}\n\t// .vacancy-banner__main\n\t&__main {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 20rem;\n\t\tpadding-top: 12rem;\n\t}\n\t// .vacancy-banner__top\n\t&__top {\n\t\tdisplay: flex;\n\t\tgap: 4.5rem;\n\t}\n\t// .vacancy-banner__slider\n\t&__slider {\n\t\toverflow: hidden;\n\t\tmin-width: 26rem;\n\t\tmax-width: 35rem;\n\t\tmax-height: 28rem;\n\t}\n\t// .vacancy-banner__slider-slide\n\t&__slider-slide.swiper-slide {\n\t\tpadding-bottom: 0.5rem;\n\t}\n\t// .vacancy-banner__footer\n\t&__footer {\n\t\tdisplay: flex;\n\t\tgap: 2.125rem;\n\t\tpadding-bottom: 4.6rem;\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\tcolor: $dark-secondary;\n\t\t\tfont-size: 2.4rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 2.8rem; /* 116.667% */\n\t\t\tletter-spacing: 0.216rem;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\t// .vacancy-banner__title\n\t&__title {\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t}\n\t\tspan.h1 {\n\t\t\tcolor: $orange;\n\t\t\ttext-transform: uppercase;\n\t\t\tline-height: 60%;\n\t\t}\n\t\tspan.h2 {\n\t\t\tmargin-top: -12rem;\n\t\t\tmargin-left: -1rem;\n\t\t}\n\t}\n\t// .vacancy-banner__image\n\t&__image {\n\t\tposition: absolute;\n\t\tright: 0;\n\t\ttop: 0;\n\t\twidth: 50%;\n\t\theight: 100%;\n\t\tz-index: -1;\n\t\toverflow: hidden;\n\t}\n\t// .vacancy-banner__buttons\n\t&__buttons {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 86.7rem;\n\t}\n\t// .vacancy-banner__navigation\n\t&__navigation {\n\t\tgap: 0.4rem;\n\t\tflex-direction: row-reverse;\n\t}\n}\n.vacancy-banner-slide {\n\t// .vacancy-banner-slide__header\n\t&__header {\n\t\tcolor: $dark-secondary;\n\t\tfont-size: 2.4rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem; /* 116.667% */\n\t\tletter-spacing: 0.216rem;\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 2.8rem;\n\t}\n\t// .vacancy-banner-slide__main\n\t&__main {\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%; /* 45px */\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\t}\n\t// .vacancy-banner-slide__title\n\t&__title {\n\t\tcolor: $dark;\n\t\tmargin-bottom: 1.2rem;\n\t}\n\t// .vacancy-banner-slide__salary\n\t&__salary {\n\t\tcolor: $orange;\n\t\tmargin-bottom: 6.6rem;\n\t\tspan {\n\t\t\tposition: relative;\n\t\t}\n\t\tsup {\n\t\t\tposition: static;\n\t\t\tfont-size: 2.8rem;\n\t\t\tmargin-left: 0.5rem;\n\t\t}\n\t}\n\t&__btn {\n\t\t&::after {\n\t\t\tbottom: 0;\n\t\t}\n\t}\n}\n.vacancy-list {\n\t// .vacancy-list__inner\n\t&__inner {\n\t\tmax-width: 192rem;\n\t\twidth: 100%;\n\t\tmargin: 0 auto;\n\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\t// .vacancy-list__title\n\t&__title {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 7rem;\n\t\tstrong {\n\t\t\tdisplay: block;\n\t\t\twidth: 11rem;\n\t\t\theight: 8.9rem;\n\t\t\tmargin: 0 1rem 0 2rem;\n\t\t}\n\t}\n\t// .vacancy-list__content\n\t&__content {\n\t\twidth: 100%;\n\t\tmargin-bottom: 5.6rem;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t\tgap: 5.6rem 1rem;\n\t\tpadding: 0 1rem;\n\t}\n}\n.vacancy-list-item {\n\toverflow: hidden;\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\tborder: 0.1rem solid $dark;\n\ttransition: color 0.2s linear, border 0.2s linear;\n\t&:hover {\n\t\ttransition: color 0.2s linear, border 0.2s linear;\n\t\tborder: 0.1rem solid $orange;\n\t\tcolor: $beige;\n\t\t.vacancy-list-item__bg-circle {\n\t\t\ttransition: opacity 0.6s linear, transform 0.8s linear;\n\t\t\topacity: 1;\n\t\t\ttransform: scale(20);\n\t\t}\n\t\t.vacancy-list-item__header {\n\t\t\ttransition: border 0.2s linear;\n\t\t\tborder-bottom: 0.1rem solid $beige;\n\t\t}\n\t\t.vacancy-list-item__title {\n\t\t\ttransition: color 0.2s linear;\n\t\t\tcolor: $beige;\n\t\t}\n\t\t.vacancy-list-item__salary {\n\t\t\ttransition: color 0.2s linear;\n\t\t\tcolor: $choco;\n\t\t}\n\t\t.vacancy-list-item__experience {\n\t\t\ttransition: color 0.2s linear;\n\t\t\tcolor: $beige;\n\t\t}\n\t\t.vacancy-list-item__btn {\n\t\t\t.small-btn {\n\t\t\t\ttransition: color 0.2s linear;\n\t\t\t\tcolor: $beige;\n\t\t\t\t&::after {\n\t\t\t\t\ttransition: width 0.3s linear, background 0.3s linear;\n\t\t\t\t\tbackground: $beige;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t// .vacancy-list-item__header\n\t&__header {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\tpadding: 1.5rem 2.4rem;\n\t\tborder-bottom: 0.1rem solid $dark;\n\t\ttransition: border 0.3s linear;\n\t\tspan {\n\t\t\ttext-align: right;\n\t\t\tfont-size: 2.4rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 2.8rem; /* 116.667% */\n\t\t\tletter-spacing: 0.216rem;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\t// .vacancy-list-item__content\n\t&__content {\n\t\tpadding: 2.4rem 2.4rem 3rem;\n\t}\n\t// .vacancy-list-item__title\n\t&__title {\n\t\ttransition: color 0.2s linear;\n\n\t\tmargin-bottom: 2.4rem;\n\t\tcolor: $dark;\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%; /* 45px */\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\t}\n\t// .vacancy-list-item__salary\n\t&__salary {\n\t\ttransition: color 0.2s linear;\n\t\tmargin-bottom: 2.8rem;\n\t\tcolor: $orange;\n\t\tfont-size: 3rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem; /* 93.333% */\n\t\tletter-spacing: -0.06rem;\n\t\ttext-transform: uppercase;\n\n\t\tspan {\n\t\t\tposition: relative;\n\t\t}\n\t\tsup {\n\t\t\tposition: absolute;\n\t\t\tfont-size: 1.8rem;\n\t\t\tright: -1.2rem;\n\t\t\ttop: -0.2rem;\n\t\t}\n\t}\n\t// .vacancy-list-item__experience\n\t&__experience {\n\t\ttransition: color 0.2s linear;\n\t\tmargin-bottom: 3.6rem;\n\n\t\tcolor: $dark-secondary;\n\t\tfont-size: 2.4rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem; /* 116.667% */\n\t\tletter-spacing: 0.216rem;\n\t\ttext-transform: uppercase;\n\t}\n\t// .vacancy-list-item__btn\n\t&__btn {\n\t\t.small-btn {\n\t\t\ttransition: color 0.2s linear;\n\t\t\t&::after {\n\t\t\t\tbottom: 0;\n\t\t\t\ttransition: width 0.3s linear, background 0.3s linear;\n\t\t\t}\n\t\t}\n\t}\n\t// .vacancy-list-item__bg\n\t&__bg {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tz-index: -1;\n\t\t// .vacancy-list-item__bg-circle\n\t\t&-circle {\n\t\t\ttransition: opacity 0.6s linear, transform 0.8s linear;\n\t\t\tposition: absolute;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground-color: $orange;\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\ttransform: scale(0);\n\t\t\topacity: 0;\n\t\t\tz-index: 1;\n\t\t\t&--first {\n\t\t\t\tbottom: 2.5rem;\n\t\t\t\tleft: 6rem;\n\t\t\t}\n\t\t\t&--second {\n\t\t\t\ttop: 5rem;\n\t\t\t\tleft: 10rem;\n\t\t\t}\n\t\t\t&--third {\n\t\t\t\ttop: 20rem;\n\t\t\t\tright: 5rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 48em) {\n\t.vacancy-banner {\n\t\toverflow: hidden;\n\t\t// .vacancy-banner__inner\n\t\t&__inner {\n\t\t\tmax-width: 100%;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0 3.2rem;\n\t\t}\n\t\t// .vacancy-banner__wrapper\n\t\t&__wrapper {\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tpadding-left: 0;\n\t\t\tgap: 0;\n\t\t}\n\t\t// .vacancy-banner__main\n\t\t&__main {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 3.2rem;\n\t\t\tpadding-top: 10.4rem;\n\t\t}\n\t\t// .vacancy-banner__top\n\t\t&__top {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 4.8rem;\n\t\t\t&-wrapper {\n\t\t\t\torder: 3;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t}\n\t\t}\n\t\t// .vacancy-banner__slider\n\t\t&__slider {\n\t\t\tmin-width: 30rem;\n\t\t\tmax-width: 40rem;\n\t\t}\n\t\t// .vacancy-banner__slider-slide\n\t\t&__slider-slide.swiper-slide {\n\t\t\tpadding-bottom: 1rem;\n\t\t}\n\t\t// .vacancy-banner__footer\n\t\t&__footer {\n\t\t\t&.mobile {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\ttext-align: right;\n\t\t\t\tgap: 2rem;\n\t\t\t\tpadding-bottom: 0;\n\t\t\t}\n\t\t\tspan {\n\t\t\t\tfont-size: 3.6rem;\n\t\t\t\tline-height: normal; /* 116.667% */\n\t\t\t\tletter-spacing: -0.072rem;\n\t\t\t}\n\t\t}\n\t\t// .vacancy-banner__title\n\t\t&__title {\n\t\t\torder: 1;\n\t\t\tspan.h1 {\n\t\t\t\tfont-size: 24rem;\n\t\t\t\tletter-spacing: -1.44rem;\n\t\t\t}\n\t\t\tspan.h2 {\n\t\t\t\tfont-size: 14rem;\n\t\t\t\tline-height: 90%; /* 63px */\n\t\t\t\tletter-spacing: -0.56rem;\n\t\t\t\tmargin-left: 0;\n\t\t\t\tmargin-top: -8rem;\n\t\t\t}\n\t\t}\n\t\t// .vacancy-banner__image\n\t\t&__image {\n\t\t\tposition: static;\n\t\t\twidth: 100%;\n\t\t\theight: 35.2rem;\n\t\t\torder: 2;\n\t\t}\n\t\t// .vacancy-banner__buttons\n\t\t&__buttons {\n\t\t\twidth: 100%;\n\t\t}\n\t\t// .vacancy-banner__navigation\n\t\t&__navigation {\n\t\t\tgap: 0.8rem;\n\t\t\tflex-direction: row;\n\t\t}\n\t}\n\t.vacancy-banner-slide {\n\t\t// .vacancy-banner-slide__header\n\t\t&__header {\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: normal; /* 116.667% */\n\t\t\tletter-spacing: -0.072rem;\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\t\t// .vacancy-banner-slide__main\n\t\t&__main {\n\t\t\tfont-size: 4.8rem;\n\t\t\tletter-spacing: -0.192rem;\n\t\t}\n\t\t// .vacancy-banner-slide__title\n\t\t&__title {\n\t\t\tmargin-bottom: 0.8rem;\n\t\t}\n\t\t// .vacancy-banner-slide__salary\n\t\t&__salary {\n\t\t\tmargin-bottom: 3.6rem;\n\t\t\tsup {\n\t\t\t\tfont-size: 3.2rem;\n\t\t\t\tmargin-left: 0.8rem;\n\t\t\t}\n\t\t}\n\t\t&__btn {\n\t\t\t&::after {\n\t\t\t\tbottom: -0.8rem;\n\t\t\t}\n\t\t}\n\t}\n\t.vacancy-list {\n\t\t// .vacancy-list__inner\n\t\t&__inner {\n\t\t\tmax-width: 100%;\n\t\t\tmargin: 0;\n\t\t}\n\t\t// .vacancy-list__title\n\t\t&__title {\n\t\t\tmargin-bottom: 8.4rem;\n\t\t\tstrong {\n\t\t\t\twidth: 8.6rem;\n\t\t\t\theight: 7rem;\n\t\t\t\tmargin: 0 0.5rem 0 1.5rem;\n\t\t\t}\n\t\t}\n\t\t// .vacancy-list__content\n\t\t&__content {\n\t\t\tmargin-bottom: 6.4rem;\n\t\t\tgap: 6.4rem;\n\t\t\tpadding: 0 3.2rem;\n\t\t\tgrid-template-columns: 1fr;\n\t\t}\n\t}\n\t.vacancy-list-item {\n\t\tborder: 0.2rem solid $dark;\n\t\t&:hover {\n\t\t\tborder: 0.2rem solid $orange;\n\t\t\t.vacancy-list-item__header {\n\t\t\t\tborder-bottom: 0.2rem solid $beige;\n\t\t\t}\n\t\t}\n\t\t// .vacancy-list-item__header\n\t\t&__header {\n\t\t\tpadding: 4rem;\n\t\t\tborder-bottom: 0.2rem solid $dark;\n\t\t\tspan {\n\t\t\t\tfont-size: 3.6rem;\n\t\t\t\tline-height: normal; /* 116.667% */\n\t\t\t\tletter-spacing: 0.072rem;\n\t\t\t}\n\t\t}\n\t\t// .vacancy-list-item__content\n\t\t&__content {\n\t\t\tpadding: 4rem 4rem 6rem;\n\t\t}\n\t\t// .vacancy-list-item__title\n\t\t&__title {\n\t\t\tmargin-bottom: 3rem;\n\t\t\tfont-size: 4.8rem;\n\t\t\tletter-spacing: -0.192rem;\n\t\t}\n\t\t// .vacancy-list-item__salary\n\t\t&__salary {\n\t\t\tmargin-bottom: 2rem;\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: normal; /* 93.333% */\n\t\t\tletter-spacing: 0.072rem;\n\n\t\t\tsup {\n\t\t\t\tposition: absolute;\n\t\t\t\tfont-size: 3rem;\n\t\t\t\tright: -2rem;\n\t\t\t\ttop: -0.2rem;\n\t\t\t}\n\t\t}\n\t\t// .vacancy-list-item__experience\n\t\t&__experience {\n\t\t\tmargin-bottom: 8rem;\n\t\t\tfont-size: 3.6rem;\n\t\t\tline-height: normal; /* 93.333% */\n\t\t\tletter-spacing: 0.072rem;\n\t\t}\n\t}\n}\n",".vacancy-detail {\n\t// .vacancy-detail__inner\n\t&__inner {\n\t\tpadding-top: 10.5rem;\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\t\tjustify-content: space-between;\n\t}\n\t// .vacancy-detail__main\n\t&__main {\n\t\tmax-width: 94.5rem;\n\t\twidth: 100%;\n\t}\n\t// .vacancy-detail__header\n\t&__header {\n\t\tdisplay: flex;\n\t\talign-items: flex-end;\n\t\tjustify-content: space-between;\n\t\tpadding-bottom: 5.6rem;\n\t\tborder-bottom: 0.1rem solid $dark;\n\t\t&-main {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 3.6rem;\n\t\t\ttext-transform: uppercase;\n\n\t\t\t&--title {\n\t\t\t\tcolor: $orange;\n\t\t\t}\n\t\t\t&--info {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 0.5rem;\n\n\t\t\t\tspan {\n\t\t\t\t\tcolor: $dark-secondary;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&--salary {\n\t\t\t\tspan {\n\t\t\t\t\tposition: relative;\n\t\t\t\t}\n\t\t\t\tsup {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tfont-size: 1.8rem;\n\t\t\t\t\tright: -1rem;\n\t\t\t\t\ttop: -0.4rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t// .vacancy-detail__info\n\t&__info {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 3.6rem;\n\t\tpadding-top: 5.6rem;\n\t\tp {\n\t\t\tcolor: $dark;\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 2.2rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 2.8rem; /* 127.273% */\n\t\t}\n\t\t&-list {\n\t\t\tspan {\n\t\t\t\tdisplay: block;\n\t\t\t\tcolor: $dark;\n\t\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\t\tfont-size: 2.2rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 2.8rem; /* 127.273% */\n\t\t\t\tmargin-bottom: 2.4rem;\n\t\t\t}\n\t\t\tul {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 1.2rem;\n\t\t\t\tli {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tpadding-left: 2.6rem;\n\n\t\t\t\t\tcolor: $dark;\n\t\t\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\t\t\tfont-size: 1.8rem;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tline-height: 2.8rem; /* 155.556% */\n\t\t\t\t\tletter-spacing: -0.036rem;\n\n\t\t\t\t\t&::after {\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\twidth: 1rem;\n\t\t\t\t\t\theight: 1rem;\n\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tz-index: 1;\n\t\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t\tbackground: $green;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t// .vacancy-detail__slider\n\t&__slider {\n\t\twidth: 46.8rem;\n\t\toverflow: hidden;\n\t}\n\t// .vacancy-detail__slider-wrapper\n\t&__slider-wrapper.swiper-wrapper {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr;\n\t\tgrid-template-rows: repeat(2, auto);\n\t\tgrid-auto-flow: column;\n\t\tmargin-bottom: 1rem;\n\t}\n\t// .vacancy-detail__slider-slide\n\t&__slider-slide.swiper-slide {\n\t\theight: auto !important;\n\t\t.vacancy-list-item__experience {\n\t\t\tmargin-bottom: 5rem;\n\t\t}\n\t\t.vacancy-list-item__title {\n\t\t\tmargin-bottom: 2.5rem;\n\t\t}\n\t}\n\t// .vacancy-detail__slider-navigation\n\t&__slider-navigation {\n\t\tflex-direction: row-reverse;\n\t\tjustify-content: flex-end;\n\t}\n}\n@media (max-width: 48em) {\n\t.vacancy-detail {\n\t\t// .vacancy-detail__inner\n\t\t&__inner {\n\t\t\tpadding-top: 9.2rem;\n\t\t\tflex-direction: column;\n\t\t\tgap: 20rem;\n\t\t}\n\t\t// .vacancy-detail__main\n\t\t&__main {\n\t\t\tmax-width: 100%;\n\t\t}\n\t\t// .vacancy-detail__header\n\t\t&__header {\n\t\t\tpadding-bottom: 4.8rem;\n\t\t\tborder-bottom: 0.2rem solid $dark;\n\t\t\t&-main {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 2rem;\n\t\t\t\ttext-transform: uppercase;\n\n\t\t\t\t&--title {\n\t\t\t\t\tmargin-bottom: 4.8rem;\n\t\t\t\t\tspan {\n\t\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\t\tfont-size: 8rem;\n\t\t\t\t\t\tletter-spacing: -0.24rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&--info {\n\t\t\t\t\tgap: 2rem;\n\t\t\t\t}\n\t\t\t\t&--salary {\n\t\t\t\t\tsup {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tfont-size: 3rem;\n\t\t\t\t\t\tright: -1.5rem;\n\t\t\t\t\t\ttop: -1rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t// .vacancy-detail__info\n\t\t&__info {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 4.8rem;\n\t\t\tpadding-top: 4.8rem;\n\t\t\tp {\n\t\t\t\tfont-size: 2.8rem;\n\t\t\t\tline-height: 4rem; /* 127.273% */\n\t\t\t\tletter-spacing: -0.056rem;\n\t\t\t}\n\t\t\t&-list {\n\t\t\t\tspan {\n\t\t\t\t\tfont-size: 3.6rem;\n\t\t\t\t\tline-height: 5.8rem; /* 127.273% */\n\t\t\t\t\tmargin-bottom: 3.2rem;\n\t\t\t\t}\n\t\t\t\tul {\n\t\t\t\t\tgap: 1.6rem;\n\t\t\t\t\tli {\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tpadding-left: 5.2rem;\n\n\t\t\t\t\t\tfont-size: 2.8rem;\n\t\t\t\t\t\tline-height: 4rem; /* 155.556% */\n\t\t\t\t\t\tletter-spacing: -0.056rem;\n\n\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\twidth: 2rem;\n\t\t\t\t\t\t\theight: 2rem;\n\t\t\t\t\t\t\ttop: 1.2rem;\n\t\t\t\t\t\t\ttransform: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t// .vacancy-detail__slider\n\t\t&__slider {\n\t\t\tposition: relative;\n\t\t\twidth: 68.6rem;\n\t\t}\n\t\t// .vacancy-detail__slider-wrapper\n\t\t&__slider-wrapper.swiper-wrapper {\n\t\t\tdisplay: flex;\n\t\t\tmargin-bottom: 6.4rem;\n\t\t}\n\t\t// .vacancy-detail__slider-slide\n\t\t&__slider-slide.swiper-slide {\n\t\t\twidth: 68.6rem;\n\t\t\theight: auto !important;\n\t\t\t.vacancy-list-item__experience {\n\t\t\t\tmargin-bottom: 8rem;\n\t\t\t}\n\t\t\t.vacancy-list-item__title {\n\t\t\t\tmargin-bottom: 3rem;\n\t\t\t}\n\t\t}\n\t\t// .vacancy-detail__slider-navigation\n\t\t&__slider-navigation {\n\t\t\tflex-direction: row;\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-start;\n\n\t\t\t&-more.mobile {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: flex-end;\n\t\t\t\twidth: 100%;\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: 2.4rem;\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n",".news-detail {\n\t// .news-detail__inner\n\t&__inner {\n\t\tpadding-top: 12rem;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\t// .news-detail__header\n\t&__header {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 4rem;\n\t\tmax-width: 90.3rem;\n\t\twidth: 100%;\n\t\tmargin-bottom: 6.4rem;\n\t}\n\t// .news-detail__title\n\t&__title {\n\t\tcolor: $orange;\n\t\ttext-transform: uppercase;\n\t}\n\t// .news-detail__date\n\t&__date {\n\t\ttext-transform: uppercase;\n\t}\n\t// .news-detail__picture\n\t&__picture {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tposition: relative;\n\t\twidth: 100%;\n\n\t\tmargin-bottom: 8.1rem;\n\t}\n\t// .news-detail__navigation-btn\n\t&__navigation-btn {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t}\n\t// .news-detail__navigation--next\n\t&__navigation--next {\n\t\tright: 0;\n\t}\n\t// .news-detail__navigation--prev\n\t&__navigation--prev {\n\t\tleft: 0;\n\t}\n\t// .news-detail__image\n\t&__image {\n\t\twidth: 142.2rem;\n\t\theight: 50.8rem;\n\t}\n\t// .news-detail__content\n\t&__content {\n\t\tmax-width: 94.5rem;\n\t\twidth: 100%;\n\t\tfont-family: \"Euclid Circular A\";\n\t\tcolor: $dark-secondary;\n\t\tfont-style: normal;\n\t\tline-height: 2.8rem; /* 155.556% */\n\n\t\tdiv {\n\t\t\tfont-size: 2.2rem;\n\t\t\tfont-weight: 500;\n\t\t\t&:not(:last-child) {\n\t\t\t\tmargin-bottom: 4rem;\n\t\t\t}\n\t\t}\n\n\t\tp {\n\t\t\tfont-size: 1.8rem;\n\t\t\tletter-spacing: -0.036rem;\n\t\t\t&:not(:last-child) {\n\t\t\t\tmargin-bottom: 4rem;\n\t\t\t}\n\t\t}\n\t}\n}\n@media (max-width: 48em) {\n\t.news-detail {\n\t\t// .news-detail__inner\n\t\t&__inner {\n\t\t\tposition: relative;\n\t\t\tpadding-top: 10.4rem;\n\t\t\tpadding-bottom: 15.2rem;\n\t\t}\n\t\t// .news-detail__header\n\t\t&__header {\n\t\t\tgap: 2rem;\n\t\t\tmax-width: 100%;\n\t\t\tmargin-bottom: 4.8rem;\n\t\t}\n\t\t// .news-detail__title\n\t\t&__title {\n\t\t\tfont-size: 8rem;\n\t\t}\n\t\t// .news-detail__picture\n\t\t&__picture {\n\t\t\tposition: static;\n\t\t\tmargin-bottom: 4.8rem;\n\t\t}\n\t\t// .news-detail__navigation-btn\n\t\t&__navigation-btn {\n\t\t\tposition: absolute;\n\t\t\ttop: unset;\n\t\t\ttransform: translateY(0);\n\t\t\tbottom: 0;\n\t\t}\n\t\t// .news-detail__image\n\t\t&__image {\n\t\t\twidth: 100%;\n\t\t\theight: 51.6rem;\n\t\t\timg {\n\t\t\t\tobject-position: center;\n\t\t\t}\n\t\t}\n\t\t// .news-detail__content\n\t\t&__content {\n\t\t\tmax-width: 100%;\n\t\t\tline-height: 5.6rem; /* 155.556% */\n\n\t\t\tdiv {\n\t\t\t\tfont-size: 3.6rem;\n\t\t\t\t&:not(:last-child) {\n\t\t\t\t\tmargin-bottom: 3.2rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tfont-size: 2.8rem;\n\t\t\t\tletter-spacing: -0.056rem;\n\t\t\t\tline-height: 4rem;\n\t\t\t\t&:not(:last-child) {\n\t\t\t\t\tmargin-bottom: 3.2rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",".service-delivery {\n\t.container {\n\t\twidth: 189rem;\n\t\tpadding: 0 1rem;\n\t}\n\t&__wrapper {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n\n\t&__block {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 6.1rem;\n\t}\n\n\t&__title {\n\t\tcolor: $dark;\n\t\tfont-family: \"Alumni Sans\", sans-serif;\n\t\tfont-size: 9rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 90%;\n\t\tletter-spacing: -2.7px;\n\t\ttext-transform: uppercase;\n\t\tpadding: 0 4rem;\n\t}\n\n\t&__block-w {\n\t\tdisplay: flex;\n\t\tpadding-right: 6rem;\n\t\tpadding-top: 1rem;\n\t}\n\n\t&__partner {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-right: 5rem;\n\t\t&-icon {\n\t\t\twidth: 5.5rem;\n\t\t\theight: 5.5rem;\n\t\t\tmargin-right: 1rem;\n\t\t}\n\n\t\t&-text {\n\t\t\tcolor: #1e1121;\n\t\t\tfont-family: \"Alumni Sans\", sans-serif;\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -1.8px;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\n\t&__partner:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&__image {\n\t\twidth: 52rem;\n\t\theight: 52rem;\n\t\tborder-radius: 50%;\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\timg {\n\t\t\tborder-radius: 50%;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t}\n\n\t&__inner {\n\t\tdisplay: flex;\n\t\twidth: 94.5rem;\n\t\tposition: relative;\n\t\tmargin-right: 1rem;\n\t}\n\n\t&__inner:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&__info {\n\t\twidth: 52rem;\n\t\theight: 52rem;\n\t\tborder-radius: 50%;\n\t\tposition: relative;\n\t\tz-index: 1;\n\t\tborder: 0.1rem solid $dark;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tpadding-left: 18rem;\n\t\tflex-direction: column;\n\t\tposition: absolute;\n\t\tright: 0;\n\t\t&-number {\n\t\t\tcolor: $orange;\n\t\t\tfont-family: \"Alumni Sans\", sans-serif;\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -1.8px;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-bottom: 2.8rem;\n\t\t}\n\n\t\t&-text {\n\t\t\tfont-family: \"Euclid Circular A\", sans-serif;\n\t\t\tfont-size: 1.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 2.8rem;\n\t\t\tletter-spacing: -0.36px;\n\t\t\tmax-width: 23.6rem;\n\t\t}\n\n\t\t&-title {\n\t\t\tcolor: $dark;\n\t\t\tfont-family: \"Alumni Sans\", sans-serif;\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -1.8px;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-bottom: 2.8rem;\n\t\t}\n\t}\n\n\t&__btn--mob {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.service-delivery {\n\t\tmargin-bottom: 10rem;\n\t\t.container {\n\t\t\twidth: 100%;\n\t\t\tpadding: 0 3.2rem;\n\t\t}\n\n\t\t&__title {\n\t\t\tpadding: 0;\n\t\t\tfont-size: 8rem;\n\t\t\tline-height: 90%;\n\t\t\tmargin-bottom: 4rem;\n\t\t\tletter-spacing: -1.2px;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\n\t\t&__block {\n\t\t\tflex-direction: column;\n\t\t\tmargin-bottom: 8rem;\n\t\t}\n\n\t\t&__block-w {\n\t\t\tpadding-right: 0;\n\t\t\tpadding-top: 0;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t}\n\n\t\t&__partner {\n\t\t\tmargin-right: 0;\n\t\t\tflex-direction: column;\n\t\t\t&-icon {\n\t\t\t\tmargin-right: 0;\n\t\t\t\tmargin-bottom: 1.6rem;\n\t\t\t\twidth: 8.8rem;\n\t\t\t\theight: 8.8rem;\n\t\t\t}\n\n\t\t\t&-text {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tline-height: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&__wrapper {\n\t\t\tflex-direction: column;\n\t\t}\n\n\t\t&__inner {\n\t\t\twidth: 100%;\n\t\t\tmargin-right: 0;\n\t\t\tflex-direction: column;\n\t\t\tmargin-bottom: 0rem;\n\t\t}\n\n\t\t&__inner:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t&__image {\n\t\t\twidth: 100%;\n\t\t\theight: 68.4rem;\n\t\t}\n\n\t\t&__info {\n\t\t\tposition: relative;\n\t\t\twidth: 100%;\n\t\t\theight: 68.4rem;\n\t\t\ttransition: 0.5s;\n\t\t\tpadding: 6.4rem;\n\t\t\ttop: -68.4rem;\n\t\t\t&-number {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 22rem;\n\t\t\t}\n\n\t\t\t&-title {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tmargin-bottom: 3.2rem;\n\t\t\t\tpadding-left: 5rem;\n\t\t\t}\n\n\t\t\t&-text {\n\t\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\t\tfont-size: 2.8rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 4rem;\n\t\t\t\tletter-spacing: -0.28px;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&__info.active {\n\t\t\ttop: -14rem;\n\t\t\ttransition: 0.5s;\n\t\t}\n\t}\n}\n",".main-delivery {\n\tmargin-bottom: 18.5rem;\n\tpadding-top: 21rem;\n\tposition: relative;\n\t&__wrapper {\n\t\tdisplay: flex;\n\t}\n\n\t&__left-text {\n\t\twidth: 19.3rem;\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem;\n\t\tletter-spacing: -0.36px;\n\t\tcolor: $dark;\n\t\tfont-family: \"Euclid Circular A\", sans-serif;\n\t}\n\n\t&__left {\n\t\tmargin-right: 23.5rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t&__right {\n\t\tdisplay: flex;\n\t}\n\n\t&__image {\n\t\twidth: 70.6rem;\n\t\theight: 61.6rem;\n\t\tmargin-right: 6rem;\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t}\n\n\t&__title {\n\t\tposition: absolute;\n\t\twidth: 83rem;\n\t\tright: 19rem;\n\t\ttop: 9rem;\n\t\tmargin-bottom: 12.1rem;\n\n\t\tstrong {\n\t\t\tdisplay: block;\n\t\t\tcolor: $orange;\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 25rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 90%;\n\t\t\tletter-spacing: -1.5rem;\n\t\t\ttext-transform: uppercase;\n\t\t\tposition: relative;\n\t\t\tz-index: 2;\n\t\t}\n\n\t\tspan {\n\t\t\tcolor: $dark;\n\t\t\tfont-family: \"Literata\";\n\t\t\tfont-size: 19rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 90%;\n\t\t\tletter-spacing: -7.6px;\n\t\t\tposition: absolute;\n\t\t\tz-index: 3;\n\t\t\ttext-align: right;\n\t\t\tright: 0;\n\t\t\ttop: 7.8rem;\n\t\t}\n\t}\n\n\t&__title--mob {\n\t\tdisplay: none;\n\t}\n\n\t&__inner {\n\t\tpadding-top: 24.2rem;\n\t}\n\n\t&__text {\n\t\tcolor: rgba(51, 13, 3, 0.6);\n\t\tfont-family: \"Euclid Circular A\", sans-serif;\n\t\tfont-size: 2.2rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 2.8rem;\n\t\twidth: 37.4rem;\n\t\tmargin-bottom: 5.6rem;\n\t}\n\n\t&__icon {\n\t\twidth: 11.6rem;\n\t\theight: 8.4rem;\n\t\tposition: absolute;\n\t\tright: 6rem;\n\t\tbottom: 0;\n\t}\n\n\t.btn {\n\t\twidth: 19rem;\n\t}\n\n\t&__scroll {\n\t\tmargin-top: auto;\n\t}\n\n\t&__left-text.mob {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.main-delivery {\n\t\tpadding-top: 7.4rem;\n\t\t.container {\n\t\t\twidth: 100%;\n\t\t\tpadding: 0 3.2rem;\n\t\t}\n\n\t\t&__left {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&__right {\n\t\t\tflex-direction: column;\n\t\t}\n\n\t\t&__title {\n\t\t\tposition: relative;\n\t\t\ttop: initial;\n\t\t\twidth: 100%;\n\t\t\tright: initial;\n\t\t\tmargin-bottom: 7.8rem;\n\n\t\t\tstrong {\n\t\t\t\tfont-size: 24rem;\n\t\t\t\tletter-spacing: -1.3rem;\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tleft: 0;\n\t\t\t\tright: initial;\n\t\t\t\tfont-size: 19rem;\n\t\t\t\ttop: 8rem;\n\t\t\t}\n\t\t}\n\n\t\t&__title--mob {\n\t\t\tdisplay: block;\n\t\t}\n\n\t\t&__inner {\n\t\t\tpadding-top: 2rem;\n\t\t\t.main-delivery__title {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t&__image {\n\t\t\twidth: 100%;\n\t\t\theight: 35.2rem;\n\t\t\tmargin-right: 0;\n\t\t}\n\n\t\t&__wrapper {\n\t\t\tflex-direction: column;\n\t\t}\n\n\t\t&__text {\n\t\t\tcolor: var(--dark-secondary, rgba(51, 13, 3, 0.6));\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 2.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 4rem;\n\t\t\tletter-spacing: -0.28px;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t&__left-text.mob {\n\t\t\tdisplay: block;\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 2.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 4rem;\n\t\t\tletter-spacing: -0.28px;\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\n\t\t.btn {\n\t\t\twidth: auto;\n\t\t}\n\t}\n}\n",".sliders-delivery {\n\toverflow: hidden;\n\t.container {\n\t\twidth: 190rem;\n\t\tpadding: 0 1rem;\n\t}\n\t&__block {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 8.3rem;\n\t\tpadding: 0 5rem;\n\t\t.btn {\n\t\t\twidth: 16.7rem;\n\t\t}\n\t}\n\n\t&__btn--mob {\n\t\tdisplay: none;\n\t}\n\n\t&__title {\n\t\tcolor: $dark;\n\t\tfont-family: \"Literata\", sans-serif;\n\t\tfont-size: 8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 110%;\n\t\tletter-spacing: -1.6px;\n\t\tdisplay: flex;\n\n\t\t&-icon {\n\t\t\twidth: 10rem;\n\t\t\theight: 10rem;\n\t\t\tmargin: 0 3rem;\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tborder-radius: 50%;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__navigation {\n\t\tdisplay: flex;\n\t\tflex-direction: initial;\n\t}\n\n\t&__swiper {\n\t\tmargin-bottom: 19rem;\n\t}\n\n\t&__swiper:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.sliders-delivery {\n\t\t.container {\n\t\t\twidth: 100%;\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t&__block {\n\t\t\tmargin-bottom: 8rem;\n\t\t\tpadding: 0;\n\n\t\t\t.btn {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t&__navigation {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&__title {\n\t\t\tfont-size: 5.6rem;\n\t\t\tjustify-content: center;\n\t\t\tmargin: 0 auto;\n\t\t\tline-height: 124%;\n\t\t\t&-icon {\n\t\t\t\twidth: 8.8rem;\n\t\t\t\theight: 8.8rem;\n\t\t\t}\n\t\t}\n\n\t\t&__swiper {\n\t\t\tmargin-bottom: 6.4rem;\n\t\t\tpadding-left: 3.2rem;\n\t\t}\n\n\t\t&__btn--mob {\n\t\t\tdisplay: flex;\n\t\t\twidth: 20rem;\n\t\t\tmargin: 0 auto;\n\t\t\tmargin-bottom: 20rem;\n\t\t}\n\n\t\t&__btn--mob:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n}\n",".delivery-box {\n\tpadding: 7rem 6rem;\n\twidth: 93rem;\n\theight: 61rem;\n\tposition: relative;\n\tdisplay: block;\n\toverflow: hidden;\n\t&__par {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-bottom: 2.4rem;\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\t&-icon {\n\t\t\twidth: 3.7rem;\n\t\t\theight: 3.7rem;\n\t\t\tmargin-right: 0.8rem;\n\t\t}\n\n\t\t&-text {\n\t\t\tcolor: $beige;\n\t\t\tfont-family: \"Alumni Sans\", sans-serif;\n\t\t\tfont-size: 2.4rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 2.8rem;\n\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\n\t&__date {\n\t\tcolor: #fff4da;\n\t\tmargin-bottom: 2.4rem;\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%;\n\t\tletter-spacing: -1.8px;\n\t\ttext-transform: uppercase;\n\t\tposition: relative;\n\t\tz-index: 2;\n\t}\n\n\t&__title {\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 9rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 90%;\n\t\tmargin-bottom: 2.4rem;\n\t\ttext-transform: uppercase;\n\t\tposition: relative;\n\t\tz-index: 2;\n\n\t\tspan {\n\t\t\tfont-style: italic;\n\t\t\tfont-size: 7.8rem;\n\t\t}\n\t}\n\n\t&__price-block {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 2.4rem;\n\t\tposition: relative;\n\t\tz-index: 2;\n\t}\n\n\t&__image-m {\n\t\tdisplay: none;\n\t}\n\n\t&__image {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tz-index: 1;\n\t\tleft: 0;\n\t}\n\n\t&__price {\n\t\tcolor: var(--beige, #fff4da);\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%;\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\t\tpadding-right: 1.5rem;\n\t\tmargin-right: 1.2rem;\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\t&::before {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"₽\";\n\t\t\tcolor: var(--beige, #fff4da);\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 3rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -0.18rem;\n\t\t\ttext-transform: uppercase;\n\t\t\tright: 0;\n\t\t}\n\t\tb {\n\t\t\tcolor: var(--white, #fff);\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 1.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 2.8rem;\n\t\t\tletter-spacing: -0.36px;\n\t\t\tmargin-right: 0.4rem;\n\t\t}\n\t}\n\n\t.btn {\n\t\tz-index: 2;\n\t}\n\n\t&__sale {\n\t\tmargin-top: 0.6rem;\n\t\tposition: relative;\n\t\tcolor: rgba(255, 244, 218, 0.6);\n\t\tz-index: 2;\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%;\n\t\tletter-spacing: -0.18rem;\n\t\ttext-transform: uppercase;\n\t\tpadding-right: 1.5rem;\n\t\tmargin-right: 1.2rem;\n\t\ttext-decoration: line-through;\n\n\t\t&::before {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"₽\";\n\t\t\tcolor: rgba(255, 244, 218, 0.6);\n\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 3rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -0.18rem;\n\t\t\ttext-transform: uppercase;\n\t\t\tright: 0;\n\t\t}\n\t}\n\t&--first {\n\t\tbackground: #4c0d00;\n\t\t.delivery-box {\n\t\t\t&__title {\n\t\t\t\tcolor: var(--orange, #ff6d2f);\n\t\t\t}\n\t\t}\n\t}\n\n\t&--second {\n\t\tbackground: var(--green, #b5bf3d);\n\n\t\t.delivery-box {\n\t\t\t&__title {\n\t\t\t\tcolor: var(--beige, #fff4da);\n\t\t\t}\n\n\t\t\t&__price-block {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\n\t\t\t&__dop-text {\n\t\t\t\tcolor: var(--beige, #fff4da);\n\t\t\t\tfont-family: \"Alumni Sans\";\n\t\t\t\tfont-size: 4.5rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 100%;\n\t\t\t\tletter-spacing: -1.8px;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 36rem;\n\t\t\t\tleft: 26.3rem;\n\n\t\t\t\tspan {\n\t\t\t\t\tfont-family: \"Alumni\", sans-serif;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 48em) {\n\t.delivery-box {\n\t\twidth: 63.8rem;\n\t\theight: 78rem;\n\t\tpadding: 9.2rem 4.8rem;\n\t\t&__image {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&__price-block {\n\t\t\tmargin-bottom: 5rem;\n\t\t}\n\n\t\t&__image-m {\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tleft: 0;\n\t\t}\n\n\t\t&__par {\n\t\t\tmargin-bottom: 5rem;\n\n\t\t\t&-icon {\n\t\t\t\twidth: 6rem;\n\t\t\t\theight: 6rem;\n\t\t\t\tmargin-right: 1.6rem;\n\t\t\t}\n\n\t\t\t&-text {\n\t\t\t\tfont-size: 4rem;\n\t\t\t}\n\t\t}\n\n\t\t&__title {\n\t\t\tfont-size: 8rem;\n\t\t}\n\n\t\t&__dop-text {\n\t\t\tdisplay: none;\n\t\t\tfont-size: 4.8rem;\n\t\t\ttop: 37rem;\n\t\t\tleft: 25.3rem;\n\t\t\twidth: 31rem;\n\t\t\tletter-spacing: -0.9.6rem;\n\t\t\tspan {\n\t\t\t\tpadding: 0 0.5rem;\n\t\t\t}\n\t\t}\n\t}\n}\n",".stock {\n\tpadding-top: 20rem;\n\t.container {\n\t\twidth: 100%;\n\t\tpadding: 0 1rem;\n\t}\n\t&__title {\n\t\tcolor: $dark;\n\t\tfont-family: \"Literata\", sans-serif;\n\t\tfont-size: 8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 110%;\n\t\tletter-spacing: -1.6px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tmargin-bottom: 7rem;\n\n\t\tbr {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&-icon {\n\t\t\twidth: 18.9rem;\n\t\t\theight: 9rem;\n\t\t\tmargin: 0 3rem;\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__inner {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin-bottom: 5.6rem;\n\t}\n\n\t.delivery-box {\n\t\tmargin-right: 1rem;\n\n\t\tmargin-bottom: 5.6rem;\n\t}\n\n\t.delivery-box:nth-child(2n) {\n\t\tmargin-right: 0;\n\t}\n\n\t.delivery-box:nth-last-child(-n + 2) {\n\t\tmargin-bottom: 0;\n\t}\n\n\t&__btn {\n\t\tcolor: var(--dark, #330d03);\n\t\ttext-align: center;\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 3rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem;\n\t\tletter-spacing: -0.6px;\n\t\ttext-transform: uppercase;\n\t\tposition: relative;\n\t\tpadding-bottom: 0.8rem;\n\t\tdisplay: block;\n\t\tmargin: 0 auto;\n\t\tmargin-bottom: 21rem;\n\t\t&::before {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"\";\n\t\t\twidth: 100%;\n\t\t\tbackground: var(--dark, #330d03);\n\t\t\theight: 0.2rem;\n\t\t\tbottom: 0;\n\t\t}\n\t}\n\n\t&__btn-all {\n\t\tmargin: 0 auto;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tmargin-bottom: 20rem;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.stock {\n\t\t.container {\n\t\t\tpadding: 0 3.2rem;\n\t\t}\n\t\t&__title {\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tfont-family: \"Literata\";\n\t\t\tfont-size: 5.6rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 110%;\n\t\t\tletter-spacing: -0.56px;\n\t\t\tposition: relative;\n\t\t\ttext-align: left;\n\t\t\tflex-direction: column;\n\t\t\tdisplay: flex;\n\t\t\tbr {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t\t&-icon {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 16.8rem;\n\t\t\t\theight: 8rem;\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t}\n\n\t\t.delivery-box {\n\t\t\twidth: 100%;\n\t\t\tmargin-right: 0;\n\t\t\tmargin-bottom: 4rem;\n\t\t}\n\n\t\t.delivery-box:nth-last-child(2n) {\n\t\t\tmargin-bottom: 4rem;\n\t\t}\n\t}\n}\n",".detailed-promotions {\n\tpadding-top: 10rem;\n\tmargin-bottom: 20rem;\n\t.container {\n\t\twidth: 100%;\n\t\tpadding-left: 6rem;\n\t}\n\t&__wrapper {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n\n\t&__left {\n\t\tposition: relative;\n\t\tpadding-top: 6rem;\n\t}\n\n\t&__title {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 9rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 90%;\n\t\tletter-spacing: -0.27rem;\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 4.8rem;\n\t\tstrong {\n\t\t\tdisplay: block;\n\t\t\tcolor: var(--orange, #ff6d2f);\n\t\t}\n\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t&__text {\n\t\tcolor: var(--choco, #4c0d00);\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem;\n\t\tletter-spacing: -0.36px;\n\t\tmargin-bottom: 6.4rem;\n\t\twidth: 70rem;\n\t}\n\n\t&__block {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 7.6rem;\n\t}\n\n\t&__inner {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tmargin-right: 4rem;\n\t}\n\n\t&__inner:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&__foodcore,\n\t&__time-title {\n\t\tcolor: var(--dark, #330d03);\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 2.4rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem;\n\t\tletter-spacing: 2.16px;\n\t\ttext-transform: uppercase;\n\t\tposition: relative;\n\t\tpadding-left: 4rem;\n\t\tmargin-bottom: 1.1rem;\n\t\t&::before {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"\";\n\t\t\twidth: 2.4rem;\n\t\t\theight: 2.4rem;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-size: 100% 100%;\n\t\t\tleft: 0;\n\t\t\ttop: 50%;\n\t\t\ttransform: translate(0, -50%);\n\t\t}\n\t}\n\n\t&__time-title {\n\t\t&::before {\n\t\t\tbackground-image: url(./assets/images/stock/watch.svg);\n\t\t}\n\t}\n\n\t&__foodcore {\n\t\t&::before {\n\t\t\tbackground-image: url(./assets/images/stock/location.svg);\n\t\t}\n\t}\n\n\t&__address {\n\t\tdisplay: flex;\n\t\tpadding-left: 4rem;\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 2.4rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 2.8rem;\n\t\t\tletter-spacing: 2.16px;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n\n\t.link {\n\t\tcolor: var(--dark, #330d03);\n\t\ttext-align: center;\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 3rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem;\n\t\tletter-spacing: -0.6px;\n\t\ttext-transform: uppercase;\n\t\tposition: relative;\n\t\tpadding-bottom: 0.8rem;\n\t\tdisplay: block;\n\t\twidth: fit-content;\n\t\t&::before {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"\";\n\t\t\twidth: 100%;\n\t\t\tbackground: var(--dark, #330d03);\n\t\t\theight: 0.2rem;\n\t\t\tbottom: 0;\n\t\t}\n\t}\n\n\t&__time {\n\t\tcolor: var(--dark, #330d03);\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 2.4rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem;\n\t\tletter-spacing: 2.16px;\n\t\ttext-transform: uppercase;\n\t\tpadding-left: 4rem;\n\t}\n\n\t&__btns {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t.btn {\n\t\t\tmargin-right: 6.4rem;\n\t\t}\n\t\t.link {\n\t\t\theight: fit-content;\n\t\t}\n\t}\n\n\t&__icon {\n\t\tposition: absolute;\n\t\twidth: 16.2rem;\n\t\theight: 13.2rem;\n\t\tright: -14.2rem;\n\t\tbottom: 10.2rem;\n\t}\n\n\t&__slide {\n\t\tdisplay: block;\n\t}\n\n\t&__box {\n\t\twidth: 70.6rem;\n\t\theight: 70rem;\n\t\tborder-radius: 50rem 50rem 0px 0px;\n\t\tbackground: var(--green, #b5bf3d);\n\t\tposition: relative;\n\t\tdisplay: block;\n\t\tpadding-top: 12.7rem;\n\t\t&-title {\n\t\t\tdisplay: block;\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\ttext-align: center;\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -1.8px;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-bottom: 2.4rem;\n\t\t}\n\n\t\t&-text {\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\ttext-align: center;\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 1.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 2.8rem;\n\t\t\tletter-spacing: -0.36px;\n\t\t}\n\t\t&-image {\n\t\t\twidth: 36.3rem;\n\t\t\theight: 24.3rem;\n\t\t\tposition: absolute;\n\t\t\tz-index: 2;\n\t\t\tleft: 50%;\n\t\t\ttop: 37.7rem;\n\t\t\ttransform: translate(-50%, 0);\n\t\t}\n\n\t\t&-tri {\n\t\t\tposition: absolute;\n\t\t\tz-index: 1;\n\t\t\tbottom: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t&__swiper {\n\t\tposition: relative;\n\t\twidth: 95.3rem;\n\t\toverflow: hidden;\n\t}\n\n\t&__navigation {\n\t\tdisplay: flex;\n\t\tflex-direction: initial;\n\t\tposition: absolute;\n\t\tright: 31rem;\n\t\ttop: 46rem;\n\t\tz-index: 3;\n\t\tjustify-content: space-between;\n\t\twidth: 59rem;\n\t}\n\n\t&__navigation-btn {\n\t\t&::after {\n\t\t\tbackground: var(--orange, #ff6d2f);\n\t\t}\n\t}\n\n\t&__btns--mob {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.detailed-promotions {\n\t\tpadding-top: 4rem;\n\t\t.container {\n\t\t\twidth: 100%;\n\t\t\tpadding-left: 3.2rem;\n\t\t\tpadding-right: 0;\n\t\t}\n\n\t\t&__left {\n\t\t\tposition: initial;\n\t\t}\n\n\t\t&__wrapper {\n\t\t\tflex-direction: column;\n\t\t\tposition: relative;\n\t\t}\n\n\t\t&__title {\n\t\t\tfont-size: 8rem;\n\t\t\tline-height: 90%;\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\n\t\t&__text {\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 2.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 142.857%;\n\t\t\tletter-spacing: -0.028rem;\n\t\t\tmargin-bottom: 4.8rem;\n\t\t}\n\t\t&__block {\n\t\t\tflex-direction: column;\n\t\t}\n\n\t\t&__inner {\n\t\t\tmargin-right: 0;\n\t\t\tmargin-bottom: 4.6rem;\n\t\t}\n\n\t\t&__inner:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t&__foodcore {\n\t\t\tmargin-bottom: 1.6rem;\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 3.6rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: normal;\n\t\t\tletter-spacing: -0.36px;\n\t\t\ttext-transform: uppercase;\n\t\t\tpadding-left: 7rem;\n\t\t\t&::before {\n\t\t\t\twidth: 3.6rem;\n\t\t\t\theight: 4rem;\n\t\t\t}\n\t\t}\n\n\t\t&__address {\n\t\t\tpadding-left: 7rem;\n\n\t\t\tspan {\n\t\t\t\tfont-size: 3.6rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tmargin-right: 2.4rem;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: normal;\n\t\t\t\tletter-spacing: -0.036rem;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t}\n\t\t}\n\n\t\t&__time-title {\n\t\t\tmargin-bottom: 1.6rem;\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 3.6rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: normal;\n\t\t\tletter-spacing: -0.36px;\n\t\t\ttext-transform: uppercase;\n\t\t\tpadding-left: 7rem;\n\t\t\t&::before {\n\t\t\t\twidth: 4rem;\n\t\t\t\theight: 4rem;\n\t\t\t}\n\t\t}\n\n\t\t&__time {\n\t\t\tpadding-left: 7rem;\n\n\t\t\tfont-size: 3.6rem;\n\t\t\tfont-style: normal;\n\t\t\tmargin-right: 2.4rem;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: normal;\n\t\t\tletter-spacing: -0.036rem;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\n\t\t&__swiper {\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 6.4rem;\n\t\t}\n\n\t\t.swiper-wrapper {\n\t\t\theight: auto;\n\t\t}\n\n\t\t&__btns--mob {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\tpadding-right: 3.6rem;\n\t\t}\n\n\t\t&__icon {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&__btns--desk {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&__box {\n\t\t\twidth: 63.4rem;\n\t\t\theight: 77.6rem;\n\n\t\t\t&-title {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tline-height: 100%;\n\t\t\t\tletter-spacing: -0.96px;\n\t\t\t\tmargin-bottom: 2rem;\n\t\t\t}\n\n\t\t\t&-text {\n\t\t\t\tfont-size: 2.8rem;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 142.857%;\n\t\t\t\tletter-spacing: -0.28px;\n\t\t\t}\n\n\t\t\t&-image {\n\t\t\t\twidth: 42.6rem;\n\t\t\t\theight: 28.6rem;\n\t\t\t}\n\t\t}\n\n\t\t&__navigation {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n",".other-promotions {\n\t.container {\n\t\twidth: 100%;\n\t\tpadding: 0 1rem;\n\t}\n\t&__block {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 8.3rem;\n\t\tpadding: 0 3.2rem;\n\t}\n\t&__title {\n\t\tcolor: $dark;\n\t\tfont-family: \"Literata\", sans-serif;\n\t\tfont-size: 8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 110%;\n\t\tletter-spacing: -1.6px;\n\t\tdisplay: flex;\n\t\t&-icon {\n\t\t\twidth: 18rem;\n\t\t\theight: 13rem;\n\t\t\tmargin: 0 1rem;\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tborder-radius: 50%;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__navigation {\n\t\tdisplay: flex;\n\t\tflex-direction: initial;\n\t}\n\n\t&__swiper {\n\t\twidth: 100%;\n\t}\n\n\t&__mob {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.other-promotions {\n\t\toverflow: hidden;\n\t\t.container {\n\t\t\twidth: 100%;\n\t\t\tpadding: 0 3.6rem;\n\t\t}\n\t\t&__swiper {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&__block {\n\t\t\tpadding: 0 3.2rem;\n\t\t}\n\n\t\t&__mob {\n\t\t\tdisplay: block;\n\t\t}\n\n\t\t&__mob-wrapper {\n\t\t\tdisplay: block;\n\n\t\t\t.delivery-box {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-bottom: 4rem;\n\t\t\t}\n\t\t}\n\n\t\t&__navigation {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&__btn {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&__title {\n\t\t\tfont-size: 5.6rem;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 110%;\n\t\t\tletter-spacing: -0.56px;\n\t\t\tmargin: 0 auto;\n\t\t\tmargin-bottom: 4rem;\n\n\t\t\t&-icon {\n\t\t\t\twidth: 11rem;\n\t\t\t\theight: 8rem;\n\t\t\t}\n\t\t}\n\n\t\t&__mob-btn {\n\t\t\tmargin: 0 auto;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\twidth: fit-content;\n\t\t}\n\t}\n}\n",".about {\n\tmargin-bottom: 20rem;\n\t.container {\n\t\twidth: 100%;\n\t}\n\n\t&__wrapper {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t}\n\n\t&__wrapper.mob {\n\t\tdisplay: none;\n\t}\n\n\t&__image {\n\t\twidth: 50%;\n\t\theight: 84rem;\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t}\n\n\t&__one {\n\t\tpadding-top: 11rem;\n\t\tpadding-bottom: 18rem;\n\t\tpadding-left: 0.8rem;\n\t\tposition: relative;\n\t\theight: 84rem;\n\t\t&-title {\n\t\t\tmargin-bottom: 5.5rem;\n\t\t\tposition: relative;\n\t\t\tstrong {\n\t\t\t\tdisplay: block;\n\t\t\t\tcolor: $orange;\n\t\t\t\tfont-family: \"Alumni Sans\";\n\t\t\t\tfont-size: 25rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 90%;\n\t\t\t\tletter-spacing: -1.5rem;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tposition: relative;\n\t\t\t\tz-index: 2;\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tcolor: #330d03;\n\t\t\t\tfont-family: \"Literata\";\n\t\t\t\tfont-size: 19rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 110%;\n\t\t\t\tletter-spacing: -7.6px;\n\t\t\t\tposition: absolute;\n\t\t\t\tz-index: 3;\n\t\t\t\ttext-align: right;\n\t\t\t\tright: 6rem;\n\t\t\t\tbottom: -3rem;\n\t\t\t}\n\t\t}\n\n\t\t&-text {\n\t\t\tcolor: var(--dark-secondary, rgba(51, 13, 3, 0.6));\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 2.2rem;\n\t\t\twidth: 42.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 2.8rem;\n\t\t\tmargin-bottom: 8.6rem;\n\t\t\tmargin-left: 1rem;\n\t\t}\n\n\t\t&-icon {\n\t\t\twidth: 22.9rem;\n\t\t\theight: 27.8rem;\n\t\t\tposition: absolute;\n\t\t\tbottom: 20rem;\n\t\t\tright: 6rem;\n\t\t}\n\t}\n\n\t&__two {\n\t\theight: 100.1rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tposition: relative;\n\t\t&-image {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tposition: absolute;\n\t\t\tz-index: -1;\n\t\t}\n\n\t\t&-age {\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tfont-family: \"Literata\";\n\t\t\tfont-size: 3rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 110%;\n\t\t\tletter-spacing: -0.6px;\n\t\t\tpadding-top: 25rem;\n\t\t}\n\t}\n\n\t&__three {\n\t\tbackground: var(--green, #b5bf3d);\n\t\tpadding: 19.3rem 6rem;\n\t\theight: 100.1rem;\n\n\t\t&-inner {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\tmargin-bottom: 5.3rem;\n\t\t}\n\n\t\t&-inner:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t&-title {\n\t\t\tcolor: var(--beige, #fff4da);\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -0.18rem;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\n\t\t&-text {\n\t\t\twidth: 41.7rem;\n\t\t\tcolor: var(--beige, #fff4da);\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 1.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 2.8rem;\n\t\t\tletter-spacing: -0.36px;\n\t\t}\n\t}\n\n\t&__four {\n\t\theight: 54.8rem;\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t}\n\n\t&__six {\n\t\theight: 54.8rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t&-title {\n\t\t\tcolor: var(--choco, #4c0d00);\n\t\t\ttext-align: center;\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -1.8px;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-bottom: 3.2rem;\n\t\t\twidth: 54.5rem;\n\t\t\tposition: relative;\n\t\t\t&::before {\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent: \"\";\n\t\t\t\twidth: 4.2rem;\n\t\t\t\theight: 3rem;\n\t\t\t\tbackground-image: url(./assets/images/icons/gright.svg);\n\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\tbackground-size: 100% 100%;\n\t\t\t\tright: -13.4rem;\n\t\t\t\ttop: 4.7rem;\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent: \"\";\n\t\t\t\twidth: 4.2rem;\n\t\t\t\theight: 3.3rem;\n\t\t\t\tbackground-image: url(./assets/images/icons/gleft.svg);\n\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\tbackground-size: 100% 100%;\n\t\t\t\tleft: -15.1rem;\n\t\t\t\ttop: 4.4rem;\n\t\t\t}\n\t\t\tspan {\n\t\t\t\tcolor: var(--orange, #ff6d2f);\n\t\t\t}\n\t\t}\n\n\t\t&-text {\n\t\t\tcolor: var(--dark-secondary, rgba(51, 13, 3, 0.6));\n\t\t\ttext-align: center;\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 2.2rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 2.8rem;\n\t\t\twidth: 43.5rem;\n\t\t}\n\t}\n\t&__one,\n\t&__two,\n\t&__three,\n\t&__four,\n\t&__six {\n\t\twidth: 50%;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.about {\n\t\tpadding-top: 4rem;\n\t\t.container {\n\t\t\tpadding: 0;\n\t\t}\n\t\t&__wrapper {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&__wrapper.mob {\n\t\t\tdisplay: block;\n\t\t}\n\n\t\t&__wrapper-content {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t}\n\n\t\t&__one {\n\t\t\twidth: 100%;\n\t\t\tpadding: 0;\n\t\t\theight: auto;\n\t\t\tmargin-bottom: 2rem;\n\t\t\tpadding: 0 3.2rem;\n\t\t\t&-title {\n\t\t\t\tmargin-bottom: 7.2rem;\n\t\t\t\tpadding-top: 9rem;\n\t\t\t\tstrong {\n\t\t\t\t\tfont-size: 20rem;\n\t\t\t\t\tletter-spacing: -1.1rem;\n\t\t\t\t}\n\n\t\t\t\tspan {\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: initial;\n\t\t\t\t\tfont-size: 16rem;\n\t\t\t\t\ttop: 14rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&-text {\n\t\t\t\twidth: 100%;\n\t\t\t\tfont-size: 3.6rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 155.556%;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\n\t\t&__image {\n\t\t\twidth: 100%;\n\t\t\theight: 46rem;\n\t\t\tmargin-bottom: 10rem;\n\t\t\tpadding: 0 3.2rem;\n\t\t}\n\n\t\t&__two {\n\t\t\theight: auto;\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 10rem;\n\t\t}\n\n\t\t&__two-age {\n\t\t\tfont-size: 4.8rem;\n\t\t\tpadding-top: 20rem;\n\t\t}\n\n\t\t&__two-image {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tposition: absolute;\n\t\t\tz-index: -1;\n\t\t}\n\n\t\t&__three {\n\t\t\twidth: 100%;\n\t\t\theight: auto;\n\t\t\tpadding: 10rem 3.2rem;\n\t\t\t&-inner {\n\t\t\t\tflex-direction: column;\n\t\t\t\tmargin-bottom: 6.4rem;\n\t\t\t}\n\n\t\t\t&-inner:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\n\t\t\t&-title {\n\t\t\t\tfont-family: \"Alumni Sans\";\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 100%;\n\t\t\t\tletter-spacing: -0.96px;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tmargin-bottom: 2rem;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t&-text {\n\t\t\t\twidth: 100%;\n\t\t\t\tfont-size: 2.8rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 142.857%;\n\t\t\t\tletter-spacing: -0.28px;\n\t\t\t}\n\t\t}\n\n\t\t&__six {\n\t\t\twidth: 100%;\n\t\t\tpadding: 10rem 3.2rem;\n\t\t\tpadding-top: 6rem;\n\t\t\t&-title {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 100%;\n\t\t\t\tletter-spacing: -0.96px;\n\t\t\t\ttext-transform: uppercase;\n\n\t\t\t\t&::before {\n\t\t\t\t\tright: -7rem;\n\t\t\t\t}\n\n\t\t\t\t&::after {\n\t\t\t\t\tleft: -7.1rem;\n\t\t\t\t\ttop: 1.4rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&-text {\n\t\t\t\tcolor: var(--dark-secondary, rgba(51, 13, 3, 0.6));\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\t\tfont-size: 3.6rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 155.556%;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&__four {\n\t\t\twidth: 100%;\n\t\t\theight: 40rem;\n\t\t}\n\t}\n}\n",".menu-main {\n\tmargin-bottom: 20rem;\n\t.container {\n\t\twidth: 100%;\n\t}\n\n\t&__wrapper {\n\t\tdisplay: flex;\n\t}\n\n\t&__left {\n\t\twidth: 50%;\n\t\tbackground-image: url(./assets/images/menu/bg.png);\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: 100% 100%;\n\t\theight: 90.7rem;\n\t\tpadding: 3rem;\n\t\tposition: relative;\n\t}\n\n\t&__swiper-title {\n\t\theight: 17rem;\n\t\tmargin-bottom: 1rem;\n\t\tpadding-left: 3rem;\n\t\tpadding-top: 1rem;\n\t}\n\n\t&__swiper-wrapper-title {\n\t\theight: auto;\n\t}\n\n\t&__left-content {\n\t\twidth: 48rem;\n\t\theight: 48rem;\n\t\tposition: relative;\n\t\tborder-radius: 50%;\n\t\tbackground: var(--beige, #fff4da);\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tmargin: 0 auto;\n\t\tmargin-bottom: 10.6rem;\n\t}\n\n\t&__left-swiper {\n\t\toverflow: hidden;\n\t\twidth: 34.5rem;\n\t\theight: 28.7rem;\n\t}\n\n\t&__left-swiper-wrapper {\n\t\theight: auto;\n\t}\n\n\t&__left-slide-image {\n\t\twidth: 34.5rem;\n\t\theight: 28.7rem;\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t}\n\n\t&__navigation {\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\tflex-direction: initial;\n\t\tjustify-content: space-between;\n\t\twidth: 88%;\n\t\tleft: 5rem;\n\t\ttop: 50%;\n\t\ttransform: translate(0, -50%);\n\t}\n\n\t&__swiper-title-slide-text {\n\t\tcolor: var(--white, #fff);\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 9rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 90%; /* 81px */\n\t\tletter-spacing: -2.7px;\n\t\ttext-transform: uppercase;\n\n\t\tspan {\n\t\t\tpadding-left: 11rem;\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t.link {\n\t\tcolor: var(--beige, #fff4da);\n\t\ttext-align: center;\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 3rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem;\n\t\tletter-spacing: -0.6px;\n\t\ttext-transform: uppercase;\n\t\tpadding-bottom: 0.8rem;\n\t\tdisplay: block;\n\t\tmargin: 0 auto;\n\t\tposition: relative;\n\t\theight: fit-content;\n\t\twidth: fit-content;\n\t\t&::before {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"\";\n\t\t\twidth: 100%;\n\t\t\tbackground: var(--beige, #fff4da);\n\t\t\theight: 0.2rem;\n\t\t\tbottom: 0;\n\t\t}\n\t}\n\n\t&__right {\n\t\twidth: 50%;\n\t\tpadding-top: 5rem;\n\t\tpadding-left: 19rem;\n\t\tpadding-right: 19rem;\n\n\t\t&-title {\n\t\t\tmargin-bottom: 11.2rem;\n\t\t\tposition: relative;\n\t\t\tstrong {\n\t\t\t\tdisplay: block;\n\t\t\t\tcolor: $orange;\n\t\t\t\tfont-family: \"Alumni Sans\";\n\t\t\t\tfont-size: 25rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 90%;\n\t\t\t\tletter-spacing: -1.5rem;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tposition: relative;\n\t\t\t\tz-index: 2;\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tcolor: $dark;\n\t\t\t\tfont-feature-settings: \"dnom\" on;\n\t\t\t\tfont-family: \"Literata\";\n\t\t\t\tfont-size: 19rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 110%;\n\t\t\t\tletter-spacing: -0.76rem;\n\t\t\t\tposition: absolute;\n\t\t\t\tz-index: 3;\n\t\t\t\ttext-align: right;\n\t\t\t\tright: -3rem;\n\t\t\t\tbottom: -3rem;\n\t\t\t}\n\t\t}\n\n\t\t&-rang {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -1.8px;\n\t\t\tjustify-content: center;\n\t\t\ttext-transform: uppercase;\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 3.6rem;\n\t\t\tp {\n\t\t\t\tposition: relative;\n\t\t\t\tpadding-right: 5.2rem;\n\t\t\t\tmargin-right: 2.4rem;\n\t\t\t\t&::before {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tright: 0;\n\t\t\t\t\twidth: 2.8rem;\n\t\t\t\t\theight: 0.2rem;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\ttransform: translate(0, -50%);\n\t\t\t\t\tbackground: var(--choco, #4c0d00);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: relative;\n\t\t\t\tpadding-left: 3.3rem;\n\t\t\t\t&::before {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\twidth: 2.7rem;\n\t\t\t\t\theight: 2.7rem;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tbackground-image: url(./assets/images/menu/iconstar.svg);\n\t\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\t\tbackground-size: 100% 100%;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\ttransform: translate(0, -50%);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&-text {\n\t\t\tcolor: var(--dark-secondary, rgba(51, 13, 3, 0.6));\n\t\t\ttext-align: center;\n\t\t\tmargin-bottom: 7.2rem;\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 1.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 2.8rem;\n\t\t\tletter-spacing: -0.36px;\n\n\t\t\tp {\n\t\t\t\tmargin-bottom: 2rem;\n\t\t\t}\n\t\t\tp:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__btn-slider {\n\t\theight: 4rem !important;\n\t}\n\n\t&__btn {\n\t\tmargin: 0 auto;\n\t\tdisplay: flex;\n\t\twidth: fit-content;\n\t\tcolor: var(--white, #fff);\n\t\t&::after {\n\t\t\tbackground: var(--white, #fff);\n\t\t}\n\t}\n\n\t&__fraction {\n\t\tcolor: var(--white, #fff);\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 2.2rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 2.8rem;\n\t\ttop: 17.4rem;\n\t\tposition: absolute;\n\t\tleft: 7.2rem;\n\t}\n\n\t.navigation-btn {\n\t\tbackground-color: var(--beige, #fff4da);\n\t\t&:hover {\n\t\t\t&::after {\n\t\t\t\tbackground-color: #4c0d00;\n\t\t\t}\n\n\t\t\tsvg {\n\t\t\t\tpath {\n\t\t\t\t\tfill: var(--beige, #fff4da);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tsvg {\n\t\t\tpath {\n\t\t\t\tfill: #4c0d00;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__btn-buy {\n\t\tdisplay: none;\n\t}\n\n\t&__btn-right {\n\t\tmargin: 0 auto;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: fit-content;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.menu-main {\n\t\tpadding-top: 9rem;\n\t\t&__left {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&__swiper-title {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&__right {\n\t\t\twidth: 100%;\n\t\t\tpadding: 6.6rem 3.2rem;\n\n\t\t\t&-title {\n\t\t\t\tmargin-bottom: 8.5rem;\n\t\t\t\tposition: relative;\n\t\t\t\tright: -3rem;\n\t\t\t\tstrong {\n\t\t\t\t\tfont-size: 20rem;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tline-height: 90%;\n\t\t\t\t\tletter-spacing: -1.1rem;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t}\n\n\t\t\t\tspan {\n\t\t\t\t\tfont-size: 18rem;\n\t\t\t\t\tletter-spacing: -2.96px;\n\t\t\t\t\tline-height: 90%;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tright: 7rem;\n\t\t\t\t\tbottom: -4rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.main-menu__categories {\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\n\t\t\t&-rang {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t}\n\n\t\t\t&-text {\n\t\t\t\tfont-size: 2.8rem;\n\t\t\t}\n\t\t}\n\n\t\t&__btn-buy {\n\t\t\tdisplay: flex;\n\t\t\tposition: fixed;\n\t\t\tbottom: 3rem;\n\t\t\tright: 3.2rem;\n\t\t\tz-index: 10;\n\t\t}\n\t}\n}\n",".position-card {\n\tmargin-bottom: 20rem;\n\t.container {\n\t\twidth: 100%;\n\t}\n\n\t&__wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t&__left {\n\t\tpadding-top: 6rem;\n\t\tpadding-left: 6rem;\n\t\twidth: 50%;\n\t}\n\n\t.small-btn {\n\t\twidth: fit-content;\n\t\tposition: absolute;\n\t\tright: 7.1rem;\n\t\tcolor: var(--beige, #fff4da);\n\t\ttop: 6.8rem;\n\n\t\t&:after {\n\t\t\tbackground: var(--beige, #fff4da);\n\t\t}\n\t}\n\n\t&__inner {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 13.5rem;\n\t}\n\n\t&__info {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tmargin-right: 2.6rem;\n\t\tstrong {\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -1.8px;\n\t\t\ttext-transform: uppercase;\n\t\t\tdisplay: block;\n\t\t}\n\n\t\tspan {\n\t\t\tcolor: var(--dark-secondary, rgba(51, 13, 3, 0.6));\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 1.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 2.8rem;\n\t\t\tletter-spacing: -0.36px;\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t&__info:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&__title {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tmargin-bottom: 19.1rem;\n\t\tmax-width: 55rem;\n\t\tstrong {\n\t\t\tdisplay: block;\n\t\t\tcolor: var(--choco, #4c0d00);\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 9rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 90%;\n\t\t\tletter-spacing: -2.7px;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\tcolor: var(--choco, #4c0d00);\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -1.8px;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\n\t&__image {\n\t\twidth: 59.7rem;\n\t\theight: 43.9rem;\n\t\tposition: absolute;\n\t\ttop: 13%;\n\t\tleft: 32%;\n\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: contain;\n\t\t}\n\t}\n\n\t&__description {\n\t\tbackground: var(--green, #b5bf3d);\n\t\tpadding: 6rem;\n\t\tcolor: var(--dark, #330d03);\n\t\tfont-family: \"Euclid Circular A\";\n\t\tfont-size: 1.8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 2.8rem;\n\t\tletter-spacing: -0.36px;\n\t\twidth: fit-content;\n\t\tp {\n\t\t\tmax-width: 30rem;\n\t\t}\n\t}\n\n\t&__block {\n\t\tdisplay: flex;\n\t\tposition: absolute;\n\t\tbottom: 7rem;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, 0);\n\t}\n\n\t&__price {\n\t\tborder: 0.12rem solid var(--green, #b5bf3d);\n\t\twidth: 16.1rem;\n\t\theight: 7rem;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tspan {\n\t\t\tposition: relative;\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tdisplay: block;\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -1.8px;\n\t\t\ttext-transform: uppercase;\n\t\t\tpadding-right: 1rem;\n\t\t\t&::before {\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent: \"₽\";\n\t\t\t\tfont-family: \"Alumni Sans\";\n\t\t\t\tfont-size: 2rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 100%;\n\t\t\t\tletter-spacing: -1.8px;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__gram {\n\t\twidth: 16.1rem;\n\t\theight: 7rem;\n\t\tbackground: var(--green, #b5bf3d);\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcolor: var(--beige, #fff4da);\n\t\ttext-align: center;\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 3rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem;\n\t\tletter-spacing: -0.6px;\n\t\ttext-transform: uppercase;\n\t}\n\n\t&__right {\n\t\twidth: 50%;\n\t\t&-block {\n\t\t\tbackground: var(--choco, #4c0d00);\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tpadding-top: 22.2rem;\n\t\t\tpadding-left: 27.8rem;\n\t\t}\n\n\t\t&-title {\n\t\t\tcolor: var(--beige, #fff4da);\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 3rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 2.8rem;\n\t\t\tletter-spacing: -0.6px;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-bottom: 2.4rem;\n\t\t}\n\t}\n\n\t&__lists {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 2fr;\n\t}\n\n\t&__item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-bottom: 1.6rem;\n\t\t&-compound {\n\t\t\tcolor: var(--white, #fff);\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 2.2rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 2.8rem;\n\t\t\tmargin-right: 1rem;\n\t\t}\n\n\t\t&-price {\n\t\t\tcolor: var(--white-secondary, rgba(255, 255, 255, 0.7));\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 2.4rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 2.8rem;\n\t\t\tletter-spacing: 2.16px;\n\t\t\ttext-transform: uppercase;\n\t\t\tposition: relative;\n\t\t\tpadding-right: 1rem;\n\t\t\t&::before {\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent: \"₽\";\n\t\t\t\tcolor: var(--white-secondary, rgba(255, 255, 255, 0.7));\n\t\t\t\tfont-family: \"Alumni Sans\";\n\t\t\t\tfont-size: 2rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 2.8rem;\n\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__aside {\n\t\tposition: absolute;\n\t\twidth: 38.4rem;\n\t\theight: 32.4rem;\n\t\tbackground: var(--orange, #ff6d2f);\n\t\tpadding: 6rem;\n\t\tright: 6rem;\n\t\tbottom: 0;\n\n\t\t&-basket {\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 2.2rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 2.8rem;\n\t\t\tmargin-bottom: 1.4rem;\n\t\t}\n\n\t\t&-name {\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -1.8px;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-bottom: 0rem;\n\t\t}\n\n\t\t&-price {\n\t\t\tcolor: var(--white-secondary, rgba(255, 255, 255, 0.7));\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 2.4rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 2.8rem;\n\t\t\tletter-spacing: 2.16px;\n\t\t\ttext-transform: uppercase;\n\t\t\tposition: relative;\n\t\t\tpadding-right: 1rem;\n\t\t\tmargin-bottom: 2.9rem;\n\t\t\twidth: fit-content;\n\t\t\t&::before {\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent: \"₽\";\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t}\n\n\t\t&-image {\n\t\t\twidth: 16.5rem;\n\t\t\theight: 17.4rem;\n\t\t\tposition: absolute;\n\t\t\tbottom: 5.1rem;\n\t\t\tright: 6rem;\n\t\t}\n\n\t\t&-btn {\n\t\t\tbackground: none;\n\t\t\tborder: 0.1rem solid var(--dark, #330d03);\n\t\t\t&:hover {\n\t\t\t\tborder: 0.1rem solid var(--green, #b5bf3d);\n\t\t\t\tsvg {\n\t\t\t\t\tpath {\n\t\t\t\t\t\tfill: var(--beige, #fff4da);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tsvg {\n\t\t\t\tpath {\n\t\t\t\t\tfill: $dark;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 48em) {\n\t.position-card {\n\t\t.container {\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t&__wrapper {\n\t\t\tflex-direction: column;\n\t\t}\n\n\t\t&__left {\n\t\t\twidth: 100%;\n\t\t\tpadding: 10.8rem 3.6rem;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t}\n\n\t\t.small-btn {\n\t\t\tposition: relative;\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tright: initial;\n\t\t\ttop: initial;\n\t\t\tleft: initial;\n\t\t\tmargin: initial;\n\t\t\tmargin-bottom: 4rem;\n\n\t\t\t&::after {\n\t\t\t\tbackground: var(--dark, #330d03);\n\t\t\t}\n\t\t}\n\n\t\t&__title {\n\t\t\torder: 1;\n\t\t\tmargin-bottom: 2rem;\n\n\t\t\tstrong {\n\t\t\t\tfont-size: 8rem;\n\t\t\t\tmargin-bottom: 2rem;\n\t\t\t\twidth: 100%;\n\t\t\t\tletter-spacing: -1.2px;\n\n\t\t\t\tbr {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t}\n\t\t}\n\t\t&__inner {\n\t\t\torder: 2;\n\t\t\tmargin-bottom: 4.8rem;\n\t\t}\n\n\t\t&__info {\n\t\t\tmargin-right: 4.8rem;\n\t\t\tstrong {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 100%;\n\t\t\t\tletter-spacing: -0.96px;\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tfont-size: 2.8rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 400;\n\t\t\t}\n\t\t}\n\n\t\t&__image {\n\t\t\tposition: initial;\n\t\t\twidth: 100%;\n\t\t\theight: 50rem;\n\t\t\torder: 3;\n\t\t\tmargin-bottom: 3.2rem;\n\t\t}\n\n\t\t&__description {\n\t\t\torder: 4;\n\t\t\twidth: 100%;\n\t\t\tpadding: 3.2rem;\n\t\t\tfont-size: 2.8rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 142.857%;\n\t\t\tmargin-bottom: 3.2rem;\n\n\t\t\tp {\n\t\t\t\twidth: 100%;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t&__block {\n\t\t\tposition: initial;\n\t\t\torder: 5;\n\t\t\ttransform: initial;\n\t\t}\n\n\t\t&__price {\n\t\t\twidth: 50%;\n\t\t\theight: 12rem;\n\n\t\t\tspan {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tpadding-right: 2rem;\n\t\t\t\t&::before {\n\t\t\t\t\tfont-size: 4rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&__gram {\n\t\t\twidth: 50%;\n\t\t\theight: 12rem;\n\t\t\tspan {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t}\n\t\t}\n\n\t\t&__right {\n\t\t\twidth: 100%;\n\t\t\t&-block {\n\t\t\t\tpadding: 10rem 3.2rem;\n\t\t\t}\n\n\t\t\t&-title {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 100%;\n\t\t\t\tletter-spacing: -0.96px;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tmargin-bottom: 4.8rem;\n\t\t\t}\n\t\t}\n\n\t\t&__aside {\n\t\t\tposition: relative;\n\t\t\tmargin-top: 10rem;\n\t\t\twidth: 68.6rem;\n\t\t\tright: initial;\n\t\t\tbottom: initial;\n\t\t\tmargin: 0 auto;\n\t\t\tmargin-top: 10rem;\n\t\t\tdisplay: block;\n\t\t\theight: auto;\n\t\t\t&-basket {\n\t\t\t\tfont-size: 3.6rem;\n\t\t\t\tmargin-bottom: 4.8rem;\n\t\t\t}\n\n\t\t\t&-name {\n\t\t\t\tmargin-bottom: 1.6rem;\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t}\n\n\t\t\t&-price {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t\tpadding-right: 3rem;\n\t\t\t\tmargin-bottom: 4.4rem;\n\t\t\t}\n\n\t\t\t&-image {\n\t\t\t\twidth: 22.5rem;\n\t\t\t\theight: 30.4rem;\n\t\t\t}\n\t\t}\n\n\t\t&__lists {\n\t\t\tgrid-template-columns: 1fr;\n\t\t}\n\n\t\t&__item {\n\t\t\tmargin-bottom: 3.2rem;\n\n\t\t\t&-compound {\n\t\t\t\tfont-size: 3.2rem;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 155.556%;\n\t\t\t\tmargin-right: 1.6rem;\n\t\t\t}\n\n\t\t\t&-price {\n\t\t\t\tfont-size: 4.8rem;\n\t\t\t}\n\t\t}\n\t}\n}\n",".stock-main {\n\tmargin-bottom: 0rem;\n\t.container {\n\t\twidth: 100%;\n\t}\n\n\t&__wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t&__left {\n\t\tposition: relative;\n\t\twidth: 50%;\n\t\t&-text {\n\t\t\tposition: absolute;\n\t\t\ttop: 10.2rem;\n\t\t\tleft: 6rem;\n\t\t\tcolor: #330d03;\n\t\t\tfont-family: \"Alumni Sans\";\n\t\t\tfont-size: 4.5rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -1.8px;\n\t\t\ttext-transform: uppercase;\n\t\t\tz-index: 3;\n\t\t}\n\n\t\t&-swiper {\n\t\t\toverflow: hidden;\n\t\t\twidth: 100%;\n\t\t\theight: 89rem;\n\t\t}\n\n\t\t&-swiper-wrapper {\n\t\t\theight: auto;\n\t\t}\n\n\t\t&-slide-bg {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t}\n\n\t&__title-swiper {\n\t\twidth: 81.9rem;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\t\ttop: 6.2rem;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, 0);\n\t\tz-index: 3;\n\t\theight: 16.2rem;\n\t}\n\n\t&__title-swiper-wrapper {\n\t\theight: auto;\n\t}\n\n\t&__slide-title-text {\n\t\tcolor: #330d03;\n\t\tfont-family: \"Alumni Sans\", sans-serif;\n\t\tfont-size: 9rem;\n\t\ttext-align: center;\n\t\tfont-weight: 600;\n\t\tline-height: 90%;\n\t\tletter-spacing: -2.7px;\n\t\ttext-transform: uppercase;\n\t\tspan {\n\t\t\tfont-style: italic;\n\t\t}\n\t}\n\n\t&__right {\n\t\twidth: 50%;\n\t\tposition: relative;\n\t\tpadding-top: 25.4rem;\n\t\theight: 89rem;\n\t\tpadding-left: 6rem;\n\t\tpadding-right: 4rem;\n\t\t&-swiper {\n\t\t\twidth: 39.7rem;\n\t\t\theight: 33.9rem;\n\t\t\toverflow: hidden;\n\t\t\tz-index: 3;\n\t\t\tmargin-bottom: 11.6rem;\n\t\t}\n\n\t\t&-swiper-wrapper {\n\t\t\theight: auto;\n\t\t}\n\n\t\t&-content-bg {\n\t\t\twidth: 39.7rem;\n\t\t\theight: 33.9rem;\n\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\t\t}\n\n\t\t&-text-slide-inner {\n\t\t\twidth: 100%;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t}\n\n\t\t&-text-slide-inner-text {\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 2.2rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 2.8rem;\n\t\t\twidth: 27.3rem;\n\t\t}\n\t}\n\n\t&__right-text-swiper {\n\t\theight: 8.4rem;\n\t\toverflow: hidden;\n\t}\n\n\t&__right-text-swiper-wrapper {\n\t\theight: auto;\n\t}\n\n\t&__navigation {\n\t\tposition: absolute;\n\t\tflex-direction: initial;\n\t\tz-index: 3;\n\t\ttop: 11.2rem;\n\t\tright: 6rem;\n\t}\n\n\t&__right-text-slide-inner-link {\n\t\theight: fit-content;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.stock-main {\n\t\toverflow: hidden;\n\t\t.container {\n\t\t\twidth: 100%;\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t&__wrapper {\n\t\t\tflex-direction: column;\n\t\t}\n\n\t\t&__left {\n\t\t\twidth: 100%;\n\n\t\t\t&-swiper {\n\t\t\t\theight: 72rem;\n\t\t\t}\n\t\t}\n\n\t\t&__right {\n\t\t\twidth: 100%;\n\t\t\tpadding-top: 0;\n\t\t\theight: 60rem;\n\t\t\tpadding: 0 3.2rem;\n\t\t\tpadding-top: 9rem;\n\t\t\t&-swiper {\n\t\t\t\twidth: 42.6rem;\n\t\t\t\theight: 36rem;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\n\t\t&__left-text {\n\t\t\tfont-size: 4.8rem;\n\t\t\tleft: 3.2rem;\n\t\t\ttop: 8.4rem;\n\t\t\tletter-spacing: -0.18rem;\n\t\t\tbr {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t&__title-swiper {\n\t\t\twidth: 100%;\n\t\t\theight: 14.4rem;\n\t\t\tleft: 3.2rem;\n\t\t\ttransform: initial;\n\t\t\ttop: 15.2rem;\n\t\t}\n\n\t\t&__slide-title-text {\n\t\t\tfont-size: 8rem;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 90%;\n\t\t\tletter-spacing: -1.2px;\n\t\t\ttext-transform: uppercase;\n\t\t\twidth: 60rem;\n\t\t\ttext-align: left;\n\t\t\tbr {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t&__right-text-swiper {\n\t\t\toverflow: hidden;\n\t\t\tposition: absolute;\n\t\t\theight: 100%;\n\t\t\ttop: 0;\n\t\t}\n\n\t\t&__right-text-slide-inner {\n\t\t\theight: 100%;\n\t\t\theight: 57rem;\n\t\t}\n\n\t\t&__right-text-slide-inner-link {\n\t\t\tposition: absolute;\n\t\t\tbottom: 2rem;\n\t\t\tright: 3.6rem;\n\t\t}\n\n\t\t&__right-text-slide-inner-text {\n\t\t\twidth: 100%;\n\t\t\tcolor: var(--dark, #330d03);\n\t\t\tfont-family: \"Euclid Circular A\";\n\t\t\tfont-size: 3.2rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 155.556%;\n\t\t}\n\n\t\t&__navigation {\n\t\t\tflex-direction: row-reverse;\n\t\t\tz-index: 3;\n\t\t\ttop: initial;\n\t\t\tright: initial;\n\t\t\tleft: 3.2rem;\n\t\t\tbottom: 1rem;\n\t\t}\n\t}\n}\n",".menu {\n\t.container {\n\t\twidth: 100%;\n\t\tpadding: 0 1rem;\n\t}\n\t&__title {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tmargin-bottom: 0.6rem;\n\t\tcolor: var(--dark, #330d03);\n\t\ttext-align: center;\n\t\tfont-family: \"Literata\";\n\t\tfont-size: 8rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 110%;\n\t\tletter-spacing: -1.6px;\n\t\t&-icon {\n\t\t\twidth: 12rem;\n\t\t\theight: 9rem;\n\t\t\tmargin-right: 2rem;\n\t\t\tmargin-left: 2rem;\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\t}\n\t.main-menu__header {\n\t\tmargin-bottom: 4.4rem;\n\t}\n\n\t.main-menu__categories {\n\t\tmax-width: 146rem;\n\t}\n\n\t.main-menu__categories-btn.active {\n\t\tposition: relative;\n\t\tcolor: #ff6d2f;\n\t}\n\t.link {\n\t\tcolor: var(--dark, #330d03);\n\n\t\ttext-align: center;\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 3rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem;\n\t\tletter-spacing: -0.6px;\n\t\ttext-transform: uppercase;\n\t\tpadding-bottom: 0.8rem;\n\t\tdisplay: block;\n\t\tmargin: 0 auto;\n\t\tposition: relative;\n\t\theight: fit-content;\n\t\twidth: fit-content;\n\t\tmargin-bottom: 20rem;\n\t\t&::before {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"\";\n\t\t\twidth: 100%;\n\t\t\tbackground: var(--dark, #330d03);\n\t\t\theight: 0.2rem;\n\t\t\tbottom: 0;\n\t\t}\n\t}\n\n\t&__popular {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t\twidth: 100%;\n\t\tmargin-bottom: 7.4rem;\n\n\t\t.menu-card {\n\t\t\t&:hover {\n\t\t\t\t.menu-card {\n\t\t\t\t\t&__name {\n\t\t\t\t\t\tcolor: var(--dark, #330d03);\n\t\t\t\t\t}\n\n\t\t\t\t\t&__price {\n\t\t\t\t\t\tcolor: var(--dark, #330d03);\n\t\t\t\t\t}\n\n\t\t\t\t\t&__description {\n\t\t\t\t\t\tcolor: var(--dark, #330d03);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&__bg {\n\t\t\t\tbackground: var(--choco, #4c0d00);\n\t\t\t}\n\n\t\t\t&__name {\n\t\t\t\tcolor: var(--beige, #fff4da);\n\t\t\t}\n\n\t\t\t&__price {\n\t\t\t\tcolor: var(--beige, #fff4da);\n\t\t\t}\n\n\t\t\t&__description {\n\t\t\t\tcolor: var(--beige, #fff4da);\n\t\t\t}\n\n\t\t\t.btn {\n\t\t\t\tbackground: var(--orange, #ff6d2f);\n\t\t\t}\n\t\t}\n\t}\n\n\t.main-menu__inner {\n\t\tmargin-bottom: 7.4rem;\n\t}\n\n\t&__chapter-title {\n\t\tcolor: var(--dark, #330d03);\n\t\ttext-align: center;\n\t\tmargin-bottom: 4.8rem;\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 4.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 100%;\n\t\tletter-spacing: -1.8px;\n\t\ttext-transform: uppercase;\n\t}\n\n\t&__chapter {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin-bottom: 7.4rem;\n\t\t.menu-card {\n\t\t\tmargin-right: 0.5rem;\n\t\t}\n\n\t\t.menu-card:nth-child(4n) {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n\n\t&__all {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tmargin: 0 auto;\n\t\tmargin-bottom: 20rem;\n\t}\n}\n\n@media (max-width: 48em) {\n\t.menu {\n\t\t.container {\n\t\t\tpadding: 0 3.2rem;\n\t\t}\n\n\t\t&__title {\n\t\t\tposition: relative;\n\t\t\tfont-size: 5.6rem;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: initial;\n\t\t\tjustify-content: initial;\n\t\t\ttext-align: left;\n\t\t\t&-icon {\n\t\t\t\twidth: 14.4rem;\n\t\t\t\theight: 8rem;\n\t\t\t\tposition: absolute;\n\t\t\t\tmargin-right: 0;\n\t\t\t\tmargin-left: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t}\n\t\t&__popular {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\n\t\t\t.menu-card {\n\t\t\t\t&:hover {\n\t\t\t\t\t.menu-card {\n\t\t\t\t\t\t&__name {\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t&__price {\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t&__description {\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.main-menu__cards-slide {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.main-menu__categories {\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n",".error-four {\n\tmargin-bottom: 20rem;\n\n\t&__wrapper {\n\t\tpadding-top: 20rem;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t&__image {\n\t\twidth: 96.4rem;\n\t\theight: 48.4rem;\n\t\tmargin: 0 auto;\n\t\tmargin-bottom: 5.6rem;\n\t}\n\n\t&__text {\n\t\tcolor: #1c1c1c;\n\t\ttext-align: center;\n\t\tfont-family: \"Alumni Sans\";\n\t\tfont-size: 2.4rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 2.8rem;\n\t\tletter-spacing: 2.16px;\n\t\ttext-transform: uppercase;\n\t\tmax-width: 65.5rem;\n\t\tmargin-bottom: 2.1rem;\n\t}\n\n\t.btn {\n\t\tmargin: 0 auto;\n\t}\n}\n@media (max-width: 48em) {\n\t.error-four {\n\t\t&__image {\n\t\t\twidth: 100%;\n\t\t\theight: 29.6rem;\n\t\t}\n\n\t\t&__text {\n\t\t\tfont-size: 4rem;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: -0.8px;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-bottom: 3.2rem;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
